// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Author         : G-axon
Template Name  : Jumbo React - Admin Template
Version        : 1.0
*/
/*=============================================================
    Table of Contents:
    =============================
    A. Globals
        01. Custom Animation
    B. Base
        01. Base Styles
        02. Typography Styles
    C. Layouts
        01. App Layout Styles
        02. Sidebar Styles
        03. Header Styles
        04. Main Content Styles
        05. Footer Styles
        06. Right Sidebar Styles
    D. UI Components
        01. Alert Styles
        02. Avatar Styles
        03. Badges Styles
        04. Blockquotes Styles
        05. Bottom Navigation Styles
        06. Breadcrumb Styles
        07. Button Styles
        08. Button Group Styles
        09. Callout Styles
        10. Cards Styles
        11. Charts Styles
        12. Chips Styles
        13. Carousel Styles
        14. Color Picker Styles
        15. Drawer Styles
        16. E-commerce Styles
        17. Grids List Styles
        18. Icons Styles
        19. Label Styles
        20. List Styles
        21. Nav Style
        22. Pricing Styles
        23. Progressbar Styles
        24. Popover Styles
        25. React Joyride Styles
        26. Tables Styles
        27. Tabs Styles
        28. Testimonial Styles
        29. Time Lines Style
        30. Joyride Tour Styles
        31. Form Styles
    E. Pages
        01. Login Styles
        02. Error Styles
        03. Editor Styles
        04. Contact Page Styles
        05. Portfolio Styles
        06. Faqs Styles
        07. Dashboard Styles
    F. Slider
    G. Modules
        01. App Module Style
        02. Chat Module Styles
        03. Mails Module Styles
        04. Contact Module Styles
        05. Calendar Module Style
  =============================================================*/
/* Globals
   ========================================================================== */
.jr-menu-icon .menu-icon {
  position: relative;
  width: 70%;
  height: 1px;
  min-height: 1px;
  color: inherit;
  background-color: #808080;
  display: block;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
  margin: 6px 0;
  cursor: pointer;
}
.jr-menu-icon .menu-icon:after, .jr-menu-icon .menu-icon:before {
  position: absolute;
  display: block;
  color: inherit;
  background-color: inherit;
  left: 0;
  height: 1px;
  min-height: 1px;
  content: "";
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.jr-menu-icon .menu-icon:after {
  width: 120%;
  bottom: -6px;
}
.jr-menu-icon .menu-icon:before {
  width: 130%;
  top: -6px;
}
.jr-menu-icon:hover .menu-icon {
  width: 100%;
}
.jr-menu-icon:hover .menu-icon:after, .jr-menu-icon:hover .menu-icon:before {
  width: 100%;
}

.timeline-badge, .user-list .user-avatar, .jr-fab-btn, .user-avatar, .size-50 {
  height: 50px !important;
  width: 50px !important;
  line-height: 50px;
}

.jr-btn-fab-lg, .size-60 {
  height: 60px !important;
  width: 60px !important;
  line-height: 60px;
}

.size-80 {
  height: 80px !important;
  width: 80px !important;
  line-height: 80px;
}

.size-100 {
  height: 100px !important;
  width: 100px !important;
  line-height: 100px;
}

.size-20 {
  height: 20px !important;
  width: 20px !important;
  line-height: 20px;
}

.icon, .jr-btn-fab-xs, .jr-menu-icon, .size-30 {
  height: 30px !important;
  width: 30px !important;
  line-height: 30px;
}

.jr-btn-fab-sm, .size-40 {
  height: 40px !important;
  width: 40px !important;
  line-height: 40px;
}

.profile-intro img.avatar-circle, .size-120 {
  height: 120px !important;
  width: 120px !important;
  line-height: 120px;
}

.icon-addon {
  display: inline-block;
  text-align: center;
  background-color: inherit;
}

.jr-card {
  padding: 24px 30px;
  margin-bottom: 34px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #ced4da;
  position: relative;
}

/* Ripple magic */
.ripple-effect {
  position: relative;
  overflow: hidden;
}
.ripple-effect:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}
.ripple-effect:hover:after {
  animation: ripple 1s ease-out;
}

@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(60, 60);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(100, 100);
  }
}
@-webkit-keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  20% {
    transform: scale(60, 60);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(100, 100);
  }
}
.quick-menu .icon-alert:after {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  -moz-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  -o-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  animation: pulse 2s infinite;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
.chat-avatar-mode .chat-mode.offline, .chat-avatar-mode .chat-mode.online {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  -moz-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  -o-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  animation: online 2s infinite;
}

@-webkit-keyframes online {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}
@keyframes online {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}
.chat-avatar-mode .chat-mode.away {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  -moz-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  -o-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  animation: away 2s infinite;
}

@-webkit-keyframes away {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
  }
}
@keyframes away {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
    box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
  }
}
/*Different size images set in Equal block height and width*/
.brand-logo, .grid-thumb-equal {
  position: relative;
  padding-bottom: 68%;
  height: 0;
  width: 100%;
  overflow: hidden;
}

.brand-logo .brand-logo-inner, .grid-thumb-cover {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
}

.grid-thumb-cover img {
  height: auto;
  max-width: 100%;
  min-height: 100%;
  object-fit: cover;
  width: 100%;
}

a.badge-dark, a.badge-info, a.badge-warning, a.badge-danger, a.badge-success, a.btn-dark, a.btn-success, a.btn-warning, a.btn-danger, a.btn-info {
  color: #fff !important;
}
a.badge-dark:hover, a.badge-info:hover, a.badge-warning:hover, a.badge-danger:hover, a.badge-success:hover, a.btn-dark:hover, a.btn-success:hover, a.btn-warning:hover, a.btn-danger:hover, a.btn-info:hover, a.badge-dark:focus, a.badge-info:focus, a.badge-warning:focus, a.badge-danger:focus, a.badge-success:focus, a.btn-dark:focus, a.btn-success:focus, a.btn-warning:focus, a.btn-danger:focus, a.btn-info:focus {
  color: #fff !important;
}

.carousel-control-next, .carousel-control-prev {
  cursor: pointer;
}

.btn:not([disabled]):not(.disabled):active,
.btn-info:not([disabled]):not(.disabled):active,
.btn-success:not([disabled]):not(.disabled):active,
.btn-warning:not([disabled]):not(.disabled):active,
.btn-danger:not([disabled]):not(.disabled):active,
.btn-light:not([disabled]):not(.disabled):active,
.btn-dark:not([disabled]):not(.disabled):active,
.btn-primary:not([disabled]):not(.disabled):active,
.btn-secondary:not([disabled]):not(.disabled):active, .btn:not([disabled]):not(.disabled).active,
.btn-info:not([disabled]):not(.disabled).active,
.btn-success:not([disabled]):not(.disabled).active,
.btn-warning:not([disabled]):not(.disabled).active,
.btn-danger:not([disabled]):not(.disabled).active,
.btn-light:not([disabled]):not(.disabled).active,
.btn-dark:not([disabled]):not(.disabled).active,
.btn-primary:not([disabled]):not(.disabled).active,
.btn-secondary:not([disabled]):not(.disabled).active {
  background-image: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}
.btn:not([disabled]):not(.disabled):active:focus,
.btn-info:not([disabled]):not(.disabled):active:focus,
.btn-success:not([disabled]):not(.disabled):active:focus,
.btn-warning:not([disabled]):not(.disabled):active:focus,
.btn-danger:not([disabled]):not(.disabled):active:focus,
.btn-light:not([disabled]):not(.disabled):active:focus,
.btn-dark:not([disabled]):not(.disabled):active:focus,
.btn-primary:not([disabled]):not(.disabled):active:focus,
.btn-secondary:not([disabled]):not(.disabled):active:focus, .btn:not([disabled]):not(.disabled).active:focus,
.btn-info:not([disabled]):not(.disabled).active:focus,
.btn-success:not([disabled]):not(.disabled).active:focus,
.btn-warning:not([disabled]):not(.disabled).active:focus,
.btn-danger:not([disabled]):not(.disabled).active:focus,
.btn-light:not([disabled]):not(.disabled).active:focus,
.btn-dark:not([disabled]):not(.disabled).active:focus,
.btn-primary:not([disabled]):not(.disabled).active:focus,
.btn-secondary:not([disabled]):not(.disabled).active:focus {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.mw-25 {
  max-width: 25% !important;
}

.mw-50 {
  max-width: 50% !important;
}

.mw-75 {
  max-width: 75% !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-25 {
  max-height: 25% !important;
}

.mh-50 {
  max-height: 50% !important;
}

.mh-75 {
  max-height: 75% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.bg-primary {
  background-color: #3f51b5 !important;
}

.text-primary {
  color: #3f51b5 !important;
}
.text-primary.icon-outline {
  border-color: #3f51b5 !important;
}

.bg-primary.lighten-5 {
  background-color: #e8eaf6 !important;
}

.text-primary.text-lighten-5 {
  color: #e8eaf6 !important;
}
.text-primary.text-lighten-5.icon-outline {
  border-color: #e8eaf6 !important;
}

.bg-primary.lighten-4 {
  background-color: #c5cae9 !important;
}

.text-primary.text-lighten-4 {
  color: #c5cae9 !important;
}
.text-primary.text-lighten-4.icon-outline {
  border-color: #c5cae9 !important;
}

.bg-primary.lighten-3 {
  background-color: #9fa8da !important;
}

.text-primary.text-lighten-3 {
  color: #9fa8da !important;
}
.text-primary.text-lighten-3.icon-outline {
  border-color: #9fa8da !important;
}

.bg-primary.lighten-2 {
  background-color: #7986cb !important;
}

.text-primary.text-lighten-2 {
  color: #7986cb !important;
}
.text-primary.text-lighten-2.icon-outline {
  border-color: #7986cb !important;
}

.bg-primary.lighten-1 {
  background-color: #5c6bc0 !important;
}

.text-primary.text-lighten-1 {
  color: #5c6bc0 !important;
}
.text-primary.text-lighten-1.icon-outline {
  border-color: #5c6bc0 !important;
}

.bg-primary.darken-1 {
  background-color: #3949ab !important;
}

.text-primary.text-darken-1 {
  color: #3949ab !important;
}
.text-primary.text-darken-1.icon-outline {
  border-color: #3949ab !important;
}

.bg-primary.darken-2 {
  background-color: #303f9f !important;
}

.text-primary.text-darken-2 {
  color: #303f9f !important;
}
.text-primary.text-darken-2.icon-outline {
  border-color: #303f9f !important;
}

.bg-primary.darken-3 {
  background-color: #283593 !important;
}

.text-primary.text-darken-3 {
  color: #283593 !important;
}
.text-primary.text-darken-3.icon-outline {
  border-color: #283593 !important;
}

.bg-primary.darken-4 {
  background-color: #1a237e !important;
}

.text-primary.text-darken-4 {
  color: #1a237e !important;
}
.text-primary.text-darken-4.icon-outline {
  border-color: #1a237e !important;
}

.bg-primary.accent-1 {
  background-color: #8c9eff !important;
}

.text-primary.text-accent-1 {
  color: #8c9eff !important;
}
.text-primary.text-accent-1.icon-outline {
  border-color: #8c9eff !important;
}

.bg-primary.accent-2 {
  background-color: #536dfe !important;
}

.text-primary.text-accent-2 {
  color: #536dfe !important;
}
.text-primary.text-accent-2.icon-outline {
  border-color: #536dfe !important;
}

.bg-primary.accent-3 {
  background-color: #3d5afe !important;
}

.text-primary.text-accent-3 {
  color: #3d5afe !important;
}
.text-primary.text-accent-3.icon-outline {
  border-color: #3d5afe !important;
}

.bg-primary.accent-4 {
  background-color: #304ffe !important;
}

.text-primary.text-accent-4 {
  color: #304ffe !important;
}
.text-primary.text-accent-4.icon-outline {
  border-color: #304ffe !important;
}

.bg-red {
  background-color: #F44336 !important;
}

.text-red {
  color: #F44336 !important;
}
.text-red.icon-outline {
  border-color: #F44336 !important;
}

.bg-red.lighten-5 {
  background-color: #FFEBEE !important;
}

.text-red.text-lighten-5 {
  color: #FFEBEE !important;
}
.text-red.text-lighten-5.icon-outline {
  border-color: #FFEBEE !important;
}

.bg-red.lighten-4 {
  background-color: #FFCDD2 !important;
}

.text-red.text-lighten-4 {
  color: #FFCDD2 !important;
}
.text-red.text-lighten-4.icon-outline {
  border-color: #FFCDD2 !important;
}

.bg-red.lighten-3 {
  background-color: #EF9A9A !important;
}

.text-red.text-lighten-3 {
  color: #EF9A9A !important;
}
.text-red.text-lighten-3.icon-outline {
  border-color: #EF9A9A !important;
}

.bg-red.lighten-2 {
  background-color: #E57373 !important;
}

.text-red.text-lighten-2 {
  color: #E57373 !important;
}
.text-red.text-lighten-2.icon-outline {
  border-color: #E57373 !important;
}

.bg-red.lighten-1 {
  background-color: #EF5350 !important;
}

.text-red.text-lighten-1 {
  color: #EF5350 !important;
}
.text-red.text-lighten-1.icon-outline {
  border-color: #EF5350 !important;
}

.bg-red.darken-1 {
  background-color: #E53935 !important;
}

.text-red.text-darken-1 {
  color: #E53935 !important;
}
.text-red.text-darken-1.icon-outline {
  border-color: #E53935 !important;
}

.bg-red.darken-2 {
  background-color: #D32F2F !important;
}

.text-red.text-darken-2 {
  color: #D32F2F !important;
}
.text-red.text-darken-2.icon-outline {
  border-color: #D32F2F !important;
}

.bg-red.darken-3 {
  background-color: #C62828 !important;
}

.text-red.text-darken-3 {
  color: #C62828 !important;
}
.text-red.text-darken-3.icon-outline {
  border-color: #C62828 !important;
}

.bg-red.darken-4 {
  background-color: #B71C1C !important;
}

.text-red.text-darken-4 {
  color: #B71C1C !important;
}
.text-red.text-darken-4.icon-outline {
  border-color: #B71C1C !important;
}

.bg-red.accent-1 {
  background-color: #FF8A80 !important;
}

.text-red.text-accent-1 {
  color: #FF8A80 !important;
}
.text-red.text-accent-1.icon-outline {
  border-color: #FF8A80 !important;
}

.bg-red.accent-2 {
  background-color: #FF5252 !important;
}

.text-red.text-accent-2 {
  color: #FF5252 !important;
}
.text-red.text-accent-2.icon-outline {
  border-color: #FF5252 !important;
}

.bg-red.accent-3 {
  background-color: #FF1744 !important;
}

.text-red.text-accent-3 {
  color: #FF1744 !important;
}
.text-red.text-accent-3.icon-outline {
  border-color: #FF1744 !important;
}

.bg-red.accent-4 {
  background-color: #D50000 !important;
}

.text-red.text-accent-4 {
  color: #D50000 !important;
}
.text-red.text-accent-4.icon-outline {
  border-color: #D50000 !important;
}

.bg-pink {
  background-color: #e91e63 !important;
}

.text-pink {
  color: #e91e63 !important;
}
.text-pink.icon-outline {
  border-color: #e91e63 !important;
}

.bg-pink.lighten-5 {
  background-color: #fce4ec !important;
}

.text-pink.text-lighten-5 {
  color: #fce4ec !important;
}
.text-pink.text-lighten-5.icon-outline {
  border-color: #fce4ec !important;
}

.bg-pink.lighten-4 {
  background-color: #f8bbd0 !important;
}

.text-pink.text-lighten-4 {
  color: #f8bbd0 !important;
}
.text-pink.text-lighten-4.icon-outline {
  border-color: #f8bbd0 !important;
}

.bg-pink.lighten-3 {
  background-color: #f48fb1 !important;
}

.text-pink.text-lighten-3 {
  color: #f48fb1 !important;
}
.text-pink.text-lighten-3.icon-outline {
  border-color: #f48fb1 !important;
}

.bg-pink.lighten-2 {
  background-color: #f06292 !important;
}

.text-pink.text-lighten-2 {
  color: #f06292 !important;
}
.text-pink.text-lighten-2.icon-outline {
  border-color: #f06292 !important;
}

.bg-pink.lighten-1 {
  background-color: #ec407a !important;
}

.text-pink.text-lighten-1 {
  color: #ec407a !important;
}
.text-pink.text-lighten-1.icon-outline {
  border-color: #ec407a !important;
}

.bg-pink.darken-1 {
  background-color: #d81b60 !important;
}

.text-pink.text-darken-1 {
  color: #d81b60 !important;
}
.text-pink.text-darken-1.icon-outline {
  border-color: #d81b60 !important;
}

.bg-pink.darken-2 {
  background-color: #c2185b !important;
}

.text-pink.text-darken-2 {
  color: #c2185b !important;
}
.text-pink.text-darken-2.icon-outline {
  border-color: #c2185b !important;
}

.bg-pink.darken-3 {
  background-color: #ad1457 !important;
}

.text-pink.text-darken-3 {
  color: #ad1457 !important;
}
.text-pink.text-darken-3.icon-outline {
  border-color: #ad1457 !important;
}

.bg-pink.darken-4 {
  background-color: #880e4f !important;
}

.text-pink.text-darken-4 {
  color: #880e4f !important;
}
.text-pink.text-darken-4.icon-outline {
  border-color: #880e4f !important;
}

.bg-pink.accent-1 {
  background-color: #ff80ab !important;
}

.text-pink.text-accent-1 {
  color: #ff80ab !important;
}
.text-pink.text-accent-1.icon-outline {
  border-color: #ff80ab !important;
}

.bg-pink.accent-2 {
  background-color: #ff4081 !important;
}

.text-pink.text-accent-2 {
  color: #ff4081 !important;
}
.text-pink.text-accent-2.icon-outline {
  border-color: #ff4081 !important;
}

.bg-pink.accent-3 {
  background-color: #f50057 !important;
}

.text-pink.text-accent-3 {
  color: #f50057 !important;
}
.text-pink.text-accent-3.icon-outline {
  border-color: #f50057 !important;
}

.bg-pink.accent-4 {
  background-color: #c51162 !important;
}

.text-pink.text-accent-4 {
  color: #c51162 !important;
}
.text-pink.text-accent-4.icon-outline {
  border-color: #c51162 !important;
}

.bg-purple {
  background-color: #9C27B0 !important;
}

.text-purple {
  color: #9C27B0 !important;
}
.text-purple.icon-outline {
  border-color: #9C27B0 !important;
}

.bg-purple.lighten-5 {
  background-color: #f3e5f5 !important;
}

.text-purple.text-lighten-5 {
  color: #f3e5f5 !important;
}
.text-purple.text-lighten-5.icon-outline {
  border-color: #f3e5f5 !important;
}

.bg-purple.lighten-4 {
  background-color: #e1bee7 !important;
}

.text-purple.text-lighten-4 {
  color: #e1bee7 !important;
}
.text-purple.text-lighten-4.icon-outline {
  border-color: #e1bee7 !important;
}

.bg-purple.lighten-3 {
  background-color: #ce93d8 !important;
}

.text-purple.text-lighten-3 {
  color: #ce93d8 !important;
}
.text-purple.text-lighten-3.icon-outline {
  border-color: #ce93d8 !important;
}

.bg-purple.lighten-2 {
  background-color: #ba68c8 !important;
}

.text-purple.text-lighten-2 {
  color: #ba68c8 !important;
}
.text-purple.text-lighten-2.icon-outline {
  border-color: #ba68c8 !important;
}

.bg-purple.lighten-1 {
  background-color: #ab47bc !important;
}

.text-purple.text-lighten-1 {
  color: #ab47bc !important;
}
.text-purple.text-lighten-1.icon-outline {
  border-color: #ab47bc !important;
}

.bg-purple.darken-1 {
  background-color: #8e24aa !important;
}

.text-purple.text-darken-1 {
  color: #8e24aa !important;
}
.text-purple.text-darken-1.icon-outline {
  border-color: #8e24aa !important;
}

.bg-purple.darken-2 {
  background-color: #7b1fa2 !important;
}

.text-purple.text-darken-2 {
  color: #7b1fa2 !important;
}
.text-purple.text-darken-2.icon-outline {
  border-color: #7b1fa2 !important;
}

.bg-purple.darken-3 {
  background-color: #6a1b9a !important;
}

.text-purple.text-darken-3 {
  color: #6a1b9a !important;
}
.text-purple.text-darken-3.icon-outline {
  border-color: #6a1b9a !important;
}

.bg-purple.darken-4 {
  background-color: #4a148c !important;
}

.text-purple.text-darken-4 {
  color: #4a148c !important;
}
.text-purple.text-darken-4.icon-outline {
  border-color: #4a148c !important;
}

.bg-purple.accent-1 {
  background-color: #ea80fc !important;
}

.text-purple.text-accent-1 {
  color: #ea80fc !important;
}
.text-purple.text-accent-1.icon-outline {
  border-color: #ea80fc !important;
}

.bg-purple.accent-2 {
  background-color: #e040fb !important;
}

.text-purple.text-accent-2 {
  color: #e040fb !important;
}
.text-purple.text-accent-2.icon-outline {
  border-color: #e040fb !important;
}

.bg-purple.accent-3 {
  background-color: #d500f9 !important;
}

.text-purple.text-accent-3 {
  color: #d500f9 !important;
}
.text-purple.text-accent-3.icon-outline {
  border-color: #d500f9 !important;
}

.bg-purple.accent-4 {
  background-color: #aa00ff !important;
}

.text-purple.text-accent-4 {
  color: #aa00ff !important;
}
.text-purple.text-accent-4.icon-outline {
  border-color: #aa00ff !important;
}

.bg-deep-purple {
  background-color: #673ab7 !important;
}

.text-deep-purple {
  color: #673ab7 !important;
}
.text-deep-purple.icon-outline {
  border-color: #673ab7 !important;
}

.bg-deep-purple.lighten-5 {
  background-color: #ede7f6 !important;
}

.text-deep-purple.text-lighten-5 {
  color: #ede7f6 !important;
}
.text-deep-purple.text-lighten-5.icon-outline {
  border-color: #ede7f6 !important;
}

.bg-deep-purple.lighten-4 {
  background-color: #d1c4e9 !important;
}

.text-deep-purple.text-lighten-4 {
  color: #d1c4e9 !important;
}
.text-deep-purple.text-lighten-4.icon-outline {
  border-color: #d1c4e9 !important;
}

.bg-deep-purple.lighten-3 {
  background-color: #b39ddb !important;
}

.text-deep-purple.text-lighten-3 {
  color: #b39ddb !important;
}
.text-deep-purple.text-lighten-3.icon-outline {
  border-color: #b39ddb !important;
}

.bg-deep-purple.lighten-2 {
  background-color: #9575cd !important;
}

.text-deep-purple.text-lighten-2 {
  color: #9575cd !important;
}
.text-deep-purple.text-lighten-2.icon-outline {
  border-color: #9575cd !important;
}

.bg-deep-purple.lighten-1 {
  background-color: #7e57c2 !important;
}

.text-deep-purple.text-lighten-1 {
  color: #7e57c2 !important;
}
.text-deep-purple.text-lighten-1.icon-outline {
  border-color: #7e57c2 !important;
}

.bg-deep-purple.darken-1 {
  background-color: #5e35b1 !important;
}

.text-deep-purple.text-darken-1 {
  color: #5e35b1 !important;
}
.text-deep-purple.text-darken-1.icon-outline {
  border-color: #5e35b1 !important;
}

.bg-deep-purple.darken-2 {
  background-color: #512da8 !important;
}

.text-deep-purple.text-darken-2 {
  color: #512da8 !important;
}
.text-deep-purple.text-darken-2.icon-outline {
  border-color: #512da8 !important;
}

.bg-deep-purple.darken-3 {
  background-color: #4527a0 !important;
}

.text-deep-purple.text-darken-3 {
  color: #4527a0 !important;
}
.text-deep-purple.text-darken-3.icon-outline {
  border-color: #4527a0 !important;
}

.bg-deep-purple.darken-4 {
  background-color: #311b92 !important;
}

.text-deep-purple.text-darken-4 {
  color: #311b92 !important;
}
.text-deep-purple.text-darken-4.icon-outline {
  border-color: #311b92 !important;
}

.bg-deep-purple.accent-1 {
  background-color: #b388ff !important;
}

.text-deep-purple.text-accent-1 {
  color: #b388ff !important;
}
.text-deep-purple.text-accent-1.icon-outline {
  border-color: #b388ff !important;
}

.bg-deep-purple.accent-2 {
  background-color: #7c4dff !important;
}

.text-deep-purple.text-accent-2 {
  color: #7c4dff !important;
}
.text-deep-purple.text-accent-2.icon-outline {
  border-color: #7c4dff !important;
}

.bg-deep-purple.accent-3 {
  background-color: #651fff !important;
}

.text-deep-purple.text-accent-3 {
  color: #651fff !important;
}
.text-deep-purple.text-accent-3.icon-outline {
  border-color: #651fff !important;
}

.bg-deep-purple.accent-4 {
  background-color: #6200ea !important;
}

.text-deep-purple.text-accent-4 {
  color: #6200ea !important;
}
.text-deep-purple.text-accent-4.icon-outline {
  border-color: #6200ea !important;
}

.bg-indigo {
  background-color: #3f51b5 !important;
}

.text-indigo {
  color: #3f51b5 !important;
}
.text-indigo.icon-outline {
  border-color: #3f51b5 !important;
}

.bg-indigo.lighten-5 {
  background-color: #e8eaf6 !important;
}

.text-indigo.text-lighten-5 {
  color: #e8eaf6 !important;
}
.text-indigo.text-lighten-5.icon-outline {
  border-color: #e8eaf6 !important;
}

.bg-indigo.lighten-4 {
  background-color: #c5cae9 !important;
}

.text-indigo.text-lighten-4 {
  color: #c5cae9 !important;
}
.text-indigo.text-lighten-4.icon-outline {
  border-color: #c5cae9 !important;
}

.bg-indigo.lighten-3 {
  background-color: #9fa8da !important;
}

.text-indigo.text-lighten-3 {
  color: #9fa8da !important;
}
.text-indigo.text-lighten-3.icon-outline {
  border-color: #9fa8da !important;
}

.bg-indigo.lighten-2 {
  background-color: #7986cb !important;
}

.text-indigo.text-lighten-2 {
  color: #7986cb !important;
}
.text-indigo.text-lighten-2.icon-outline {
  border-color: #7986cb !important;
}

.bg-indigo.lighten-1 {
  background-color: #5c6bc0 !important;
}

.text-indigo.text-lighten-1 {
  color: #5c6bc0 !important;
}
.text-indigo.text-lighten-1.icon-outline {
  border-color: #5c6bc0 !important;
}

.bg-indigo.darken-1 {
  background-color: #3949ab !important;
}

.text-indigo.text-darken-1 {
  color: #3949ab !important;
}
.text-indigo.text-darken-1.icon-outline {
  border-color: #3949ab !important;
}

.bg-indigo.darken-2 {
  background-color: #303f9f !important;
}

.text-indigo.text-darken-2 {
  color: #303f9f !important;
}
.text-indigo.text-darken-2.icon-outline {
  border-color: #303f9f !important;
}

.bg-indigo.darken-3 {
  background-color: #283593 !important;
}

.text-indigo.text-darken-3 {
  color: #283593 !important;
}
.text-indigo.text-darken-3.icon-outline {
  border-color: #283593 !important;
}

.bg-indigo.darken-4 {
  background-color: #1a237e !important;
}

.text-indigo.text-darken-4 {
  color: #1a237e !important;
}
.text-indigo.text-darken-4.icon-outline {
  border-color: #1a237e !important;
}

.bg-indigo.accent-1 {
  background-color: #8c9eff !important;
}

.text-indigo.text-accent-1 {
  color: #8c9eff !important;
}
.text-indigo.text-accent-1.icon-outline {
  border-color: #8c9eff !important;
}

.bg-indigo.accent-2 {
  background-color: #536dfe !important;
}

.text-indigo.text-accent-2 {
  color: #536dfe !important;
}
.text-indigo.text-accent-2.icon-outline {
  border-color: #536dfe !important;
}

.bg-indigo.accent-3 {
  background-color: #3d5afe !important;
}

.text-indigo.text-accent-3 {
  color: #3d5afe !important;
}
.text-indigo.text-accent-3.icon-outline {
  border-color: #3d5afe !important;
}

.bg-indigo.accent-4 {
  background-color: #304ffe !important;
}

.text-indigo.text-accent-4 {
  color: #304ffe !important;
}
.text-indigo.text-accent-4.icon-outline {
  border-color: #304ffe !important;
}

.bg-blue {
  background-color: #2196F3 !important;
}

.text-blue {
  color: #2196F3 !important;
}
.text-blue.icon-outline {
  border-color: #2196F3 !important;
}

.bg-blue.lighten-5 {
  background-color: #E3F2FD !important;
}

.text-blue.text-lighten-5 {
  color: #E3F2FD !important;
}
.text-blue.text-lighten-5.icon-outline {
  border-color: #E3F2FD !important;
}

.bg-blue.lighten-4 {
  background-color: #BBDEFB !important;
}

.text-blue.text-lighten-4 {
  color: #BBDEFB !important;
}
.text-blue.text-lighten-4.icon-outline {
  border-color: #BBDEFB !important;
}

.bg-blue.lighten-3 {
  background-color: #90CAF9 !important;
}

.text-blue.text-lighten-3 {
  color: #90CAF9 !important;
}
.text-blue.text-lighten-3.icon-outline {
  border-color: #90CAF9 !important;
}

.bg-blue.lighten-2 {
  background-color: #64B5F6 !important;
}

.text-blue.text-lighten-2 {
  color: #64B5F6 !important;
}
.text-blue.text-lighten-2.icon-outline {
  border-color: #64B5F6 !important;
}

.bg-blue.lighten-1 {
  background-color: #42A5F5 !important;
}

.text-blue.text-lighten-1 {
  color: #42A5F5 !important;
}
.text-blue.text-lighten-1.icon-outline {
  border-color: #42A5F5 !important;
}

.bg-blue.darken-1 {
  background-color: #1E88E5 !important;
}

.text-blue.text-darken-1 {
  color: #1E88E5 !important;
}
.text-blue.text-darken-1.icon-outline {
  border-color: #1E88E5 !important;
}

.bg-blue.darken-2 {
  background-color: #1976D2 !important;
}

.text-blue.text-darken-2 {
  color: #1976D2 !important;
}
.text-blue.text-darken-2.icon-outline {
  border-color: #1976D2 !important;
}

.bg-blue.darken-3 {
  background-color: #1565C0 !important;
}

.text-blue.text-darken-3 {
  color: #1565C0 !important;
}
.text-blue.text-darken-3.icon-outline {
  border-color: #1565C0 !important;
}

.bg-blue.darken-4 {
  background-color: #0D47A1 !important;
}

.text-blue.text-darken-4 {
  color: #0D47A1 !important;
}
.text-blue.text-darken-4.icon-outline {
  border-color: #0D47A1 !important;
}

.bg-blue.accent-1 {
  background-color: #82B1FF !important;
}

.text-blue.text-accent-1 {
  color: #82B1FF !important;
}
.text-blue.text-accent-1.icon-outline {
  border-color: #82B1FF !important;
}

.bg-blue.accent-2 {
  background-color: #448AFF !important;
}

.text-blue.text-accent-2 {
  color: #448AFF !important;
}
.text-blue.text-accent-2.icon-outline {
  border-color: #448AFF !important;
}

.bg-blue.accent-3 {
  background-color: #2979FF !important;
}

.text-blue.text-accent-3 {
  color: #2979FF !important;
}
.text-blue.text-accent-3.icon-outline {
  border-color: #2979FF !important;
}

.bg-blue.accent-4 {
  background-color: #2962FF !important;
}

.text-blue.text-accent-4 {
  color: #2962FF !important;
}
.text-blue.text-accent-4.icon-outline {
  border-color: #2962FF !important;
}

.bg-light-blue {
  background-color: #03a9f4 !important;
}

.text-light-blue {
  color: #03a9f4 !important;
}
.text-light-blue.icon-outline {
  border-color: #03a9f4 !important;
}

.bg-light-blue.lighten-5 {
  background-color: #e1f5fe !important;
}

.text-light-blue.text-lighten-5 {
  color: #e1f5fe !important;
}
.text-light-blue.text-lighten-5.icon-outline {
  border-color: #e1f5fe !important;
}

.bg-light-blue.lighten-4 {
  background-color: #b3e5fc !important;
}

.text-light-blue.text-lighten-4 {
  color: #b3e5fc !important;
}
.text-light-blue.text-lighten-4.icon-outline {
  border-color: #b3e5fc !important;
}

.bg-light-blue.lighten-3 {
  background-color: #81d4fa !important;
}

.text-light-blue.text-lighten-3 {
  color: #81d4fa !important;
}
.text-light-blue.text-lighten-3.icon-outline {
  border-color: #81d4fa !important;
}

.bg-light-blue.lighten-2 {
  background-color: #4fc3f7 !important;
}

.text-light-blue.text-lighten-2 {
  color: #4fc3f7 !important;
}
.text-light-blue.text-lighten-2.icon-outline {
  border-color: #4fc3f7 !important;
}

.bg-light-blue.lighten-1 {
  background-color: #29b6f6 !important;
}

.text-light-blue.text-lighten-1 {
  color: #29b6f6 !important;
}
.text-light-blue.text-lighten-1.icon-outline {
  border-color: #29b6f6 !important;
}

.bg-light-blue.darken-1 {
  background-color: #039be5 !important;
}

.text-light-blue.text-darken-1 {
  color: #039be5 !important;
}
.text-light-blue.text-darken-1.icon-outline {
  border-color: #039be5 !important;
}

.bg-light-blue.darken-2 {
  background-color: #0288d1 !important;
}

.text-light-blue.text-darken-2 {
  color: #0288d1 !important;
}
.text-light-blue.text-darken-2.icon-outline {
  border-color: #0288d1 !important;
}

.bg-light-blue.darken-3 {
  background-color: #0277bd !important;
}

.text-light-blue.text-darken-3 {
  color: #0277bd !important;
}
.text-light-blue.text-darken-3.icon-outline {
  border-color: #0277bd !important;
}

.bg-light-blue.darken-4 {
  background-color: #01579b !important;
}

.text-light-blue.text-darken-4 {
  color: #01579b !important;
}
.text-light-blue.text-darken-4.icon-outline {
  border-color: #01579b !important;
}

.bg-light-blue.accent-1 {
  background-color: #80d8ff !important;
}

.text-light-blue.text-accent-1 {
  color: #80d8ff !important;
}
.text-light-blue.text-accent-1.icon-outline {
  border-color: #80d8ff !important;
}

.bg-light-blue.accent-2 {
  background-color: #40c4ff !important;
}

.text-light-blue.text-accent-2 {
  color: #40c4ff !important;
}
.text-light-blue.text-accent-2.icon-outline {
  border-color: #40c4ff !important;
}

.bg-light-blue.accent-3 {
  background-color: #00b0ff !important;
}

.text-light-blue.text-accent-3 {
  color: #00b0ff !important;
}
.text-light-blue.text-accent-3.icon-outline {
  border-color: #00b0ff !important;
}

.bg-light-blue.accent-4 {
  background-color: #0091ea !important;
}

.text-light-blue.text-accent-4 {
  color: #0091ea !important;
}
.text-light-blue.text-accent-4.icon-outline {
  border-color: #0091ea !important;
}

.bg-cyan {
  background-color: #00bcd4 !important;
}

.text-cyan {
  color: #00bcd4 !important;
}
.text-cyan.icon-outline {
  border-color: #00bcd4 !important;
}

.bg-cyan.lighten-5 {
  background-color: #e0f7fa !important;
}

.text-cyan.text-lighten-5 {
  color: #e0f7fa !important;
}
.text-cyan.text-lighten-5.icon-outline {
  border-color: #e0f7fa !important;
}

.bg-cyan.lighten-4 {
  background-color: #b2ebf2 !important;
}

.text-cyan.text-lighten-4 {
  color: #b2ebf2 !important;
}
.text-cyan.text-lighten-4.icon-outline {
  border-color: #b2ebf2 !important;
}

.bg-cyan.lighten-3 {
  background-color: #80deea !important;
}

.text-cyan.text-lighten-3 {
  color: #80deea !important;
}
.text-cyan.text-lighten-3.icon-outline {
  border-color: #80deea !important;
}

.bg-cyan.lighten-2 {
  background-color: #4dd0e1 !important;
}

.text-cyan.text-lighten-2 {
  color: #4dd0e1 !important;
}
.text-cyan.text-lighten-2.icon-outline {
  border-color: #4dd0e1 !important;
}

.bg-cyan.lighten-1 {
  background-color: #26c6da !important;
}

.text-cyan.text-lighten-1 {
  color: #26c6da !important;
}
.text-cyan.text-lighten-1.icon-outline {
  border-color: #26c6da !important;
}

.bg-cyan.darken-1 {
  background-color: #00acc1 !important;
}

.text-cyan.text-darken-1 {
  color: #00acc1 !important;
}
.text-cyan.text-darken-1.icon-outline {
  border-color: #00acc1 !important;
}

.bg-cyan.darken-2 {
  background-color: #0097a7 !important;
}

.text-cyan.text-darken-2 {
  color: #0097a7 !important;
}
.text-cyan.text-darken-2.icon-outline {
  border-color: #0097a7 !important;
}

.bg-cyan.darken-3 {
  background-color: #00838f !important;
}

.text-cyan.text-darken-3 {
  color: #00838f !important;
}
.text-cyan.text-darken-3.icon-outline {
  border-color: #00838f !important;
}

.bg-cyan.darken-4 {
  background-color: #006064 !important;
}

.text-cyan.text-darken-4 {
  color: #006064 !important;
}
.text-cyan.text-darken-4.icon-outline {
  border-color: #006064 !important;
}

.bg-cyan.accent-1 {
  background-color: #84ffff !important;
}

.text-cyan.text-accent-1 {
  color: #84ffff !important;
}
.text-cyan.text-accent-1.icon-outline {
  border-color: #84ffff !important;
}

.bg-cyan.accent-2 {
  background-color: #18ffff !important;
}

.text-cyan.text-accent-2 {
  color: #18ffff !important;
}
.text-cyan.text-accent-2.icon-outline {
  border-color: #18ffff !important;
}

.bg-cyan.accent-3 {
  background-color: #00e5ff !important;
}

.text-cyan.text-accent-3 {
  color: #00e5ff !important;
}
.text-cyan.text-accent-3.icon-outline {
  border-color: #00e5ff !important;
}

.bg-cyan.accent-4 {
  background-color: #00b8d4 !important;
}

.text-cyan.text-accent-4 {
  color: #00b8d4 !important;
}
.text-cyan.text-accent-4.icon-outline {
  border-color: #00b8d4 !important;
}

.bg-teal {
  background-color: #009688 !important;
}

.text-teal {
  color: #009688 !important;
}
.text-teal.icon-outline {
  border-color: #009688 !important;
}

.bg-teal.lighten-5 {
  background-color: #e0f2f1 !important;
}

.text-teal.text-lighten-5 {
  color: #e0f2f1 !important;
}
.text-teal.text-lighten-5.icon-outline {
  border-color: #e0f2f1 !important;
}

.bg-teal.lighten-4 {
  background-color: #b2dfdb !important;
}

.text-teal.text-lighten-4 {
  color: #b2dfdb !important;
}
.text-teal.text-lighten-4.icon-outline {
  border-color: #b2dfdb !important;
}

.bg-teal.lighten-3 {
  background-color: #80cbc4 !important;
}

.text-teal.text-lighten-3 {
  color: #80cbc4 !important;
}
.text-teal.text-lighten-3.icon-outline {
  border-color: #80cbc4 !important;
}

.bg-teal.lighten-2 {
  background-color: #4db6ac !important;
}

.text-teal.text-lighten-2 {
  color: #4db6ac !important;
}
.text-teal.text-lighten-2.icon-outline {
  border-color: #4db6ac !important;
}

.bg-teal.lighten-1 {
  background-color: #26a69a !important;
}

.text-teal.text-lighten-1 {
  color: #26a69a !important;
}
.text-teal.text-lighten-1.icon-outline {
  border-color: #26a69a !important;
}

.bg-teal.darken-1 {
  background-color: #00897b !important;
}

.text-teal.text-darken-1 {
  color: #00897b !important;
}
.text-teal.text-darken-1.icon-outline {
  border-color: #00897b !important;
}

.bg-teal.darken-2 {
  background-color: #00796b !important;
}

.text-teal.text-darken-2 {
  color: #00796b !important;
}
.text-teal.text-darken-2.icon-outline {
  border-color: #00796b !important;
}

.bg-teal.darken-3 {
  background-color: #00695c !important;
}

.text-teal.text-darken-3 {
  color: #00695c !important;
}
.text-teal.text-darken-3.icon-outline {
  border-color: #00695c !important;
}

.bg-teal.darken-4 {
  background-color: #004d40 !important;
}

.text-teal.text-darken-4 {
  color: #004d40 !important;
}
.text-teal.text-darken-4.icon-outline {
  border-color: #004d40 !important;
}

.bg-teal.accent-1 {
  background-color: #a7ffeb !important;
}

.text-teal.text-accent-1 {
  color: #a7ffeb !important;
}
.text-teal.text-accent-1.icon-outline {
  border-color: #a7ffeb !important;
}

.bg-teal.accent-2 {
  background-color: #64ffda !important;
}

.text-teal.text-accent-2 {
  color: #64ffda !important;
}
.text-teal.text-accent-2.icon-outline {
  border-color: #64ffda !important;
}

.bg-teal.accent-3 {
  background-color: #1de9b6 !important;
}

.text-teal.text-accent-3 {
  color: #1de9b6 !important;
}
.text-teal.text-accent-3.icon-outline {
  border-color: #1de9b6 !important;
}

.bg-teal.accent-4 {
  background-color: #00bfa5 !important;
}

.text-teal.text-accent-4 {
  color: #00bfa5 !important;
}
.text-teal.text-accent-4.icon-outline {
  border-color: #00bfa5 !important;
}

.bg-green {
  background-color: #4CAF50 !important;
}

.text-green {
  color: #4CAF50 !important;
}
.text-green.icon-outline {
  border-color: #4CAF50 !important;
}

.bg-green.lighten-5 {
  background-color: #E8F5E9 !important;
}

.text-green.text-lighten-5 {
  color: #E8F5E9 !important;
}
.text-green.text-lighten-5.icon-outline {
  border-color: #E8F5E9 !important;
}

.bg-green.lighten-4 {
  background-color: #C8E6C9 !important;
}

.text-green.text-lighten-4 {
  color: #C8E6C9 !important;
}
.text-green.text-lighten-4.icon-outline {
  border-color: #C8E6C9 !important;
}

.bg-green.lighten-3 {
  background-color: #A5D6A7 !important;
}

.text-green.text-lighten-3 {
  color: #A5D6A7 !important;
}
.text-green.text-lighten-3.icon-outline {
  border-color: #A5D6A7 !important;
}

.bg-green.lighten-2 {
  background-color: #81C784 !important;
}

.text-green.text-lighten-2 {
  color: #81C784 !important;
}
.text-green.text-lighten-2.icon-outline {
  border-color: #81C784 !important;
}

.bg-green.lighten-1 {
  background-color: #66BB6A !important;
}

.text-green.text-lighten-1 {
  color: #66BB6A !important;
}
.text-green.text-lighten-1.icon-outline {
  border-color: #66BB6A !important;
}

.bg-green.darken-1 {
  background-color: #43A047 !important;
}

.text-green.text-darken-1 {
  color: #43A047 !important;
}
.text-green.text-darken-1.icon-outline {
  border-color: #43A047 !important;
}

.bg-green.darken-2 {
  background-color: #388E3C !important;
}

.text-green.text-darken-2 {
  color: #388E3C !important;
}
.text-green.text-darken-2.icon-outline {
  border-color: #388E3C !important;
}

.bg-green.darken-3 {
  background-color: #2E7D32 !important;
}

.text-green.text-darken-3 {
  color: #2E7D32 !important;
}
.text-green.text-darken-3.icon-outline {
  border-color: #2E7D32 !important;
}

.bg-green.darken-4 {
  background-color: #1B5E20 !important;
}

.text-green.text-darken-4 {
  color: #1B5E20 !important;
}
.text-green.text-darken-4.icon-outline {
  border-color: #1B5E20 !important;
}

.bg-green.accent-1 {
  background-color: #B9F6CA !important;
}

.text-green.text-accent-1 {
  color: #B9F6CA !important;
}
.text-green.text-accent-1.icon-outline {
  border-color: #B9F6CA !important;
}

.bg-green.accent-2 {
  background-color: #69F0AE !important;
}

.text-green.text-accent-2 {
  color: #69F0AE !important;
}
.text-green.text-accent-2.icon-outline {
  border-color: #69F0AE !important;
}

.bg-green.accent-3 {
  background-color: #00E676 !important;
}

.text-green.text-accent-3 {
  color: #00E676 !important;
}
.text-green.text-accent-3.icon-outline {
  border-color: #00E676 !important;
}

.bg-green.accent-4 {
  background-color: #00C853 !important;
}

.text-green.text-accent-4 {
  color: #00C853 !important;
}
.text-green.text-accent-4.icon-outline {
  border-color: #00C853 !important;
}

.bg-light-green {
  background-color: #8bc34a !important;
}

.text-light-green {
  color: #8bc34a !important;
}
.text-light-green.icon-outline {
  border-color: #8bc34a !important;
}

.bg-light-green.lighten-5 {
  background-color: #f1f8e9 !important;
}

.text-light-green.text-lighten-5 {
  color: #f1f8e9 !important;
}
.text-light-green.text-lighten-5.icon-outline {
  border-color: #f1f8e9 !important;
}

.bg-light-green.lighten-4 {
  background-color: #dcedc8 !important;
}

.text-light-green.text-lighten-4 {
  color: #dcedc8 !important;
}
.text-light-green.text-lighten-4.icon-outline {
  border-color: #dcedc8 !important;
}

.bg-light-green.lighten-3 {
  background-color: #c5e1a5 !important;
}

.text-light-green.text-lighten-3 {
  color: #c5e1a5 !important;
}
.text-light-green.text-lighten-3.icon-outline {
  border-color: #c5e1a5 !important;
}

.bg-light-green.lighten-2 {
  background-color: #aed581 !important;
}

.text-light-green.text-lighten-2 {
  color: #aed581 !important;
}
.text-light-green.text-lighten-2.icon-outline {
  border-color: #aed581 !important;
}

.bg-light-green.lighten-1 {
  background-color: #9ccc65 !important;
}

.text-light-green.text-lighten-1 {
  color: #9ccc65 !important;
}
.text-light-green.text-lighten-1.icon-outline {
  border-color: #9ccc65 !important;
}

.bg-light-green.darken-1 {
  background-color: #7cb342 !important;
}

.text-light-green.text-darken-1 {
  color: #7cb342 !important;
}
.text-light-green.text-darken-1.icon-outline {
  border-color: #7cb342 !important;
}

.bg-light-green.darken-2 {
  background-color: #689f38 !important;
}

.text-light-green.text-darken-2 {
  color: #689f38 !important;
}
.text-light-green.text-darken-2.icon-outline {
  border-color: #689f38 !important;
}

.bg-light-green.darken-3 {
  background-color: #558b2f !important;
}

.text-light-green.text-darken-3 {
  color: #558b2f !important;
}
.text-light-green.text-darken-3.icon-outline {
  border-color: #558b2f !important;
}

.bg-light-green.darken-4 {
  background-color: #33691e !important;
}

.text-light-green.text-darken-4 {
  color: #33691e !important;
}
.text-light-green.text-darken-4.icon-outline {
  border-color: #33691e !important;
}

.bg-light-green.accent-1 {
  background-color: #ccff90 !important;
}

.text-light-green.text-accent-1 {
  color: #ccff90 !important;
}
.text-light-green.text-accent-1.icon-outline {
  border-color: #ccff90 !important;
}

.bg-light-green.accent-2 {
  background-color: #b2ff59 !important;
}

.text-light-green.text-accent-2 {
  color: #b2ff59 !important;
}
.text-light-green.text-accent-2.icon-outline {
  border-color: #b2ff59 !important;
}

.bg-light-green.accent-3 {
  background-color: #76ff03 !important;
}

.text-light-green.text-accent-3 {
  color: #76ff03 !important;
}
.text-light-green.text-accent-3.icon-outline {
  border-color: #76ff03 !important;
}

.bg-light-green.accent-4 {
  background-color: #64dd17 !important;
}

.text-light-green.text-accent-4 {
  color: #64dd17 !important;
}
.text-light-green.text-accent-4.icon-outline {
  border-color: #64dd17 !important;
}

.bg-lime {
  background-color: #cddc39 !important;
}

.text-lime {
  color: #cddc39 !important;
}
.text-lime.icon-outline {
  border-color: #cddc39 !important;
}

.bg-lime.lighten-5 {
  background-color: #f9fbe7 !important;
}

.text-lime.text-lighten-5 {
  color: #f9fbe7 !important;
}
.text-lime.text-lighten-5.icon-outline {
  border-color: #f9fbe7 !important;
}

.bg-lime.lighten-4 {
  background-color: #f0f4c3 !important;
}

.text-lime.text-lighten-4 {
  color: #f0f4c3 !important;
}
.text-lime.text-lighten-4.icon-outline {
  border-color: #f0f4c3 !important;
}

.bg-lime.lighten-3 {
  background-color: #e6ee9c !important;
}

.text-lime.text-lighten-3 {
  color: #e6ee9c !important;
}
.text-lime.text-lighten-3.icon-outline {
  border-color: #e6ee9c !important;
}

.bg-lime.lighten-2 {
  background-color: #dce775 !important;
}

.text-lime.text-lighten-2 {
  color: #dce775 !important;
}
.text-lime.text-lighten-2.icon-outline {
  border-color: #dce775 !important;
}

.bg-lime.lighten-1 {
  background-color: #d4e157 !important;
}

.text-lime.text-lighten-1 {
  color: #d4e157 !important;
}
.text-lime.text-lighten-1.icon-outline {
  border-color: #d4e157 !important;
}

.bg-lime.darken-1 {
  background-color: #c0ca33 !important;
}

.text-lime.text-darken-1 {
  color: #c0ca33 !important;
}
.text-lime.text-darken-1.icon-outline {
  border-color: #c0ca33 !important;
}

.bg-lime.darken-2 {
  background-color: #afb42b !important;
}

.text-lime.text-darken-2 {
  color: #afb42b !important;
}
.text-lime.text-darken-2.icon-outline {
  border-color: #afb42b !important;
}

.bg-lime.darken-3 {
  background-color: #9e9d24 !important;
}

.text-lime.text-darken-3 {
  color: #9e9d24 !important;
}
.text-lime.text-darken-3.icon-outline {
  border-color: #9e9d24 !important;
}

.bg-lime.darken-4 {
  background-color: #827717 !important;
}

.text-lime.text-darken-4 {
  color: #827717 !important;
}
.text-lime.text-darken-4.icon-outline {
  border-color: #827717 !important;
}

.bg-lime.accent-1 {
  background-color: #f4ff81 !important;
}

.text-lime.text-accent-1 {
  color: #f4ff81 !important;
}
.text-lime.text-accent-1.icon-outline {
  border-color: #f4ff81 !important;
}

.bg-lime.accent-2 {
  background-color: #eeff41 !important;
}

.text-lime.text-accent-2 {
  color: #eeff41 !important;
}
.text-lime.text-accent-2.icon-outline {
  border-color: #eeff41 !important;
}

.bg-lime.accent-3 {
  background-color: #c6ff00 !important;
}

.text-lime.text-accent-3 {
  color: #c6ff00 !important;
}
.text-lime.text-accent-3.icon-outline {
  border-color: #c6ff00 !important;
}

.bg-lime.accent-4 {
  background-color: #aeea00 !important;
}

.text-lime.text-accent-4 {
  color: #aeea00 !important;
}
.text-lime.text-accent-4.icon-outline {
  border-color: #aeea00 !important;
}

.bg-yellow {
  background-color: #ffeb3b !important;
}

.text-yellow {
  color: #ffeb3b !important;
}
.text-yellow.icon-outline {
  border-color: #ffeb3b !important;
}

.bg-yellow.lighten-5 {
  background-color: #fffde7 !important;
}

.text-yellow.text-lighten-5 {
  color: #fffde7 !important;
}
.text-yellow.text-lighten-5.icon-outline {
  border-color: #fffde7 !important;
}

.bg-yellow.lighten-4 {
  background-color: #fff9c4 !important;
}

.text-yellow.text-lighten-4 {
  color: #fff9c4 !important;
}
.text-yellow.text-lighten-4.icon-outline {
  border-color: #fff9c4 !important;
}

.bg-yellow.lighten-3 {
  background-color: #fff59d !important;
}

.text-yellow.text-lighten-3 {
  color: #fff59d !important;
}
.text-yellow.text-lighten-3.icon-outline {
  border-color: #fff59d !important;
}

.bg-yellow.lighten-2 {
  background-color: #fff176 !important;
}

.text-yellow.text-lighten-2 {
  color: #fff176 !important;
}
.text-yellow.text-lighten-2.icon-outline {
  border-color: #fff176 !important;
}

.bg-yellow.lighten-1 {
  background-color: #ffee58 !important;
}

.text-yellow.text-lighten-1 {
  color: #ffee58 !important;
}
.text-yellow.text-lighten-1.icon-outline {
  border-color: #ffee58 !important;
}

.bg-yellow.darken-1 {
  background-color: #fdd835 !important;
}

.text-yellow.text-darken-1 {
  color: #fdd835 !important;
}
.text-yellow.text-darken-1.icon-outline {
  border-color: #fdd835 !important;
}

.bg-yellow.darken-2 {
  background-color: #fbc02d !important;
}

.text-yellow.text-darken-2 {
  color: #fbc02d !important;
}
.text-yellow.text-darken-2.icon-outline {
  border-color: #fbc02d !important;
}

.bg-yellow.darken-3 {
  background-color: #f9a825 !important;
}

.text-yellow.text-darken-3 {
  color: #f9a825 !important;
}
.text-yellow.text-darken-3.icon-outline {
  border-color: #f9a825 !important;
}

.bg-yellow.darken-4 {
  background-color: #f57f17 !important;
}

.text-yellow.text-darken-4 {
  color: #f57f17 !important;
}
.text-yellow.text-darken-4.icon-outline {
  border-color: #f57f17 !important;
}

.bg-yellow.accent-1 {
  background-color: #ffff8d !important;
}

.text-yellow.text-accent-1 {
  color: #ffff8d !important;
}
.text-yellow.text-accent-1.icon-outline {
  border-color: #ffff8d !important;
}

.bg-yellow.accent-2 {
  background-color: #ffff00 !important;
}

.text-yellow.text-accent-2 {
  color: #ffff00 !important;
}
.text-yellow.text-accent-2.icon-outline {
  border-color: #ffff00 !important;
}

.bg-yellow.accent-3 {
  background-color: #ffea00 !important;
}

.text-yellow.text-accent-3 {
  color: #ffea00 !important;
}
.text-yellow.text-accent-3.icon-outline {
  border-color: #ffea00 !important;
}

.bg-yellow.accent-4 {
  background-color: #ffd600 !important;
}

.text-yellow.text-accent-4 {
  color: #ffd600 !important;
}
.text-yellow.text-accent-4.icon-outline {
  border-color: #ffd600 !important;
}

.bg-amber {
  background-color: #ffc107 !important;
}

.text-amber {
  color: #ffc107 !important;
}
.text-amber.icon-outline {
  border-color: #ffc107 !important;
}

.bg-amber.lighten-5 {
  background-color: #fff8e1 !important;
}

.text-amber.text-lighten-5 {
  color: #fff8e1 !important;
}
.text-amber.text-lighten-5.icon-outline {
  border-color: #fff8e1 !important;
}

.bg-amber.lighten-4 {
  background-color: #ffecb3 !important;
}

.text-amber.text-lighten-4 {
  color: #ffecb3 !important;
}
.text-amber.text-lighten-4.icon-outline {
  border-color: #ffecb3 !important;
}

.bg-amber.lighten-3 {
  background-color: #ffe082 !important;
}

.text-amber.text-lighten-3 {
  color: #ffe082 !important;
}
.text-amber.text-lighten-3.icon-outline {
  border-color: #ffe082 !important;
}

.bg-amber.lighten-2 {
  background-color: #ffd54f !important;
}

.text-amber.text-lighten-2 {
  color: #ffd54f !important;
}
.text-amber.text-lighten-2.icon-outline {
  border-color: #ffd54f !important;
}

.bg-amber.lighten-1 {
  background-color: #ffca28 !important;
}

.text-amber.text-lighten-1 {
  color: #ffca28 !important;
}
.text-amber.text-lighten-1.icon-outline {
  border-color: #ffca28 !important;
}

.bg-amber.darken-1 {
  background-color: #ffb300 !important;
}

.text-amber.text-darken-1 {
  color: #ffb300 !important;
}
.text-amber.text-darken-1.icon-outline {
  border-color: #ffb300 !important;
}

.bg-amber.darken-2 {
  background-color: #ffa000 !important;
}

.text-amber.text-darken-2 {
  color: #ffa000 !important;
}
.text-amber.text-darken-2.icon-outline {
  border-color: #ffa000 !important;
}

.bg-amber.darken-3 {
  background-color: #ff8f00 !important;
}

.text-amber.text-darken-3 {
  color: #ff8f00 !important;
}
.text-amber.text-darken-3.icon-outline {
  border-color: #ff8f00 !important;
}

.bg-amber.darken-4 {
  background-color: #ff6f00 !important;
}

.text-amber.text-darken-4 {
  color: #ff6f00 !important;
}
.text-amber.text-darken-4.icon-outline {
  border-color: #ff6f00 !important;
}

.bg-amber.accent-1 {
  background-color: #ffe57f !important;
}

.text-amber.text-accent-1 {
  color: #ffe57f !important;
}
.text-amber.text-accent-1.icon-outline {
  border-color: #ffe57f !important;
}

.bg-amber.accent-2 {
  background-color: #ffd740 !important;
}

.text-amber.text-accent-2 {
  color: #ffd740 !important;
}
.text-amber.text-accent-2.icon-outline {
  border-color: #ffd740 !important;
}

.bg-amber.accent-3 {
  background-color: #ffc400 !important;
}

.text-amber.text-accent-3 {
  color: #ffc400 !important;
}
.text-amber.text-accent-3.icon-outline {
  border-color: #ffc400 !important;
}

.bg-amber.accent-4 {
  background-color: #ffab00 !important;
}

.text-amber.text-accent-4 {
  color: #ffab00 !important;
}
.text-amber.text-accent-4.icon-outline {
  border-color: #ffab00 !important;
}

.bg-orange {
  background-color: #ff9800 !important;
}

.text-orange {
  color: #ff9800 !important;
}
.text-orange.icon-outline {
  border-color: #ff9800 !important;
}

.bg-orange.lighten-5 {
  background-color: #fff3e0 !important;
}

.text-orange.text-lighten-5 {
  color: #fff3e0 !important;
}
.text-orange.text-lighten-5.icon-outline {
  border-color: #fff3e0 !important;
}

.bg-orange.lighten-4 {
  background-color: #ffe0b2 !important;
}

.text-orange.text-lighten-4 {
  color: #ffe0b2 !important;
}
.text-orange.text-lighten-4.icon-outline {
  border-color: #ffe0b2 !important;
}

.bg-orange.lighten-3 {
  background-color: #ffcc80 !important;
}

.text-orange.text-lighten-3 {
  color: #ffcc80 !important;
}
.text-orange.text-lighten-3.icon-outline {
  border-color: #ffcc80 !important;
}

.bg-orange.lighten-2 {
  background-color: #ffb74d !important;
}

.text-orange.text-lighten-2 {
  color: #ffb74d !important;
}
.text-orange.text-lighten-2.icon-outline {
  border-color: #ffb74d !important;
}

.bg-orange.lighten-1 {
  background-color: #ffa726 !important;
}

.text-orange.text-lighten-1 {
  color: #ffa726 !important;
}
.text-orange.text-lighten-1.icon-outline {
  border-color: #ffa726 !important;
}

.bg-orange.darken-1 {
  background-color: #fb8c00 !important;
}

.text-orange.text-darken-1 {
  color: #fb8c00 !important;
}
.text-orange.text-darken-1.icon-outline {
  border-color: #fb8c00 !important;
}

.bg-orange.darken-2 {
  background-color: #f57c00 !important;
}

.text-orange.text-darken-2 {
  color: #f57c00 !important;
}
.text-orange.text-darken-2.icon-outline {
  border-color: #f57c00 !important;
}

.bg-orange.darken-3 {
  background-color: #ef6c00 !important;
}

.text-orange.text-darken-3 {
  color: #ef6c00 !important;
}
.text-orange.text-darken-3.icon-outline {
  border-color: #ef6c00 !important;
}

.bg-orange.darken-4 {
  background-color: #e65100 !important;
}

.text-orange.text-darken-4 {
  color: #e65100 !important;
}
.text-orange.text-darken-4.icon-outline {
  border-color: #e65100 !important;
}

.bg-orange.accent-1 {
  background-color: #ffd180 !important;
}

.text-orange.text-accent-1 {
  color: #ffd180 !important;
}
.text-orange.text-accent-1.icon-outline {
  border-color: #ffd180 !important;
}

.bg-orange.accent-2 {
  background-color: #ffab40 !important;
}

.text-orange.text-accent-2 {
  color: #ffab40 !important;
}
.text-orange.text-accent-2.icon-outline {
  border-color: #ffab40 !important;
}

.bg-orange.accent-3 {
  background-color: #ff9100 !important;
}

.text-orange.text-accent-3 {
  color: #ff9100 !important;
}
.text-orange.text-accent-3.icon-outline {
  border-color: #ff9100 !important;
}

.bg-orange.accent-4 {
  background-color: #ff6d00 !important;
}

.text-orange.text-accent-4 {
  color: #ff6d00 !important;
}
.text-orange.text-accent-4.icon-outline {
  border-color: #ff6d00 !important;
}

.bg-deep-orange {
  background-color: #ff5722 !important;
}

.text-deep-orange {
  color: #ff5722 !important;
}
.text-deep-orange.icon-outline {
  border-color: #ff5722 !important;
}

.bg-deep-orange.lighten-5 {
  background-color: #fbe9e7 !important;
}

.text-deep-orange.text-lighten-5 {
  color: #fbe9e7 !important;
}
.text-deep-orange.text-lighten-5.icon-outline {
  border-color: #fbe9e7 !important;
}

.bg-deep-orange.lighten-4 {
  background-color: #ffccbc !important;
}

.text-deep-orange.text-lighten-4 {
  color: #ffccbc !important;
}
.text-deep-orange.text-lighten-4.icon-outline {
  border-color: #ffccbc !important;
}

.bg-deep-orange.lighten-3 {
  background-color: #ffab91 !important;
}

.text-deep-orange.text-lighten-3 {
  color: #ffab91 !important;
}
.text-deep-orange.text-lighten-3.icon-outline {
  border-color: #ffab91 !important;
}

.bg-deep-orange.lighten-2 {
  background-color: #ff8a65 !important;
}

.text-deep-orange.text-lighten-2 {
  color: #ff8a65 !important;
}
.text-deep-orange.text-lighten-2.icon-outline {
  border-color: #ff8a65 !important;
}

.bg-deep-orange.lighten-1 {
  background-color: #ff7043 !important;
}

.text-deep-orange.text-lighten-1 {
  color: #ff7043 !important;
}
.text-deep-orange.text-lighten-1.icon-outline {
  border-color: #ff7043 !important;
}

.bg-deep-orange.darken-1 {
  background-color: #f4511e !important;
}

.text-deep-orange.text-darken-1 {
  color: #f4511e !important;
}
.text-deep-orange.text-darken-1.icon-outline {
  border-color: #f4511e !important;
}

.bg-deep-orange.darken-2 {
  background-color: #e64a19 !important;
}

.text-deep-orange.text-darken-2 {
  color: #e64a19 !important;
}
.text-deep-orange.text-darken-2.icon-outline {
  border-color: #e64a19 !important;
}

.bg-deep-orange.darken-3 {
  background-color: #d84315 !important;
}

.text-deep-orange.text-darken-3 {
  color: #d84315 !important;
}
.text-deep-orange.text-darken-3.icon-outline {
  border-color: #d84315 !important;
}

.bg-deep-orange.darken-4 {
  background-color: #bf360c !important;
}

.text-deep-orange.text-darken-4 {
  color: #bf360c !important;
}
.text-deep-orange.text-darken-4.icon-outline {
  border-color: #bf360c !important;
}

.bg-deep-orange.accent-1 {
  background-color: #ff9e80 !important;
}

.text-deep-orange.text-accent-1 {
  color: #ff9e80 !important;
}
.text-deep-orange.text-accent-1.icon-outline {
  border-color: #ff9e80 !important;
}

.bg-deep-orange.accent-2 {
  background-color: #ff6e40 !important;
}

.text-deep-orange.text-accent-2 {
  color: #ff6e40 !important;
}
.text-deep-orange.text-accent-2.icon-outline {
  border-color: #ff6e40 !important;
}

.bg-deep-orange.accent-3 {
  background-color: #ff3d00 !important;
}

.text-deep-orange.text-accent-3 {
  color: #ff3d00 !important;
}
.text-deep-orange.text-accent-3.icon-outline {
  border-color: #ff3d00 !important;
}

.bg-deep-orange.accent-4 {
  background-color: #dd2c00 !important;
}

.text-deep-orange.text-accent-4 {
  color: #dd2c00 !important;
}
.text-deep-orange.text-accent-4.icon-outline {
  border-color: #dd2c00 !important;
}

.bg-brown {
  background-color: #795548 !important;
}

.text-brown {
  color: #795548 !important;
}
.text-brown.icon-outline {
  border-color: #795548 !important;
}

.bg-brown.lighten-5 {
  background-color: #efebe9 !important;
}

.text-brown.text-lighten-5 {
  color: #efebe9 !important;
}
.text-brown.text-lighten-5.icon-outline {
  border-color: #efebe9 !important;
}

.bg-brown.lighten-4 {
  background-color: #d7ccc8 !important;
}

.text-brown.text-lighten-4 {
  color: #d7ccc8 !important;
}
.text-brown.text-lighten-4.icon-outline {
  border-color: #d7ccc8 !important;
}

.bg-brown.lighten-3 {
  background-color: #bcaaa4 !important;
}

.text-brown.text-lighten-3 {
  color: #bcaaa4 !important;
}
.text-brown.text-lighten-3.icon-outline {
  border-color: #bcaaa4 !important;
}

.bg-brown.lighten-2 {
  background-color: #a1887f !important;
}

.text-brown.text-lighten-2 {
  color: #a1887f !important;
}
.text-brown.text-lighten-2.icon-outline {
  border-color: #a1887f !important;
}

.bg-brown.lighten-1 {
  background-color: #8d6e63 !important;
}

.text-brown.text-lighten-1 {
  color: #8d6e63 !important;
}
.text-brown.text-lighten-1.icon-outline {
  border-color: #8d6e63 !important;
}

.bg-brown.darken-1 {
  background-color: #6d4c41 !important;
}

.text-brown.text-darken-1 {
  color: #6d4c41 !important;
}
.text-brown.text-darken-1.icon-outline {
  border-color: #6d4c41 !important;
}

.bg-brown.darken-2 {
  background-color: #5d4037 !important;
}

.text-brown.text-darken-2 {
  color: #5d4037 !important;
}
.text-brown.text-darken-2.icon-outline {
  border-color: #5d4037 !important;
}

.bg-brown.darken-3 {
  background-color: #4e342e !important;
}

.text-brown.text-darken-3 {
  color: #4e342e !important;
}
.text-brown.text-darken-3.icon-outline {
  border-color: #4e342e !important;
}

.bg-brown.darken-4 {
  background-color: #3e2723 !important;
}

.text-brown.text-darken-4 {
  color: #3e2723 !important;
}
.text-brown.text-darken-4.icon-outline {
  border-color: #3e2723 !important;
}

.bg-blue-grey {
  background-color: #607d8b !important;
}

.text-blue-grey {
  color: #607d8b !important;
}
.text-blue-grey.icon-outline {
  border-color: #607d8b !important;
}

.bg-blue-grey.lighten-5 {
  background-color: #eceff1 !important;
}

.text-blue-grey.text-lighten-5 {
  color: #eceff1 !important;
}
.text-blue-grey.text-lighten-5.icon-outline {
  border-color: #eceff1 !important;
}

.bg-blue-grey.lighten-4 {
  background-color: #cfd8dc !important;
}

.text-blue-grey.text-lighten-4 {
  color: #cfd8dc !important;
}
.text-blue-grey.text-lighten-4.icon-outline {
  border-color: #cfd8dc !important;
}

.bg-blue-grey.lighten-3 {
  background-color: #b0bec5 !important;
}

.text-blue-grey.text-lighten-3 {
  color: #b0bec5 !important;
}
.text-blue-grey.text-lighten-3.icon-outline {
  border-color: #b0bec5 !important;
}

.bg-blue-grey.lighten-2 {
  background-color: #90a4ae !important;
}

.text-blue-grey.text-lighten-2 {
  color: #90a4ae !important;
}
.text-blue-grey.text-lighten-2.icon-outline {
  border-color: #90a4ae !important;
}

.bg-blue-grey.lighten-1 {
  background-color: #78909c !important;
}

.text-blue-grey.text-lighten-1 {
  color: #78909c !important;
}
.text-blue-grey.text-lighten-1.icon-outline {
  border-color: #78909c !important;
}

.bg-blue-grey.darken-1 {
  background-color: #546e7a !important;
}

.text-blue-grey.text-darken-1 {
  color: #546e7a !important;
}
.text-blue-grey.text-darken-1.icon-outline {
  border-color: #546e7a !important;
}

.bg-blue-grey.darken-2 {
  background-color: #455a64 !important;
}

.text-blue-grey.text-darken-2 {
  color: #455a64 !important;
}
.text-blue-grey.text-darken-2.icon-outline {
  border-color: #455a64 !important;
}

.bg-blue-grey.darken-3 {
  background-color: #37474f !important;
}

.text-blue-grey.text-darken-3 {
  color: #37474f !important;
}
.text-blue-grey.text-darken-3.icon-outline {
  border-color: #37474f !important;
}

.bg-blue-grey.darken-4 {
  background-color: #263238 !important;
}

.text-blue-grey.text-darken-4 {
  color: #263238 !important;
}
.text-blue-grey.text-darken-4.icon-outline {
  border-color: #263238 !important;
}

.bg-grey {
  background-color: #9e9e9e !important;
}

.text-grey {
  color: #9e9e9e !important;
}
.text-grey.icon-outline {
  border-color: #9e9e9e !important;
}

.bg-grey.lighten-5 {
  background-color: #fafafa !important;
}

.text-grey.text-lighten-5 {
  color: #fafafa !important;
}
.text-grey.text-lighten-5.icon-outline {
  border-color: #fafafa !important;
}

.bg-grey.lighten-4 {
  background-color: #f5f5f5 !important;
}

.text-grey.text-lighten-4 {
  color: #f5f5f5 !important;
}
.text-grey.text-lighten-4.icon-outline {
  border-color: #f5f5f5 !important;
}

.bg-grey.lighten-3 {
  background-color: #eeeeee !important;
}

.text-grey.text-lighten-3 {
  color: #eeeeee !important;
}
.text-grey.text-lighten-3.icon-outline {
  border-color: #eeeeee !important;
}

.bg-grey.lighten-2 {
  background-color: #e0e0e0 !important;
}

.text-grey.text-lighten-2 {
  color: #e0e0e0 !important;
}
.text-grey.text-lighten-2.icon-outline {
  border-color: #e0e0e0 !important;
}

.bg-grey.lighten-1 {
  background-color: #bdbdbd !important;
}

.text-grey.text-lighten-1 {
  color: #bdbdbd !important;
}
.text-grey.text-lighten-1.icon-outline {
  border-color: #bdbdbd !important;
}

.bg-grey.darken-1 {
  background-color: #757575 !important;
}

.text-grey.text-darken-1 {
  color: #757575 !important;
}
.text-grey.text-darken-1.icon-outline {
  border-color: #757575 !important;
}

.bg-grey.darken-2 {
  background-color: #616161 !important;
}

.text-grey.text-darken-2 {
  color: #616161 !important;
}
.text-grey.text-darken-2.icon-outline {
  border-color: #616161 !important;
}

.bg-grey.darken-3 {
  background-color: #424242 !important;
}

.text-grey.text-darken-3 {
  color: #424242 !important;
}
.text-grey.text-darken-3.icon-outline {
  border-color: #424242 !important;
}

.bg-grey.darken-4 {
  background-color: #212121 !important;
}

.text-grey.text-darken-4 {
  color: #212121 !important;
}
.text-grey.text-darken-4.icon-outline {
  border-color: #212121 !important;
}

.bg-black {
  background-color: #000000 !important;
}

.text-black {
  color: #000000 !important;
}
.text-black.icon-outline {
  border-color: #000000 !important;
}

.bg-white {
  background-color: #FFFFFF !important;
}

.text-white {
  color: #FFFFFF !important;
}
.text-white.icon-outline {
  border-color: #FFFFFF !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.text-transparent {
  color: transparent !important;
}
.text-transparent.icon-outline {
  border-color: transparent !important;
}

/*Custom Animation*/
@keyframes flipCenter {
  0% {
    animation-timing-function: ease-in;
    opacity: 0;
    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);
  }
  40% {
    animation-timing-function: ease-in;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  60% {
    opacity: 1;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  80% {
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  100% {
    transform: perspective(100000px);
  }
}
@-webkit-keyframes flipCenter {
  0% {
    animation-timing-function: ease-in;
    opacity: 0;
    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);
  }
  40% {
    animation-timing-function: ease-in;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  60% {
    opacity: 1;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  80% {
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);
  }
  100% {
    transform: perspective(100000px);
  }
}
.flipCenter {
  animation-name: flipCenter;
  backface-visibility: visible;
}

@keyframes desployDown {
  0% {
    transform: scaleY(0);
    transform-origin: center top 0;
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
    transform-origin: center top 0;
  }
}
@-webkit-keyframes desployDown {
  0% {
    transform: scaleY(0);
    transform-origin: center top 0;
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
    transform-origin: center top 0;
  }
}
.desployDown {
  animation-name: desployDown;
  backface-visibility: visible;
}

@keyframes fadeInRightTiny {
  0% {
    opacity: 0;
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
@-webkit-keyframes fadeInRightTiny {
  0% {
    opacity: 0;
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
.fadeInRightTiny {
  animation-name: fadeInRightTiny;
}

@keyframes fadeInLeftTiny {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
@-webkit-keyframes fadeInLeftTiny {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
.fadeInLeftTiny {
  animation-name: fadeInLeftTiny;
}

@keyframes slideInRightTiny {
  0% {
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
@-webkit-keyframes slideInRightTiny {
  0% {
    transform: translate3d(30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
.slideInRightTiny {
  animation-name: slideInRightTiny;
}

@keyframes slideInLeftTiny {
  0% {
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
@-webkit-keyframes slideInLeftTiny {
  0% {
    transform: translate3d(-30%, 0px, 0px);
  }
  100% {
    transform: none;
  }
}
.slideInLeftTiny {
  animation-name: slideInLeftTiny;
}

@keyframes slideInUpTiny {
  0% {
    transform: translate3d(0px, 5%, 0px);
  }
  100% {
    transform: none;
  }
}
@-webkit-keyframes slideInUpTiny {
  0% {
    transform: translate3d(0px, 5%, 0px);
  }
  100% {
    transform: none;
  }
}
.slideInUpTiny {
  animation-name: slideInUpTiny;
}

/*Animation Durations*/
.animation-duration-1 {
  animation-duration: 0.1s;
}

.animation-duration-2 {
  animation-duration: 0.2s;
}

.animation-duration-3 {
  animation-duration: 0.3s;
}

.animation-duration-4 {
  animation-duration: 0.4s;
}

.animation-duration-5 {
  animation-duration: 0.5s;
}

.animation-duration-6 {
  animation-duration: 0.6s;
}

.animation-duration-7 {
  animation-duration: 0.7s;
}

.animation-duration-8 {
  animation-duration: 0.8s;
}

.animation-duration-9 {
  animation-duration: 0.9s;
}

.animation-duration-10 {
  animation-duration: 1s;
}

.animation-duration-11 {
  animation-duration: 1.1s;
}

.animation-duration-12 {
  animation-duration: 1.2s;
}

.animation-duration-13 {
  animation-duration: 1.3s;
}

.animation-duration-14 {
  animation-duration: 1.4s;
}

.animation-duration-15 {
  animation-duration: 1.5s;
}

.animation-duration-16 {
  animation-duration: 1.6s;
}

.animation-duration-17 {
  animation-duration: 1.7s;
}

.animation-duration-18 {
  animation-duration: 1.8s;
}

.animation-duration-19 {
  animation-duration: 1.9s;
}

.animation-duration-20 {
  animation-duration: 2s;
}

.animation-duration-21 {
  animation-duration: 2.1s;
}

.animation-duration-22 {
  animation-duration: 2.2s;
}

.animation-duration-23 {
  animation-duration: 2.3s;
}

.animation-duration-24 {
  animation-duration: 2.4s;
}

.animation-duration-25 {
  animation-duration: 2.5s;
}

.animation-duration-26 {
  animation-duration: 2.6s;
}

.animation-duration-27 {
  animation-duration: 2.7s;
}

.animation-duration-28 {
  animation-duration: 2.8s;
}

.animation-duration-29 {
  animation-duration: 2.9s;
}

.animation-duration-30 {
  animation-duration: 3s;
}

.animation-duration-31 {
  animation-duration: 3.1s;
}

.animation-duration-32 {
  animation-duration: 3.2s;
}

.animation-duration-33 {
  animation-duration: 3.3s;
}

.animation-duration-34 {
  animation-duration: 3.4s;
}

.animation-duration-35 {
  animation-duration: 3.5s;
}

.animation-duration-36 {
  animation-duration: 3.6s;
}

.animation-duration-37 {
  animation-duration: 3.7s;
}

.animation-duration-38 {
  animation-duration: 3.8s;
}

.animation-duration-39 {
  animation-duration: 3.9s;
}

.animation-duration-40 {
  animation-duration: 4s;
}

.animation-delay-1 {
  animation-delay: 0.1s;
}

.animation-delay-2 {
  animation-delay: 0.2s;
}

.animation-delay-3 {
  animation-delay: 0.3s;
}

.animation-delay-4 {
  animation-delay: 0.4s;
}

.animation-delay-5 {
  animation-delay: 0.5s;
}

.animation-delay-6 {
  animation-delay: 0.6s;
}

.animation-delay-7 {
  animation-delay: 0.7s;
}

.animation-delay-8 {
  animation-delay: 0.8s;
}

.animation-delay-9 {
  animation-delay: 0.9s;
}

.animation-delay-10 {
  animation-delay: 1s;
}

.animation-delay-11 {
  animation-delay: 1.1s;
}

.animation-delay-12 {
  animation-delay: 1.2s;
}

.animation-delay-13 {
  animation-delay: 1.3s;
}

.animation-delay-14 {
  animation-delay: 1.4s;
}

.animation-delay-15 {
  animation-delay: 1.5s;
}

.animation-delay-16 {
  animation-delay: 1.6s;
}

.animation-delay-17 {
  animation-delay: 1.7s;
}

.animation-delay-18 {
  animation-delay: 1.8s;
}

.animation-delay-19 {
  animation-delay: 1.9s;
}

.animation-delay-20 {
  animation-delay: 2s;
}

.animation-delay-21 {
  animation-delay: 2.1s;
}

.animation-delay-22 {
  animation-delay: 2.2s;
}

.animation-delay-23 {
  animation-delay: 2.3s;
}

.animation-delay-24 {
  animation-delay: 2.4s;
}

.animation-delay-25 {
  animation-delay: 2.5s;
}

.animation-delay-26 {
  animation-delay: 2.6s;
}

.animation-delay-27 {
  animation-delay: 2.6s;
}

.animation-delay-28 {
  animation-delay: 2.8s;
}

.animation-delay-29 {
  animation-delay: 2.9s;
}

.animation-delay-30 {
  animation-delay: 3s;
}

.animation-delay-31 {
  animation-delay: 3.1s;
}

.animation-delay-32 {
  animation-delay: 3.2s;
}

.animation-delay-33 {
  animation-delay: 3.3s;
}

.animation-delay-34 {
  animation-delay: 3.4s;
}

.animation-delay-35 {
  animation-delay: 3.5s;
}

.animation-delay-36 {
  animation-delay: 3.6s;
}

.animation-delay-37 {
  animation-delay: 3.7s;
}

.animation-delay-38 {
  animation-delay: 3.8s;
}

.animation-delay-39 {
  animation-delay: 3.9s;
}

.animation-delay-40 {
  animation-delay: 4s;
}

.animation-delay-41 {
  animation-delay: 4.1s;
}

.animation-delay-42 {
  animation-delay: 4.2s;
}

.animation-delay-43 {
  animation-delay: 4.3s;
}

.animation-delay-44 {
  animation-delay: 4.4s;
}

.animation-delay-45 {
  animation-delay: 4.5s;
}

.animation-delay-46 {
  animation-delay: 4.6s;
}

.animation-delay-47 {
  animation-delay: 4.7s;
}

.animation-delay-48 {
  animation-delay: 4.8s;
}

.animation-delay-49 {
  animation-delay: 4.9s;
}

.animation-delay-50 {
  animation-delay: 5s;
}

/* Base
   ========================================================================== */
/*Base Styles*/
html {
  height: 100%;
}

body {
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #5c5c5c;
  background-color: #fff;
  height: 100%;
  overflow: hidden;
}

body.ios-mobile-view-height {
  height: auto !important;
  overflow: visible !important;
}

#nprogress .bar {
  z-index: 5000 !important;
  background: #3f51b5 !important;
}

#nprogress .peg {
  -webkit-box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important;
  -moz-box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important;
  -o-box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important;
  box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important;
}

#nprogress .spinner {
  z-index: 5000 !important;
}

#nprogress .spinner-icon {
  border-top-color: #3f51b5 !important;
  border-left-color: #3f51b5 !important;
}

.text-transform-none {
  text-transform: none;
}

.br-break {
  word-break: break-all !important;
}

.font-weight-semibold {
  font-weight: 500 !important;
}

.z-index-20 {
  z-index: 20;
}

.border-bottom {
  border-bottom: solid 1px #dee2e6;
}

.col-with-divider div[class*=col-] {
  border-left: solid 1px #dee2e6;
}
.col-with-divider div[class*=col-]:first-child {
  border: 0 none;
}

.height-100 {
  height: 100px !important;
}

.height-150 {
  height: 150px !important;
}

.height-130 {
  height: 130px !important;
}

.height-200 {
  height: 200px !important;
}

.max-width-100 {
  max-width: 100px !important;
}

.max-height-120 {
  max-height: 120px !important;
}

.right-arrow {
  display: inline-block;
  color: #3f51b5;
  text-transform: capitalize;
}
.right-arrow:after {
  content: "\\f30f";
  font-family: "Material-Design-Iconic-Font";
  color: #3f51b5;
  margin-left: 8px;
  font-size: 20px;
  vertical-align: middle;
}
.right-arrow:hover, .right-arrow:focus {
  text-decoration: none;
}

.letter-spacing-base {
  letter-spacing: 3px;
}

.letter-spacing-lg {
  letter-spacing: 6px;
}

.letter-spacing-xl {
  letter-spacing: 8px;
}

.page-heading {
  margin-bottom: 38px;
}
.page-heading .title {
  text-transform: capitalize;
  font-weight: 600;
}
.page-heading .breadcrumb {
  padding: 0;
  background-color: transparent;
  margin-bottom: 0;
}
@media screen and (max-width: 575px) {
  .page-heading {
    margin-bottom: 18px;
  }
}

.sub-heading {
  font-size: 13px;
  color: #adb5bd;
  margin-bottom: 0;
}
.sub-heading:not(:last-child) {
  margin-bottom: 16px !important;
}

.manage-margin {
  margin-bottom: 0;
}
.manage-margin > * {
  margin-bottom: 6px;
}
.manage-margin > *:not(:last-child) {
  margin-right: 16px;
}

.no-shadow {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

.shadow-sm {
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
}

.shadow {
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}

.shadow-lg {
  -webkit-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
}

.shadow-xl {
  -webkit-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
}

.avatar-shadow {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  -o-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
}

.remove-table-border td, .remove-table-border th {
  border: 0 none;
}

.media-list {
  margin-bottom: 10px;
}
.media-list:not(:last-child) {
  border-bottom: solid 1px #e9ecef;
  padding-bottom: 15px;
  margin-bottom: 20px;
  position: relative;
}

.border-2 {
  border: 2px solid #ced4da !important;
}

.border-w2 {
  border-width: 2px;
}

.border-primary {
  border-color: #3f51b5 !important;
}

.border-red {
  border-color: #F44336 !important;
}

.border-pink {
  border-color: #e91e63 !important;
}

.border-purple {
  border-color: #9C27B0 !important;
}

.border-deep-purple {
  border-color: #673ab7 !important;
}

.border-indigo {
  border-color: #3f51b5 !important;
}

.border-blue {
  border-color: #2196F3 !important;
}

.border-light-blue {
  border-color: #03a9f4 !important;
}

.border-cyan {
  border-color: #00bcd4 !important;
}

.border-teal {
  border-color: #009688 !important;
}

.border-green {
  border-color: #4CAF50 !important;
}

.border-light-green {
  border-color: #8bc34a !important;
}

.border-lime {
  border-color: #cddc39 !important;
}

.border-yellow {
  border-color: #ffeb3b !important;
}

.border-amber {
  border-color: #ffc107 !important;
}

.border-orange {
  border-color: #ff9800 !important;
}

.border-deep-orange {
  border-color: #ff5722 !important;
}

.border-brown {
  border-color: #795548 !important;
}

.border-blue-grey {
  border-color: #607d8b !important;
}

.border-grey {
  border-color: #9e9e9e !important;
}

.center-crop-img {
  position: relative;
  width: 100%;
  min-height: 120px;
  overflow: hidden;
}
.center-crop-img img {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100%;
  width: auto;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.center-crop-img img.portrait {
  width: 100%;
  height: auto;
}

.pointer {
  cursor: pointer;
}

.icon-btn {
  height: 48px;
  display: flex;
  align-items: center;
  width: 48px;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  color: #6c757d;
}
.header-notifications .icon-btn {
  padding: 0 4px;
}

.avatar {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  color: #fafafa;
}

.avatar-lg {
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #fafafa;
}

.avatar-sm {
  width: 40px;
  height: 40px;
  text-align: center;
  color: #fafafa;
}

.animated {
  -webkit-animation-fill-mode: none !important;
  animation-fill-mode: none !important;
}

.overflow-hidden {
  overflow: hidden;
}

.icons-showcase > div {
  cursor: pointer;
  padding: 7px 15px;
  border-radius: 4px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-decoration {
  text-decoration: none !important;
}

.row-5 {
  margin-left: -5px;
  margin-right: -5px;
}
.row-5 > [class*=col-] {
  padding-left: 5px;
  padding-right: 5px;
}

.font-size-16 {
  font-size: 16px !important;
}

.material-icons {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  text-align: center;
  padding-bottom: 3px;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-image: linear-gradient(to bottom right, #ebebeb, #bebebe);
  border: solid 1px #ababab;
}

::selection {
  background-color: #006FC9;
  color: #fff;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 2px 30px 2px 2px;
  border: none;
  cursor: pointer;
}

.my-tooltip > .tooltip-inner {
  background-color: #fff;
  color: #808080;
  border: 1px solid #d8dcdf;
}

.my-tooltip [class\$=arrow] {
  display: none;
}

::-ms-clear {
  display: none;
}

.hs-button {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
  cursor: pointer;
  display: inline-block;
  font-weight: 700;
  line-height: 12px;
  position: relative;
  text-align: center;
  transition: all 0.15s linear;
  background-color: #ff7a59;
  border-color: #ff7a59;
  color: #fff;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  font-size: 14px;
  padding: 12px 24px;
}

.hs-button:hover, .hs-button:focus {
  background-color: #ff8f73;
  border-color: #ff8f73;
}

.hs-button:active {
  background-color: #e66e50;
  border-color: #e66e50;
}

label {
  font-size: 14px;
  width: 130px;
  text-align: right;
  color: #33475b;
  display: block;
  float: none;
  width: auto;
  font-weight: 500;
  text-align: left;
  line-height: 20px;
  padding-top: 0;
  margin-bottom: 4px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.hs-video-form label {
  color: #fff !important;
}

.hs-video-form .hs-back-button {
  background-color: #fff;
  width: 20%;
  height: 38px;
  margin-right: 10px;
  border: 1px solid;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  border-radius: 3px;
}

.hs-video-form .hs-button {
  width: 70%;
}

.hs-video-form .hs-button span {
  font-size: 15px;
}

.hs-video-form .hs-richtext {
  color: #fff !important;
}

.hs-video-form .legal-consent-container {
  max-height: 180px !important;
  overflow-y: scroll !important;
}

.hs-video-form .legal-consent-container:after {
  content: "";
  display: block;
  height: 100px;
  width: 100%;
}

.hs-video-form .legal-consent-wrapper {
  position: relative;
}

.hs-video-form .legal-consent-overlay {
  position: absolute;
  pointer-events: none;
  left: 0;
  bottom: 0;
  height: 100px;
  width: 100%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #292929 100%);
}

.hs-error-msgs label {
  color: #f2545b;
}

.hs-input {
  display: inline-block;
  width: 90%;
  max-width: 500px;
  height: 40px;
  padding: 9px 10px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: normal;
  line-height: 22px;
  color: #33475b;
  border: 1px solid #cbd6e2;
  box-sizing: border-box;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  border-radius: 3px;
}

.hs-input:not([type=file]) {
  background-color: #f5f8fa;
}

.hs-input[type=checkbox], .hs-input[type=radio] {
  cursor: pointer;
  width: auto;
  height: auto;
  padding: 0;
  margin: 3px 5px 3px 0px;
  line-height: normal;
  border: none;
}

.hs-input[type=file] {
  padding: initial;
  border: initial;
  line-height: initial;
  box-shadow: none;
}

select.is-placeholder {
  color: #bfbfbf;
}

select.is-placeholder:focus {
  color: #33475b;
}

.hs-input:-moz-placeholder {
  color: #bfbfbf;
}

.hs-input::-webkit-input-placeholder {
  color: #bfbfbf;
}

.hs-input option:disabled {
  color: #bfbfbf;
}

.hs-input input, .hs-input textarea {
  transition: border 0.2s linear;
}

.hs-input:focus {
  outline: none;
  border-color: rgba(82, 168, 236, 0.8);
}

textarea.hs-input {
  height: auto;
}

select[multiple].hs-input {
  height: inherit;
}

input.hs-input.error, div.field.error input, div.field.error textarea, div.field.error .chzn-choices, textarea.hs-input.error, select.hs-input.error {
  border-color: #c87872 !important;
}

input.hs-input.error:focus, div.field.error input:focus, div.field.error textarea:focus, div.field.error .chzn-choices:focus, textarea.hs-input.error:focus, select.hs-input.error:focus {
  border-color: #b9554d !important;
}

.actions {
  margin-top: 18px;
  margin-bottom: 18px;
  padding: 17px 0px;
}

.inputs-list {
  margin: 0 0 5px;
  width: 100%;
  padding-left: 5px;
}

.inputs-list > li {
  display: block;
  padding: 0;
  width: 100%;
  padding-top: 0;
}

.inputs-list label {
  display: block;
  float: none;
  width: auto;
  padding: 0;
  line-height: 18px;
  text-align: left;
  white-space: normal;
  font-weight: normal;
}

.inputs-list:first-child {
  padding-top: 6px;
}

.inputs-list > li + li {
  padding-top: 2px;
}

ul.no-list {
  list-style: none;
}

.field {
  margin-bottom: 18px;
}

.hs-field-desc {
  color: #7c98b6;
  margin: 0px 0px 6px;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.hs-form-required {
  color: red;
}

.hs-richtext {
  margin-bottom: 3px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 24px;
  font-size: 14px;
  color: #33475b;
}

.hs-richtext hr {
  text-align: left;
  margin-left: 0;
  width: 91%;
}

.email-correction, .email-validation {
  padding-top: 3px;
  font-size: 12px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.email-correction a, .email-validation a {
  cursor: pointer;
}

@media (max-width: 400px), (min-device-width: 320px) and (max-device-width: 480px) {
  .email-correction form .form-columns-2 .hs-form-field, .email-correction form .form-columns-3 .hs-form-field, .email-validation form .form-columns-2 .hs-form-field, .email-validation form .form-columns-3 .hs-form-field {
    float: none;
    width: 100%;
  }
  .email-correction form .form-columns-2 .hs-form-field .hs-input, .email-correction form .form-columns-3 .hs-form-field .hs-input, .email-validation form .form-columns-2 .hs-form-field .hs-input, .email-validation form .form-columns-3 .hs-form-field .hs-input {
    width: 90%;
  }
  .email-correction form .form-columns-2 .hs-form-field input[type=checkbox], .email-correction form .form-columns-2 .hs-form-field input[type=radio], .email-correction form .form-columns-3 .hs-form-field input[type=checkbox], .email-correction form .form-columns-3 .hs-form-field input[type=radio], .email-validation form .form-columns-2 .hs-form-field input[type=checkbox], .email-validation form .form-columns-2 .hs-form-field input[type=radio], .email-validation form .form-columns-3 .hs-form-field input[type=checkbox], .email-validation form .form-columns-3 .hs-form-field input[type=radio] {
    width: 24px;
  }
}
.hs-button, .hs-form-field input[type=text], .hs-form-field input[type=email], .hs-form-field input[type=phone], .hs-form-field input[type=number], .hs-form-field input[type=tel], .hs-form-field input[type=date], .hs-form-field textarea {
  -webkit-appearance: none;
  -moz-appearance: none;
}

.hs-default-font-element, .hs-main-font-element {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.hs-form label {
  margin: 0 !important;
  font-family: "Poppins", sans-serif !important;
}

.hs-form input[type=checkbox] {
  margin: 0 10px 0 0 !important;
}

.hs-form fieldset {
  max-width: unset !important;
}

.hs-input {
  max-width: unset !important;
  font-family: "Poppins", sans-serif !important;
}

.hs-form .input textarea {
  width: 100% !important;
}

.hs-form .input select {
  width: 100% !important;
}

.hs-form select {
  margin: 0 !important;
}

.hs-form textarea {
  margin: 0 !important;
}

.hs-form input[type=text], .hs-form input[type=email], .hs-form input[type=tel] {
  margin: 0 !important;
}

.hs-form input[type=file i]::-webkit-file-upload-button {
  cursor: pointer !important;
}

.hs-form ::placeholder {
  color: #bfbfbf !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

.hs-form .input input[type=file] {
  width: 100% !important;
  margin: 0 !important;
}

.hs-form .input input[type=text] {
  width: 100% !important;
  border: 1px solid #cbd6e2;
  border-radius: 3px !important;
}

.hs-form .input input[type=text]::placeholder {
  font-size: 14px !important;
}

.hs-field-desc {
  text-align: left !important;
}

.hs-form body .hs-button.primary, body input[type=submit], body input[type=button] {
  float: none !important;
  margin: 0 !important;
}

.hs-form .actions {
  margin: 0 !important;
  text-align: left !important;
}

/* OVERRIDE DEFAULT REACT-DATES STYLES */

/* Will edit everything selected including everything between a range of dates */
.CalendarDay__selected_span {
  background: #3392E6 !important;
  border: 1px double #3392E6 !important;
  color: white !important;
}

/* Will edit selected date or the endpoints of a range of dates */
.CalendarDay__selected {
  background: #3392E6 !important;
  border: 1px double #3392E6 !important;
  color: white !important;
}

/* Will edit when hovered over. _span style also has this property */
.CalendarDay__selected:hover {
  opacity: 0.8 !important;
}

/* Will edit when the second date (end date) in a range of dates */
/* is not yet selected. Edits the dates between your mouse and said date */
.CalendarDay__hovered_span:hover,
.CalendarDay__hovered_span {
  background: #3392E6 !important;
}

.DayPickerKeyboardShortcuts_show__bottomRight::before {
  border-right: 33px solid #3392E6 !important;
  border-right-color: #3392E6 !important;
}

.SingleDatePicker_picker {
  z-index: 100 !important;
}

.SingleDatePicker {
  display: block !important;
}

.SingleDatePickerInput {
  display: block !important;
}

.DateInput {
  display: block !important;
  width: 100% !important;
}

.DateInput_input {
  font-size: 14px !important;
  color: #808080 !important;
  border: 1px solid #ced4da !important;
  box-shadow: none !important;
  border-radius: 0.25rem !important;
  padding: 10px 0 5px 10px !important;
  font-weight: 400 !important;
  display: block !important;
  width: 100% !important;
  height: calc(2.25rem + 2px) !important;
}

.DateInput_input__focused {
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem !important;
}

.DateRangePicker {
  display: block !important;
}

.DateRangePickerInput {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.DateRangePickerInput_arrow {
  padding: 0 10px !important;
}

.DateInput_input__disabled {
  font-style: normal !important;
}

.hs-form input[type=text],
.hs-form input[type=email],
.hs-form input[type=tel] {
  border: none;
  box-shadow: none;
  border-radius: 5;
  padding: "5px 0 5px 0";
  font-weight: 400;
  font-size: 14px;
  font-family: "Roboto";
  letter-spacing: 2;
  line-height: 1.5;
  margin: 5px 0 10px 0;
  color: #0071B9;
  padding-bottom: 5px;
  border: 1px solid #cbd6e2;
  width: 100%;
}

.hs-form input[type=checkbox] {
  margin: 10px 10px 10px 0;
}

.hs-form input[type=text]:focus {
  outline: 0;
}

.hs-form input[type=email]:focus {
  outline: 0;
}

.hs-form input[type=tel]:focus {
  outline: 0;
}

.hs-form label {
  font-family: "Roboto";
  margin: 10px 0;
}

.hs-form .hs-form-field > label {
  color: #0071B9;
  font-family: "Roboto";
  margin: 10px 0;
}

.hs-form .hs-field-desc {
  color: #33475b;
  font-family: "Roboto";
  margin: 5px 0;
}

.hs-form select {
  background: whitesmoke;
  margin: 15px 0 25px 0;
  color: #5e7993;
  border-radius: 3px;
  font-family: "Roboto";
}

.hs-form select:focus {
  outline: none;
}

.hs-form select:active {
  outline: none;
}

.hs-form .hs-richtext {
  color: #5e7993;
  font-family: "Roboto";
  margin: 5px 0 20px 0;
  font-size: 14px;
}

.hs-form textarea {
  margin: 10px 0;
  color: #0071B9;
  border: 1px solid #d8dcdf;
  border-radius: 0.2rem;
  width: 100%;
}

.hs-form textarea:focus {
  outline: none;
}

body .hs-button.primary,
body input[type=submit],
body input[type=button] {
  background: #0071B9;
  color: #ffffff;
  border-radius: 0.2rem;
  padding: 1em;
  font-size: 14px;
  font-weight: 400;
  padding: 10px 20px;
  margin-bottom: -70px;
  font-family: "Roboto";
  border: 1px solid #0071B9;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  margin: 30px 0 0 10px;
}

body .hs-button.primary:hover,
body input[type=submit]:hover,
body input[type=button]:hover {
  cursor: pointer;
  opacity: 0.8;
}

body input[type=file] {
  margin: 25px 0 25px 0;
  font-family: "Roboto";
}

.hs-form .hs-error-msgs label {
  color: #d8000c;
  font-size: 13px;
  padding-bottom: 5px;
}

.material-icons {
  user-select: none;
}

.d-inline-block {
  user-select: none;
}

/*Typography Styles*/
h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  font-weight: 400;
  margin: 0 0 12px;
  color: inherit;
}

h1, .h1 {
  font-size: 24px;
  font-family: "Poppins", sans-serif;
}

h2, .h2 {
  font-size: 18px;
  font-family: "Poppins", sans-serif;
}

h3, .h3 {
  font-size: 16px;
}

h4, .h4 {
  font-size: 15px;
}

h5, .h5 {
  font-size: 13px;
}

h6, .h6 {
  font-size: 12px;
}

.text-strikethrough {
  text-decoration: line-through !important;
}

@media screen and (max-width: 991px) {
  h1, .h1 {
    font-size: 18px;
    font-family: "Poppins", sans-serif;
  }
  h2, .h2 {
    font-size: 16px;
    font-family: "Poppins", sans-serif;
  }
  h3, .h3 {
    font-size: 15px;
  }
}
.desc-list {
  margin-bottom: 0;
}
.desc-list li {
  padding: 24px 30px;
  border-bottom: 1px solid #ced4da;
  margin-left: -30px;
  margin-right: -30px;
}
.desc-list li:last-child {
  border-bottom: 0 none;
}
.desc-list li .card-title {
  margin-bottom: 6px;
}
.desc-list.even-odd li {
  border-bottom: 0 none;
}
.desc-list.even-odd li:nth-child(2n) {
  background-color: #dee2e6;
}

/* Layouts
   ========================================================================== */
/*App Layout Styles*/
#app-site,
.app-main {
  display: flex;
  width: 100%;
  height: 100%;
}

.app-container {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
}

.app-sidebar {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}

.app-main-container {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  overflow: hidden;
  position: relative;
}

.app-header {
  min-height: 60px;
  z-index: 99;
  position: relative;
}

.app-main-content-wrapper {
  flex: 1;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.app-container.fixed-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
}
.app-container.collapsible-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
}
.app-container.collapsible-drawer .app-main-container {
  position: relative;
}
.app-container.mini-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
}
.app-container.mini-drawer .app-sidebar {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

/*Sidebar Styles*/
.side-nav {
  width: 200px;
  background-color: #f5f7f9 !important;
  color: #868e96 !important;
  border-right: solid 1px #e9ecef !important;
  z-index: 1250 !important;
  height: 100%;
}
.side-nav .user-profile {
  background-color: rgb(235.4375, 239.35, 243.2625);
  padding: 13px 20px !important;
}
.side-nav .user-avatar {
  margin: 0 15px 0 0 !important;
  height: 44px !important;
  width: 44px !important;
  line-height: 44px;
}
.side-nav .user-detail .user-name {
  color: #3f51b5;
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  white-space: nowrap;
}

.user-detail .user-name {
  cursor: pointer;
}

/*Navbar Styles*/
ul.nav-menu {
  position: relative;
  font-size: 13px;
  list-style: outside none none;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

ul.nav-menu li {
  position: relative;
  margin-bottom: 1px;
}

ul.nav-menu li.menu + .nav-header {
  margin-top: 40px;
}
ul.nav-menu li.menu .sub-menu {
  display: none;
}
ul.nav-menu li.menu.open > .sub-menu {
  display: block;
}
ul.nav-menu li.menu.open .menu.active > .sub-menu {
  display: block;
}

ul.nav-menu li a {
  color: #868e96;
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  border-radius: 0;
}
ul.nav-menu li a .badge {
  margin-bottom: 0;
  padding: 3px 8px 2px;
}

ul.nav-menu .nav-header {
  color: #868e96;
  padding: 4px 22px;
  font-size: 11px;
  text-transform: uppercase;
}
ul.nav-menu .nav-header:first-child {
  margin-top: 30px;
}

ul.nav-menu > li.selected > a,
ul.nav-menu > li.open > a,
ul.nav-menu > li > a:hover,
ul.nav-menu > li > a:focus {
  color: #3f51b5;
}

ul.nav-menu li.menu > a {
  padding: 16px 20px;
  border-left: 2px solid transparent;
}

ul.nav-menu li.menu.open > a {
  border-color: transparent;
}

ul.nav-menu li.menu > a:focus:before,
ul.nav-menu li.menu > a:hover:before {
  color: #3f51b5;
}

ul.nav-menu li i {
  margin-right: 12px;
  font-size: 15px;
}

ul.nav-menu li ul {
  list-style: outside none none;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
}

ul.nav-menu li ul.sub-menu li > a {
  padding: 7px 20px 7px 56px;
}

ul.nav-menu li ul.sub-menu > li > ul > li > a {
  padding-left: 76px;
}

ul.nav-menu li ul.sub-menu > li > ul > li > ul > li > a {
  padding-left: 96px;
}

ul.nav-menu li ul.sub-menu > li > ul > li > ul > li > ul > li > a {
  padding-left: 116px;
}

ul.nav-menu li.menu > a:before {
  color: #868e96;
  content: "\\f2fb";
  display: inline-block;
  float: right;
  font-family: "Material-Design-Iconic-Font";
  font-size: 15px;
  margin-left: 10px;
  position: relative;
  -webkit-transition: all 300ms ease-in-out;
  -o-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
  font-weight: normal;
}

ul.nav-menu li.menu.no-arrow > a:before {
  display: none;
}

ul.nav-menu li.menu.selected > a:before,
ul.nav-menu li.menu.open > a:before,
ul.nav-menu li.menu > a:focus:before,
ul.nav-menu li.menu li > a:hover:before {
  background-color: transparent;
  color: #3f51b5;
}

ul.nav-menu li.menu.open > a:before,
ul.nav-menu li.menu.active > a:before {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  padding: 3px 7px;
  margin-left: -7px;
  background-color: #3f51b5;
  color: #fff;
  border-radius: 4px;
  display: inline-block;
}

ul.nav-menu li.menu .sub-menu li > a:hover,
ul.nav-menu li.menu .sub-menu li > a:focus,
ul.nav-menu li.menu.open .sub-menu li > a.active:before,
ul.nav-menu li.menu .sub-menu li > a:focus:before,
ul.nav-menu li.menu .sub-menu li > a:hover:before {
  color: #3f51b5;
}

.app-container.mini-drawer .side-nav {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  width: 80px;
}
.app-container.mini-drawer .side-nav .nav-menu li span.nav-text, .app-container.mini-drawer .side-nav .customizer {
  display: none;
}
.app-container.mini-drawer .side-nav .user-profile .user-detail {
  display: none !important;
}
.app-container.mini-drawer .side-nav .nav-menu .menu.open > .sub-menu {
  display: none !important;
}
.app-container.mini-drawer .side-nav .nav-menu li {
  text-align: center;
}
.app-container.mini-drawer .side-nav .nav-menu li i {
  margin-right: 0;
}
.app-container.mini-drawer .side-nav .nav-menu li.nav-header {
  padding: 4px 5px;
}
.app-container.mini-drawer .side-nav ul.nav-menu li a {
  padding: 16px 20px;
}
.app-container.mini-drawer .side-nav ul.nav-menu ul.sub-menu li a {
  padding-left: 30px;
}
.app-container.mini-drawer .side-nav ul.nav-menu > li > a:before {
  display: none;
}
.app-container.mini-drawer .side-nav .mini-logo-img-hover {
  display: none;
}

.app-container.mini-drawer .side-nav:hover {
  width: 200px;
}
.app-container.mini-drawer .side-nav:hover .nav-menu li span.nav-text {
  display: inline-block !important;
}
.app-container.mini-drawer .side-nav:hover .user-profile .user-detail {
  display: flex !important;
}
.app-container.mini-drawer .side-nav:hover .nav-menu .menu.open > .sub-menu {
  display: block !important;
}
.app-container.mini-drawer .side-nav:hover .customizer {
  display: flex !important;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu li {
  text-align: left;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu li i {
  margin-right: 16px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu li a {
  padding: 16px 20px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu li.nav-header {
  padding: 4px 22px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu li a {
  padding: 7px 20px 7px 56px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > a {
  padding-left: 76px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > ul > li > a {
  padding-left: 96px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > ul > li > ul > li > a {
  padding-left: 116px;
}
.app-container.mini-drawer .side-nav:hover ul.nav-menu > li > a:before {
  display: block;
}
.app-container.mini-drawer .side-nav:hover .mini-logo-img {
  display: none;
}
.app-container.mini-drawer .side-nav:hover .mini-logo-img-hover {
  display: block;
}

.customizer {
  padding: 20px 35px;
}
.customizer img {
  padding: 5px;
  cursor: pointer;
}

.user-info ul li {
  font-size: 15px;
}

.rmc-drawer-left .rmc-drawer-sidebar, .rmc-drawer-right .rmc-drawer-sidebar {
  height: 100%;
}

.rmc-drawer-sidebar {
  position: fixed;
  transition: -webkit-transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
  overflow: hidden;
}
.rmc-drawer.rmc-drawer-left .rmc-drawer-sidebar {
  left: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  z-index: 903;
}
.rmc-drawer.rmc-drawer-right .rmc-drawer-sidebar {
  right: 0;
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
  z-index: 903;
}
.rmc-drawer.rmc-drawer-top .rmc-drawer-sidebar {
  z-index: 903;
}
.rmc-drawer.rmc-drawer-bottom .rmc-drawer-sidebar {
  z-index: 903;
}

@media (max-width: 1025px) {
  .rmc-drawer-draghandle {
    background-color: transparent;
  }
}

.drawer-container {
  position: relative;
}
.drawer-container .main {
  position: relative;
  padding: 10px;
  box-sizing: border-box;
}

.rmc-drawer-overlay {
  z-index: 902;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-out;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100%;
  min-width: 100% !important;
}

.app-sidebar.rmc-drawer.rmc-drawer-docked {
  position: relative;
}

/*Header Styles*/
.jr-menu-icon {
  outline: none !important;
  -webkit-justify-content: flex-start !important;
  justify-content: flex-start !important;
  padding: 0 5px !important;
  margin-right: 15px;
  display: flex;
  cursor: pointer;
  align-items: center;
}

.app-main-header {
  background-color: #fff;
  color: #808080;
  max-height: 70px;
  position: relative;
}
.app-main-header .search-bar input {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  background-color: transparent;
  color: #808080;
  font-weight: 200;
}
.app-main-header .search-bar input + .search-icon {
  top: 0;
}
.app-main-header .search-bar input + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
  font-size: 32px;
}
.app-main-header .search-bar input::placeholder {
  color: grey;
}
.app-main-header .search-bar input:focus {
  background-color: #fff;
  color: #808080;
}
.app-main-header .search-bar input:focus + .search-icon i {
  color: rgba(128, 128, 128, 0.8);
}
.jr-card .app-main-header {
  border: 1px solid #ced4da;
  border-radius: 8px;
}

.app-logo {
  margin-right: 12px;
}
.app-logo img {
  height: 35px;
}
@media screen and (max-width: 575px) {
  .app-logo img {
    height: 28px;
  }
}
.app-header .app-logo {
  margin-right: 20px;
}
@media screen and (max-width: 991px) {
  .app-header .app-logo {
    margin-right: auto;
  }
}

.react-logo-white.d-block {
  display: none !important;
}

@media screen and (min-width: 992px) {
  .react-logo-white.d-lg-block {
    display: none !important;
  }
}
.sidebar-header {
  min-height: 70px;
  padding: 10px 22px;
}

.app-toolbar {
  min-height: 60px;
  padding: 0 17px 0 0;
}
.app-toolbar .search-bar {
  margin-right: auto;
  max-width: 320px;
  width: 300px;
}
@media screen and (max-width: 1199px) {
  .app-toolbar .search-bar {
    width: 240px;
  }
}
@media screen and (max-width: 1099px) {
  .app-toolbar .search-bar {
    width: 200px;
  }
}
@media screen and (max-width: 767px) {
  .app-toolbar .search-bar {
    margin-left: 40px;
    width: 180px;
  }
}
@media screen and (max-width: 575px) {
  .app-toolbar {
    padding: 0 17px;
  }
}
@media screen and (max-width: 1199px) {
  .app-toolbar {
    padding: 0 17px;
  }
}
.app-top-nav .app-toolbar {
  min-height: 40px;
}

@media screen and (max-width: 1199px) {
  .app-header-horizontal .app-toolbar .search-bar {
    margin-right: 10px;
  }
}

.app-toolbar-special .search-bar {
  width: 200px;
}
@media screen and (max-width: 991px) {
  .app-toolbar-special .search-bar {
    width: 280px;
  }
}
@media screen and (max-width: 767px) {
  .app-toolbar-special .search-bar {
    width: 200px;
  }
}

.app-toolbar .nav-searchbox .search-bar {
  margin-left: 0;
  width: 100%;
}
.app-toolbar .nav-searchbox .search-bar input {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
  color: #5c5c5c;
}
.app-toolbar .nav-searchbox .search-bar input + .search-icon i {
  color: rgba(92, 92, 92, 0.8);
}
.app-toolbar .nav-searchbox .search-bar input:focus {
  background-color: transparent;
  color: #5c5c5c;
}
.app-toolbar .nav-searchbox .search-bar input:focus + .search-icon i {
  color: rgba(92, 92, 92, 0.8);
}

.header-notifications {
  margin-bottom: 0;
}
.header-notifications li {
  vertical-align: middle;
}
@media screen and (max-width: 449px) {
  .header-notifications .list-inline-item:not(:last-child) {
    margin-right: 0;
  }
}

.dropdown-menu {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}

.quick-menu .dropdown-menu {
  padding: 5px 10px;
  width: 350px;
}
.quick-menu .dropdown-menu .jr-card-header {
  margin: -5px -10px 5px;
  padding: 10px 10px 10px 20px;
  border-bottom: 1px solid #dee2e6;
  z-index: 10;
}
.quick-menu .dropdown-menu:after {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #fff;
  top: -9px;
  content: "";
  height: 9px;
  position: absolute;
  right: 8px;
  width: 10px;
}
.quick-menu .dropdown-menu:before {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #000;
  top: -10px;
  content: "";
  height: 10px;
  position: absolute;
  right: 8px;
  width: 10px;
}
@media screen and (max-width: 449px) {
  .quick-menu .dropdown-menu {
    width: 230px;
  }
}
@media screen and (max-width: 359px) {
  .quick-menu .dropdown-menu {
    width: 180px;
  }
}
.quick-menu .messages-list .user-avatar {
  position: relative;
}
.quick-menu .messages-list .badge {
  position: absolute;
  left: -4px;
  top: -4px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  padding: 0;
}

.app-header .nav-searchbox.quick-menu .dropdown-menu {
  width: 200px;
  left: 0 !important;
  right: auto !important;
}
.app-header .nav-searchbox.quick-menu .dropdown-menu:after {
  right: auto;
  left: 8px;
}
.app-header .nav-searchbox.quick-menu .dropdown-menu:before {
  right: auto;
  left: 8px;
}
@media screen and (max-width: 400px) {
  .app-header .nav-searchbox.quick-menu {
    display: none;
  }
}

@media screen and (max-width: 575px) {
  .app-header .nav-searchbox.quick-menu .dropdown-menu {
    width: 200px;
  }
}
@media screen and (max-width: 399px) {
  .app-header .nav-searchbox.quick-menu .dropdown-menu {
    width: 100px;
  }
}
.language-list li {
  display: block !important;
}

.messages-list.language-list ul li {
  padding: 7px 6px 6px;
}

.messages-list ul li {
  position: relative;
  padding: 20px 10px 14px;
  border-bottom: 1px solid #dee2e6;
}
.messages-list ul li .user-name a {
  color: #3f51b5;
}
.messages-list ul li .sub-heading {
  font-size: 11px;
  margin-bottom: 6px !important;
}
.messages-list ul li .sub-heading.mb-0 {
  margin-bottom: 0 !important;
}
.messages-list ul li:last-child {
  border-bottom: 0 none;
}
.messages-list ul li .jr-btn {
  margin-right: 0 !important;
}
.messages-list ul li .jr-btn-xs {
  font-size: 11px !important;
  padding: 5px !important;
}

.quick-menu .icon-btn {
  color: #808080;
}
.quick-menu .icon-alert {
  position: relative;
}
.quick-menu .icon-alert:after {
  display: block;
  position: absolute;
  content: "";
  right: 0;
  top: 0;
  z-index: 10;
  width: 8px;
  height: 8px;
  background-color: #f44336;
  border-radius: 50%;
}
.quick-menu i.animated.infinite {
  -moz-animation-iteration-count: 25;
  -webkit-animation-iteration-count: 25;
  -o-animation-iteration-count: 25;
  animation-iteration-count: 25;
}

.quick-menu .dropdown-menu {
  display: block;
  visibility: hidden;
  left: auto !important;
  right: 0 !important;
  opacity: 0;
  transform: translate3d(0px, 100px, 0px) !important;
  -webkit-transition: all 200ms linear 0ms;
  -o-transition: all 200ms linear 0ms;
  transition: all 200ms linear 0ms;
}
.quick-menu.show .dropdown-menu {
  opacity: 1;
  transform: translate3d(0px, 30px, 0px) !important;
  visibility: visible;
}

.user-nav .quick-menu .dropdown-menu {
  width: 200px;
  padding: 0 0 15px;
}
.user-nav .quick-menu .dropdown-menu:after {
  border-bottom-color: #fff;
}
.user-nav .quick-menu .user-profile {
  position: relative;
  padding: 20px 25px;
  background-color: #fff;
  margin-bottom: 15px;
  border-radius: 0.25rem 0.25rem 0 0;
}

.module-box-header-right {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}

.app-top-header {
  position: relative;
  z-index: 9999;
}

/*Navbar Styles*/
.app-main-menu .navbar-nav {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.navbar-nav {
  position: relative;
}
.navbar-nav li {
  position: relative;
}
.navbar-nav li:hover > ul.sub-menu, .navbar-nav li:focus > ul.sub-menu {
  opacity: 1;
  visibility: visible;
  top: 100%;
}
.navbar-nav li:hover > a, .navbar-nav li:focus > a {
  color: #3f51b5;
}
.navbar-nav li a {
  display: block;
  color: #868e96;
  padding: 10px 0;
  font-size: 14px;
}
.navbar-nav li a:hover, .navbar-nav li a:focus {
  text-decoration: none;
  color: #3f51b5;
}
.navbar-nav li.mega-menu {
  position: static;
}
.navbar-nav li.mega-menu ul.sub-menu {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 85%;
  margin: 0 auto;
  left: 0;
  right: 0;
}
.navbar-nav li.mega-menu ul.sub-menu li {
  width: 25%;
  padding: 0 15px;
}
.navbar-nav > li:last-child ul.sub-menu {
  left: auto;
  right: 0;
}
.navbar-nav > li:last-child ul.sub-menu ul.sub-menu {
  left: auto;
  right: 100%;
  top: 50px;
}
.navbar-nav > li:last-child ul.sub-menu li:hover > ul.sub-menu,
.navbar-nav > li:last-child ul.sub-menu li:focus > ul.sub-menu {
  top: 0;
}
.navbar-nav li.nav-item {
  padding: 0 10px;
}
.navbar-nav li.nav-item > a {
  padding: 23px 0;
}
.navbar-nav li.nav-item.active > a {
  color: #3f51b5;
}
.navbar-nav li.nav-item:hover > a, .navbar-nav li.nav-item:focus > a, .navbar-nav li.nav-item > a:hover, .navbar-nav li.nav-item > a:focus {
  color: #3f51b5;
}
.navbar-nav ul.sub-menu {
  list-style: none;
  border: solid 1px #ced4da;
  position: absolute;
  left: 0;
  top: 100px;
  opacity: 0;
  padding: 10px 0;
  background-color: #fff;
  visibility: hidden;
  border-radius: 4px;
  -webkit-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.navbar-nav ul.sub-menu li a {
  padding: 5px 15px;
  width: 200px;
  font-size: 14px;
}
.navbar-nav ul.sub-menu li a.active {
  color: #3f51b5;
}
.navbar-nav ul.sub-menu li > ul.sub-menu {
  left: 100%;
  right: auto;
  top: 50px;
}
.navbar-nav ul.sub-menu li:hover > ul.sub-menu, .navbar-nav ul.sub-menu li:focus > ul.sub-menu {
  top: 0;
}
.navbar-nav ul.sub-menu li a i {
  margin-right: 10px;
}
.navbar-nav ul.sub-menu li.active > a {
  color: #3f51b5;
}
.navbar-nav .nav-arrow > a {
  position: relative;
}
.navbar-nav .nav-arrow > a:before {
  color: #868e96;
  content: "\\f2fb";
  display: inline-block;
  float: right;
  font-family: "Material-Design-Iconic-Font";
  font-size: 15px;
  margin-left: 10px;
  position: relative;
  -webkit-transition: all 300ms ease-in-out;
  -o-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
  font-weight: normal;
}
.navbar-nav .nav-arrow a:hover:before, .navbar-nav .nav-arrow a:focus:before {
  color: #3f51b5;
}
.navbar-nav .nav-arrow:hover > a:before, .navbar-nav .nav-arrow:focus > a:before, .navbar-nav .nav-arrow.active > a:before {
  color: #3f51b5;
}
.navbar-nav ul.sub-menu-half {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 300px;
}
.navbar-nav ul.sub-menu-half li {
  width: 50%;
}
.navbar-nav ul.sub-menu-half li a {
  width: 100%;
}
@media screen and (max-width: 1099px) {
  .navbar-nav ul.sub-menu-half li a {
    font-size: 13px;
  }
}
@media screen and (max-width: 1099px) {
  .navbar-nav ul.sub-menu-half {
    width: 262px;
  }
}

.navbar-nav-mega {
  position: static !important;
}

.app-top-nav {
  background-color: #3f51b5;
}
.app-top-nav .navbar-nav li.nav-item {
  padding: 0 30px;
}
.app-top-nav .navbar-nav li.nav-item > a {
  color: #fff;
  padding: 13px 0;
}
.app-top-nav .navbar-nav li.nav-item:hover > a, .app-top-nav .navbar-nav li.nav-item:focus > a, .app-top-nav .navbar-nav li.nav-item > a:hover, .app-top-nav .navbar-nav li.nav-item > a:focus, .app-top-nav .navbar-nav li.nav-item.active > a {
  color: #E91E63;
}
.app-top-nav .navbar-nav ul.sub-menu {
  margin-top: 0;
}

/*Main Content Styles*/
.app-main-content {
  flex: 1;
  width: 100%;
}
@media screen and (max-width: 575px) {
  .app-main-content {
    padding: 0;
  }
}

.app-wrapper {
  padding: 36px 40px 0 40px;
  width: 100%;
}
@media screen and (max-width: 575px) {
  .app-wrapper {
    padding: 20px;
  }
}

/*Footer Styles*/
.app-footer {
  padding: 0 40px;
  border-top: solid 1px rgb(229.5, 229.5, 229.5);
  background-color: #fff;
  color: #868e96;
  line-height: 50px;
  min-height: 50px;
}
.app-footer a {
  color: #868e96;
}
.app-footer a:hover {
  color: #3f51b5;
}
@media screen and (max-width: 575px) {
  .app-footer {
    padding: 20px;
  }
}
@media screen and (max-width: 400px) {
  .app-footer {
    font-size: 12px;
  }
}

/*Right Sidebar Styles*/
.color-theme {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: 300px;
  height: 100%;
}
@media screen and (max-width: 499px) {
  .color-theme {
    max-width: 250px;
  }
}

.color-theme-header {
  background-color: #3f51b5;
  color: #fff;
  padding: 19px 25px 20px;
  text-transform: uppercase;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.color-theme-header .color-theme-title {
  margin-bottom: 0;
}

.color-theme-body {
  padding: 28px 25px;
}
.color-theme-body h3 {
  margin-bottom: 20px;
}
@media screen and (max-width: 499px) {
  .color-theme-body {
    padding: 25px 15px;
  }
}

.color-option {
  list-style: none;
  padding-left: 0;
  margin: 0 -7px 10px;
}
.color-option li {
  position: relative;
  display: inline-block;
  padding: 0 7px;
  margin-bottom: 10px;
}
.color-option li a {
  height: 45px;
  width: 45px;
  line-height: 45px;
  display: inline-block;
  color: transparent !important;
  position: relative;
}
.color-option li a:before {
  content: "\\f26b";
  font-family: "Material-Design-Iconic-Font";
  font-size: 20px;
  height: 45px;
  width: 45px;
  line-height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  text-align: center;
  display: none;
  z-index: 2;
}
.color-option li a.active:before {
  display: block;
}

.cr-op-dark-sidebar li a:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  background-color: #5c5c5c;
  width: 8px;
}

.theme-option {
  position: fixed;
  top: 10%;
  right: 0;
  z-index: 1500;
  background-color: #0070cd;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -o-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  color: #fff;
}
.theme-option span.icon-btn {
  position: relative;
  z-index: 1505;
}

.app-sidebar-content.right-sidebar .rmc-drawer-sidebar {
  z-index: 1506;
  color: #5c5c5c;
  background-color: #fff;
}

.material-switch {
  margin-bottom: 24px;
}
.material-switch > input[type=checkbox] {
  display: none;
}
.material-switch > label {
  cursor: pointer;
  height: 0;
  position: relative;
  width: 40px;
}
.material-switch > label:before {
  background: rgb(0, 0, 0);
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  content: "";
  height: 16px;
  margin-top: -8px;
  position: absolute;
  opacity: 0.3;
  transition: all 0.4s ease-in-out;
  width: 40px;
}
.material-switch > label:after {
  background: rgb(255, 255, 255);
  border-radius: 16px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  content: "";
  height: 24px;
  left: -4px;
  margin-top: -8px;
  position: absolute;
  top: -4px;
  transition: all 0.3s ease-in-out;
  width: 24px;
}
.material-switch > input[type=checkbox]:checked + label::before {
  background: #000;
  opacity: 0.5;
}
.material-switch > input[type=checkbox]:checked + label::after {
  background: #495057;
  left: 20px;
}

@media screen and (max-width: 499px) {
  .color-theme .jr-btn {
    padding: 10px 15px !important;
  }
}
/* UI Components
   ========================================================================== */
/*Alert Styles*/
.alert {
  border: 0 none;
  padding: 20px 24px;
  border-radius: 8px;
  position: relative;
}
.alert .close {
  line-height: inherit;
  font-weight: 300;
}
.alert .alert-addon {
  width: 60px;
  background-color: rgba(0, 0, 0, 0.2);
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}

.alert-dismissible {
  padding-right: 60px;
}

.alert-addon-card {
  padding-left: 80px;
}

/*Avatar Styles*/
.user-avatar {
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  position: relative;
  overflow: hidden;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  border-radius: 50%;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  border: 1px solid #ced4da;
}
.user-avatar.avatar-shadow {
  border: 0 none;
}

.user-profile {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}
.user-profile .user-detail {
  -webkit-flex: 1;
  flex: 1;
  -ms-flex-align: center;
  -webkit-align-self: center;
  align-self: center;
}

.user-detail .user-name {
  margin-bottom: 2px;
  font-weight: 400;
  text-transform: capitalize;
}
.user-detail .user-description {
  font-size: 12px;
  margin-bottom: 0;
  color: #adb5bd;
}

.user-thumb {
  position: relative;
}
.messages-list .user-thumb {
  margin-right: 8px;
}

/*Badges Styles*/
.badge {
  font-weight: 400;
  padding: 3px 8px;
  line-height: inherit;
  margin-bottom: 6px;
  border-radius: 2px;
}
.badge:not(:last-child) {
  margin-right: 15px;
}
table .badge {
  margin-bottom: 0;
}

.badge-pill {
  border-radius: 20px;
}

.badge-border {
  border: 2px solid !important;
}

.badge-outline {
  background-color: transparent;
  border: 1px solid #ced4da;
}

/*Blockquotes Styles*/
blockquote {
  padding: 10px 0 10px 20px;
  font-size: 13px !important;
}
blockquote .blockquote-footer {
  font-size: 13px !important;
}

.blockquote {
  border-left: 5px solid #e9ecef;
}

.blockquote-reverse {
  border-left: 0 none;
  border-right: 5px solid #e9ecef;
  text-align: right;
  padding-left: 0;
  padding-right: 20px;
}

/*Bottom Navigation Styles*/
.bottom-navigation button {
  min-width: 10px !important;
}

/*Breadcrumb Styles*/
.breadcrumb {
  border-radius: 2px;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: "\\f2fb";
  font-family: "Material-Design-Iconic-Font";
  font-size: 16px;
  line-height: 1;
  vertical-align: middle;
}

/*Button Styles*/
button {
  outline: 0 none !important;
  cursor: pointer;
  border: 1px solid transparent;
}

.jr-btn {
  position: relative;
  display: inline-block;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  border-radius: 4px;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
}
.jr-btn:hover, .jr-btn:focus, .jr-btn:active {
  outline: 0 none;
  text-decoration: none;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}
.login-content .jr-btn {
  padding: 10px 35px;
}

.btn:hover, .btn:focus, .btn:active {
  outline: 0 none;
  text-decoration: none;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}
.login-content .btn {
  padding: 10px 35px;
}

.btn,
.btn-info,
.btn-success,
.btn-warning,
.btn-danger,
.btn-light,
.btn-dark,
.btn-primary,
.btn-secondary {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

.show > .btn.dropdown-toggle:focus,
.show > .btn-info.dropdown-toggle:focus,
.show > .btn-success.dropdown-toggle:focus,
.show > .btn-warning.dropdown-toggle:focus,
.show > .btn-danger.dropdown-toggle:focus,
.show > .btn-light.dropdown-toggle:focus,
.show > .btn-dark.dropdown-toggle:focus,
.show > .btn-primary.dropdown-toggle:focus,
.show > .btn-secondary.dropdown-toggle:focus {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

.jr-btn,
.jr-fab-btn,
.jr-flat-btn,
.btn {
  margin-bottom: 6px;
}
.jr-btn:not(:last-child),
.jr-fab-btn:not(:last-child),
.jr-flat-btn:not(:last-child),
.btn:not(:last-child) {
  margin-right: 15px;
}
.form-inline .jr-btn,
.form-inline .jr-fab-btn,
.form-inline .jr-flat-btn,
.form-inline .btn {
  margin-bottom: 0;
  min-height: 35px;
}
.navbar .jr-btn,
.navbar .jr-fab-btn,
.navbar .jr-flat-btn,
.navbar .btn {
  margin-bottom: 0;
}

.btn-primary:focus, .btn-primary.focus {
  box-shadow: none !important;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-append > .btn {
  margin-right: 0;
  margin-bottom: 0;
  line-height: inherit;
}

.jr-fab-btn {
  position: relative;
  display: inline-flex;
  border-radius: 50%;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  background-color: #eeeeee;
  overflow: hidden;
}
.jr-fab-btn:hover, .jr-fab-btn:focus {
  outline: 0 none;
  text-decoration: none;
}

.jr-btn,
.jr-flat-btn {
  padding: 12px 20px;
}
.jr-btn i + span, .jr-btn span + i,
.jr-flat-btn i + span,
.jr-flat-btn span + i {
  margin-left: 6px;
}

.jr-flat-btn {
  background-color: transparent;
  color: #5c5c5c;
}
.jr-flat-btn:hover, .jr-flat-btn:focus, .jr-flat-btn:active {
  background-color: #f5f5f5;
  color: #5c5c5c;
}

.jr-btn-group {
  margin: 0 -8px;
}
.jr-btn-group:not(:last-child) {
  margin-bottom: 16px;
}
.jr-btn-group .jr-btn, .jr-btn-group .jr-fab-btn {
  margin: 0 8px 18px;
}

.jr-btn-rounded {
  border-radius: 50px !important;
}

.jr-btn-lg, .btn-group-lg > .jr-btn {
  padding: 16px 24px;
}

.jr-btn-sm, .btn-group-sm > .jr-btn {
  padding: 8px 15px;
}

.jr-btn-xs {
  padding: 6px 10px;
}

.jr-btn-fab-lg,
.jr-btn-lg,
.btn-group-lg > .jr-btn {
  font-size: 17px;
}
.jr-btn-fab-lg i,
.jr-btn-lg i,
.btn-group-lg > .jr-btn i {
  font-size: 19px;
}

.jr-btn-fab-sm,
.jr-btn-sm,
.btn-group-sm > .jr-btn {
  font-size: 11px;
}
.jr-btn-fab-sm i,
.jr-btn-sm i,
.btn-group-sm > .jr-btn i {
  font-size: 11px;
}

.jr-btn-fab-xs,
.jr-btn-xs {
  font-size: 10px;
}
.jr-btn-fab-xs i,
.jr-btn-xs i {
  font-size: 10px;
}

.complex-btn-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  min-width: 200px;
  width: 100%;
}

.complex-btn {
  position: relative;
  height: 200px;
  overflow: hidden;
  width: 33.333%;
  border: 0 none;
}
@media screen and (max-width: 767px) {
  .complex-btn {
    width: 100%;
    height: 100px;
  }
}
.complex-btn:hover {
  z-index: 1;
}
.complex-btn:hover .img-btn-overlay {
  opacity: 0.15;
}
.complex-btn:hover .img-marked {
  opacity: 0;
}
.complex-btn:hover .img-title {
  border: 4px solid currentColor;
}
.complex-btn .img-btn {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  color: #fff;
}
.complex-btn .img-src {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-size: cover;
  background-position: center 40%;
}
.complex-btn .img-btn-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #000;
  opacity: 0.4;
  -webkit-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.complex-btn .img-title {
  position: relative;
  padding: 16px 32px 14px;
}
.complex-btn .img-marked {
  height: 3px;
  width: 18px;
  background: #fff;
  position: absolute;
  bottom: -2px;
  left: calc(50% - 9px);
  -webkit-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-group-mins {
  margin: 0 -5px;
}
.btn-group-mins .btn, .btn-group-mins .jr-btn {
  margin: 0 5px 5px;
}

.jr-btn.jr-btn-label i {
  background-color: rgba(255, 255, 255, 0.2);
  width: 40px;
  height: 100%;
  line-height: 42px;
  text-align: center;
}

.jr-btn.jr-btn-label.left i {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
}

.jr-btn.jr-btn-label.right i {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.jr-btn.jr-btn-label.left i + span {
  margin-left: 30px;
}

.jr-btn.jr-btn-label.right i + span {
  margin-right: 30px;
  margin-left: 0;
}

.jr-btn.jr-btn-label.jr-btn-lg i, .btn-group-lg > .jr-btn.jr-btn-label i {
  line-height: 54px;
}

.jr-btn.jr-btn-label.jr-btn-sm i, .btn-group-sm > .jr-btn.jr-btn-label i {
  line-height: 32px;
}

.jr-btn.jr-btn-label.jr-btn-xs i {
  line-height: 24px;
  width: 30px;
}

.btn-primary {
  background-color: #3f51b5;
  color: #fff;
}
.btn-primary:hover, .btn-primary:focus {
  background-color: rgb(56.4159836066, 72.5348360656, 162.0840163934);
  color: #fff;
}

.btn-red {
  background-color: #F44336;
  color: #fff;
}
.btn-red:hover, .btn-red:focus {
  background-color: rgb(242.6768867925, 44.3867924528, 29.8231132075);
  color: #fff;
}

.btn-pink {
  background-color: #e91e63;
  color: #fff;
}
.btn-pink:hover, .btn-pink:focus {
  background-color: rgb(216.3461538462, 21.1538461538, 87.5);
  color: #fff;
}

.btn-purple {
  background-color: #9C27B0;
  color: #fff;
}
.btn-purple:hover, .btn-purple:focus {
  background-color: rgb(137.4976744186, 34.3744186047, 155.1255813953);
  color: #fff;
}

.btn-deep-purple {
  background-color: #673ab7;
  color: #fff;
}
.btn-deep-purple:hover, .btn-deep-purple:focus {
  background-color: rgb(92.101659751, 51.8630705394, 163.6369294606);
  color: #fff;
}

.btn-indigo {
  background-color: #3f51b5;
  color: #fff;
}
.btn-indigo:hover, .btn-indigo:focus {
  background-color: rgb(56.4159836066, 72.5348360656, 162.0840163934);
  color: #fff;
}

.btn-blue {
  background-color: #2196F3;
  color: #fff;
}
.btn-blue:hover, .btn-blue:focus {
  background-color: rgb(12.8461538462, 138.0961538462, 237.6538461538);
  color: #fff;
}

.btn-light-blue {
  background-color: #03a9f4;
  color: #fff;
}
.btn-light-blue:hover, .btn-light-blue:focus {
  background-color: rgb(2.6902834008, 151.5526315789, 218.8097165992);
  color: #fff;
}

.btn-cyan {
  background-color: #00bcd4;
  color: #fff;
}
.btn-cyan:hover, .btn-cyan:focus {
  background-color: rgb(0, 165.3867924528, 186.5);
  color: #fff;
}

.btn-teal {
  background-color: #009688;
  color: #fff;
}
.btn-teal:hover, .btn-teal:focus {
  background-color: rgb(0, 124.5, 112.88);
  color: #fff;
}

.btn-green {
  background-color: #4CAF50;
  color: #fff;
}
.btn-green:hover, .btn-green:focus {
  background-color: rgb(68.2788844622, 157.2211155378, 71.8725099602);
  color: #fff;
}

.btn-light-green {
  background-color: #8bc34a;
  color: #fff;
}
.btn-light-green:hover, .btn-light-green:focus {
  background-color: rgb(126.2966804979, 182.877593361, 60.622406639);
  color: #fff;
}

.btn-lime {
  background-color: #cddc39;
  color: #fff;
}
.btn-lime:hover, .btn-lime:focus {
  background-color: rgb(197.5300429185, 213.7210300429, 37.7789699571);
  color: #fff;
}

.btn-yellow {
  background-color: #ffeb3b;
  color: #fff;
}
.btn-yellow:hover, .btn-yellow:focus {
  background-color: rgb(255, 232.3979591837, 33.5);
  color: #fff;
}

.btn-amber {
  background-color: #ffc107;
  color: #fff;
}
.btn-amber:hover, .btn-amber:focus {
  background-color: rgb(236.5, 177.375, 0);
  color: #fff;
}

.btn-orange {
  background-color: #ff9800;
  color: #fff;
}
.btn-orange:hover, .btn-orange:focus {
  background-color: rgb(229.5, 136.8, 0);
  color: #fff;
}

.btn-deep-orange {
  background-color: #ff5722;
  color: #fff;
}
.btn-deep-orange:hover, .btn-deep-orange:focus {
  background-color: rgb(255, 67.6153846154, 8.5);
  color: #fff;
}

.btn-brown {
  background-color: #795548;
  color: #fff;
}
.btn-brown:hover, .btn-brown:focus {
  background-color: rgb(105.0129533679, 73.7694300518, 62.4870466321);
  color: #fff;
}

.btn-blue-grey {
  background-color: #607d8b;
  color: #fff;
}
.btn-blue-grey:hover, .btn-blue-grey:focus {
  background-color: rgb(85.5829787234, 111.4361702128, 123.9170212766);
  color: #fff;
}

.btn-grey {
  background-color: #9e9e9e;
  color: #fff;
}
.btn-grey:hover, .btn-grey:focus {
  background-color: rgb(145.25, 145.25, 145.25);
  color: #fff;
}

.jr-btn-shadow {
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -moz-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -o-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
}
.jr-btn-shadow:hover, .jr-btn-shadow:focus {
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -moz-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -o-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
}
.jr-btn-shadow:active {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

.jr-btn.disabled,
.jr-btn.disabled {
  pointer-events: none;
  opacity: 0.65;
}

.jr-btn-default {
  background-color: #fff;
  color: #5c5c5c;
  border: 1px solid #dee2e6;
}
.jr-btn-default:hover, .jr-btn-default:focus {
  background-color: rgb(242.25, 242.25, 242.25);
  color: #5c5c5c;
}

.jr-btn-secondary {
  background-color: #E91E63;
  color: #fff;
}
.jr-btn-secondary:hover, .jr-btn-secondary:focus {
  background-color: rgb(216.3461538462, 21.1538461538, 87.5);
  color: #fff;
}

.jr-flat-btn.jr-btn-primary {
  background-color: transparent;
  color: #3f51b5;
}
.jr-flat-btn.jr-btn-primary:hover, .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(63, 81, 181, 0.12);
  color: #3f51b5;
}

.bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent;
  color: #fff;
}
.bg-primary .jr-flat-btn.jr-btn-primary:hover, .bg-primary .jr-flat-btn.jr-btn-primary:focus {
  background-color: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.jr-flat-btn.jr-btn-secondary {
  background-color: transparent;
  color: #E91E63;
}
.jr-flat-btn.jr-btn-secondary:hover, .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(233, 30, 99, 0.12);
  color: #E91E63;
}

.bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent;
  color: #fff;
}
.bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
  background-color: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.jr-btn-hover:hover:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.06);
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.action-btn {
  height: 40px;
  width: 40px;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  vertical-align: middle;
  color: rgba(0, 0, 0, 0.54);
}
.action-btn:hover, .action-btn:focus, .action-btn:active {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.64);
}
.circle-check .action-btn {
  height: 24px;
  width: 24px;
  font-size: 16px;
}
.chat-main-header .action-btn {
  color: #fff;
}

.action-replay .jr-btn-default {
  font-size: 14px;
  padding: 5px 10px;
  border-color: #6c757d !important;
}

.btn-outline-primary:focus,
.btn-outline-secondary:focus {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important;
}

/*Button Group Styles*/
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .jr-btn,
.btn-group-vertical > .jr-btn {
  position: relative;
  flex: 0 1 auto;
  border-color: #dee2e6;
}
.btn-group > .jr-btn:hover,
.btn-group-vertical > .jr-btn:hover {
  z-index: 2;
}
.btn-group > .jr-btn:focus, .btn-group > .jr-btn:active, .btn-group > .jr-btn.active,
.btn-group-vertical > .jr-btn:focus,
.btn-group-vertical > .jr-btn:active,
.btn-group-vertical > .jr-btn.active {
  z-index: 2;
}
.btn-group > .jr-btn.active,
.btn-group-vertical > .jr-btn.active {
  background-color: #3f51b5;
  color: #fff;
  border-color: #3f51b5;
}
.btn-group > .jr-btn.jr-flat-btn,
.btn-group-vertical > .jr-btn.jr-flat-btn {
  border-color: transparent;
}
.btn-group > .jr-btn.jr-flat-btn.active,
.btn-group-vertical > .jr-btn.jr-flat-btn.active {
  background-color: transparent;
  color: #3f51b5;
}
.btn-group > .jr-btn.jr-flat-btn.active:hover, .btn-group > .jr-btn.jr-flat-btn.active:focus,
.btn-group-vertical > .jr-btn.jr-flat-btn.active:hover,
.btn-group-vertical > .jr-btn.jr-flat-btn.active:focus {
  background-color: rgba(63, 81, 181, 0.12);
  color: #3f51b5;
}
.btn-group .jr-btn + .jr-btn,
.btn-group .jr-btn + .btn-group,
.btn-group .btn-group + .jr-btn,
.btn-group .btn-group + .btn-group,
.btn-group-vertical .jr-btn + .jr-btn,
.btn-group-vertical .jr-btn + .btn-group,
.btn-group-vertical .btn-group + .jr-btn,
.btn-group-vertical .btn-group + .btn-group {
  margin-left: -1px;
}

.btn-group.no-border > .btn-group > .jr-btn, .btn-group.no-border > .btn-group-vertical > .jr-btn, .btn-group.no-border > .jr-btn,
.btn-group-vertical.no-border > .btn-group > .jr-btn,
.btn-group-vertical.no-border > .btn-group-vertical > .jr-btn,
.btn-group-vertical.no-border > .jr-btn {
  border-color: transparent;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .jr-btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-radius: 0;
}

.btn-group > .jr-btn:first-child {
  margin-left: 0;
}
.btn-group > .jr-btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .jr-btn:last-child:not(:first-child),
.btn-group > .dropdown-toggle:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group > .btn-group {
  float: left;
}

.btn-group > .btn-group:not(:first-child):not(:last-child) > .jr-btn {
  border-radius: 0;
}

.btn-group > .btn-group:first-child:not(:last-child) > .jr-btn:last-child,
.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.jr-btn + .dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.jr-btn + .dropdown-toggle-split::after {
  margin-left: 0;
}

.jr-btn-sm + .dropdown-toggle-split, .btn-group-sm > .jr-btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.jr-btn-lg + .dropdown-toggle-split, .btn-group-lg > .jr-btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group.show .dropdown-toggle {
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  -o-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn-group.show .dropdown-toggle.btn-link {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical .jr-btn,
.btn-group-vertical .btn-group {
  width: 100%;
}
.btn-group-vertical > .jr-btn + .jr-btn,
.btn-group-vertical > .jr-btn + .btn-group,
.btn-group-vertical > .btn-group + .jr-btn,
.btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-left: 0;
}
.btn-group-vertical > .jr-btn:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.btn-group-vertical > .jr-btn:first-child:not(:last-child) {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .jr-btn:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .jr-btn {
  border-radius: 0;
}
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .jr-btn:last-child,
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

[data-toggle=buttons] > .jr-btn input[type=radio],
[data-toggle=buttons] > .jr-btn input[type=checkbox],
[data-toggle=buttons] > .btn-group > .jr-btn input[type=radio],
[data-toggle=buttons] > .btn-group > .jr-btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}

.btn-group > .jr-btn,
.btn-group > .btn,
.btn-group-vertical > .jr-btn,
.btn-group-vertical > .btn {
  margin-right: 0;
  margin-bottom: 0;
}

/*Callout Styles*/
.card-image .grid-thumb-equal {
  padding-bottom: 82%;
}

/*Product listing page style*/
.product-row {
  position: relative;
  overflow: hidden;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  text-align: right;
}
.product-row.even {
  text-align: left;
}

.product-col {
  order: 1;
  width: 50%;
}

.odd .product-thumb {
  order: 2;
}

.product-content {
  padding: 20px 55px;
}

.product-row .grid-thumb-equal {
  padding-bottom: 69%;
}

.product-thumb img {
  width: 100%;
}

.product-content h4 {
  margin-bottom: 25px;
}

@media screen and (max-width: 1230px) {
  .product-row .grid-thumb-equal {
    padding-bottom: 71%;
  }
}
@media screen and (max-width: 1199px) {
  .product-content h4 {
    margin-bottom: 10px;
  }
  .product-content {
    padding: 20px 35px;
  }
  .product-row .grid-thumb-equal {
    padding-bottom: 85%;
  }
}
@media screen and (max-width: 991px) {
  .card-image .grid-thumb-equal {
    padding-bottom: 120%;
  }
}
@media screen and (max-width: 767px) {
  .product-row {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: center;
  }
  .product-row.even {
    text-align: center;
  }
  .product-content {
    padding: 20px 0;
  }
  .product-col,
  .odd .product-thumb {
    order: 1;
    width: 100%;
  }
  .product-row .grid-thumb-equal {
    padding-bottom: 44%;
  }
  .card-image .grid-thumb-equal {
    padding-bottom: 44%;
  }
}
/*Cards Styles*/
.profile-intro {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.profile-intro img.avatar-circle {
  display: inline-block;
  border-radius: 50%;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  position: relative;
  margin: 0 auto;
  -webkit-transform: translateY(50px);
  -ms-transform: translateY(50px);
  transform: translateY(50px);
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  z-index: 1;
}
.profile-intro:hover .avatar-circle {
  -webkit-transition: border-radius 0.4s ease 0.1s;
  -o-transition: border-radius 0.4s ease 0.1s;
  transition: border-radius 0.4s ease 0.1s;
  border-radius: 25%;
}

.profile-intro .card-image {
  position: relative;
  width: 100%;
  min-height: 100%;
  background-image: url("http://via.placeholder.com/1920x1072");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.profile-intro .pi-content {
  padding: 70px 40px 24px;
}
.profile-intro .pi-footer {
  padding: 0 40px 24px;
}
.profile-intro .icon {
  display: inline-block;
  -webkit-transition: all 0.2s ease 0s;
  -o-transition: all 0.2s ease 0s;
  transition: all 0.2s ease 0s;
  color: #3f51b5;
}
.profile-intro .icon:hover, .profile-intro .icon:focus, .profile-intro .icon:active {
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
}
.profile-intro .icon:not(:last-child) {
  margin-right: 10px;
}

.layer:before {
  display: block;
  content: "";
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
}

.card.jr-card-full-height,
.jr-card.jr-card-full-height {
  height: calc(100% - 34px);
}
@media screen and (max-width: 575px) {
  .card.jr-card-full-height,
  .jr-card.jr-card-full-height {
    height: auto;
  }
}

.jr-card > .jr-card-body:first-child {
  margin-top: 6px;
}
.jr-card.p-0 > .jr-card-body:first-child {
  margin-top: 0;
}
.jr-card .jr-card-thumb {
  margin: -24px -30px 0;
}
.jr-card .jr-card-thumb .card-img {
  border-radius: 8px 8px 0 0;
}
@media screen and (max-width: 575px) {
  .jr-card {
    margin-bottom: 18px;
  }
}

.jr-card-header {
  margin-bottom: 24px;
}
.jr-card-header .card-heading {
  margin-bottom: 4px;
}
.jr-card-header .badge {
  margin-bottom: 0;
}
.jr-card-header .badge:last-child {
  margin-left: 10px;
}
@media screen and (max-width: 575px) {
  .jr-card-header {
    margin-bottom: 18px;
  }
}

.jr-entry-header {
  margin-bottom: 24px;
}
.jr-entry-header .entry-heading {
  margin-bottom: 4px;
}
.jr-entry-header .entry-description {
  margin-bottom: 0;
  font-size: 13px;
  color: #6c757d;
}
@media screen and (max-width: 575px) {
  .jr-entry-header {
    margin-bottom: 18px;
  }
}

.card {
  margin-bottom: 34px;
}
@media screen and (max-width: 575px) {
  .card {
    margin-bottom: 18px;
  }
}

.card-header {
  font-size: 16px;
}
.card-header .badge {
  margin-bottom: 0;
}
.card-header .badge:last-child {
  margin-left: 10px;
}

.card-title {
  font-size: 16px;
  text-transform: capitalize;
}

.card-subtitle {
  font-size: 14px;
  color: #495057;
}
.card-subtitle:not(:last-child) {
  margin-bottom: 16px;
}

.card-mt-footer {
  padding: 0 15px 20px;
  margin-top: -10px;
}

.jr-card-social {
  font-size: 22px;
  padding-top: 26px;
}

.social-link {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin: 0 -5px 10px;
}
.social-link li {
  padding: 0 5px;
  margin-bottom: 5px;
}
.social-link li a {
  color: #5c5c5c;
}
.social-link li.active a, .social-link li a:hover, .social-link li a:focus {
  color: #E91E63;
}
.jr-card-social .social-link {
  margin-bottom: 0;
  -webkit-justify-content: space-around;
  justify-content: space-around;
}

.jr-cart-ab {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  color: #fff;
  font-size: 16px;
}
.jr-cart-ab i {
  vertical-align: middle;
  font-size: 25px;
}

.img-overlay-card {
  border-radius: 8px;
  margin-bottom: 34px;
}
@media screen and (max-width: 1199px) {
  .img-overlay-card .center-crop-img {
    min-height: 135px;
  }
}
@media screen and (max-width: 767px) {
  .img-overlay-card .center-crop-img {
    min-height: 160px;
  }
}
@media screen and (max-width: 575px) {
  .img-overlay-card {
    margin-bottom: 18px;
  }
}

/*Charts Styles*/
.chart-header {
  padding: 15px 18px;
}
.chart-header .card-title h4 {
  color: #fff;
  margin-bottom: 4px;
}
.chart-header .title h4 {
  margin-bottom: 4px;
}
.chart-header p {
  margin-bottom: 4px;
}

/*Chips Styles*/
.chip-outline {
  background-color: transparent !important;
  border: 1px solid #adb5bd !important;
}

/*Carousel Styles*/
.carousel-caption h3 {
  font-size: 18px;
}

/*Color Picker Styles*/
.cp-color {
  width: 36px;
  height: 14px;
  border-radius: 2px;
}

.cp-swatch {
  padding: 5px;
  background: #fff;
  border-radius: 1px;
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -o-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  display: inline-block;
  cursor: pointer;
}

.cp-popover {
  position: absolute;
  z-index: 2;
}

.cp-cover {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.photoshop-picker,
.swatches-picker,
.alpha-picker,
.hue-picker {
  width: 100% !important;
}

.material-picker {
  width: 100% !important;
  height: 100% !important;
}

.rc-time-picker-input {
  height: 31px !important;
}

.date-btn {
  display: inline-block;
  vertical-align: top;
}

.dateInputCreateUser .DateInput,
.dateInputCreateUser .SingleDatePickerInput {
  background: transparent !important;
}

.dateInputCreateUser .DateInput_input {
  font-size: 15px !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  border: none !important;
  padding: 10px 0 5px 0px !important;
  font-weight: 400 !important;
  display: block !important;
  width: 100% !important;
  height: calc(2.25rem + 2px) !important;
  outline: none !important;
  background-color: transparent !important;
  transition: 0.2s all ease-in-out;
}

.dateInputCreateUserDark .DateInput_input {
  color: white !important;
}

.dateInputCreateUserWarn .DateInput_input {
  color: red !important;
}

.dateInputCreateUserWarn .DateInput_input::placeholder {
  color: red !important;
}

.dateInputCreateUser .DateInput_input::placeholder {
  font-size: 15px !important;
  transition: 0.2s all ease-in-out;
}

.dateInputCreateUser .DateInput,
.dateInputCreateUser .SingleDatePickerInput {
  background: transparent !important;
}

.dateInputEditUser .DateInput_input {
  font-size: 12px !important;
  font-family: "roboto";
  box-shadow: none !important;
  border-radius: 0 !important;
  border: none !important;
  padding: 5px 0px !important;
  font-weight: 400 !important;
  display: block !important;
  width: 100% !important;
  height: 28px !important;
  outline: none !important;
  background-color: transparent !important;
  background: transparent !important;
  transition: 0.2s all ease-in-out;
}

.dateInputEditUserDark .DateInput_input {
  color: white !important;
  background-color: #1c2938 !important;
  background: #1c2938 !important;
}

.dateInputEditUserDark1 .DateInput_input {
  color: #d5d5d5 !important;
  background-color: #1C1C1C !important;
  background: #1C1C1C !important;
}

.dateInputEditUserDark2 .DateInput_input {
  color: #ebebed !important;
  background-color: #333333 !important;
  background: #333333 !important;
}

.dateInputEditUserDark3 .DateInput_input {
  color: #e7e7e7 !important;
  background-color: #262335 !important;
  background: #262335 !important;
}

.dateInputEditUserLight1 .DateInput_input {
  color: #949494 !important;
  background-color: #ffffff !important;
  background: #ffffff !important;
}

.dateInputEditUserLight2 .DateInput_input {
  color: #333333 !important;
  background-color: #fafafa !important;
  background: #fafafa !important;
}

.dateInputEditUserContrast .DateInput_input {
  color: #000000 !important;
  background-color: transparent !important;
  background: transparent !important;
}

.dateInputEditUser .DateInput_input::placeholder {
  font-size: 12px !important;
  transition: 0.2s all ease-in-out;
}

/*Drawer Styles*/
.drawer {
  width: 250px;
}

.full-drawer {
  width: 100%;
}

/*E-commerce Styles*/
.product-item, .product-item-vertical {
  overflow: hidden;
}

.product-item-vertical .card-image .grid-thumb-equal {
  padding-bottom: 110%;
}
@media screen and (max-width: 1199px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 74%;
  }
}
@media screen and (max-width: 991px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 110%;
  }
}
@media screen and (max-width: 829px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 120%;
  }
}
@media screen and (max-width: 767px) {
  .product-item-vertical .card-image .grid-thumb-equal {
    padding-bottom: 44%;
  }
}

/*Grids List Styles*/
.gl-image,
.gl-list,
.gl-advanced,
.gl-single-line {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  overflow: hidden;
}

.gl {
  max-width: 100%;
  max-height: 360px;
  transform: translateZ(0);
}
.gl.row.no-gutters {
  margin: 0 -2px;
}
.gl.row.no-gutters .col, .gl.row.no-gutters > [class*=col-] {
  padding-right: 2px;
  padding-left: 2px;
  margin-bottom: 4px;
}

.gl-single-line .slg {
  -ms-flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: 100%;
}

.title-gradient {
  background: -webkit-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
}

.title-gradient-bottom {
  background: -webkit-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: -o-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
}

.g-title {
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}

.grid {
  height: 100%;
  display: block;
  position: relative;
  overflow: hidden;
}
.grid > img {
  top: 50%;
  left: 50%;
  position: relative;
  transform: translate(-50%, -50%);
  display: flex;
  padding: 0;
  flex-wrap: wrap;
}

.g-ul {
  display: flex;
  padding: 0;
  flex-wrap: wrap;
  overflow-y: auto;
  list-style: none;
  -webkit-overflow-scrolling: touch;
}

.gradient-text {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 20px;
  color: white;
}

.title-gradient-bottom {
  padding: 20px;
  bottom: 0;
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  background: -webkit-linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
  background: -o-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent 100%) !important;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
}

.title-gradient-top {
  padding: 10px;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent 100%) !important;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
}

.grid-thumb img {
  max-height: 185px;
}

.gl-advanced-grid {
  position: relative;
}

/*Icons Styles*/
.icon {
  display: inline-block;
  text-align: center;
}

.icons-wrapper {
  display: inline-block;
}
.icons-wrapper + .icons-wrapper {
  margin-left: 25px;
}

/*Label Styles*/
label {
  margin-bottom: 0;
}

/*List Styles*/
.pinned-list {
  position: relative;
  height: 370px;
  overflow: auto;
  width: auto;
}

.user-list {
  width: 100%;
  padding: 20px 15px 10px;
}
.user-list.card {
  padding-left: 30px;
}
@media screen and (max-width: 575px) {
  .user-list.card {
    padding-left: 15px;
  }
}
.user-list .user-avatar {
  margin-right: 20px;
  margin-bottom: 10px;
}
.user-list h3 {
  font-weight: 700;
  margin-bottom: 8px;
}
.user-list a[class*=meta-] i {
  margin-right: 6px;
}
.user-list a[class*=meta-]:hover {
  text-decoration: none;
}
.user-list a[class*=meta-] {
  display: inline-block;
  color: #5c5c5c;
  font-size: 13px;
  font-weight: 700;
}

.user-list .img-section {
  width: 230px;
}
@media screen and (max-width: 649px) {
  .user-list .img-section {
    width: 100%;
  }
}
.user-list .description {
  width: calc(100% - 300px);
}
@media screen and (max-width: 649px) {
  .user-list .description {
    width: 100%;
  }
}
.user-list .jr-btn-list li:not(:last-child) {
  margin-right: 10px;
}
.user-list .jr-btn-list .btn-light {
  background-color: rgb(211.25, 211.25, 211.25);
  border-color: rgb(211.25, 211.25, 211.25);
  color: #5c5c5c;
  font-weight: 600;
}
.user-list .jr-btn-list .btn-light:hover, .user-list .jr-btn-list .btn-light:focus, .user-list .jr-btn-list .btn-light:active {
  background-color: rgb(198.5, 198.5, 198.5);
  border-color: rgb(198.5, 198.5, 198.5);
}
.user-list .jr-btn-list.badge-list li:not(:last-child) {
  margin-right: 0;
}

.list-inline {
  margin-left: -5px;
  margin-right: -5px;
}
.list-inline li {
  padding: 0 5px;
  display: inline-block;
}
.list-inline li.media {
  display: flex;
}

.card-strip {
  border-bottom: solid 1px #dee2e6;
  margin-bottom: 10px;
}

.jr-mbtn-list {
  margin-left: -20px;
}

.img-res {
  max-width: 100%;
  height: auto;
}

.nav-link {
  cursor: pointer;
  padding: 0.5rem;
}

.card-header.bg-primary .nav-link {
  color: #fff;
}
.card-header.bg-primary .nav-link.active, .card-header.bg-primary .nav-link:hover, .card-header.bg-primary .nav-link:focus {
  color: #000;
  background-color: #fff;
}
.card-header.bg-primary .nav-link.disabled {
  color: #f8f9fa;
}
.card-header.bg-primary .nav-link.disabled:hover {
  color: #212529;
}

/*Pricing Styles*/
.pt-classic .package,
.pt-default .package,
.pt-dark .package,
.pt-circle .package {
  position: relative;
  padding: 0;
  overflow: hidden;
  border-radius: 10px;
  -webkit-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
.pt-classic .package:hover, .pt-classic .package:focus, .pt-classic .package:active,
.pt-default .package:hover,
.pt-default .package:focus,
.pt-default .package:active,
.pt-dark .package:hover,
.pt-dark .package:focus,
.pt-dark .package:active,
.pt-circle .package:hover,
.pt-circle .package:focus,
.pt-circle .package:active {
  -webkit-transform: scale(1.05);
  -ms-transform: scale(1.05);
  transform: scale(1.05);
}
.pt-classic .package.highlight,
.pt-default .package.highlight,
.pt-dark .package.highlight,
.pt-circle .package.highlight {
  -webkit-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
  transform: scale(1.05);
  z-index: 2;
}
.pt-classic .package-header,
.pt-default .package-header,
.pt-dark .package-header,
.pt-circle .package-header {
  padding: 35px;
  text-align: center;
}
.pt-classic .package-header > .price,
.pt-default .package-header > .price,
.pt-dark .package-header > .price,
.pt-circle .package-header > .price {
  display: inline-block;
  font-size: 36px;
  font-weight: 700;
  margin-left: 0;
  margin-bottom: 12px;
}
.pt-classic .package-header > .price > i,
.pt-default .package-header > .price > i,
.pt-dark .package-header > .price > i,
.pt-circle .package-header > .price > i {
  display: inline-block;
  margin-right: 6px;
  font-weight: bold;
}
.pt-classic .package-header h5,
.pt-default .package-header h5,
.pt-dark .package-header h5,
.pt-circle .package-header h5 {
  color: inherit;
}
.pt-classic .package-items,
.pt-default .package-items,
.pt-dark .package-items,
.pt-circle .package-items {
  list-style: none;
  font-size: 14px;
  margin: 0;
  padding: 50px 50px 120px;
}
.pt-classic .package-items li,
.pt-default .package-items li,
.pt-dark .package-items li,
.pt-circle .package-items li {
  margin-bottom: 16px;
  line-height: inherit;
}
.pt-classic .package-items li:before, .pt-classic .package-items li:after,
.pt-default .package-items li:before,
.pt-default .package-items li:after,
.pt-dark .package-items li:before,
.pt-dark .package-items li:after,
.pt-circle .package-items li:before,
.pt-circle .package-items li:after {
  content: " ";
  display: table;
}
.pt-classic .package-items li:after,
.pt-default .package-items li:after,
.pt-dark .package-items li:after,
.pt-circle .package-items li:after {
  clear: both;
}
.pt-classic .package-items li i,
.pt-default .package-items li i,
.pt-dark .package-items li i,
.pt-circle .package-items li i {
  float: left;
  min-width: 20px;
  margin-right: 16px;
  line-height: inherit;
}
.pt-classic .package-items li span,
.pt-default .package-items li span,
.pt-dark .package-items li span,
.pt-circle .package-items li span {
  display: block;
  overflow: hidden;
}
.pt-classic .package-footer,
.pt-default .package-footer,
.pt-dark .package-footer,
.pt-circle .package-footer {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  padding: 40px 50px;
  text-align: center;
}
.pt-classic .package-footer .btn,
.pt-default .package-footer .btn,
.pt-dark .package-footer .btn,
.pt-circle .package-footer .btn {
  color: inherit;
  padding: 10px 30px;
  border: 0 none;
}

.pt-classic .package {
  border: 0 none;
  border-radius: 0;
}

.pt-dark .package:hover {
  border-radius: 20px;
}

.pt-circle .package-header {
  border-radius: 50%;
  height: 224px;
  width: 224px;
  margin: 40px auto 0;
  -webkit-align-items: center;
  align-items: center;
}
.pt-circle .package-header .price {
  margin-top: 30px;
}

@media only screen and (max-width: 991px) {
  .pt-classic .package-header,
  .pt-default .package-header,
  .pt-dark .package-header,
  .pt-circle .package-header {
    padding: 30px 20px;
  }
  .pt-classic .package-items,
  .pt-default .package-items,
  .pt-dark .package-items,
  .pt-circle .package-items {
    padding: 30px 20px 120px;
  }
  .pt-circle .package-header {
    height: 204px;
    width: 204px;
  }
}
@media only screen and (max-width: 767px) {
  .pt-classic .package:hover, .pt-classic .package:focus, .pt-classic .package:active, .pt-classic .package.highlight,
  .pt-default .package:hover,
  .pt-default .package:focus,
  .pt-default .package:active,
  .pt-default .package.highlight,
  .pt-dark .package:hover,
  .pt-dark .package:focus,
  .pt-dark .package:active,
  .pt-dark .package.highlight,
  .pt-circle .package:hover,
  .pt-circle .package:focus,
  .pt-circle .package:active,
  .pt-circle .package.highlight {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }
}
/*Progressbar Styles*/
.pb-wrapper {
  display: flex;
  align-items: center;
}

.pb-btn-wrapper {
  margin: 8px;
  position: relative;
}
.pb-btn-wrapper .btn-success {
  background-color: #4CAF50;
}
.pb-btn-wrapper .btn-success:hover {
  background-color: #388E3C;
}

.fab-progress {
  color: #4CAF50;
  position: absolute;
  top: -6px;
  left: -6px;
  z-index: 1;
}

.btn-progress {
  color: #4CAF50;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -12px;
}

/*Popover Styles*/
.popover {
  z-index: 1510;
  max-height: 400px;
}

.popover-inner {
  max-height: 400px;
}

.popover-header {
  background-color: transparent;
  border-bottom: 0 none;
  color: #000;
  font-size: 18px;
  padding: 15px 20px 0;
}

.popover-body {
  padding: 15px 20px;
  max-height: 355px;
  overflow: auto;
}

/*Tables Styles*/
.table-header {
  padding-right: 2px !important;
  min-height: 64px;
  padding-left: 24px;
  align-items: center;
}
.table-header.highlight-light {
  color: #616161;
  background-color: #e0e0e0;
}
.table-header.highlight-dark {
  color: #fff;
  background-color: #616161;
}

.spacer {
  -webkit-flex: 1 1 100%;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
}

.actions {
  color: #F44336;
}

.title {
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}

.table-hover tbody tr:hover {
  background-color: rgba(63, 81, 181, 0.075);
}

.table-material {
  width: 100% !important;
  max-width: 100% !important;
  background-color: transparent !important;
}
.table-material th,
.table-material td {
  padding: 0.75rem !important;
  vertical-align: top !important;
  border-top: 1px solid #dee2e6 !important;
}
.table-material thead th {
  vertical-align: bottom !important;
  border-bottom: 2px solid #dee2e6 !important;
}
.table-material tbody + tbody {
  border-top: 2px solid #dee2e6 !important;
}
.table-material .table-material {
  background-color: #fff !important;
}

.d-flex-stretch {
  -webkit-align-items: stretch;
  align-items: stretch;
  display: -webkit-flex;
  display: -webkit-box;
  display: -moz-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.default-table {
  margin-bottom: 0;
}
.default-table thead th {
  font-weight: 400;
  font-size: 16px;
}
.default-table td {
  vertical-align: middle;
}

.table-unbordered th, .table-unbordered td {
  border: 0 none !important;
}
.table-unbordered .th-border-b th {
  border-bottom: 2px solid #ced4da !important;
}

.table-responsive-material {
  min-height: 0.01%;
  overflow-x: auto;
}

@media screen and (max-width: 767px) {
  .table-responsive-material {
    width: 100%;
    margin-bottom: 15px;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #ddd;
  }
  .table-responsive-material > .table {
    margin-bottom: 0;
  }
  .table-responsive-material > .table > thead > tr > th,
  .table-responsive-material > .table > tbody > tr > th,
  .table-responsive-material > .table > tfoot > tr > th,
  .table-responsive-material > .table > thead > tr > td,
  .table-responsive-material > .table > tbody > tr > td,
  .table-responsive-material > .table > tfoot > tr > td {
    white-space: nowrap;
  }
  .table-responsive-material > .table-bordered {
    border: 0;
  }
  .table-responsive-material > .table-bordered > thead > tr > th:first-child,
  .table-responsive-material > .table-bordered > tbody > tr > th:first-child,
  .table-responsive-material > .table-bordered > tfoot > tr > th:first-child,
  .table-responsive-material > .table-bordered > thead > tr > td:first-child,
  .table-responsive-material > .table-bordered > tbody > tr > td:first-child,
  .table-responsive-material > .table-bordered > tfoot > tr > td:first-child {
    border-left: 0;
  }
  .table-responsive-material > .table-bordered > thead > tr > th:last-child,
  .table-responsive-material > .table-bordered > tbody > tr > th:last-child,
  .table-responsive-material > .table-bordered > tfoot > tr > th:last-child,
  .table-responsive-material > .table-bordered > thead > tr > td:last-child,
  .table-responsive-material > .table-bordered > tbody > tr > td:last-child,
  .table-responsive-material > .table-bordered > tfoot > tr > td:last-child {
    border-right: 0;
  }
  .table-responsive-material > .table-bordered > tbody > tr:last-child > th,
  .table-responsive-material > .table-bordered > tfoot > tr:last-child > th,
  .table-responsive-material > .table-bordered > tbody > tr:last-child > td,
  .table-responsive-material > .table-bordered > tfoot > tr:last-child > td {
    border-bottom: 0;
  }
}
.fst-td-br-tp-0 tr:first-child td {
  border-top: 0 none;
}

/*Tabs Styles*/
.tab {
  min-width: 10px !important;
}

.tab-icon > span {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

/*Testimonial Styles*/
.testimonial-in-bg {
  background-color: rgba(0, 0, 0, 0.8);
  box-shadow: 5px 5px 6px rgba(0, 0, 0, 0.06);
  padding: 30px 30px 30px 150px;
  overflow: hidden;
  position: relative;
}
@media screen and (max-width: 450px) {
  .testimonial-in-bg {
    padding-left: 100px;
  }
}
.testimonial-in-bg .pic {
  display: inline-block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  top: 30px;
  left: 20px;
  border: 4px solid #ffa000;
}
@media screen and (max-width: 450px) {
  .testimonial-in-bg .pic {
    width: 50px;
    height: 50px;
  }
}
.testimonial-in-bg .pic img {
  width: 100%;
  height: auto;
}
.testimonial-in-bg .description {
  color: #bdbdbd;
  font-style: italic;
  font-weight: 400;
  line-height: 25px;
  margin-bottom: 15px;
  position: relative;
}
.testimonial-in-bg .description:before {
  content: "\\f1b2";
  font-family: "Material-Design-Iconic-Font";
  font-size: 24px;
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  transform: scaleX(-1);
  position: absolute;
  left: -24px;
}
.testimonial-in-bg .title {
  color: #ffa000;
  margin-bottom: 2px;
}

.classic-testimonial {
  text-align: center;
}
.classic-testimonial .pic {
  margin: 0 auto;
  margin-bottom: 30px;
  width: 120px;
  height: 120px;
}
@media screen and (max-width: 500px) {
  .classic-testimonial .pic {
    width: 80px;
    height: 80px;
  }
}
.classic-testimonial .pic img {
  width: 100%;
  height: 100%;
}

/*Time Lines Style*/
.timeline-left {
  float: left;
  margin-right: 20px;
}

.timeline-right {
  float: right;
  margin-left: 20px;
}

.timeline-circle {
  border-radius: 50%;
}

.timeline-section {
  margin-bottom: 25px;
}

.timeline-item {
  padding-bottom: 25px;
  padding-left: 80px;
  position: relative;
}
.timeline-item:before {
  border-left: solid 2px #dee2e6;
  content: "";
  left: 25px;
  position: absolute;
  top: 25px;
  bottom: -20px;
  width: 2px;
  z-index: 1;
}
.timeline-item:first-child:before {
  border-left-style: dashed;
}
.timeline-item:last-child:before {
  border-left-style: dashed;
  bottom: 25px;
}

.timeline-badge {
  position: absolute;
  left: 0;
  top: 16px;
  z-index: 2;
  font-size: 16px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
}
.timeline-badge.timeline-img {
  background-color: transparent;
}
.timeline-badge svg {
  vertical-align: calc(100% - 56px);
}

.timeline-badge.timeline-img:after {
  display: none;
}
.timeline-badge:after {
  position: absolute;
  content: "";
  width: 42px;
  height: 42px;
  background-color: transparent;
  border: 4px solid #fff;
  border-radius: 50%;
  left: 4px;
  top: 4px;
  z-index: 1;
}

.timeline-img > img,
.timeline-header-img > img {
  display: inline-block;
  max-width: 100%;
  height: auto;
}

.timeline-panel {
  padding: 20px 30px;
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  border: solid 1px #e9ecef;
}
.timeline-panel:after, .timeline-panel:before {
  content: "";
  position: absolute;
  border-style: solid;
  display: inline-block;
}
.timeline-panel:before {
  border-color: transparent #dee2e6;
  border-width: 10px 17px 10px 0;
  left: -17px;
  top: 30px;
}
.timeline-panel:after {
  border-color: transparent #fff;
  border-width: 10px 16px 10px 0;
  left: -16px;
  top: 30px;
}

.timeline-no-padding {
  padding: 0;
}

.timeline-no-shadow {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}
.timeline-no-shadow:before, .timeline-no-shadow:after {
  display: none;
}

.timeline-panel-header, .timeline-header-img {
  margin-bottom: 10px;
}

.timeline-inverted .timeline-left {
  float: right;
  margin-right: 0;
  margin-left: 20px;
}

.timeline-heading {
  overflow: hidden;
  margin-bottom: 10px;
}

.timeline-body {
  clear: both;
}

/*Gxtl Center Style*/
.timeline-center .timeline-item {
  clear: both;
  float: right;
  width: 50%;
  padding-left: 55px;
}
.timeline-center .timeline-item:before {
  left: 0;
}

.timeline-center .timeline-badge {
  left: -25px;
  right: auto;
}
.timeline-center .timeline-time {
  position: absolute;
  top: 32px;
  left: -150px;
  right: auto;
  z-index: 2;
}
.timeline-center .timeline-inverted {
  float: left;
  text-align: right;
  padding-left: 0;
  padding-right: 55px;
}
.timeline-center .timeline-inverted:before {
  border-left: 0 none;
  border-right: solid 2px #dee2e6;
  left: auto;
  right: -2px;
}
.timeline-center .timeline-inverted .timeline-badge {
  left: auto;
  right: -25px;
}
.timeline-center .timeline-inverted .timeline-panel:before {
  border-width: 10px 0 10px 17px;
  left: auto;
  right: -17px;
}
.timeline-center .timeline-inverted .timeline-panel:after {
  border-width: 10px 0 10px 16px;
  left: auto;
  right: -16px;
}
.timeline-center .timeline-inverted .timeline-time {
  position: absolute;
  top: 32px;
  right: -150px;
  left: auto;
  z-index: 2;
}

/*Gxtl Zigzag Style*/
.timeline-zigzag .timeline-item {
  padding-left: 150px;
}
.timeline-zigzag .timeline-item + .timeline-item {
  margin-top: -80px;
}
.timeline-zigzag .timeline-img {
  width: 90px;
  height: 90px;
  left: 5px;
}
.timeline-zigzag .timeline-img > img {
  width: 100%;
}
.timeline-zigzag .timeline-inverted .timeline-img {
  right: 5px !important;
}
.timeline-zigzag .timeline-item:before {
  -webkit-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  -o-transform: rotate(35deg);
  transform: rotate(35deg);
  top: 20px;
  bottom: 20px;
}
.timeline-zigzag .timeline-inverted {
  padding-left: 0;
  padding-right: 150px;
}
.timeline-zigzag .timeline-inverted:before {
  -webkit-transform: rotate(-35deg);
  -ms-transform: rotate(-35deg);
  -o-transform: rotate(-35deg);
  transform: rotate(-35deg);
}
.timeline-zigzag .timeline-item:first-child:before {
  border-left-style: solid;
}
.timeline-zigzag .timeline-item:last-child:before {
  display: none;
}

.timeline-item:last-child:before {
  bottom: 25px;
}

@media screen and (max-width: 991px) {
  .timeline-zigzag .timeline-item + .timeline-item {
    margin-top: -60px;
  }
  .timeline-zigzag .timeline-item:before {
    bottom: 0;
  }
  .timeline-zigzag .timeline-item {
    padding-left: 120px;
  }
  .timeline-zigzag .timeline-inverted {
    padding-right: 120px;
    padding-left: 0;
  }
}
@media screen and (max-width: 767px) {
  .timeline-center .timeline-item {
    float: none;
    padding-left: 80px;
    width: auto;
  }
  .timeline-center .timeline-item:before {
    left: 25px;
  }
  .timeline-center .timeline-badge {
    left: 0;
  }
  .timeline-center .timeline-inverted {
    float: none;
    text-align: left;
    padding-right: 0;
  }
  .timeline-center .timeline-inverted:before {
    border-left: solid 2px #dee2e6;
    border-right: 0 none;
    left: 24px;
    right: auto;
  }
  .timeline-center .timeline-inverted .timeline-badge {
    right: auto;
    left: 0;
  }
  .timeline-center .timeline-inverted .timeline-panel:before {
    border-width: 10px 17px 10px 0;
    left: -17px;
    right: auto;
  }
  .timeline-center .timeline-inverted .timeline-panel:after {
    border-width: 10px 16px 10px 0;
    left: -16px;
    right: auto;
  }
  .timeline-inverted .timeline-panel-header {
    float: none;
  }
  .timeline-inverted .timeline-left {
    float: left;
    margin-left: 0;
    margin-right: 20px;
  }
  .timeline-zigzag .timeline-panel {
    max-height: none;
    min-height: 10px;
    overflow-y: visible;
  }
  .timeline-zigzag .timeline-item {
    padding-left: 100px;
  }
  .timeline-zigzag .timeline-item + .timeline-item {
    margin-top: 0;
  }
  .timeline-zigzag .timeline-item:before {
    transform: none;
    top: 25px;
    bottom: -25px;
    left: 45px;
  }
  .timeline-zigzag .timeline-item:last-child:before {
    bottom: 0;
  }
  .timeline-zigzag .timeline-inverted:before {
    transform: none;
  }
  .timeline-center .timeline-time, .timeline-center .timeline-inverted .timeline-time {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    margin-bottom: 6px;
  }
  .timeline-center .timeline-time-item .timeline-panel::before {
    top: 10px;
  }
  .timeline-center .timeline-time-item .timeline-panel::after {
    top: 11px;
  }
}
@media screen and (max-width: 399px) {
  .timeline-left {
    float: none;
    margin-right: 0;
  }
  .timeline-right {
    float: none;
    margin-left: 0;
  }
  .timeline-inverted .timeline-left {
    float: none;
    margin-right: 0;
  }
}
/*Form Styles*/
@media screen and (max-width: 575px) {
  .horizontal-stepper p, .horizontal-stepper span {
    opacity: 0;
    visibility: hidden;
    font-size: 12px;
  }
  .horizontal-stepper.active p, .horizontal-stepper.active span {
    opacity: 1;
    visibility: visible;
  }
  .horizontal-stepper > *, .horizontal-stepper > button > * {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .horizontal-stepper .stepperlabel, .horizontal-stepper .stepperbutton, .horizontal-stepper .stepperlabel span:first-child, .horizontal-stepper .stepperbutton span:first-child {
    opacity: 1;
    visibility: visible;
  }
  .horizontal-stepper-linear {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.form-checkbox {
  position: relative;
  z-index: 1;
}

.form-checkbox > input {
  height: 18px;
  opacity: 0;
  position: absolute;
  padding: 10px;
  top: 0;
  width: 18px;
  z-index: 2;
  cursor: pointer;
}

.form-control-checkbox .form-checkbox > input {
  height: 48px;
  width: 48px;
}

.form-control-checkbox .form-checkbox {
  height: 48px;
  display: flex;
  align-items: center;
  width: 48px;
  justify-content: center;
}

.form-checkbox > input + .check {
  border: 1px solid #868e96;
  border-radius: 2px;
  color: #3f51b5;
  cursor: pointer;
  display: inline-block;
  height: 18px;
  position: relative;
  width: 18px;
  z-index: -1;
}

.form-checkbox > input.sm + .check {
  border: 1px solid #868e96;
  border-radius: 2px;
  color: #3f51b5;
  cursor: pointer;
  display: inline-block;
  height: 14px;
  position: relative;
  top: 3px;
  width: 14px;
  z-index: -1;
}

.form-checkbox > input + .check i {
  display: none;
  left: 1px;
  opacity: 0;
  position: absolute;
  top: 2px;
}

.form-checkbox > input.sm + .check i {
  display: none;
  left: 1px;
  opacity: 0;
  position: absolute;
  top: 2px;
}

.form-checkbox > input:checked + span i {
  display: block;
  opacity: 1;
}

/*Radio and Checkbox styles*/
.checkbox-replace {
  padding-left: 20px;
}

.checkbox-replace input[type=checkbox],
.radio-replace input[type=radio] {
  margin-left: -20px;
  position: absolute;
}

.form-inline .checkbox-replace label {
  padding-left: 5px;
}

.form-inline .checkbox-replace,
.form-inline .radio-replace {
  margin-right: 20px;
}

.form-inline .checkbox-replace:last-child {
  margin-right: 0;
}

.checkbox-replace label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 5px;
}

.checkbox-replace label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 18px;
  height: 18px;
  left: 0;
  top: 0;
  margin-left: -20px;
  margin-top: 2px;
  border: 1px solid #868e96;
  border-radius: 3px;
  background-color: #fff;
  -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}

.checkbox-replace label::after {
  display: inline-block;
  position: absolute;
  width: 12px;
  height: 12px;
  left: 3px;
  top: 5px;
  margin-left: -20px;
  font-size: 11px;
  color: #495057;
}

.checkbox-replace input[type=checkbox] {
  opacity: 0;
  z-index: 1;
  cursor: pointer;
}

.checkbox-replace input[type=checkbox]:focus + label::before {
  outline: 0 none;
}

.checkbox-replace input[type=checkbox]:checked + label::after {
  background-color: #ced4da;
  content: "";
}

.checkbox-replace input[type=checkbox]:disabled + label {
  opacity: 0.65;
}

.checkbox-replace input[type=checkbox]:disabled + label::before {
  background-color: #fff;
  cursor: not-allowed;
}

.checkbox-replace.checkbox-inline {
  margin-top: 0;
}

.checkbox-primary label::before {
  border-color: #3f51b5;
}

.checkbox-primary input[type=checkbox]:checked + label::after {
  background-color: #3f51b5;
}

.checkbox-danger label::before {
  border-color: #E91E63;
}

.checkbox-danger input[type=checkbox]:checked + label::after {
  border-color: #E91E63;
}

.checkbox-info label::before {
  border-color: #00bcd4;
}

.checkbox-info input[type=checkbox]:checked + label::after {
  border-color: #00bcd4;
}

.checkbox-warning label::before {
  border-color: #ff9800;
}

.checkbox-warning input[type=checkbox]:checked + label::after {
  border-color: #ff9800;
}

.checkbox-success label::before {
  border-color: #4caf50;
}

.checkbox-success input[type=checkbox]:checked + label::after {
  border-color: #4caf50;
}

.radio-replace {
  padding-left: 20px;
}

.radio-replace label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 5px;
}

.radio-replace label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 18px;
  height: 18px;
  left: 0;
  top: 0;
  margin-left: -20px;
  margin-top: 2px;
  border: 1px solid #ced4da;
  border-radius: 50%;
  background-color: #fff;
  -webkit-transition: border 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out;
  transition: border 0.15s ease-in-out;
}

.radio-replace label::after {
  display: inline-block;
  position: absolute;
  content: " ";
  width: 12px;
  height: 12px;
  left: 3px;
  top: 5px;
  margin-left: -20px;
  border-radius: 50%;
  background-color: #ced4da;
  -webkit-transform: rotate(scale(0, 0));
  -ms-transform: rotate(scale(0, 0));
  -o-transform: rotate(scale(0, 0));
  transform: rotate(scale(0, 0));
  -webkit-transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  -o-transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
}

.radio-replace input[type=radio] {
  opacity: 0;
  z-index: 1;
  cursor: pointer;
}

.radio-replace input[type=radio]:focus + label::before {
  outline: 0 none;
}

.radio-replace input[type=radio]:checked + label::after {
  -webkit-transform: rotate(scale(1, 1));
  -ms-transform: rotate(scale(1, 1));
  -o-transform: rotate(scale(1, 1));
  transform: rotate(scale(1, 1));
}

.radio-replace input[type=radio]:disabled + label {
  opacity: 0.65;
}

.radio-replace input[type=radio]:disabled + label::before {
  cursor: not-allowed;
}

.radio-replace.radio-inline {
  margin-top: 0;
}

.radio-primary input[type=radio] + label::after {
  background-color: #3f51b5;
}

.radio-primary input[type=radio]:checked + label::before {
  border-color: #3f51b5;
}

.radio-primary input[type=radio]:checked + label::after {
  background-color: #3f51b5;
}

.radio-danger input[type=radio] + label::after {
  background-color: #E91E63;
}

.radio-danger input[type=radio]:checked + label::before {
  border-color: #E91E63;
}

.radio-danger input[type=radio]:checked + label::after {
  background-color: #E91E63;
}

.radio-info input[type=radio] + label::after {
  background-color: #00bcd4;
}

.radio-info input[type=radio]:checked + label::before {
  border-color: #00bcd4;
}

.radio-info input[type=radio]:checked + label::after {
  background-color: #00bcd4;
}

.radio-warning input[type=radio] + label::after {
  background-color: #ff9800;
}

.radio-warning input[type=radio]:checked + label::before {
  border-color: #ff9800;
}

.radio-warning input[type=radio]:checked + label::after {
  background-color: #ff9800;
}

.radio-success input[type=radio] + label::after {
  background-color: #4caf50;
}

.radio-success input[type=radio]:checked + label::before {
  border-color: #4caf50;
}

.radio-success input[type=radio]:checked + label::after {
  background-color: #4caf50;
}

.form-horizontal .checkbox, .form-horizontal .checkbox-inline, .form-horizontal .radio, .form-horizontal .radio-inline {
  padding-top: 7px;
  margin-top: 0;
  margin-bottom: 0;
}

.form-horizontal .form-inline .checkbox,
.form-horizontal .form-inline .checkbox-inline,
.form-horizontal .form-inline .radio,
.form-horizontal .form-inline .radio-inline {
  padding-top: 0;
}

.form-horizontal .checkbox, .form-horizontal .radio {
  min-height: 27px;
}

.form-wizard .tab-content .pager.wizard .first a {
  margin-right: 8px;
}

.form-wizard .tab-content .pager.wizard .last a {
  margin-left: 8px;
}

.wizard-navbar {
  margin: 60px auto 20px;
}

.wizard-navbar > ul {
  display: table;
  width: 100%;
  text-align: center;
  margin: 0;
  font-weight: 600;
  padding: 0;
  list-style: none outside none;
  table-layout: fixed;
}

.wizard-navbar > ul li {
  display: table-cell;
  width: 1%;
  position: relative;
}

.wizard-navbar > ul li a {
  color: #868e96;
  position: relative;
  padding: 0 10px;
  display: block;
  text-decoration: none;
}

.wizard-navbar > ul li a span.wz-number {
  background-color: #e9ecef;
  border-radius: 50%;
  color: #adb5bd;
  display: block;
  height: 40px;
  left: 50%;
  line-height: 40px;
  margin-left: -20px;
  margin-top: -50px;
  position: absolute;
  text-align: center;
  -webkit-transition: all 300ms ease-in-out 0s;
  -o-transition: all 300ms ease-in-out 0s;
  transition: all 300ms ease-in-out 0s;
  width: 40px;
  z-index: 5;
}

.wizard-navbar > ul li.completed a span.wz-number {
  background-color: #3f51b5;
  color: #fff;
}

.wizard-navbar > ul li a.active span.wz-number {
  background-color: #E91E63;
  color: #fff;
}

.wizard-navbar > ul li a.active,
.wizard-navbar > ul li.completed a {
  color: #6c757d;
}

.wizard-navbar > ul li a:before,
.wizard-navbar > ul li a:after {
  content: "";
  position: absolute;
  height: 4px;
  width: 50%;
  background-color: #e9ecef;
  top: -32px;
  left: 0;
}

.wizard-navbar > ul li a:after {
  left: auto;
  right: 0;
}

.wizard-navbar > ul li a.active:before,
.wizard-navbar > ul li a.active:after {
  background-color: #E91E63;
}

.wizard-navbar > ul li.completed a:before,
.wizard-navbar > ul li.completed a:after {
  background-color: #3f51b5;
}

label.error {
  display: block;
  color: #f44336;
  font-weight: 400;
  margin: 5px 0;
}

@media screen and (max-width: 479px) {
  .wizard-navbar > ul li a span.wz-label {
    visibility: hidden;
  }
  .wizard-navbar > ul li a.active span.wz-label {
    visibility: visible;
  }
}
.form-checkbox-custom {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 12px;
}

.form-checkbox-custom .check {
  margin-right: 10px;
}

.react-switch {
  vertical-align: middle;
  margin-left: 4px;
}

/*Input Styles*/
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 12px;
  color: rgb(219.5, 219.5, 219.5);
}

::-moz-placeholder { /* Firefox 19+ */
  font-size: 12px;
  color: rgb(219.5, 219.5, 219.5);
}

:-ms-input-placeholder { /* IE 10+ */
  font-size: 12px;
  color: rgb(219.5, 219.5, 219.5);
}

:-moz-placeholder { /* Firefox 18- */
  font-size: 12px;
  color: rgb(219.5, 219.5, 219.5);
}

.module-box-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 14px;
}

.module-box-header ::-moz-placeholder { /* Firefox 19+ */
  font-size: 14px;
}

.module-box-header :-ms-input-placeholder { /* IE 10+ */
  font-size: 14px;
}

.module-box-header :-moz-placeholder { /* Firefox 18- */
  font-size: 14px;
}

.search-bar {
  background-color: #fff;
  position: relative;
}
.search-bar .form-group {
  width: 100%;
  height: 100%;
  margin-bottom: 0;
}
.search-bar input[type=search] {
  padding-right: 50px;
}
.search-bar .search-icon {
  background-color: transparent;
  border: 0 none;
  color: rgb(133.7553648069, 142.4849785408, 150.2446351931);
  height: 36px;
  width: 30px;
}
.search-bar .form-control {
  box-shadow: none;
}
.search-bar .form-control.form-control-lg + .search-icon {
  position: absolute;
  right: 14px;
  top: 6px;
}
.search-bar .search-icon {
  position: absolute;
  right: 14px;
  top: 3px;
}
.search-bar.right-side-icon input[type=search] {
  padding-right: 16px;
  padding-left: 50px;
}
.search-bar.right-side-icon .search-icon {
  position: absolute;
  left: 14px;
  top: 2px;
}
.search-bar.right-side-icon .form-control {
  box-shadow: none;
}
.search-bar.right-side-icon .form-control.form-control-lg + .search-icon {
  position: absolute;
  left: 14px;
  top: 6px;
}

.nav-searchbox .search-bar input + .search-icon i {
  color: rgba(92, 92, 92, 0.8);
}

/* Removing arrows for input type number in Chrome, Safari, Edge, Opera */
.inputClassComponent::-webkit-outer-spin-button,
.inputClassComponent::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Removing arrows for input type number in Firefox */
.inputClassComponent[type=number] {
  -moz-appearance: textfield;
}

@media screen and (max-width: 767px) {
  .jr-card .app-main-header .search-bar {
    width: 150px;
  }
}
/* Pages
   ========================================================================== */
/*Login Styles*/
/*Login Styles*/
.indexPage {
  background-color: #f4f6f8;
  height: 100vh;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0;
  margin: 0;
}
@media screen and (max-width: 575px) {
  .indexPage {
    height: 100%;
  }
}

.landingPage {
  background-color: #fff;
  height: 680px;
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: cover;
}
@media screen and (max-width: 575px) {
  .landingPage {
    height: 100%;
  }
}

.login-container {
  position: relative;
  height: 100%;
}

.login-content {
  width: 420px;
  margin: auto;
  padding: 35px 35px 20px;
  background-color: #fff;
  border-radius: 8px;
  border: solid 1px #ced4da;
  font-size: 14px;
  max-width: 94%;
}

.login-header {
  margin-bottom: 30px;
}

.login-content .form-control {
  background-color: #f5f5f5;
}
.login-content .form-control:focus {
  box-shadow: none;
  border-color: #3f51b5;
}

.login-content .btn, .login-content .jr-btn {
  padding: 10px 35px !important;
}

.app-login-container {
  position: relative;
  max-width: 680px;
  width: 94%;
  margin: 0 auto;
}
.app-login-container .loader-view {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  z-index: 2;
}

.app-login-main-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background-color: #fff;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  font-size: 14px;
  overflow: hidden;
}

.app-login-content {
  padding: 35px 35px 20px;
  width: 60%;
  order: 1;
}
@media screen and (max-width: 575px) {
  .app-login-content {
    width: 100%;
    order: 2;
  }
}

.app-login-header {
  margin-bottom: 30px;
}

.app-login-content .form-control {
  background-color: #f5f5f5;
}
.app-login-content .form-control:focus {
  box-shadow: none;
  border-color: #3f51b5;
}

.app-login-content .btn, .login-content .jr-btn {
  padding: 10px 35px !important;
}

.app-logo-content {
  background-color: #3f51b5;
  padding: 35px 35px 20px;
  width: 40%;
  order: 2;
}
@media screen and (max-width: 575px) {
  .app-logo-content {
    width: 100%;
    order: 1;
  }
}

.app-social-block {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.app-social-block .social-link, .app-social-block .social-link li {
  margin: 0;
}
.app-social-block .social-link span {
  border: solid 1px #3f51b5;
  border-radius: 50%;
  color: #3f51b5;
}
.app-social-block .social-link span:hover, .app-social-block .social-link span:focus {
  color: #fff;
  background-color: #3f51b5;
}
.app-social-block p {
  margin-bottom: 0;
}

/*Error Styles*/
.page-error-container {
  padding: 30px 0;
  position: relative;
}
@media screen and (max-width: 575px) {
  .page-error-container {
    padding: 15px 0;
  }
}

.page-error-content {
  margin: 0 auto;
  padding: 40px 0;
  width: 380px;
  max-width: 94%;
}
@media screen and (max-width: 767px) {
  .page-error-content {
    padding: 15px 0;
  }
}
@media screen and (max-width: 575px) {
  .page-error-content {
    padding: 0;
  }
}

.error-code {
  color: #212529;
  font-size: 160px;
  text-align: center;
  line-height: 1;
  font-weight: 600;
  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8);
}
@media screen and (max-width: 991px) {
  .error-code {
    font-size: 130px;
  }
}
@media screen and (max-width: 767px) {
  .error-code {
    font-size: 100px;
  }
}
@media screen and (max-width: 575px) {
  .error-code {
    font-size: 80px;
  }
}

.page-error-content h2 {
  margin-bottom: 50px;
}
@media screen and (max-width: 767px) {
  .page-error-content h2 {
    margin-bottom: 20px;
  }
}

/*Editor Styles*/
.rdw-inline-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.rdw-option-wrapper {
  margin-bottom: 6px;
}

/*Contact Page Styles*/
.contact-form {
  padding: 60px;
}

.contact-block .contact-info {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-align-content: stretch;
  -ms-flex-align: stretch;
  align-content: stretch;
}
.contact-block .contact-info li {
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  overflow: hidden;
  padding: 10px 40px;
  border-right: 2px solid #5c5c5c;
  word-wrap: break-word;
}
.contact-block .contact-info li:last-child {
  border: 0 none;
}
.contact-block .contact-info li > i {
  float: left;
  font-size: 16px;
  margin-right: 5px;
}
.contact-block .contact-info li .contact-body {
  overflow: hidden;
}
.contact-block .contact-info li .contact-body .icons-wrapper {
  margin-top: 15px;
  margin-left: 0;
}
.contact-block .contact-info li .contact-body .icon {
  background-color: #5c6bc0;
  color: #fff;
  border-radius: 50%;
  margin-right: 6px;
  margin-bottom: 6px;
}
.contact-block .contact-info li .contact-body .icon:last-child {
  margin-right: 0;
}
.contact-block .contact-info li .contact-body .twitter-icon {
  background-color: #40c4ff;
}
.contact-block .contact-info li .contact-body .google-icon {
  background-color: #EF5350;
}
.contact-block .contact-info li .contact-body .linkedin-icon {
  background-color: #0277bd;
}
.contact-block .contact-info.vertical {
  display: block;
  margin-bottom: 0;
}
.contact-block .contact-info.vertical li {
  padding: 0 0 24px;
  border-right: 0 none;
  border-bottom: 2px solid #5c5c5c;
  margin-bottom: 24px;
}
.contact-block .contact-info.vertical li:last-child {
  border: 0 none;
  margin-bottom: 0;
  padding-bottom: 0;
}

@media screen and (max-width: 767px) {
  .contact-form {
    padding: 30px;
  }
  .contact-block .contact-info {
    display: block;
    margin-bottom: 0;
  }
  .contact-block .contact-info li {
    padding: 0 0 24px;
    border-right: 0 none;
    border-bottom: 2px solid #5c5c5c;
    margin-bottom: 24px;
  }
  .contact-block .contact-info li:last-child {
    border: 0 none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .content-section {
    padding: 20px 10px 0;
    text-align: center;
  }
  .content-section h2 {
    font-size: 28px;
  }
  .content-section p {
    font-size: 18px;
  }
}
/*Portfolio Styles*/
.portfolio-section .card-image {
  margin-bottom: 20px;
}
.portfolio-section .card-image img {
  width: 100%;
  -webkit-transition: all 1200ms ease;
  -o-transition: all 1200ms ease;
  transition: all 1200ms ease;
}
.portfolio-section .card-image:hover img {
  -webkit-transform: scale(1.08);
  -ms-transform: scale(1.08);
  transform: scale(1.08);
}

.filter-with-bg-color ul {
  padding-left: 0;
  margin: 0 -10px 45px;
}
.filter-with-bg-color ul li {
  display: inline-block;
  margin-bottom: 10px;
  padding: 0 10px;
}
.filter-with-bg-color ul li a {
  text-transform: uppercase;
  font-size: 12px;
  padding: 10px 24px;
  border: 1px solid #3f51b5;
  display: block;
  text-decoration: none;
}
.filter-with-bg-color ul li a:hover, .filter-with-bg-color ul li a:focus, .filter-with-bg-color ul li a.active {
  cursor: pointer;
  background-color: #3f51b5;
  border-color: #3f51b5;
  color: #fff;
}
@media screen and (max-width: 575px) {
  .filter-with-bg-color ul {
    margin-bottom: 15px;
  }
}

/*Faqs Styles*/
.Collapsible {
  margin-bottom: 15px;
}

.Collapsible__contentInner {
  padding: 20px;
  border: 1px solid #e9ecef;
  background-color: #fff;
  border-top: 0;
}
.Collapsible__contentInner p {
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 20px;
}
.Collapsible__contentInner p:last-child {
  margin-bottom: 0;
}

.Collapsible__trigger {
  display: block;
  cursor: pointer;
  font-weight: 400;
  text-decoration: none;
  position: relative;
  padding: 18px 20px;
  border-radius: 8px;
  background: #3f51b5;
  color: #fff;
}
.Collapsible__trigger:after {
  content: "\\f2f9";
  font-family: "Material-Design-Iconic-Font";
  font-size: 20px;
  position: absolute;
  right: 24px;
  top: 16px;
  display: block;
  transition: transform 300ms;
}
.Collapsible__trigger.is-open {
  border-radius: 8px 8px 0 0;
}
.Collapsible__trigger.is-open:after {
  transform: rotateZ(180deg);
}

.categories-list {
  margin-bottom: 0;
}
.categories-list li {
  margin-bottom: 10px;
}
.categories-list li:last-child {
  margin-bottom: 0;
}
.categories-list li.active a {
  color: #3f51b5;
}
.categories-list .badge {
  font-size: 9px;
}

.articles-section .articles {
  margin-bottom: 26px;
}
.articles-section .articles:last-child {
  margin-bottom: 0;
}

.article-image {
  display: block;
  margin-bottom: 12px;
}
.article-image > img {
  border-radius: 8px;
  width: 100%;
}

.article-description p {
  font-weight: 500;
  margin-bottom: 2px;
}

.meta-wrapper {
  margin-bottom: 10px;
}

.meta-date,
.meta-comment {
  font-size: 14px;
  color: #adb5bd;
  display: inline-block;
}
.meta-date i,
.meta-comment i {
  display: inline-block;
  margin-right: 6px;
}

.meta-date + .meta-comment {
  margin-left: 10px;
}

/*Dashboard Styles*/
.box {
  position: relative;
}
.box .box-top,
.box .box-bottom {
  height: 100px;
  padding: 32px 15px;
  font-size: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: 300;
}
.box .box-top .size-h5,
.box .box-bottom .size-h5 {
  font-size: 24px;
  margin-left: 2px;
}
.box .box-top .material-icons,
.box .box-bottom .material-icons {
  font-size: 40px;
  line-height: 40px;
}
.box .box-bottom {
  border-top: 1px solid rgba(0, 0, 0, 0.15);
}
.box .box-info {
  position: absolute;
  width: 100%;
  top: 50%;
  margin-top: -12px;
  text-align: center;
}
.box .box-info span {
  height: 24px;
  display: inline-block;
  padding: 4px 10px;
  text-transform: uppercase;
  line-height: 14px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  font-size: 12px;
  color: #6c757d;
  border-radius: 1em;
}
.box .box-info span .material-icons {
  line-height: 14px;
  font-size: 11px;
}

.contact-list {
  margin-bottom: 14px;
}
.contact-list i {
  margin-right: 14px;
  color: #3f51b5;
}
.contact-list .media {
  margin-bottom: 10px;
}

.temp-section .temp-point,
.temp-section .detail-icon {
  font-size: 54px;
}

.assignment-table tbody tr:nth-child(odd) {
  background-color: #dee2e6 !important;
}
.assignment-table td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.status-cell {
  min-width: 100px;
  max-width: 120px;
  padding-right: 24px !important;
}
.status-cell .badge {
  min-width: 70px;
}

.thumbnail-list {
  margin-bottom: 0;
}
.thumbnail-list .thumbnail-item {
  padding: 0 2.5px;
  display: inline-block;
  width: 33.333%;
  margin-bottom: 5px;
}
@media screen and (max-width: 767px) {
  .thumbnail-list .thumbnail-item {
    width: 50%;
  }
}
@media screen and (max-width: 575px) {
  .thumbnail-list .thumbnail-item {
    width: 33.333%;
  }
}

.post-list .post-image .grid-thumb-equal {
  padding-bottom: 100%;
}

/*Ecommerce Dashboard Styles*/
.chart-f30 {
  font-size: 30px;
}
@media screen and (max-width: 1099px) {
  .chart-f30 {
    font-size: 20px;
  }
}

.chart-f20 {
  font-size: 20px;
}
@media screen and (max-width: 1099px) {
  .chart-f20 {
    font-size: 16px;
  }
}

.chart-order .col-5 {
  order: 2;
  text-align: center;
}
@media screen and (max-width: 575px) {
  .chart-order .col-5 {
    order: 1;
  }
}
.chart-order .col-7 {
  order: 1;
}
@media screen and (max-width: 575px) {
  .chart-order .col-7 {
    order: 2;
  }
}

.tab-notifications {
  margin-left: -30px;
  margin-right: -30px;
  border-bottom: 1px solid #adb5bd;
}
@media screen and (max-width: 567px) {
  .tab-notifications button,
  .tab-notifications button * {
    font-size: 12px !important;
  }
}

.chart-title h2 {
  font-size: 22px;
  margin-bottom: 5px;
}

.img-fluid {
  width: 100%;
}

.comment-footer button {
  margin-bottom: 6px;
}

/*Intranet Dashboard Styles*/
.net-chart {
  padding-left: 80px;
  padding-right: 15px;
  min-height: 100px;
  position: relative;
  overflow: hidden;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}
.net-chart .jr-card-thumb {
  margin: 0;
  width: 50px;
  height: 50px;
  color: #fff;
  font-size: 20px;
  border-radius: 50%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-transition: all 100ms ease;
  -o-transition: all 100ms ease;
  transition: all 100ms ease;
  position: absolute;
  left: 15px;
}
.net-chart:hover .jr-card-thumb {
  width: 70px;
  height: 100%;
  font-size: 30px;
  border-radius: 0;
  position: absolute;
  left: 0;
}

.net-chart-hr {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  min-height: 120px;
  padding-right: 8px;
  overflow: hidden;
}
.net-chart-hr .jr-card-thumb {
  margin: -30px 12px -30px -30px;
  min-width: 105px;
}
.net-chart-hr .grid-thumb-equal {
  padding-bottom: 130%;
}
.net-chart-hr .jr-card-body {
  width: calc(100% - 100px);
}

.user-profile {
  padding: 10px 0;
}

.mh-120 {
  min-height: 120px;
}

.jr-card-header-top {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-right: -16px;
}

.jr-card-header-color {
  padding: 10px 20px 20px;
  margin: -24px -30px 25px;
}

.todo-cell-group .todo-cell:not(:last-child) {
  margin-bottom: 8px;
}

.social-list-line {
  position: relative;
}
.social-list-line:not(:last-child):before {
  border-left: solid 1px #adb5bd;
  content: "";
  left: 20px;
  position: absolute;
  top: 5px;
  bottom: 0;
  width: 1px;
  z-index: 1;
}

.list-line-item {
  position: relative;
  padding-left: 40px;
}
.list-line-item:not(:last-child):before {
  border-left: solid 1px #adb5bd;
  content: "";
  left: 20px;
  position: absolute;
  top: -25px;
  bottom: -25px;
  width: 1px;
  z-index: 1;
}

.list-line-badge {
  position: absolute;
  left: 16px;
  top: 15px;
  z-index: 2;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background-color: #adb5bd;
}

.circle-shape {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.project-list {
  line-height: 1;
}
.project-list:not(:last-child) {
  margin-bottom: 20px;
}
.project-list .circle-shape {
  margin-top: 4px;
  margin-right: 16px;
}
.project-list .project-name {
  display: block;
  margin-bottom: 4px;
  color: #5c5c5c;
}
.project-list .project-name:hover, .project-list .project-name:focus {
  color: #3f51b5;
  text-decoration: none;
}

.nav-pill-sales li + li {
  margin-right: -1px;
}
.nav-pill-sales .nav-link {
  background-color: #e9ecef;
  border-radius: 0;
  padding: 6px 15px;
  color: #6c757d;
  font-size: 13px;
  border: 1px solid #ced4da;
}
.nav-pill-sales .nav-link.active {
  background-color: #3f51b5;
  color: #fff;
  border-color: #3f51b5;
}
.nav-pill-sales .nav-link.active:hover, .nav-pill-sales .nav-link.active:focus {
  color: #fff;
}
.nav-pill-sales li:first-child .nav-link {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.nav-pill-sales li:last-child .nav-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.temp-week-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  color: rgb(128.2832618026, 137.4068669528, 145.5167381974);
}
.temp-week-list li:not(:last-child) {
  margin-bottom: 10px;
}
@media screen and (max-width: 340px) {
  .temp-week-list li:not(:last-child) {
    margin-bottom: 20px;
  }
}
.temp-week-list img {
  width: 24px;
  height: 24px;
}
.temp-week-list span {
  display: inline-block;
}
.temp-week-list span.temp-point {
  margin: 0 20px;
}
@media screen and (max-width: 1199px) {
  .temp-week-list span.temp-point {
    margin: 0 10px;
  }
}
@media screen and (max-width: 1050px) {
  .temp-week-list span.temp-point {
    margin: 0 5px;
  }
}
@media screen and (max-width: 340px) {
  .temp-week-list span.temp-point {
    margin: 0 20px;
  }
}

.temp-section .temp-point {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 0;
}
.temp-section .temp-point sub, .temp-section .temp-point sup {
  font-size: 70%;
}

/*Dropzone Styles*/
.dropzone-card {
  position: relative;
}

.dropzone {
  margin-bottom: 20px;
}
.dropzone > div {
  margin: 0 auto;
  padding: 15px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}
.dropzone > div :last-child {
  margin-bottom: 0;
}
.dropzone .btn {
  margin-top: 20px;
}

.upload-file-list {
  list-style: none;
  padding-left: 0;
}
.upload-file-list li {
  margin-bottom: 5px;
}

.form-group-dropzone label {
  margin-bottom: 6px;
}
.form-group-dropzone .form-control {
  max-width: 200px;
  margin: 0 auto;
}

/* Slider
   ========================================================================== */
.brand-logo {
  border: 1px solid #dee2e6;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding-bottom: 75%;
}
.brand-logo .brand-logo-inner {
  text-align: center;
}
.brand-logo .brand-logo-inner:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.brand-logo .brand-logo-inner img {
  height: auto;
  max-height: 100%;
  max-width: 100%;
  display: inline-block;
  vertical-align: middle;
  width: auto !important;
}
.brand-logo:hover {
  -webkit-transition: all 0.4s ease-in-out 0.1s;
  -o-transition: all 0.4s ease-in-out 0.1s;
  transition: all 0.4s ease-in-out 0.1s;
  background-color: rgb(242.25, 242.25, 242.25);
}
@media screen and (max-width: 575px) {
  .brand-logo {
    margin-bottom: 15px;
  }
}

.owl-app-frame.owl-carousel .owl-item img {
  display: inline-block;
  width: auto;
}

.carousel-item img {
  max-width: 100%;
}

/* Modules
   ========================================================================== */
/* App Module Style */
.app-wrapper-module {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: stretch;
  align-items: stretch;
  height: 100%;
}

.app-module {
  position: relative;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin: -36px -40px 0 -40px;
}
@media screen and (max-width: 575px) {
  .app-module {
    margin: -20px;
  }
}

.module-side {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 230px;
  -ms-flex: 0 1 230px;
  flex: 0 1 230px;
  max-width: 230px;
  min-width: 230px;
}

.module-side-header {
  border-bottom: solid 1px #e9ecef;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.module-side-header .user-detail {
  padding: 15px 10px;
  text-align: center;
}

.module-logo {
  padding: 10px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  min-height: 78px;
  font-size: 20px;
  background-color: rgb(249.4875, 250.275, 251.0625);
  color: rgb(47.4275862069, 52.9, 58.3724137931);
}
.module-logo .zmdi {
  font-size: 28px;
}

.module-user-info, .module-side-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.module-user-detail {
  font-size: 12px;
}

.module-add-task {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 24px;
}

.module-nav {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}
.module-nav li {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.module-nav li a {
  padding: 12px 29px;
  color: #8f8f8f;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  text-decoration: none;
}
.module-nav li a:hover, .module-nav li a:focus {
  color: #5c5c5c;
}
.module-nav li a.active {
  color: #3f51b5;
}
.module-nav li i {
  margin-right: 16px;
  font-size: 16px;
}
.module-nav li span {
  display: inline-block;
  vertical-align: middle;
}
.module-nav li.module-nav-label {
  padding: 12px 29px;
}

.module-box {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: calc(100% - 231px);
}

.module-box-header {
  padding: 10px 26px;
  min-height: 79px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  background-color: #fff;
  border-bottom: solid 1px #e9ecef;
}
.module-box-header .search-bar.right-side-icon {
  min-width: 350px;
}
.module-box-header .search-bar.right-side-icon .form-control {
  border-radius: 0;
  height: 46px;
  padding: 10px 18px 10px 40px;
}
.module-box-header .search-bar.right-side-icon .form-control:focus {
  background-color: #f8f9fa;
}
.module-box-header .search-bar.right-side-icon .search-icon {
  width: 25px;
  height: 46px;
  font-size: 16px;
  left: 10px;
  top: 0;
  padding: 0;
}

.module-box-header-inner {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.module-box-content {
  background-color: #fff;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.module-box-topbar {
  padding: 8px 12px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: solid 1px #e9ecef;
}
.module-box-topbar button + button {
  border-radius: 0;
}

.module-box-topbar-todo {
  padding-left: 64px;
}
@media screen and (max-width: 575px) {
  .module-box-topbar-todo {
    padding-left: 27px;
  }
}

.module-list-icon {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  padding-right: 10px;
}

.bar-icon {
  margin-right: 15px;
}

.toolbar-separator {
  border-left: solid 1px #ced4da;
  height: 100%;
  width: 1px;
  margin: 0 12px;
}

.toolbar-left {
  margin-left: auto;
}

.module-list {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}

.module-list-item {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  padding: 15px 28px;
  border-bottom: solid 1px #e9ecef;
  z-index: 5;
  position: relative;
  cursor: pointer;
}
.module-list-item > .check-label {
  margin-left: 0;
  margin-bottom: 0;
}
.module-list-item.mail-cell {
  padding-left: 12px;
  -webkit-align-items: start;
  align-items: start;
}

.module-detail-header {
  margin-bottom: 10px;
}
.module-detail-header > .check-label {
  margin-right: auto;
}

.module-list-info {
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: calc(100% - 169px);
}

.module-todo-content {
  position: relative;
}
.module-todo-content .subject {
  margin-bottom: 5px;
}

.module-list-actions {
  text-align: right;
}

.app-module-sidenav {
  background-color: #fff;
  border-right: solid 1px #e9ecef;
  position: relative;
  z-index: 9;
}
.app-module-sidenav .chat-sidenav-main {
  max-width: 300px;
  min-width: 300px;
  width: 90%;
}

.module-date {
  max-width: 160px;
}
.module-date > div:before {
  display: none;
}

.module-detail-item {
  padding: 10px 28px;
}

.task-title {
  font-size: 18px;
}

.chat-todo-avatar {
  margin-right: 15px;
}

.modal-title {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
  width: 100%;
  font-size: 18px;
}

.loader-view-block, .loader-view {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
}

.module-date > div {
  -webkit-align-items: center;
  align-items: center;
}

@media screen and (max-width: 1199px) {
  .module-side {
    display: -webkit-block;
    display: -moz-block;
    display: -ms-block;
    display: -o-block;
    display: block;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 200px;
    min-width: 200px;
    background-color: #fff;
  }
  .module-box-header {
    position: relative;
    min-height: 58px;
    padding: 5px 26px 5px 75px;
  }
  .module-box-header .drawer-btn {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    border-right: solid 1px #e9ecef;
    height: 58px;
    width: 56px;
    border-radius: 0;
    font-size: 22px;
  }
  .module-box-header .search-bar.right-side-icon .form-control {
    height: 38px;
    padding: 5px 18px 5px 40px;
  }
  .module-box-header .search-bar.right-side-icon .search-icon {
    height: 38px;
  }
  .chat-loader-view {
    height: calc(100vh - 120px);
  }
  .module-box {
    max-width: 100%;
  }
}
@media screen and (min-width: 991px) {
  .modal-dialog {
    max-width: 750px;
  }
}
@media screen and (max-width: 991px) {
  .app-module {
    padding-top: 0;
  }
}
@media screen and (max-width: 599px) {
  .module-box-header .search-bar {
    margin-left: 0;
    max-width: none;
  }
  .module-box-header .search-bar.right-side-icon {
    min-width: 250px;
  }
}
@media screen and (max-width: 575px) {
  .module-list-item {
    padding: 10px 12px;
  }
  .module-list-info {
    max-width: 100%;
  }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu {
    right: auto !important;
    left: 0 !important;
  }
  .module-box-header .search-bar.right-side-icon {
    min-width: 200px;
  }
  .module-box-header .search-bar.right-side-icon .form-control {
    border-radius: 0.25rem;
  }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu:after {
    right: auto;
    left: 9px;
  }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu:before {
    right: auto;
    left: 9px;
  }
  .module-box-header .search-bar {
    padding-right: 2px;
  }
}
@media screen and (max-width: 399px) {
  .module-box-header .search-bar.right-side-icon {
    min-width: 100px;
  }
}
@media screen and (min-width: 399px) {
  .d-xs-flex {
    display: flex !important;
  }
}
/*Chat Module Styles*/
.chat-module {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.chat-module:before {
  left: -29px;
}

.chat-module-box {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  background-color: #f8f9fa;
  position: relative;
  width: 100%;
}

.chat-sidenav {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 315px;
  -ms-flex: 0 1 315px;
  flex: 0 1 315px;
  min-width: 315px;
  border-right: solid 1px #e9ecef;
}

.chat-box {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: 100%;
  position: relative;
  z-index: 2;
}

.chat-sidenav-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding: 25px 20px 12px;
  background-color: rgb(249.4875, 250.275, 251.0625);
}

.chat-user-hd {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 25px;
}

.chat-sidenav-header .search-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-bottom: 0;
}
.chat-sidenav-header .search-wrapper .search-bar.right-side-icon {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.chat-sidenav-header .search-wrapper .search-bar.right-side-icon .form-control {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
  padding-left: 42px;
  height: 42px;
}
.chat-sidenav-header .search-wrapper .search-bar.right-side-icon .search-icon {
  left: 10px;
  top: 0;
  height: 42px;
  padding: 0;
}

.chat-avatar {
  min-width: 50px;
}
.chat-user-item .chat-avatar {
  padding: 0 5px;
  min-width: 10px;
}
.chat-user-hd .chat-avatar {
  cursor: pointer;
}

.chat-avatar-mode {
  position: relative;
  max-width: 50px;
}
.chat-avatar-mode .chat-mode {
  display: block;
  position: absolute;
  left: 0;
  top: 2px;
  z-index: 1;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.chat-avatar-mode .chat-mode.small {
  width: 8px;
  height: 8px;
}
.chat-avatar-mode .chat-mode.online {
  background-color: #4CAF50;
}
.chat-avatar-mode .chat-mode.offline {
  background-color: #fff;
  border: solid 1px #4CAF50;
}
.chat-avatar-mode .chat-mode.away {
  background-color: #fdd835;
}
.chat-main-header-info .chat-avatar-mode {
  max-width: 60px;
}

.chat-sidenav-content {
  background-color: #fff;
}

.chat-sidenav-title {
  padding: 10px 16px;
  font-size: 13px;
  color: #00bcd4;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
}

.chat-tabs-header {
  background-color: rgb(249.4875, 250.275, 251.0625) !important;
}

.chat-user {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.chat-user.chat-user-center {
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
}
.chat-user.chat-user-center .chat-avatar {
  margin-left: auto;
}

.chat-user-item {
  border-bottom: solid 1px #e9ecef;
  padding: 16px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  cursor: pointer;
  max-height: 96px;
}
.chat-user-item.active, .chat-user-item:hover {
  background-color: rgb(227.9241803279, 230.6168032787, 245.5758196721);
}

.chat-user-row {
  margin: 0 -5px;
  -webkit-align-items: center;
  align-items: center;
}

.chat-info, .chat-contact-col {
  padding: 0 5px;
}
.chat-info p, .chat-contact-col p {
  margin-bottom: 0;
}
.chat-info .h4, .chat-contact-col .h4 {
  display: block;
  margin-bottom: 3px;
}

.chat-info-des {
  color: #6c757d;
  font-size: 13px;
}

.chat-date {
  padding: 0 5px;
  text-align: right;
}

.chat-box-main {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%;
}

.module-default {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  height: 100%;
  padding: 15px;
}

.s-128 {
  font-size: 128px !important;
  width: 128px !important;
  height: 128px !important;
  line-height: 128px !important;
  margin-bottom: 12px;
}

.chat-main {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.chat-main-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  border-bottom: solid 1px #e9ecef;
  padding: 16px;
  background-color: #fff;
  width: 100%;
}

.chat-main-header-info {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-right: auto;
}

.chat-contact-name {
  font-size: 20px;
  font-weight: 500;
}

.chat-main-footer {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  border-top: solid 1px #e9ecef;
  padding: 16px;
  background-color: #fff;
  width: 100%;
}
.chat-main-footer .form-group {
  margin-bottom: 0;
}

.todo-main-footer {
  padding: 6px 16px;
}

.chat-item {
  padding: 16px;
}
.chat-item .bubble {
  padding: 8px 12px;
  background-color: #fff;
  border-radius: 20px 20px 20px 0px;
  position: relative;
  margin-left: 16px;
  max-width: 600px;
  border: solid 1px #ced4da;
}
.chat-item.flex-row-reverse .bubble {
  margin-right: 16px;
  margin-left: 0;
  background-color: rgb(227.9241803279, 230.6168032787, 245.5758196721);
  border-radius: 20px 20px 0 20px;
}

.chat-btn {
  font-size: 38px !important;
  margin: 0 10px 0 -8px;
}

.chat-textarea {
  height: 40px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
}

.last-message-time {
  font-size: 11px;
  color: #adb5bd;
}

@media screen and (max-width: 1399px) {
  .s-128 {
    font-size: 100px !important;
    width: 100px !important;
    height: 100px !important;
    line-height: 100px !important;
  }
}
@media screen and (max-width: 1199px) {
  .chat-module {
    margin: -24px -29px -23px;
    padding-top: 0;
  }
  .chat-main-header {
    padding: 8px 24px;
  }
  .chat-main-header .size-60 {
    height: 50px !important;
    width: 50px !important;
    line-height: 50px;
  }
  .chat-main-header button {
    margin-bottom: 0;
  }
  .chat-main-header-info .chat-avatar-mode {
    max-width: 50px;
  }
  .chat-contact-name,
  .chat-sidenav-title {
    font-size: 16px;
  }
  .chat-main-footer {
    padding: 8px 16px;
  }
  .s-128 {
    font-size: 128px !important;
    width: 128px !important;
    height: 128px !important;
    line-height: 128px !important;
  }
}
@media screen and (max-width: 991px) {
  .s-128 {
    font-size: 100px !important;
    width: 100px !important;
    height: 100px !important;
    line-height: 100px !important;
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 767px) {
  .chat-sidenav-title,
  .chat-contact-name {
    font-size: 15px;
  }
  .s-128 {
    font-size: 80px !important;
    width: 80px !important;
    height: 80px !important;
    line-height: 80px !important;
  }
}
@media screen and (max-width: 575px) {
  .module-default h1 {
    font-size: 17px;
  }
  .s-128 {
    font-size: 40px !important;
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important;
  }
}
/*Mails Module Styles*/
.module-box-row {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}

.module-box-column {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
}

.mail-user-info {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}
.mail-user-info .avatar {
  margin-right: 10px;
}
.mail-user-info .time, .mail-user-info button {
  margin-left: auto;
}
.mail-user-info .badge {
  margin-bottom: 0;
}

.module-list-item.mail-cell {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.mail-detail {
  padding: 24px !important;
}

.mail-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
}

.mail-header-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.mail-header-content .subject {
  margin-bottom: 5px;
}

.show-detail {
  cursor: pointer;
}

.text-truncate, .module-list-content .message p, .module-list-content .subject {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.module-list-content .message {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  color: rgb(144.7432432432, 155.5, 166.2567567568);
  font-size: 13px;
}
.module-list-content .message p {
  margin-bottom: 8px;
}

.size {
  margin: 5px 0;
}

.sender-name {
  margin-right: 0;
  font-weight: 500;
  font-size: 15px;
}

.mail-header-actions {
  text-align: right;
  min-width: 100px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.mail-header-actions .icon-btn:not(:last-child) {
  margin-right: 3px;
}

@media screen and (max-width: 991px) {
  .module-list-item.mail-cell {
    padding-right: 20px;
  }
}
@media screen and (max-width: 576px) {
  .mail-list {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
    border-right: 0 none;
  }
  .mail-detail {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
  }
  .mail-detail .module-list-scroll {
    padding: 24px;
  }
}
@media screen and (max-width: 499px) {
  .mail-header {
    display: block;
    -webkit-align-items: flex-start;
    align-items: flex-start;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .mail-header-actions {
    text-align: left;
    min-width: 10px;
  }
  .MuiDialog-paperWidthSm-99 {
    max-width: 250px !important;
  }
}
/*Contact Module Styles*/
.contact-item {
  -webkit-align-items: center;
  align-items: center;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: solid 1px #e9ecef;
  padding: 8px 12px;
}

.contact-name {
  font-size: 15px;
}

.modal-box {
  position: relative;
}

.modal-w {
  max-width: 400px;
  min-width: 350px;
}
.modal-box-mail .modal-w {
  min-width: 600px;
}

.modal-box-header {
  color: #fff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.modal-box-header h2 {
  color: #fff;
  position: relative;
}
.modal-box-header h2 button {
  position: absolute;
  right: 0;
  top: -10px;
  z-index: 1;
  color: #fff;
}

.modal-box-content {
  padding: 24px;
}
.modal-box-content .avatar {
  margin: 0 auto;
}

.modal-box-footer {
  padding: 0 24px 24px;
}
.modal-box-footer .attach-file {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 15px;
}

.btn-fixed {
  position: fixed !important;
  right: 40px;
  bottom: 60px;
  z-index: 100;
}

.draggable-icon {
  cursor: all-scroll;
  color: #6c757d;
}
.draggable-icon:hover, .draggable-icon:focus, .draggable-icon:active {
  cursor: all-scroll;
  color: #212529;
}

.module-side-nav {
  padding: 20px 0;
}

@media screen and (max-width: 767px) {
  .modal-box-mail .modal-w {
    min-width: 500px;
  }
  .modal-box-header h2 {
    font-size: 18px;
  }
}
@media screen and (max-width: 575px) {
  .modal-w {
    min-width: 300px;
  }
  .modal-box-mail .modal-w {
    min-width: 400px;
  }
  .modal-box-header h2 {
    font-size: 16px;
  }
}
@media screen and (max-width: 419px) {
  .modal-w {
    min-width: 250px;
  }
  .modal-box-mail .modal-w {
    min-width: 250px;
  }
}
@media screen and (max-width: 399px) {
  .con-inf-mw-100 {
    min-width: 100% !important;
  }
}
/* Calendar Module Style */
.app-calendar .rbc-calendar {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-height: calc(100vh - 160px);
}
.app-cul-calendar .rbc-calendar {
  min-height: calc(100vh - 200px);
}

.rbc-event {
  background-color: #3f51b5;
}

.rbc-event.rbc-selected {
  background-color: rgb(49.8319672131, 64.0696721311, 143.1680327869);
}

.rbc-slot-selection {
  background-color: rgba(63, 81, 181, 0.7);
}

.rbc-toolbar button:active,
.rbc-toolbar button.rbc-active {
  color: #fff;
  background-image: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.rbc-toolbar button:active:hover,
.rbc-toolbar button.rbc-active:hover,
.rbc-toolbar button:active:focus,
.rbc-toolbar button.rbc-active:focus {
  color: #fff;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.rbc-toolbar button:focus {
  color: #fff;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.rbc-toolbar button:hover {
  color: #fff;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5;
}

.rbc-month-row {
  min-height: 100px;
}

.rbc-event {
  min-height: 50px;
}

@media screen and (max-width: 867px) {
  .rbc-toolbar {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-align-items: flex-start;
    align-items: flex-start;
  }
  .rbc-toolbar .rbc-toolbar-label {
    margin: 8px 0;
  }
}
@media screen and (max-height: 600px) {
  .app-calendar .rbc-calendar {
    min-height: 400px;
  }
  .app-cul-calendar .rbc-calendar {
    min-height: 400px;
  }
}
@media screen and (max-width: 467px) {
  .rbc-toolbar {
    font-size: 12px;
  }
  .rbc-toolbar button {
    padding: 5px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./styles/app.scss","webpack://./styles/global/__global-dir.scss","webpack://./styles/global/_place-holder.scss","webpack://./styles/global/_variables.scss","webpack://./styles/global/_mixin.scss","webpack://./styles/bootstrap/_variables.scss","webpack://./styles/global/_sizes.scss","webpack://./styles/global/_color.scss","webpack://./styles/global/_custom-animation.scss","webpack://./styles/base/__base-dir.scss","webpack://./styles/base/_base.scss","webpack://./styles/base/_typography.scss","webpack://./styles/layout/__layout-dir.scss","webpack://./styles/layout/_app-layout.scss","webpack://./styles/layout/_sidebar.scss","webpack://./styles/layout/_header.scss","webpack://./styles/layout/_navbar.scss","webpack://./styles/layout/_main-content.scss","webpack://./styles/layout/_footer.scss","webpack://./styles/layout/_right-sidebar.scss","webpack://./styles/ui/__ui-dir.scss","webpack://./styles/ui/_alert.scss","webpack://./styles/ui/_avatar.scss","webpack://./styles/ui/_badges.scss","webpack://./styles/ui/_blockquotes.scss","webpack://./styles/ui/_bottom-navigation.scss","webpack://./styles/ui/_breadcrumb.scss","webpack://./styles/ui/_button.scss","webpack://./styles/ui/_button-group.scss","webpack://./styles/ui/_callout.scss","webpack://./styles/ui/_card.scss","webpack://./styles/ui/_charts.scss","webpack://./styles/ui/_chip.scss","webpack://./styles/ui/_carousel.scss","webpack://./styles/ui/_color-picker.scss","webpack://./styles/ui/_date-input.scss","webpack://./styles/ui/_drawer.scss","webpack://./styles/ui/_e-commerce.scss","webpack://./styles/ui/_grid-list.scss","webpack://./styles/ui/_icons.scss","webpack://./styles/ui/_label.scss","webpack://./styles/ui/_list.scss","webpack://./styles/ui/_nav.scss","webpack://./styles/ui/_pricing-tables.scss","webpack://./styles/ui/_progressbar.scss","webpack://./styles/ui/_popover.scss","webpack://./styles/ui/_tables.scss","webpack://./styles/ui/_tabs.scss","webpack://./styles/ui/_testimonial.scss","webpack://./styles/ui/_timeline.scss","webpack://./styles/ui/_form.scss","webpack://./styles/ui/_ad-form.scss","webpack://./styles/ui/_input.scss","webpack://./styles/pages/__pages-dir.scss","webpack://./styles/pages/_login.scss","webpack://./styles/pages/_error.scss","webpack://./styles/pages/_editor.scss","webpack://./styles/pages/_contact.scss","webpack://./styles/pages/_portfolio.scss","webpack://./styles/pages/_faq.scss","webpack://./styles/pages/_dashboard.scss","webpack://./styles/pages/_dropzone.scss","webpack://./styles/slider/_owl-carousel.scss","webpack://./styles/module/__module-dir.scss","webpack://./styles/module/_app-module.scss","webpack://./styles/module/_chat.scss","webpack://./styles/module/_mail.scss","webpack://./styles/module/_contact.scss","webpack://./styles/module/_calendar.scss"],"names":[],"mappings":"AAAA;;;;CAAA;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;gEAAA;ACLA;+EAAA;ACEE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,yBCqDW;EDpDX,cAAA;EE4BF,iCF3BE;EE4BF,4BF5BE;EE6BF,yBF7BE;EACA,aAAA;EACA,eAAA;AF0EJ;AExEI;EAEE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EEcJ,iCFbI;EEcJ,4BFdI;EEeJ,yBFfI;AF2EN;AExEI;EACE,WAAA;EACA,YAAA;AF0EN;AEvEI;EACE,WAAA;EACA,SAAA;AFyEN;AErEI;EACE,WAAA;AFuEN;AEtEM;EAEE,WAAA;AFuER;;AEjEA;EACE,uBAAA;EACA,sBAAA;EACA,iBCyGQ;AHrCV;;AEjEA;EACE,uBAAA;EACA,sBAAA;EACA,iBCoGQ;AHhCV;;AEjEA;EACE,uBAAA;EACA,sBAAA;EACA,iBC+FQ;AH3BV;;AEjEA;EACE,wBAAA;EACA,uBAAA;EACA,kBC0FS;AHtBX;;AEjEA;EACE,uBAAA;EACA,sBAAA;EACA,iBC8EQ;AHVV;;AEhEA;EACE,uBAAA;EACA,sBAAA;EACA,iBCwEQ;AHLV;;AEhEA;EACE,uBAAA;EACA,sBAAA;EACA,iBCmEQ;AHAV;;AEhEA;EACE,wBAAA;EACA,uBAAA;EACA,kBCkES;AHCX;;AEhEA;EACE,qBAAA;EACA,kBAAA;EACA,yBAAA;AFmEF;;AEhEA;EACE,kBCxBgB;EDyBhB,mBC1Be;ED2Bf,sBGhGM;EDsFJ,kBDxDe;EDoEjB,yBC3BU;ED4BV,kBAAA;AFmEF;;AEhEA,iBAAA;AACA;EACE,kBAAA;EACA,gBAAA;AFmEF;AElEE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;EE5BA,mBF6BuB;EACvB,sCAAA;EACA,yBAAA;AFoEJ;AEjEE;EACE,6BAAA;AFmEJ;;AE/DA;EACE;IACE,sBAAA;IACA,YAAA;EFkEF;EEhEA;IACE,wBAAA;IACA,YAAA;EFkEF;EEhEA;IACE,UAAA;IACA,0BAAA;EFkEF;AACF;AE/DA;EACE;IACE,sBAAA;IACA,YAAA;EFiEF;EE/DA;IACE,wBAAA;IACA,YAAA;EFiEF;EE/DA;IACE,UAAA;IACA,0BAAA;EFiEF;AACF;AE7DA;EACE,cAAA;EErKA,gDFsKA;EErKA,6CFqKA;EEpKA,2CFoKA;EEnKA,wCFmKA;EACA,4BAAA;AFkEF;;AE/DA;EACE;IACE,kDAAA;EFkEF;EEhEA;IACE,mDAAA;EFkEF;EEhEA;IACE,gDAAA;EFkEF;AACF;AE/DA;EACE;IACE,+CAAA;IACA,0CAAA;EFiEF;EE/DA;IACE,gDAAA;IACA,2CAAA;EFiEF;EE/DA;IACE,6CAAA;IACA,wCAAA;EFiEF;AACF;AE7DA;EACE,cAAA;EEvMA,gDFwMA;EEvMA,6CFuMA;EEtMA,2CFsMA;EErMA,wCFqMA;EACA,6BAAA;AFkEF;;AE/DA;EACE;IACE,kDAAA;EFkEF;EEhEA;IACE,mDAAA;EFkEF;EEhEA;IACE,gDAAA;EFkEF;AACF;AE/DA;EACE;IACE,+CAAA;IACA,0CAAA;EFiEF;EE/DA;IACE,gDAAA;IACA,2CAAA;EFiEF;EE/DA;IACE,6CAAA;IACA,wCAAA;EFiEF;AACF;AE7DA;EACE,cAAA;EEzOA,gDF0OA;EEzOA,6CFyOA;EExOA,2CFwOA;EEvOA,wCFuOA;EACA,2BAAA;AFkEF;;AE/DA;EACE;IACE,kDAAA;EFkEF;EEhEA;IACE,mDAAA;EFkEF;EEhEA;IACE,gDAAA;EFkEF;AACF;AE/DA;EACE;IACE,+CAAA;IACA,0CAAA;EFiEF;EE/DA;IACE,gDAAA;IACA,2CAAA;EFiEF;EE/DA;IACE,6CAAA;IACA,wCAAA;EFiEF;AACF;AE9DA,4DAAA;AACA;EACE,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AFgEF;;AE7DA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AFgEF;;AE7DA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AFgEF;;AE5DA;EACE,sBAAA;AF+DF;AE7DE;EAEE,sBAAA;AF8DJ;;AEzDA;EACE,eAAA;AF4DF;;AEtDE;;;;;;;;;;;;;;;;;EAEE,sBAAA;EErTF,wBFsTE;EErTF,qBFqTE;EEpTF,mBFoTE;EEnTF,gBFmTE;AF2EJ;AEzEI;;;;;;;;;;;;;;;;;EExTF,wBFyTI;EExTJ,qBFwTI;EEvTJ,mBFuTI;EEtTJ,gBFsTI;AF8FN;;AMrZI;EACE,qBAAA;ANwZN;;AMzZI;EACE,qBAAA;AN4ZN;;AM7ZI;EACE,qBAAA;ANgaN;;AMjaI;EACE,sBAAA;ANoaN;;AMraI;EACE,sBAAA;ANwaN;;AMzaI;EACE,sBAAA;AN4aN;;AM7aI;EACE,sBAAA;ANgbN;;AMjbI;EACE,uBAAA;ANobN;;AMrbI;EACE,yBAAA;ANwbN;;AMzbI;EACE,yBAAA;AN4bN;;AM7bI;EACE,yBAAA;ANgcN;;AMjcI;EACE,0BAAA;ANocN;;AMrcI;EACE,0BAAA;ANwcN;;AMzcI;EACE,0BAAA;AN4cN;;AM7cI;EACE,0BAAA;ANgdN;;AMjdI;EACE,2BAAA;ANodN;;AOtGM;EACE,oCAAA;APyGR;;AOvGM;EACE,yBAAA;AP0GR;AOzGQ;EACE,gCAAA;AP2GV;;AOvGM;EACE,oCAAA;AP0GR;;AOxGM;EACE,yBAAA;AP2GR;AO1GQ;EACE,gCAAA;AP4GV;;AOlHM;EACE,oCAAA;APqHR;;AOnHM;EACE,yBAAA;APsHR;AOrHQ;EACE,gCAAA;APuHV;;AO7HM;EACE,oCAAA;APgIR;;AO9HM;EACE,yBAAA;APiIR;AOhIQ;EACE,gCAAA;APkIV;;AOxIM;EACE,oCAAA;AP2IR;;AOzIM;EACE,yBAAA;AP4IR;AO3IQ;EACE,gCAAA;AP6IV;;AOnJM;EACE,oCAAA;APsJR;;AOpJM;EACE,yBAAA;APuJR;AOtJQ;EACE,gCAAA;APwJV;;AO9JM;EACE,oCAAA;APiKR;;AO/JM;EACE,yBAAA;APkKR;AOjKQ;EACE,gCAAA;APmKV;;AOzKM;EACE,oCAAA;AP4KR;;AO1KM;EACE,yBAAA;AP6KR;AO5KQ;EACE,gCAAA;AP8KV;;AOpLM;EACE,oCAAA;APuLR;;AOrLM;EACE,yBAAA;APwLR;AOvLQ;EACE,gCAAA;APyLV;;AO/LM;EACE,oCAAA;APkMR;;AOhMM;EACE,yBAAA;APmMR;AOlMQ;EACE,gCAAA;APoMV;;AO1MM;EACE,oCAAA;AP6MR;;AO3MM;EACE,yBAAA;AP8MR;AO7MQ;EACE,gCAAA;AP+MV;;AOrNM;EACE,oCAAA;APwNR;;AOtNM;EACE,yBAAA;APyNR;AOxNQ;EACE,gCAAA;AP0NV;;AOhOM;EACE,oCAAA;APmOR;;AOjOM;EACE,yBAAA;APoOR;AOnOQ;EACE,gCAAA;APqOV;;AO3OM;EACE,oCAAA;AP8OR;;AO5OM;EACE,yBAAA;AP+OR;AO9OQ;EACE,gCAAA;APgPV;;AOhQM;EACE,oCAAA;APmQR;;AOjQM;EACE,yBAAA;APoQR;AOnQQ;EACE,gCAAA;APqQV;;AOjQM;EACE,oCAAA;APoQR;;AOlQM;EACE,yBAAA;APqQR;AOpQQ;EACE,gCAAA;APsQV;;AO5QM;EACE,oCAAA;AP+QR;;AO7QM;EACE,yBAAA;APgRR;AO/QQ;EACE,gCAAA;APiRV;;AOvRM;EACE,oCAAA;AP0RR;;AOxRM;EACE,yBAAA;AP2RR;AO1RQ;EACE,gCAAA;AP4RV;;AOlSM;EACE,oCAAA;APqSR;;AOnSM;EACE,yBAAA;APsSR;AOrSQ;EACE,gCAAA;APuSV;;AO7SM;EACE,oCAAA;APgTR;;AO9SM;EACE,yBAAA;APiTR;AOhTQ;EACE,gCAAA;APkTV;;AOxTM;EACE,oCAAA;AP2TR;;AOzTM;EACE,yBAAA;AP4TR;AO3TQ;EACE,gCAAA;AP6TV;;AOnUM;EACE,oCAAA;APsUR;;AOpUM;EACE,yBAAA;APuUR;AOtUQ;EACE,gCAAA;APwUV;;AO9UM;EACE,oCAAA;APiVR;;AO/UM;EACE,yBAAA;APkVR;AOjVQ;EACE,gCAAA;APmVV;;AOzVM;EACE,oCAAA;AP4VR;;AO1VM;EACE,yBAAA;AP6VR;AO5VQ;EACE,gCAAA;AP8VV;;AOpWM;EACE,oCAAA;APuWR;;AOrWM;EACE,yBAAA;APwWR;AOvWQ;EACE,gCAAA;APyWV;;AO/WM;EACE,oCAAA;APkXR;;AOhXM;EACE,yBAAA;APmXR;AOlXQ;EACE,gCAAA;APoXV;;AO1XM;EACE,oCAAA;AP6XR;;AO3XM;EACE,yBAAA;AP8XR;AO7XQ;EACE,gCAAA;AP+XV;;AOrYM;EACE,oCAAA;APwYR;;AOtYM;EACE,yBAAA;APyYR;AOxYQ;EACE,gCAAA;AP0YV;;AO1ZM;EACE,oCAAA;AP6ZR;;AO3ZM;EACE,yBAAA;AP8ZR;AO7ZQ;EACE,gCAAA;AP+ZV;;AO3ZM;EACE,oCAAA;AP8ZR;;AO5ZM;EACE,yBAAA;AP+ZR;AO9ZQ;EACE,gCAAA;APgaV;;AOtaM;EACE,oCAAA;APyaR;;AOvaM;EACE,yBAAA;AP0aR;AOzaQ;EACE,gCAAA;AP2aV;;AOjbM;EACE,oCAAA;APobR;;AOlbM;EACE,yBAAA;APqbR;AOpbQ;EACE,gCAAA;APsbV;;AO5bM;EACE,oCAAA;AP+bR;;AO7bM;EACE,yBAAA;APgcR;AO/bQ;EACE,gCAAA;APicV;;AOvcM;EACE,oCAAA;AP0cR;;AOxcM;EACE,yBAAA;AP2cR;AO1cQ;EACE,gCAAA;AP4cV;;AOldM;EACE,oCAAA;APqdR;;AOndM;EACE,yBAAA;APsdR;AOrdQ;EACE,gCAAA;APudV;;AO7dM;EACE,oCAAA;APgeR;;AO9dM;EACE,yBAAA;APieR;AOheQ;EACE,gCAAA;APkeV;;AOxeM;EACE,oCAAA;AP2eR;;AOzeM;EACE,yBAAA;AP4eR;AO3eQ;EACE,gCAAA;AP6eV;;AOnfM;EACE,oCAAA;APsfR;;AOpfM;EACE,yBAAA;APufR;AOtfQ;EACE,gCAAA;APwfV;;AO9fM;EACE,oCAAA;APigBR;;AO/fM;EACE,yBAAA;APkgBR;AOjgBQ;EACE,gCAAA;APmgBV;;AOzgBM;EACE,oCAAA;AP4gBR;;AO1gBM;EACE,yBAAA;AP6gBR;AO5gBQ;EACE,gCAAA;AP8gBV;;AOphBM;EACE,oCAAA;APuhBR;;AOrhBM;EACE,yBAAA;APwhBR;AOvhBQ;EACE,gCAAA;APyhBV;;AO/hBM;EACE,oCAAA;APkiBR;;AOhiBM;EACE,yBAAA;APmiBR;AOliBQ;EACE,gCAAA;APoiBV;;AOpjBM;EACE,oCAAA;APujBR;;AOrjBM;EACE,yBAAA;APwjBR;AOvjBQ;EACE,gCAAA;APyjBV;;AOrjBM;EACE,oCAAA;APwjBR;;AOtjBM;EACE,yBAAA;APyjBR;AOxjBQ;EACE,gCAAA;AP0jBV;;AOhkBM;EACE,oCAAA;APmkBR;;AOjkBM;EACE,yBAAA;APokBR;AOnkBQ;EACE,gCAAA;APqkBV;;AO3kBM;EACE,oCAAA;AP8kBR;;AO5kBM;EACE,yBAAA;AP+kBR;AO9kBQ;EACE,gCAAA;APglBV;;AOtlBM;EACE,oCAAA;APylBR;;AOvlBM;EACE,yBAAA;AP0lBR;AOzlBQ;EACE,gCAAA;AP2lBV;;AOjmBM;EACE,oCAAA;APomBR;;AOlmBM;EACE,yBAAA;APqmBR;AOpmBQ;EACE,gCAAA;APsmBV;;AO5mBM;EACE,oCAAA;AP+mBR;;AO7mBM;EACE,yBAAA;APgnBR;AO/mBQ;EACE,gCAAA;APinBV;;AOvnBM;EACE,oCAAA;AP0nBR;;AOxnBM;EACE,yBAAA;AP2nBR;AO1nBQ;EACE,gCAAA;AP4nBV;;AOloBM;EACE,oCAAA;APqoBR;;AOnoBM;EACE,yBAAA;APsoBR;AOroBQ;EACE,gCAAA;APuoBV;;AO7oBM;EACE,oCAAA;APgpBR;;AO9oBM;EACE,yBAAA;APipBR;AOhpBQ;EACE,gCAAA;APkpBV;;AOxpBM;EACE,oCAAA;AP2pBR;;AOzpBM;EACE,yBAAA;AP4pBR;AO3pBQ;EACE,gCAAA;AP6pBV;;AOnqBM;EACE,oCAAA;APsqBR;;AOpqBM;EACE,yBAAA;APuqBR;AOtqBQ;EACE,gCAAA;APwqBV;;AO9qBM;EACE,oCAAA;APirBR;;AO/qBM;EACE,yBAAA;APkrBR;AOjrBQ;EACE,gCAAA;APmrBV;;AOzrBM;EACE,oCAAA;AP4rBR;;AO1rBM;EACE,yBAAA;AP6rBR;AO5rBQ;EACE,gCAAA;AP8rBV;;AO9sBM;EACE,oCAAA;APitBR;;AO/sBM;EACE,yBAAA;APktBR;AOjtBQ;EACE,gCAAA;APmtBV;;AO/sBM;EACE,oCAAA;APktBR;;AOhtBM;EACE,yBAAA;APmtBR;AOltBQ;EACE,gCAAA;APotBV;;AO1tBM;EACE,oCAAA;AP6tBR;;AO3tBM;EACE,yBAAA;AP8tBR;AO7tBQ;EACE,gCAAA;AP+tBV;;AOruBM;EACE,oCAAA;APwuBR;;AOtuBM;EACE,yBAAA;APyuBR;AOxuBQ;EACE,gCAAA;AP0uBV;;AOhvBM;EACE,oCAAA;APmvBR;;AOjvBM;EACE,yBAAA;APovBR;AOnvBQ;EACE,gCAAA;APqvBV;;AO3vBM;EACE,oCAAA;AP8vBR;;AO5vBM;EACE,yBAAA;AP+vBR;AO9vBQ;EACE,gCAAA;APgwBV;;AOtwBM;EACE,oCAAA;APywBR;;AOvwBM;EACE,yBAAA;AP0wBR;AOzwBQ;EACE,gCAAA;AP2wBV;;AOjxBM;EACE,oCAAA;APoxBR;;AOlxBM;EACE,yBAAA;APqxBR;AOpxBQ;EACE,gCAAA;APsxBV;;AO5xBM;EACE,oCAAA;AP+xBR;;AO7xBM;EACE,yBAAA;APgyBR;AO/xBQ;EACE,gCAAA;APiyBV;;AOvyBM;EACE,oCAAA;AP0yBR;;AOxyBM;EACE,yBAAA;AP2yBR;AO1yBQ;EACE,gCAAA;AP4yBV;;AOlzBM;EACE,oCAAA;APqzBR;;AOnzBM;EACE,yBAAA;APszBR;AOrzBQ;EACE,gCAAA;APuzBV;;AO7zBM;EACE,oCAAA;APg0BR;;AO9zBM;EACE,yBAAA;APi0BR;AOh0BQ;EACE,gCAAA;APk0BV;;AOx0BM;EACE,oCAAA;AP20BR;;AOz0BM;EACE,yBAAA;AP40BR;AO30BQ;EACE,gCAAA;AP60BV;;AOn1BM;EACE,oCAAA;APs1BR;;AOp1BM;EACE,yBAAA;APu1BR;AOt1BQ;EACE,gCAAA;APw1BV;;AOx2BM;EACE,oCAAA;AP22BR;;AOz2BM;EACE,yBAAA;AP42BR;AO32BQ;EACE,gCAAA;AP62BV;;AOz2BM;EACE,oCAAA;AP42BR;;AO12BM;EACE,yBAAA;AP62BR;AO52BQ;EACE,gCAAA;AP82BV;;AOp3BM;EACE,oCAAA;APu3BR;;AOr3BM;EACE,yBAAA;APw3BR;AOv3BQ;EACE,gCAAA;APy3BV;;AO/3BM;EACE,oCAAA;APk4BR;;AOh4BM;EACE,yBAAA;APm4BR;AOl4BQ;EACE,gCAAA;APo4BV;;AO14BM;EACE,oCAAA;AP64BR;;AO34BM;EACE,yBAAA;AP84BR;AO74BQ;EACE,gCAAA;AP+4BV;;AOr5BM;EACE,oCAAA;APw5BR;;AOt5BM;EACE,yBAAA;APy5BR;AOx5BQ;EACE,gCAAA;AP05BV;;AOh6BM;EACE,oCAAA;APm6BR;;AOj6BM;EACE,yBAAA;APo6BR;AOn6BQ;EACE,gCAAA;APq6BV;;AO36BM;EACE,oCAAA;AP86BR;;AO56BM;EACE,yBAAA;AP+6BR;AO96BQ;EACE,gCAAA;APg7BV;;AOt7BM;EACE,oCAAA;APy7BR;;AOv7BM;EACE,yBAAA;AP07BR;AOz7BQ;EACE,gCAAA;AP27BV;;AOj8BM;EACE,oCAAA;APo8BR;;AOl8BM;EACE,yBAAA;APq8BR;AOp8BQ;EACE,gCAAA;APs8BV;;AO58BM;EACE,oCAAA;AP+8BR;;AO78BM;EACE,yBAAA;APg9BR;AO/8BQ;EACE,gCAAA;APi9BV;;AOv9BM;EACE,oCAAA;AP09BR;;AOx9BM;EACE,yBAAA;AP29BR;AO19BQ;EACE,gCAAA;AP49BV;;AOl+BM;EACE,oCAAA;APq+BR;;AOn+BM;EACE,yBAAA;APs+BR;AOr+BQ;EACE,gCAAA;APu+BV;;AO7+BM;EACE,oCAAA;APg/BR;;AO9+BM;EACE,yBAAA;APi/BR;AOh/BQ;EACE,gCAAA;APk/BV;;AOlgCM;EACE,oCAAA;APqgCR;;AOngCM;EACE,yBAAA;APsgCR;AOrgCQ;EACE,gCAAA;APugCV;;AOngCM;EACE,oCAAA;APsgCR;;AOpgCM;EACE,yBAAA;APugCR;AOtgCQ;EACE,gCAAA;APwgCV;;AO9gCM;EACE,oCAAA;APihCR;;AO/gCM;EACE,yBAAA;APkhCR;AOjhCQ;EACE,gCAAA;APmhCV;;AOzhCM;EACE,oCAAA;AP4hCR;;AO1hCM;EACE,yBAAA;AP6hCR;AO5hCQ;EACE,gCAAA;AP8hCV;;AOpiCM;EACE,oCAAA;APuiCR;;AOriCM;EACE,yBAAA;APwiCR;AOviCQ;EACE,gCAAA;APyiCV;;AO/iCM;EACE,oCAAA;APkjCR;;AOhjCM;EACE,yBAAA;APmjCR;AOljCQ;EACE,gCAAA;APojCV;;AO1jCM;EACE,oCAAA;AP6jCR;;AO3jCM;EACE,yBAAA;AP8jCR;AO7jCQ;EACE,gCAAA;AP+jCV;;AOrkCM;EACE,oCAAA;APwkCR;;AOtkCM;EACE,yBAAA;APykCR;AOxkCQ;EACE,gCAAA;AP0kCV;;AOhlCM;EACE,oCAAA;APmlCR;;AOjlCM;EACE,yBAAA;APolCR;AOnlCQ;EACE,gCAAA;APqlCV;;AO3lCM;EACE,oCAAA;AP8lCR;;AO5lCM;EACE,yBAAA;AP+lCR;AO9lCQ;EACE,gCAAA;APgmCV;;AOtmCM;EACE,oCAAA;APymCR;;AOvmCM;EACE,yBAAA;AP0mCR;AOzmCQ;EACE,gCAAA;AP2mCV;;AOjnCM;EACE,oCAAA;APonCR;;AOlnCM;EACE,yBAAA;APqnCR;AOpnCQ;EACE,gCAAA;APsnCV;;AO5nCM;EACE,oCAAA;AP+nCR;;AO7nCM;EACE,yBAAA;APgoCR;AO/nCQ;EACE,gCAAA;APioCV;;AOvoCM;EACE,oCAAA;AP0oCR;;AOxoCM;EACE,yBAAA;AP2oCR;AO1oCQ;EACE,gCAAA;AP4oCV;;AO5pCM;EACE,oCAAA;AP+pCR;;AO7pCM;EACE,yBAAA;APgqCR;AO/pCQ;EACE,gCAAA;APiqCV;;AO7pCM;EACE,oCAAA;APgqCR;;AO9pCM;EACE,yBAAA;APiqCR;AOhqCQ;EACE,gCAAA;APkqCV;;AOxqCM;EACE,oCAAA;AP2qCR;;AOzqCM;EACE,yBAAA;AP4qCR;AO3qCQ;EACE,gCAAA;AP6qCV;;AOnrCM;EACE,oCAAA;APsrCR;;AOprCM;EACE,yBAAA;APurCR;AOtrCQ;EACE,gCAAA;APwrCV;;AO9rCM;EACE,oCAAA;APisCR;;AO/rCM;EACE,yBAAA;APksCR;AOjsCQ;EACE,gCAAA;APmsCV;;AOzsCM;EACE,oCAAA;AP4sCR;;AO1sCM;EACE,yBAAA;AP6sCR;AO5sCQ;EACE,gCAAA;AP8sCV;;AOptCM;EACE,oCAAA;APutCR;;AOrtCM;EACE,yBAAA;APwtCR;AOvtCQ;EACE,gCAAA;APytCV;;AO/tCM;EACE,oCAAA;APkuCR;;AOhuCM;EACE,yBAAA;APmuCR;AOluCQ;EACE,gCAAA;APouCV;;AO1uCM;EACE,oCAAA;AP6uCR;;AO3uCM;EACE,yBAAA;AP8uCR;AO7uCQ;EACE,gCAAA;AP+uCV;;AOrvCM;EACE,oCAAA;APwvCR;;AOtvCM;EACE,yBAAA;APyvCR;AOxvCQ;EACE,gCAAA;AP0vCV;;AOhwCM;EACE,oCAAA;APmwCR;;AOjwCM;EACE,yBAAA;APowCR;AOnwCQ;EACE,gCAAA;APqwCV;;AO3wCM;EACE,oCAAA;AP8wCR;;AO5wCM;EACE,yBAAA;AP+wCR;AO9wCQ;EACE,gCAAA;APgxCV;;AOtxCM;EACE,oCAAA;APyxCR;;AOvxCM;EACE,yBAAA;AP0xCR;AOzxCQ;EACE,gCAAA;AP2xCV;;AOjyCM;EACE,oCAAA;APoyCR;;AOlyCM;EACE,yBAAA;APqyCR;AOpyCQ;EACE,gCAAA;APsyCV;;AOtzCM;EACE,oCAAA;APyzCR;;AOvzCM;EACE,yBAAA;AP0zCR;AOzzCQ;EACE,gCAAA;AP2zCV;;AOvzCM;EACE,oCAAA;AP0zCR;;AOxzCM;EACE,yBAAA;AP2zCR;AO1zCQ;EACE,gCAAA;AP4zCV;;AOl0CM;EACE,oCAAA;APq0CR;;AOn0CM;EACE,yBAAA;APs0CR;AOr0CQ;EACE,gCAAA;APu0CV;;AO70CM;EACE,oCAAA;APg1CR;;AO90CM;EACE,yBAAA;APi1CR;AOh1CQ;EACE,gCAAA;APk1CV;;AOx1CM;EACE,oCAAA;AP21CR;;AOz1CM;EACE,yBAAA;AP41CR;AO31CQ;EACE,gCAAA;AP61CV;;AOn2CM;EACE,oCAAA;APs2CR;;AOp2CM;EACE,yBAAA;APu2CR;AOt2CQ;EACE,gCAAA;APw2CV;;AO92CM;EACE,oCAAA;APi3CR;;AO/2CM;EACE,yBAAA;APk3CR;AOj3CQ;EACE,gCAAA;APm3CV;;AOz3CM;EACE,oCAAA;AP43CR;;AO13CM;EACE,yBAAA;AP63CR;AO53CQ;EACE,gCAAA;AP83CV;;AOp4CM;EACE,oCAAA;APu4CR;;AOr4CM;EACE,yBAAA;APw4CR;AOv4CQ;EACE,gCAAA;APy4CV;;AO/4CM;EACE,oCAAA;APk5CR;;AOh5CM;EACE,yBAAA;APm5CR;AOl5CQ;EACE,gCAAA;APo5CV;;AO15CM;EACE,oCAAA;AP65CR;;AO35CM;EACE,yBAAA;AP85CR;AO75CQ;EACE,gCAAA;AP+5CV;;AOr6CM;EACE,oCAAA;APw6CR;;AOt6CM;EACE,yBAAA;APy6CR;AOx6CQ;EACE,gCAAA;AP06CV;;AOh7CM;EACE,oCAAA;APm7CR;;AOj7CM;EACE,yBAAA;APo7CR;AOn7CQ;EACE,gCAAA;APq7CV;;AO37CM;EACE,oCAAA;AP87CR;;AO57CM;EACE,yBAAA;AP+7CR;AO97CQ;EACE,gCAAA;APg8CV;;AOh9CM;EACE,oCAAA;APm9CR;;AOj9CM;EACE,yBAAA;APo9CR;AOn9CQ;EACE,gCAAA;APq9CV;;AOj9CM;EACE,oCAAA;APo9CR;;AOl9CM;EACE,yBAAA;APq9CR;AOp9CQ;EACE,gCAAA;APs9CV;;AO59CM;EACE,oCAAA;AP+9CR;;AO79CM;EACE,yBAAA;APg+CR;AO/9CQ;EACE,gCAAA;APi+CV;;AOv+CM;EACE,oCAAA;AP0+CR;;AOx+CM;EACE,yBAAA;AP2+CR;AO1+CQ;EACE,gCAAA;AP4+CV;;AOl/CM;EACE,oCAAA;APq/CR;;AOn/CM;EACE,yBAAA;APs/CR;AOr/CQ;EACE,gCAAA;APu/CV;;AO7/CM;EACE,oCAAA;APggDR;;AO9/CM;EACE,yBAAA;APigDR;AOhgDQ;EACE,gCAAA;APkgDV;;AOxgDM;EACE,oCAAA;AP2gDR;;AOzgDM;EACE,yBAAA;AP4gDR;AO3gDQ;EACE,gCAAA;AP6gDV;;AOnhDM;EACE,oCAAA;APshDR;;AOphDM;EACE,yBAAA;APuhDR;AOthDQ;EACE,gCAAA;APwhDV;;AO9hDM;EACE,oCAAA;APiiDR;;AO/hDM;EACE,yBAAA;APkiDR;AOjiDQ;EACE,gCAAA;APmiDV;;AOziDM;EACE,oCAAA;AP4iDR;;AO1iDM;EACE,yBAAA;AP6iDR;AO5iDQ;EACE,gCAAA;AP8iDV;;AOpjDM;EACE,oCAAA;APujDR;;AOrjDM;EACE,yBAAA;APwjDR;AOvjDQ;EACE,gCAAA;APyjDV;;AO/jDM;EACE,oCAAA;APkkDR;;AOhkDM;EACE,yBAAA;APmkDR;AOlkDQ;EACE,gCAAA;APokDV;;AO1kDM;EACE,oCAAA;AP6kDR;;AO3kDM;EACE,yBAAA;AP8kDR;AO7kDQ;EACE,gCAAA;AP+kDV;;AOrlDM;EACE,oCAAA;APwlDR;;AOtlDM;EACE,yBAAA;APylDR;AOxlDQ;EACE,gCAAA;AP0lDV;;AO1mDM;EACE,oCAAA;AP6mDR;;AO3mDM;EACE,yBAAA;AP8mDR;AO7mDQ;EACE,gCAAA;AP+mDV;;AO3mDM;EACE,oCAAA;AP8mDR;;AO5mDM;EACE,yBAAA;AP+mDR;AO9mDQ;EACE,gCAAA;APgnDV;;AOtnDM;EACE,oCAAA;APynDR;;AOvnDM;EACE,yBAAA;AP0nDR;AOznDQ;EACE,gCAAA;AP2nDV;;AOjoDM;EACE,oCAAA;APooDR;;AOloDM;EACE,yBAAA;APqoDR;AOpoDQ;EACE,gCAAA;APsoDV;;AO5oDM;EACE,oCAAA;AP+oDR;;AO7oDM;EACE,yBAAA;APgpDR;AO/oDQ;EACE,gCAAA;APipDV;;AOvpDM;EACE,oCAAA;AP0pDR;;AOxpDM;EACE,yBAAA;AP2pDR;AO1pDQ;EACE,gCAAA;AP4pDV;;AOlqDM;EACE,oCAAA;APqqDR;;AOnqDM;EACE,yBAAA;APsqDR;AOrqDQ;EACE,gCAAA;APuqDV;;AO7qDM;EACE,oCAAA;APgrDR;;AO9qDM;EACE,yBAAA;APirDR;AOhrDQ;EACE,gCAAA;APkrDV;;AOxrDM;EACE,oCAAA;AP2rDR;;AOzrDM;EACE,yBAAA;AP4rDR;AO3rDQ;EACE,gCAAA;AP6rDV;;AOnsDM;EACE,oCAAA;APssDR;;AOpsDM;EACE,yBAAA;APusDR;AOtsDQ;EACE,gCAAA;APwsDV;;AO9sDM;EACE,oCAAA;APitDR;;AO/sDM;EACE,yBAAA;APktDR;AOjtDQ;EACE,gCAAA;APmtDV;;AOztDM;EACE,oCAAA;AP4tDR;;AO1tDM;EACE,yBAAA;AP6tDR;AO5tDQ;EACE,gCAAA;AP8tDV;;AOpuDM;EACE,oCAAA;APuuDR;;AOruDM;EACE,yBAAA;APwuDR;AOvuDQ;EACE,gCAAA;APyuDV;;AO/uDM;EACE,oCAAA;APkvDR;;AOhvDM;EACE,yBAAA;APmvDR;AOlvDQ;EACE,gCAAA;APovDV;;AOpwDM;EACE,oCAAA;APuwDR;;AOrwDM;EACE,yBAAA;APwwDR;AOvwDQ;EACE,gCAAA;APywDV;;AOrwDM;EACE,oCAAA;APwwDR;;AOtwDM;EACE,yBAAA;APywDR;AOxwDQ;EACE,gCAAA;AP0wDV;;AOhxDM;EACE,oCAAA;APmxDR;;AOjxDM;EACE,yBAAA;APoxDR;AOnxDQ;EACE,gCAAA;APqxDV;;AO3xDM;EACE,oCAAA;AP8xDR;;AO5xDM;EACE,yBAAA;AP+xDR;AO9xDQ;EACE,gCAAA;APgyDV;;AOtyDM;EACE,oCAAA;APyyDR;;AOvyDM;EACE,yBAAA;AP0yDR;AOzyDQ;EACE,gCAAA;AP2yDV;;AOjzDM;EACE,oCAAA;APozDR;;AOlzDM;EACE,yBAAA;APqzDR;AOpzDQ;EACE,gCAAA;APszDV;;AO5zDM;EACE,oCAAA;AP+zDR;;AO7zDM;EACE,yBAAA;APg0DR;AO/zDQ;EACE,gCAAA;APi0DV;;AOv0DM;EACE,oCAAA;AP00DR;;AOx0DM;EACE,yBAAA;AP20DR;AO10DQ;EACE,gCAAA;AP40DV;;AOl1DM;EACE,oCAAA;APq1DR;;AOn1DM;EACE,yBAAA;APs1DR;AOr1DQ;EACE,gCAAA;APu1DV;;AO71DM;EACE,oCAAA;APg2DR;;AO91DM;EACE,yBAAA;APi2DR;AOh2DQ;EACE,gCAAA;APk2DV;;AOx2DM;EACE,oCAAA;AP22DR;;AOz2DM;EACE,yBAAA;AP42DR;AO32DQ;EACE,gCAAA;AP62DV;;AOn3DM;EACE,oCAAA;APs3DR;;AOp3DM;EACE,yBAAA;APu3DR;AOt3DQ;EACE,gCAAA;APw3DV;;AO93DM;EACE,oCAAA;APi4DR;;AO/3DM;EACE,yBAAA;APk4DR;AOj4DQ;EACE,gCAAA;APm4DV;;AOz4DM;EACE,oCAAA;AP44DR;;AO14DM;EACE,yBAAA;AP64DR;AO54DQ;EACE,gCAAA;AP84DV;;AO95DM;EACE,oCAAA;APi6DR;;AO/5DM;EACE,yBAAA;APk6DR;AOj6DQ;EACE,gCAAA;APm6DV;;AO/5DM;EACE,oCAAA;APk6DR;;AOh6DM;EACE,yBAAA;APm6DR;AOl6DQ;EACE,gCAAA;APo6DV;;AO16DM;EACE,oCAAA;AP66DR;;AO36DM;EACE,yBAAA;AP86DR;AO76DQ;EACE,gCAAA;AP+6DV;;AOr7DM;EACE,oCAAA;APw7DR;;AOt7DM;EACE,yBAAA;APy7DR;AOx7DQ;EACE,gCAAA;AP07DV;;AOh8DM;EACE,oCAAA;APm8DR;;AOj8DM;EACE,yBAAA;APo8DR;AOn8DQ;EACE,gCAAA;APq8DV;;AO38DM;EACE,oCAAA;AP88DR;;AO58DM;EACE,yBAAA;AP+8DR;AO98DQ;EACE,gCAAA;APg9DV;;AOt9DM;EACE,oCAAA;APy9DR;;AOv9DM;EACE,yBAAA;AP09DR;AOz9DQ;EACE,gCAAA;AP29DV;;AOj+DM;EACE,oCAAA;APo+DR;;AOl+DM;EACE,yBAAA;APq+DR;AOp+DQ;EACE,gCAAA;APs+DV;;AO5+DM;EACE,oCAAA;AP++DR;;AO7+DM;EACE,yBAAA;APg/DR;AO/+DQ;EACE,gCAAA;APi/DV;;AOv/DM;EACE,oCAAA;AP0/DR;;AOx/DM;EACE,yBAAA;AP2/DR;AO1/DQ;EACE,gCAAA;AP4/DV;;AOlgEM;EACE,oCAAA;APqgER;;AOngEM;EACE,yBAAA;APsgER;AOrgEQ;EACE,gCAAA;APugEV;;AO7gEM;EACE,oCAAA;APghER;;AO9gEM;EACE,yBAAA;APihER;AOhhEQ;EACE,gCAAA;APkhEV;;AOxhEM;EACE,oCAAA;AP2hER;;AOzhEM;EACE,yBAAA;AP4hER;AO3hEQ;EACE,gCAAA;AP6hEV;;AOniEM;EACE,oCAAA;APsiER;;AOpiEM;EACE,yBAAA;APuiER;AOtiEQ;EACE,gCAAA;APwiEV;;AOxjEM;EACE,oCAAA;AP2jER;;AOzjEM;EACE,yBAAA;AP4jER;AO3jEQ;EACE,gCAAA;AP6jEV;;AOzjEM;EACE,oCAAA;AP4jER;;AO1jEM;EACE,yBAAA;AP6jER;AO5jEQ;EACE,gCAAA;AP8jEV;;AOpkEM;EACE,oCAAA;APukER;;AOrkEM;EACE,yBAAA;APwkER;AOvkEQ;EACE,gCAAA;APykEV;;AO/kEM;EACE,oCAAA;APklER;;AOhlEM;EACE,yBAAA;APmlER;AOllEQ;EACE,gCAAA;APolEV;;AO1lEM;EACE,oCAAA;AP6lER;;AO3lEM;EACE,yBAAA;AP8lER;AO7lEQ;EACE,gCAAA;AP+lEV;;AOrmEM;EACE,oCAAA;APwmER;;AOtmEM;EACE,yBAAA;APymER;AOxmEQ;EACE,gCAAA;AP0mEV;;AOhnEM;EACE,oCAAA;APmnER;;AOjnEM;EACE,yBAAA;APonER;AOnnEQ;EACE,gCAAA;APqnEV;;AO3nEM;EACE,oCAAA;AP8nER;;AO5nEM;EACE,yBAAA;AP+nER;AO9nEQ;EACE,gCAAA;APgoEV;;AOtoEM;EACE,oCAAA;APyoER;;AOvoEM;EACE,yBAAA;AP0oER;AOzoEQ;EACE,gCAAA;AP2oEV;;AOjpEM;EACE,oCAAA;APopER;;AOlpEM;EACE,yBAAA;APqpER;AOppEQ;EACE,gCAAA;APspEV;;AO5pEM;EACE,oCAAA;AP+pER;;AO7pEM;EACE,yBAAA;APgqER;AO/pEQ;EACE,gCAAA;APiqEV;;AOvqEM;EACE,oCAAA;AP0qER;;AOxqEM;EACE,yBAAA;AP2qER;AO1qEQ;EACE,gCAAA;AP4qEV;;AOlrEM;EACE,oCAAA;APqrER;;AOnrEM;EACE,yBAAA;APsrER;AOrrEQ;EACE,gCAAA;APurEV;;AO7rEM;EACE,oCAAA;APgsER;;AO9rEM;EACE,yBAAA;APisER;AOhsEQ;EACE,gCAAA;APksEV;;AOltEM;EACE,oCAAA;APqtER;;AOntEM;EACE,yBAAA;APstER;AOrtEQ;EACE,gCAAA;APutEV;;AOntEM;EACE,oCAAA;APstER;;AOptEM;EACE,yBAAA;APutER;AOttEQ;EACE,gCAAA;APwtEV;;AO9tEM;EACE,oCAAA;APiuER;;AO/tEM;EACE,yBAAA;APkuER;AOjuEQ;EACE,gCAAA;APmuEV;;AOzuEM;EACE,oCAAA;AP4uER;;AO1uEM;EACE,yBAAA;AP6uER;AO5uEQ;EACE,gCAAA;AP8uEV;;AOpvEM;EACE,oCAAA;APuvER;;AOrvEM;EACE,yBAAA;APwvER;AOvvEQ;EACE,gCAAA;APyvEV;;AO/vEM;EACE,oCAAA;APkwER;;AOhwEM;EACE,yBAAA;APmwER;AOlwEQ;EACE,gCAAA;APowEV;;AO1wEM;EACE,oCAAA;AP6wER;;AO3wEM;EACE,yBAAA;AP8wER;AO7wEQ;EACE,gCAAA;AP+wEV;;AOrxEM;EACE,oCAAA;APwxER;;AOtxEM;EACE,yBAAA;APyxER;AOxxEQ;EACE,gCAAA;AP0xEV;;AOhyEM;EACE,oCAAA;APmyER;;AOjyEM;EACE,yBAAA;APoyER;AOnyEQ;EACE,gCAAA;APqyEV;;AO3yEM;EACE,oCAAA;AP8yER;;AO5yEM;EACE,yBAAA;AP+yER;AO9yEQ;EACE,gCAAA;APgzEV;;AOtzEM;EACE,oCAAA;APyzER;;AOvzEM;EACE,yBAAA;AP0zER;AOzzEQ;EACE,gCAAA;AP2zEV;;AOj0EM;EACE,oCAAA;APo0ER;;AOl0EM;EACE,yBAAA;APq0ER;AOp0EQ;EACE,gCAAA;APs0EV;;AO50EM;EACE,oCAAA;AP+0ER;;AO70EM;EACE,yBAAA;APg1ER;AO/0EQ;EACE,gCAAA;APi1EV;;AOv1EM;EACE,oCAAA;AP01ER;;AOx1EM;EACE,yBAAA;AP21ER;AO11EQ;EACE,gCAAA;AP41EV;;AO52EM;EACE,oCAAA;AP+2ER;;AO72EM;EACE,yBAAA;APg3ER;AO/2EQ;EACE,gCAAA;APi3EV;;AO72EM;EACE,oCAAA;APg3ER;;AO92EM;EACE,yBAAA;APi3ER;AOh3EQ;EACE,gCAAA;APk3EV;;AOx3EM;EACE,oCAAA;AP23ER;;AOz3EM;EACE,yBAAA;AP43ER;AO33EQ;EACE,gCAAA;AP63EV;;AOn4EM;EACE,oCAAA;APs4ER;;AOp4EM;EACE,yBAAA;APu4ER;AOt4EQ;EACE,gCAAA;APw4EV;;AO94EM;EACE,oCAAA;APi5ER;;AO/4EM;EACE,yBAAA;APk5ER;AOj5EQ;EACE,gCAAA;APm5EV;;AOz5EM;EACE,oCAAA;AP45ER;;AO15EM;EACE,yBAAA;AP65ER;AO55EQ;EACE,gCAAA;AP85EV;;AOp6EM;EACE,oCAAA;APu6ER;;AOr6EM;EACE,yBAAA;APw6ER;AOv6EQ;EACE,gCAAA;APy6EV;;AO/6EM;EACE,oCAAA;APk7ER;;AOh7EM;EACE,yBAAA;APm7ER;AOl7EQ;EACE,gCAAA;APo7EV;;AO17EM;EACE,oCAAA;AP67ER;;AO37EM;EACE,yBAAA;AP87ER;AO77EQ;EACE,gCAAA;AP+7EV;;AOr8EM;EACE,oCAAA;APw8ER;;AOt8EM;EACE,yBAAA;APy8ER;AOx8EQ;EACE,gCAAA;AP08EV;;AOh9EM;EACE,oCAAA;APm9ER;;AOj9EM;EACE,yBAAA;APo9ER;AOn9EQ;EACE,gCAAA;APq9EV;;AO39EM;EACE,oCAAA;AP89ER;;AO59EM;EACE,yBAAA;AP+9ER;AO99EQ;EACE,gCAAA;APg+EV;;AOt+EM;EACE,oCAAA;APy+ER;;AOv+EM;EACE,yBAAA;AP0+ER;AOz+EQ;EACE,gCAAA;AP2+EV;;AOj/EM;EACE,oCAAA;APo/ER;;AOl/EM;EACE,yBAAA;APq/ER;AOp/EQ;EACE,gCAAA;APs/EV;;AOtgFM;EACE,oCAAA;APygFR;;AOvgFM;EACE,yBAAA;AP0gFR;AOzgFQ;EACE,gCAAA;AP2gFV;;AOvgFM;EACE,oCAAA;AP0gFR;;AOxgFM;EACE,yBAAA;AP2gFR;AO1gFQ;EACE,gCAAA;AP4gFV;;AOlhFM;EACE,oCAAA;APqhFR;;AOnhFM;EACE,yBAAA;APshFR;AOrhFQ;EACE,gCAAA;APuhFV;;AO7hFM;EACE,oCAAA;APgiFR;;AO9hFM;EACE,yBAAA;APiiFR;AOhiFQ;EACE,gCAAA;APkiFV;;AOxiFM;EACE,oCAAA;AP2iFR;;AOziFM;EACE,yBAAA;AP4iFR;AO3iFQ;EACE,gCAAA;AP6iFV;;AOnjFM;EACE,oCAAA;APsjFR;;AOpjFM;EACE,yBAAA;APujFR;AOtjFQ;EACE,gCAAA;APwjFV;;AO9jFM;EACE,oCAAA;APikFR;;AO/jFM;EACE,yBAAA;APkkFR;AOjkFQ;EACE,gCAAA;APmkFV;;AOzkFM;EACE,oCAAA;AP4kFR;;AO1kFM;EACE,yBAAA;AP6kFR;AO5kFQ;EACE,gCAAA;AP8kFV;;AOplFM;EACE,oCAAA;APulFR;;AOrlFM;EACE,yBAAA;APwlFR;AOvlFQ;EACE,gCAAA;APylFV;;AO/lFM;EACE,oCAAA;APkmFR;;AOhmFM;EACE,yBAAA;APmmFR;AOlmFQ;EACE,gCAAA;APomFV;;AO1mFM;EACE,oCAAA;AP6mFR;;AO3mFM;EACE,yBAAA;AP8mFR;AO7mFQ;EACE,gCAAA;AP+mFV;;AOrnFM;EACE,oCAAA;APwnFR;;AOtnFM;EACE,yBAAA;APynFR;AOxnFQ;EACE,gCAAA;AP0nFV;;AOhoFM;EACE,oCAAA;APmoFR;;AOjoFM;EACE,yBAAA;APooFR;AOnoFQ;EACE,gCAAA;APqoFV;;AO3oFM;EACE,oCAAA;AP8oFR;;AO5oFM;EACE,yBAAA;AP+oFR;AO9oFQ;EACE,gCAAA;APgpFV;;AOhqFM;EACE,oCAAA;APmqFR;;AOjqFM;EACE,yBAAA;APoqFR;AOnqFQ;EACE,gCAAA;APqqFV;;AOjqFM;EACE,oCAAA;APoqFR;;AOlqFM;EACE,yBAAA;APqqFR;AOpqFQ;EACE,gCAAA;APsqFV;;AO5qFM;EACE,oCAAA;AP+qFR;;AO7qFM;EACE,yBAAA;APgrFR;AO/qFQ;EACE,gCAAA;APirFV;;AOvrFM;EACE,oCAAA;AP0rFR;;AOxrFM;EACE,yBAAA;AP2rFR;AO1rFQ;EACE,gCAAA;AP4rFV;;AOlsFM;EACE,oCAAA;APqsFR;;AOnsFM;EACE,yBAAA;APssFR;AOrsFQ;EACE,gCAAA;APusFV;;AO7sFM;EACE,oCAAA;APgtFR;;AO9sFM;EACE,yBAAA;APitFR;AOhtFQ;EACE,gCAAA;APktFV;;AOxtFM;EACE,oCAAA;AP2tFR;;AOztFM;EACE,yBAAA;AP4tFR;AO3tFQ;EACE,gCAAA;AP6tFV;;AOnuFM;EACE,oCAAA;APsuFR;;AOpuFM;EACE,yBAAA;APuuFR;AOtuFQ;EACE,gCAAA;APwuFV;;AO9uFM;EACE,oCAAA;APivFR;;AO/uFM;EACE,yBAAA;APkvFR;AOjvFQ;EACE,gCAAA;APmvFV;;AOzvFM;EACE,oCAAA;AP4vFR;;AO1vFM;EACE,yBAAA;AP6vFR;AO5vFQ;EACE,gCAAA;AP8vFV;;AO9wFM;EACE,oCAAA;APixFR;;AO/wFM;EACE,yBAAA;APkxFR;AOjxFQ;EACE,gCAAA;APmxFV;;AO/wFM;EACE,oCAAA;APkxFR;;AOhxFM;EACE,yBAAA;APmxFR;AOlxFQ;EACE,gCAAA;APoxFV;;AO1xFM;EACE,oCAAA;AP6xFR;;AO3xFM;EACE,yBAAA;AP8xFR;AO7xFQ;EACE,gCAAA;AP+xFV;;AOryFM;EACE,oCAAA;APwyFR;;AOtyFM;EACE,yBAAA;APyyFR;AOxyFQ;EACE,gCAAA;AP0yFV;;AOhzFM;EACE,oCAAA;APmzFR;;AOjzFM;EACE,yBAAA;APozFR;AOnzFQ;EACE,gCAAA;APqzFV;;AO3zFM;EACE,oCAAA;AP8zFR;;AO5zFM;EACE,yBAAA;AP+zFR;AO9zFQ;EACE,gCAAA;APg0FV;;AOt0FM;EACE,oCAAA;APy0FR;;AOv0FM;EACE,yBAAA;AP00FR;AOz0FQ;EACE,gCAAA;AP20FV;;AOj1FM;EACE,oCAAA;APo1FR;;AOl1FM;EACE,yBAAA;APq1FR;AOp1FQ;EACE,gCAAA;APs1FV;;AO51FM;EACE,oCAAA;AP+1FR;;AO71FM;EACE,yBAAA;APg2FR;AO/1FQ;EACE,gCAAA;APi2FV;;AOv2FM;EACE,oCAAA;AP02FR;;AOx2FM;EACE,yBAAA;AP22FR;AO12FQ;EACE,gCAAA;AP42FV;;AO53FM;EACE,oCAAA;AP+3FR;;AO73FM;EACE,yBAAA;APg4FR;AO/3FQ;EACE,gCAAA;APi4FV;;AO73FM;EACE,oCAAA;APg4FR;;AO93FM;EACE,yBAAA;APi4FR;AOh4FQ;EACE,gCAAA;APk4FV;;AOx4FM;EACE,oCAAA;AP24FR;;AOz4FM;EACE,yBAAA;AP44FR;AO34FQ;EACE,gCAAA;AP64FV;;AOn5FM;EACE,oCAAA;APs5FR;;AOp5FM;EACE,yBAAA;APu5FR;AOt5FQ;EACE,gCAAA;APw5FV;;AO95FM;EACE,oCAAA;APi6FR;;AO/5FM;EACE,yBAAA;APk6FR;AOj6FQ;EACE,gCAAA;APm6FV;;AOz6FM;EACE,oCAAA;AP46FR;;AO16FM;EACE,yBAAA;AP66FR;AO56FQ;EACE,gCAAA;AP86FV;;AOp7FM;EACE,oCAAA;APu7FR;;AOr7FM;EACE,yBAAA;APw7FR;AOv7FQ;EACE,gCAAA;APy7FV;;AO/7FM;EACE,oCAAA;APk8FR;;AOh8FM;EACE,yBAAA;APm8FR;AOl8FQ;EACE,gCAAA;APo8FV;;AO18FM;EACE,oCAAA;AP68FR;;AO38FM;EACE,yBAAA;AP88FR;AO78FQ;EACE,gCAAA;AP+8FV;;AOr9FM;EACE,oCAAA;APw9FR;;AOt9FM;EACE,yBAAA;APy9FR;AOx9FQ;EACE,gCAAA;AP09FV;;AOj9FE;EACE,oCAAA;APo9FJ;;AOl9FE;EACE,yBAAA;APq9FJ;AOp9FI;EACE,gCAAA;APs9FN;;AO59FE;EACE,oCAAA;AP+9FJ;;AO79FE;EACE,yBAAA;APg+FJ;AO/9FI;EACE,gCAAA;APi+FN;;AOv+FE;EACE,wCAAA;AP0+FJ;;AOx+FE;EACE,6BAAA;AP2+FJ;AO1+FI;EACE,oCAAA;AP4+FN;;AQ93GA,mBAAA;AAEA;EACE;IACE,kCAAA;IACA,UAAA;IACA,yDAAA;ERg4GF;EQ93GA;IACE,kCAAA;IACA,wDAAA;ERg4GF;EQ93GA;IACE,UAAA;IACA,wDAAA;ERg4GF;EQ93GA;IACE,wDAAA;ERg4GF;EQ93GA;IACE,gCAAA;ERg4GF;AACF;AQ73GA;EACE;IACE,kCAAA;IACA,UAAA;IACA,yDAAA;ER+3GF;EQ73GA;IACE,kCAAA;IACA,wDAAA;ER+3GF;EQ73GA;IACE,UAAA;IACA,wDAAA;ER+3GF;EQ73GA;IACE,wDAAA;ER+3GF;EQ73GA;IACE,gCAAA;ER+3GF;AACF;AQ53GA;EACE,0BAAA;EACA,4BAAA;AR83GF;;AQ33GA;EACE;IACE,oBAAA;IACA,8BAAA;ER83GF;EQ53GA;IACE,UAAA;IACA,oBAAA;IACA,8BAAA;ER83GF;AACF;AQ33GA;EACE;IACE,oBAAA;IACA,8BAAA;ER63GF;EQ33GA;IACE,UAAA;IACA,oBAAA;IACA,8BAAA;ER63GF;AACF;AQ13GA;EACE,2BAAA;EACA,4BAAA;AR43GF;;AQz3GA;EACE;IACE,UAAA;IACA,qCAAA;ER43GF;EQ13GA;IACE,UAAA;IACA,eAAA;ER43GF;AACF;AQz3GA;EACE;IACE,UAAA;IACA,qCAAA;ER23GF;EQz3GA;IACE,UAAA;IACA,eAAA;ER23GF;AACF;AQx3GA;EACE,+BAAA;AR03GF;;AQv3GA;EACE;IACE,UAAA;IACA,sCAAA;ER03GF;EQx3GA;IACE,UAAA;IACA,eAAA;ER03GF;AACF;AQv3GA;EACE;IACE,UAAA;IACA,sCAAA;ERy3GF;EQv3GA;IACE,UAAA;IACA,eAAA;ERy3GF;AACF;AQt3GA;EACE,8BAAA;ARw3GF;;AQr3GA;EACE;IACE,qCAAA;ERw3GF;EQt3GA;IACE,eAAA;ERw3GF;AACF;AQr3GA;EACE;IACE,qCAAA;ERu3GF;EQr3GA;IACE,eAAA;ERu3GF;AACF;AQp3GA;EACE,gCAAA;ARs3GF;;AQn3GA;EACE;IACE,sCAAA;ERs3GF;EQp3GA;IACE,eAAA;ERs3GF;AACF;AQn3GA;EACE;IACE,sCAAA;ERq3GF;EQn3GA;IACE,eAAA;ERq3GF;AACF;AQl3GA;EACE,+BAAA;ARo3GF;;AQj3GA;EACE;IACE,oCAAA;ERo3GF;EQl3GA;IACE,eAAA;ERo3GF;AACF;AQj3GA;EACE;IACE,oCAAA;ERm3GF;EQj3GA;IACE,eAAA;ERm3GF;AACF;AQh3GA;EACE,6BAAA;ARk3GF;;AQ/2GA,sBAAA;AACA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,sBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,sBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,sBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,wBAAA;ARk3GF;;AQ/2GA;EACE,sBAAA;ARk3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,mBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,mBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,mBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,mBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,qBAAA;ARg3GF;;AQ72GA;EACE,mBAAA;ARg3GF;;AS95HA;+EAAA;ACAA,cAAA;AAEA;EACE,YAAA;AVk6HF;;AU/5HA;EAEI,iCPQqB;EOPrB,ePWa;EOVb,gBL8NiB;EK5NnB,cPmFW;EOlFX,sBPiFQ;EOhFR,YAAA;EACA,gBAAA;AVg6HF;;AU75HA;EACE,uBAAA;EACA,4BAAA;AVg6HF;;AU75HA;EACE,wBAAA;EACA,8BAAA;AVg6HF;;AU75HA;EN1BE,gEM2BA;EN1BA,6DM0BA;ENzBA,2DMyBA;ENxBA,wDMwBA;AVm6HF;;AUh6HA;EACE,wBAAA;AVm6HF;;AUh6HA;EACE,oCAAA;EACA,qCAAA;AVm6HF;;AU55HA;EACE,oBAAA;AV+5HF;;AU55HA;EACE,gCAAA;AV+5HF;;AU55HA;EACE,2BAAA;AV+5HF;;AU55HA;EACE,WAAA;AV+5HF;;AU53HA;EACE,gCAAA;AV+3HF;;AU53HA;EACE,8BAAA;AV+3HF;AU93HE;EACE,cAAA;AVg4HJ;;AU53HA;EACE,wBAAA;AV+3HF;;AU53HA;EACE,wBAAA;AV+3HF;;AU53HA;EACE,wBAAA;AV+3HF;;AU53HA;EACE,wBAAA;AV+3HF;;AU53HA;EACE,2BAAA;AV+3HF;;AU53HA;EACE,4BAAA;AV+3HF;;AU53HA;EACE,qBAAA;EACA,cPxEY;EOyEZ,0BAAA;AV+3HF;AU93HE;EACE,gBAAA;EACA,0CAAA;EACA,cP7EU;EO8EV,gBAAA;EACA,eAAA;EACA,sBAAA;AVg4HJ;AU73HE;EAEE,qBAAA;AV83HJ;;AU13HA;EACE,mBPlBoB;AH+4HtB;;AU13HA;EACE,mBPrBkB;AHk5HpB;;AU13HA;EACE,mBPxBkB;AHq5HpB;;AU13HA;EACE,mBAAA;AV63HF;AU33HE;EACE,0BAAA;EACA,gBAAA;AV63HJ;AU13HE;EACE,UAAA;EACA,6BAAA;EACA,gBAAA;AV43HJ;AUz3HE;EAdF;IAeI,mBAAA;EV43HF;AACF;;AUz3HA;EACE,eP/Je;EOgKf,cLrKS;EKsKT,gBAAA;AV43HF;AU33HE;EACE,8BAAA;AV63HJ;;AUz3HA;EACE,gBAAA;AV43HF;AU33HE;EACE,kBAAA;AV63HJ;AU53HI;EACE,kBAAA;AV83HN;;AUx3HA;ENpME,mCMqMA;ENpMA,gCMoMA;ENnMA,8BMmMA;ENlMA,2BMkMA;AV83HF;;AU33HA;ENxME,mDMyMA;ENxMA,gDMwMA;ENvMA,8CMuMA;ENtMA,2CMsMA;AVi4HF;;AU93HA;EN5ME,mDM6MA;EN5MA,gDM4MA;EN3MA,8CM2MA;EN1MA,2CM0MA;AVo4HF;;AUj4HA;ENhNE,qDMiNA;ENhNA,kDMgNA;EN/MA,gDM+MA;EN9MA,6CM8MA;AVu4HF;;AUp4HA;ENpNE,mDMqNA;ENpNA,gDMoNA;ENnNA,8CMmNA;ENlNA,2CMkNA;AV04HF;;AUv4HA;ENxNE,kDMyNA;ENxNA,+CMwNA;ENvNA,6CMuNA;ENtNA,0CMsNA;AV64HF;;AUz4HE;EACE,cAAA;AV44HJ;;AUv4HA;EACE,mBAAA;AV04HF;AUz4HE;EACE,gCAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AV24HJ;;AUv4HA;EACE,oCAAA;AV04HF;;AUv4HA;EACE,iBAAA;AV04HF;;AUl4HM;EACE,gCAAA;AVq4HR;;AUt4HM;EACE,gCAAA;AVy4HR;;AU14HM;EACE,gCAAA;AV64HR;;AU94HM;EACE,gCAAA;AVi5HR;;AUl5HM;EACE,gCAAA;AVq5HR;;AUt5HM;EACE,gCAAA;AVy5HR;;AU15HM;EACE,gCAAA;AV65HR;;AU95HM;EACE,gCAAA;AVi6HR;;AUl6HM;EACE,gCAAA;AVq6HR;;AUt6HM;EACE,gCAAA;AVy6HR;;AU16HM;EACE,gCAAA;AV66HR;;AU96HM;EACE,gCAAA;AVi7HR;;AUl7HM;EACE,gCAAA;AVq7HR;;AUt7HM;EACE,gCAAA;AVy7HR;;AU17HM;EACE,gCAAA;AV67HR;;AU97HM;EACE,gCAAA;AVi8HR;;AUl8HM;EACE,gCAAA;AVq8HR;;AUt8HM;EACE,gCAAA;AVy8HR;;AU18HM;EACE,gCAAA;AV68HR;;AU98HM;EACE,gCAAA;AVi9HR;;AUz8HA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AV48HF;AU18HE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,wCAAA;EACA,oCAAA;EACA,gCAAA;AV48HJ;AUz8HE;EACE,WAAA;EACA,YAAA;AV28HJ;;AU15HA;EACE,eAAA;AV65HF;;AU15HA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,cLrUS;ALkuIX;AU35HE;EACE,cAAA;AV65HJ;;AUz5HA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AV45HF;;AUz5HA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AV45HF;;AUz5HA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AV45HF;;AU15HA;EACE,4CAAA;EACA,oCAAA;AV65HF;;AU15HA;EACE,gBAAA;AV65HF;;AU15HA;EACE,eAAA;EACA,iBAAA;EN7RE,kBDzDY;EOwVd,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AV65HF;;AU15HA;EACE,gCAAA;AV65HF;;AU15HA;EACE,iBAAA;EACA,kBAAA;AV65HF;AU35HE;EACE,iBAAA;EACA,kBAAA;AV65HJ;;AUz5HA;EACE,0BAAA;AV45HF;;AUz5HA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AV45HF;;AUz5HA;EACE,wBAAA;EACA,WAAA;EACA,YAAA;AV45HF;;AUz5HA;EACE,kBAAA;EACA,oEAAA;EACA,yBAAA;AV45HF;;AUz5HA;EACE,yBAAA;EACA,WAAA;AV45HF;;AUz5HA;EACE,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AV45HF;;AUz5HA;EACE,sBAAA;EACA,cAAA;EACA,yBAAA;AV45HF;;AUz5HA;EACE,aAAA;AV45HF;;AUx5HA;EACE,aAAA;AV25HF;;AUp5HA;EACE,2DAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AVu5HF;;AUr5HA;EACE,yBAAA;EACA,qBAAA;AVw5HF;;AUt5HA;EACE,yBAAA;EACA,qBAAA;AVy5HF;;AUv5HA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,2DAAA;AV05HF;;AUx5HA;EACE,sBAAA;AV25HF;;AUz5HA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AV45HF;;AU15HA;EACE,UAAA;AV65HF;;AU35HA;EACE,eAAA;AV85HF;;AU55HA;EACE,sBAAA;AV+5HF;;AU75HA;EACE,4BAAA;EACA,6BAAA;AVg6HF;;AU95HA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;AVi6HF;;AUh6HC;EACC,kBAAA;AVm6HF;;AUj6HA;EACE,kBAAA;EACA,oBAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,+EAAA;AVo6HF;;AUl6HA;EACE,cAAA;AVq6HF;;AUn6HA;EACE,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,2DAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AVs6HF;;AUp6HA;EACE,yBAAA;AVu6HF;;AUr6HA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AVw6HF;;AUt6HA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AVy6HF;;AUv6HA;EACE,cAAA;AV06HF;;AUx6HA;EACE,cAAA;AV26HF;;AUz6HA;EACE,cAAA;AV46HF;;AU16HA;EACE,cAAA;AV66HF;;AU36HA;EACE,cAAA;AV86HF;;AU56HA;EACE,8BAAA;AV+6HF;;AU76HA;EACE,aAAA;EACA,qCAAA;AVg7HF;;AU96HA;EAAkB,YAAA;AVk7HlB;;AUl7H8B;EAC5B,eAAA;AVq7HF;;AUn7HA;EACE,gCAAA;AVs7HF;;AUp7HA;EACE,gCAAA;AVu7HF;;AUr7HA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;AVw7HF;;AUt7HA;EACE,eAAA;EACA,WAAA;EACA,iBAAA;AVy7HF;;AUv7HA;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AV07HF;;AUx7HA;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AV27HF;;AUz7HA;EACE,gBAAA;AV47HF;;AU17HA;EACE,gBAAA;AV67HF;;AU37HA;EACE,gBAAA;AV87HF;;AU57HA;EACE,mBAAA;AV+7HF;;AU77HA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,2DAAA;AVg8HF;;AU97HA;EACE,UAAA;AVi8HF;;AU/7HA;EACE,kBAAA;EACA,2DAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AVk8HF;;AUh8HA;EACE,gBAAA;EACA,cAAA;EACA,UAAA;AVm8HF;;AUj8HA;EACE,gBAAA;EACA,eAAA;EACA,2DAAA;AVo8HF;;AUl8HA;EACE,eAAA;AVq8HF;;AUn8HA;EACE;IACE,WAAA;IAAW,WAAA;EVu8Hb;EUr8HA;IACE,UAAA;EVu8HF;EUr8HA;IACE,WAAA;EVu8HF;AACF;AUr8HA;EACE,wBAAA;EACA,qBAAA;AVu8HF;;AUr8HA;EACE,2DAAA;AVw8HF;;AUt8HA;EACE,oBAAA;EACA,6CAAA;AVy8HF;;AUt8HA;EACE,6BAAA;AVy8HF;;AUv8HA;EACE,2BAAA;AV08HF;;AUx8HA;EACE,2BAAA;EACA,6CAAA;AV28HF;;AUz8HA;EACE,sBAAA;AV48HF;;AU18HA;EACE,sBAAA;AV68HF;;AU38HA;EACE,oBAAA;AV88HF;;AU58HA;EACE,oBAAA;AV+8HF;;AU78HA;EACE,oBAAA;AVg9HF;;AU98HA;EACE,0BAAA;AVi9HF;;AU/8HA;EACE,yBAAA;EACA,2BAAA;EACA,0BAAA;AVk9HF;;AUh9HA;EACE,sBAAA;EACA,oBAAA;AVm9HF;;AUj9HA;EACE,sBAAA;EACA,yBAAA;EACA,6BAAA;AVo9HF;;AUl9HA;EACE,0BAAA;AVq9HF;;AUn9HA;EACE,2BAAA;AVs9HF;;AUp9HA;EACE,sBAAA;EACA,oBAAA;AVu9HF;;AUr9HA;EACE,oBAAA;EACA,2BAAA;AVw9HF;;AUj1HA,wCAAA;;AAGA,gFAAA;AACA;EACE,8BAAA;EACA,qCAAA;EACA,uBAAA;AVm1HF;;AUh1HA,iEAAA;AACA;EACE,8BAAA;EACA,qCAAA;EACA,uBAAA;AVm1HF;;AUh1HA,oEAAA;AACA;EACE,uBAAA;AVm1HF;;AUh1HA,kEAAA;AACA,0EAAA;AACA;;EAEE,8BAAA;AVm1HF;;AU/0HA;EACE,2CAAA;EACA,sCAAA;AVk1HF;;AU/0HA;EACE,uBAAA;AVk1HF;;AU/0HA;EACE,yBAAA;AVk1HF;;AU/0HA;EACE,yBAAA;AVk1HF;;AU/0HA;EACE,yBAAA;EACA,sBAAA;AVk1HF;;AU/0HA;EACE,0BAAA;EACA,yBAAA;EACA,oCAAA;EACA,2BAAA;EACA,iCAAA;EACA,mCAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,sCAAA;AVk1HF;;AU/0HA;EACE,oCAAA;EACA,iCAAA;AVk1HF;;AU/0HA;EACE,yBAAA;AVk1HF;;AU/0HA;EACI,wBAAA;EACA,8BAAA;EACA,yCAAA;AVk1HJ;;AU/0HA;EACE,0BAAA;AVk1HF;;AU/0HA;EACE,6BAAA;AVk1HF;;AU70HA;;;EAGI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;AVg1HJ;;AU70HA;EACI,wBAAA;AVg1HJ;;AU70HA;EACI,UAAA;AVg1HJ;;AU70HA;EACI,UAAA;AVg1HJ;;AU70HA;EACI,UAAA;AVg1HJ;;AU70HA;EAEI,qBAAA;EACA,cAAA;AV+0HJ;;AU70HA;EACI,cAAA;EACA,qBAAA;EACA,cAAA;AVg1HJ;;AU70HA;EACI,cAAA;EACA,qBAAA;EACA,aAAA;AVg1HJ;;AU70HA;EACI,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AVg1HJ;;AU70HA;EACI,aAAA;AVg1HJ;;AU70HA;EACI,aAAA;AVg1HJ;;AU30HA;EACI,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;AV80HJ;;AU30HA;EACI,cAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;AV80HJ;;AU30HA;EACI,aAAA;AV80HJ;;AU30HA;;;EAGI,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;EACA,qBAAA;AV60HJ;;AU10HA;;;EAGI,eAAA;EACA,YAAA;AV60HJ;;AU10HA;EACI,qBAAA;EACA,qBAAA;AV60HJ;;AU10HA;EACI,cAAA;EACA,eAAA;EACA,mBAAA;AV60HJ;;AU10HA;EACE,iBAAA;AV60HF;;AU10HA;EACE,iBAAA;AV60HF;;AW76JA,oBAAA;AACA;;EAEE,gBR8BqB;EQ7BrB,gBAAA;EACA,cR8Be;AHk5JjB;;AW76JA;EACE,eRea;EQdb,kCAAA;AXg7JF;;AW76JA;EACE,eRWa;EQVb,kCAAA;AXg7JF;;AW76JA;EACE,eROa;AHy6Jf;;AW76JA;EACE,eRIa;AH46Jf;;AW76JA;EACE,eRCa;AH+6Jf;;AW76JA;EACE,eRFa;AHk7Jf;;AW76JA;EACE,wCAAA;AXg7JF;;AW76JA;EACE;IACE,eRfW;IQgBX,kCAAA;EXg7JF;EW76JA;IACE,eRnBW;IQoBX,kCAAA;EX+6JF;EW56JA;IACE,eRvBW;EHq8Jb;AACF;AW36JA;EACE,gBAAA;AX66JF;AW56JE;EACE,kBRuBc;EQtBd,gCAAA;EACA,kBAAA;EACA,mBAAA;AX86JJ;AW56JI;EACE,qBAAA;AX86JN;AW36JI;EACE,kBAAA;AX66JN;AWv6JI;EACE,qBAAA;AXy6JN;AWv6JM;EACE,yBNhEG;ALy+JX;;AYt/JA;+EAAA;ACAA,oBAAA;AAEA;;EAEE,aAAA;EACA,WAAA;EACA,YAAA;Ab0/JF;;Aav/JA;EToDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aSvDsB;ETwDtB,2BSxD4B;ETyD5B,uBSzD4B;ET0D5B,mBS1D4B;ET2D5B,yBS3DiC;ET4DjC,qBS5DiC;ET6DjC,iBS7DiC;EACjC,WAAA;AbogKF;;AajgKA;ET+CE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aSlDsB;ETmDtB,8BSnD4B;EToD5B,0BSpD4B;ETqD5B,sBSrD4B;ETsD5B,yBStDoC;ETuDpC,qBSvDoC;ETwDpC,iBSxDoC;EACpC,YVwGe;EUvGf,gBVuGe;EUtGf,gBVsGe;AHw6JjB;;Aa3gKA;ETwCE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aS3CsB;ET4CtB,8BS5C4B;ET6C5B,0BS7C4B;ET8C5B,sBS9C4B;ET+C5B,yBS/CoC;ETgDpC,qBShDoC;ETiDpC,iBSjDoC;EACpC,WAAA;EACA,gBAAA;EACA,kBAAA;AbwhKF;;AarhKA;EACE,gBV+Fe;EU9Ff,WAAA;EACA,kBAAA;AbwhKF;;AarhKA;EACE,OAAA;ET0BA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aS7BsB;ET8BtB,8BS9B4B;ET+B5B,0BS/B4B;ETgC5B,sBShC4B;ETiC5B,yBSjCoC;ETkCpC,qBSlCoC;ETmCpC,iBSnCoC;EACpC,WAAA;EACA,kBAAA;EACA,gBAAA;AbkiKF;;Aa7hKI;EACE,sBAAA;ETRJ,kESSI;ETRJ,6DSQI;ETPJ,0DSOI;AbkiKN;Aa7hKI;EACE,sBAAA;ETfJ,kESgBI;ETfJ,6DSeI;ETdJ,0DScI;AbiiKN;Aa9hKI;EACE,kBAAA;AbgiKN;Aa3hKI;EACE,sBAAA;ET1BJ,kES2BI;ET1BJ,6DS0BI;ETzBJ,0DSyBI;Ab+hKN;Aa5hKI;EACE,WVqDc;EUpDd,eVoDc;EUnDd,eVmDc;AH2+JpB;;AcpmKA,iBAAA;AAEA;EACE,YXqHe;EWpHf,oCAAA;EACA,yBAAA;EACA,0CAAA;EACA,wBAAA;EACA,YAAA;AdsmKF;AcpmKE;EACE,iDXsDgB;EWrDhB,6BAAA;AdsmKJ;AcnmKE;EACE,6BAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;AdqmKJ;AcjmKI;EACE,cXkCQ;EWjCR,eAAA;EACA,eXNW;EWOX,gBAAA;EACA,mBAAA;AdmmKN;;Ac7lKE;EACE,eAAA;AdgmKJ;;Ac5lKA,gBAAA;AACA;EACE,kBAAA;EACA,eXtBe;EWuBf,6BAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;Ad+lKF;;Ac5lKA;EACE,kBAAA;EACA,kBAAA;Ad+lKF;;Ac3lKE;EACE,gBAAA;Ad8lKJ;Ac5lKE;EACE,aAAA;Ad8lKJ;Ac5lKE;EACE,cAAA;Ad8lKJ;Ac1lKI;EACE,cAAA;Ad4lKN;;AcvlKA;EACE,cXVmB;EWWnB,cAAA;EACA,eAAA;EACA,gBAAA;EAEA,qBAAA;EViBE,gBUhBqB;AdylKzB;AcvlKE;EACE,gBAAA;EACA,oBAAA;AdylKJ;;AcplKE;EACE,cX1BiB;EW2BjB,iBAAA;EACA,eAAA;EACA,yBAAA;AdulKJ;AcrlKI;EACE,gBAAA;AdulKN;;AcllKA;;;;EAIE,cX/CY;AHooKd;;AcllKA;EACE,kBAAA;EACA,kCAAA;AdqlKF;;AcllKA;EACE,yBAAA;AdqlKF;;AcllKA;;EAEE,cX7DY;AHkpKd;;AcllKA;EACE,kBAAA;EACA,eAAA;AdqlKF;;AcllKA;EACE,6BAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AdqlKF;;AcllKA;EACE,0BAAA;AdqlKF;;AcllKA;EACE,kBAAA;AdqlKF;;AcllKA;EACE,kBAAA;AdqlKF;;AcllKA;EACE,mBAAA;AdqlKF;;AcllKA;EACE,cXxFmB;EWyFnB,gBAAA;EACA,qBAAA;EACA,YAAA;EAEE,0CAAA;EACA,eAAA;EAEF,iBAAA;EACA,kBAAA;EV5HA,yCU6HA;EV5HA,oCU4HA;EV3HA,iCU2HA;EACA,mBAAA;AdqlKF;;AcnlKA;EACE,aAAA;AdslKF;;AcnlKA;;;;EAIE,6BAAA;EACA,cXpHY;AH0sKd;;AcnlKA;;EVtIE,gCAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;AJ8tKF;;ActlKA;EACE,gBAAA;EACA,iBAAA;EACA,yBX/HY;EWgIZ,WThLM;EDsFJ,kBDzDY;EWqJd,qBAAA;AdylKF;;ActlKA;;;;;EAKE,cX1IY;AHmuKd;;AcrlKE;EVnKA,wCUoKE;EVnKF,mCUmKE;EVlKF,gCUkKE;EACA,WXjFgB;AH2qKpB;AcxlKI;EAEE,aAAA;AdylKN;ActlKI;EACE,wBAAA;AdwlKN;AcrlKI;EACE,wBAAA;AdulKN;AcplKI;EACE,kBAAA;AdslKN;AcrlKM;EACE,eAAA;AdulKR;AcplKM;EACE,gBAAA;AdslKR;AcjlKM;EACE,kBAAA;AdmlKR;AcjlKM;EACE,kBAAA;AdmlKR;Ac9kKM;EACE,aAAA;AdglKR;Ac5kKI;EACE,aAAA;Ad8kKN;;AcxkKE;EACE,YXnIa;AH8sKjB;AczkKI;EACE,gCAAA;Ad2kKN;AcxkKI;EACE,wBAAA;Ad0kKN;AcvkKI;EACE,yBAAA;AdykKN;ActkKI;EACE,wBAAA;AdwkKN;AcpkKM;EACE,gBAAA;AdskKR;AcrkKQ;EACE,kBAAA;AdukKV;AcpkKQ;EACE,kBAAA;AdskKV;AcnkKQ;EACE,iBAAA;AdqkKV;AcjkKM;EACE,0BAAA;AdmkKR;AchkKM;EACE,kBAAA;AdkkKR;Ac/jKM;EACE,kBAAA;AdikKR;Ac9jKM;EACE,mBAAA;AdgkKR;Ac3jKM;EACE,cAAA;Ad6jKR;AczjKI;EACE,aAAA;Ad2jKN;AcxjKI;EACE,cAAA;Ad0jKN;;AcrjKA;EACE,kBAAA;AdwjKF;AcvjKE;EACE,YAAA;EACA,eAAA;AdyjKJ;;AcnjKI;EACE,eAAA;AdsjKN;;AchjKE;EAEE,YAAA;AdkjKJ;;Ac9iKA;EACE,eAAA;EACA,2CAAA;EACA,mCAAA;EACA,gBAAA;AdijKF;Ac/iKE;EACE,OAAA;EACA,oCAAA;EACA,4BAAA;EACA,YAAA;AdijKJ;Ac9iKE;EACE,QAAA;EACA,mCAAA;EACA,2BAAA;EACA,YAAA;AdgjKJ;Ac7iKE;EACE,YAAA;Ad+iKJ;Ac5iKE;EACE,YAAA;Ad8iKJ;;AcziKE;EADF;IAEI,6BAAA;Ed6iKF;AACF;;Ac1iKA;EACE,kBAAA;Ad6iKF;Ac5iKE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;Ad8iKJ;;Ac1iKA;EACE,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,YAAA;EACA,0BAAA;Ad6iKF;;AcziKE;EACE,kBAAA;Ad4iKJ;;Ae97KA,gBAAA;AACA;EACE,wBAAA;EX+EA,8CW9EyB;EX+EzB,sCW/EyB;EAEzB,yBAAA;EAEA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;Afg8KF;;Ae77KA;EACE,sBVJM;EUKN,cZ8Ca;EY7Cb,gBAAA;EACA,kBAAA;Afg8KF;Ae97KE;EXkBA,wCWjBE;EXkBF,mCWlBE;EXmBF,gCWnBE;EACA,6BAAA;EACA,cZuCW;EYrCX,gBAAA;Afi8KJ;Aeh8KI;EACE,MAAA;Afk8KN;Aej8KM;EACE,+BAAA;EACA,eAAA;Afm8KR;Aeh8KI;EACE,WAAA;Afk8KN;Ae97KI;EACE,sBZwDI;EYvDJ,cZsBS;AH06Kf;Ae97KQ;EACE,+BAAA;Afg8KV;Aer7KE;EACE,yBAAA;EX0CA,kBDxDe;AHs8KnB;;Aen7KA;EACE,kBAAA;Afs7KF;Aep7KE;EACE,YAAA;Afs7KJ;Aep7KI;EAHF;IAII,YAAA;Efu7KJ;AACF;Aep7KE;EACE,kBAAA;Afs7KJ;Aep7KI;EAHF;IAII,kBAAA;Efu7KJ;AACF;;Ael7KA;EACE,wBAAA;Afq7KF;;Ael7KA;EACE;IACE,wBAAA;Efq7KF;AACF;Ael7KA;EACE,gBAAA;EACA,kBAAA;Afo7KF;;Aeh7KA;EACE,gBZ2Be;EY1Bf,mBAAA;Afm7KF;Aej7KE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;Afm7KJ;Aej7KI;EALF;IAMI,YAAA;Efo7KJ;AACF;Ael7KI;EATF;IAUI,YAAA;Efq7KJ;AACF;Aen7KI;EAbF;IAcI,iBAAA;IACA,YAAA;Efs7KJ;AACF;Aen7KE;EAvBF;IAwBI,eAAA;Efs7KF;AACF;Aep7KE;EA3BF;IA4BI,eAAA;Efu7KF;AACF;Aer7KE;EACE,gBAAA;Afu7KJ;;Aej7KI;EADF;IAEI,kBAAA;Efq7KJ;AACF;;Aeh7KE;EACE,YAAA;Afm7KJ;Aej7KI;EAHF;IAII,YAAA;Efo7KJ;AACF;Ael7KI;EAPF;IAQI,YAAA;Efq7KJ;AACF;;Ae/6KI;EACE,cAAA;EACA,WAAA;Afk7KN;Ae/6KI;EX5HF,wCW6HI;EX5HJ,mCW4HI;EX3HJ,gCW2HI;EACA,sBVzJE;EU0JF,cZrEO;AHw/Kb;Aej7KQ;EACE,4BAAA;Afm7KV;Ae/6KM;EACE,6BAAA;EACA,cZ9EK;AH+/Kb;Ae/6KU;EACE,4BAAA;Afi7KZ;;Aez6KA;EACE,gBAAA;Af46KF;Ae16KE;EACE,sBAAA;Af46KJ;Aex6KI;EADF;IAEI,eAAA;Ef26KJ;AACF;;Aev6KA;EXpME,wBWqMA;EXpMA,qBWoMA;EXnMA,mBWmMA;EXlMA,gBWkMA;Af66KF;;Aex6KE;EACE,iBAAA;EACA,YAAA;Af26KJ;Aez6KI;EACE,sBAAA;EACA,4BAAA;EACA,gCAAA;EACA,WAAA;Af26KN;Aex6KI;EACE,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;Af06KN;Aev6KI;EACE,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;Afy6KN;Aet6KI;EAnCF;IAoCI,YAAA;Efy6KJ;AACF;Aev6KI;EAvCF;IAwCI,YAAA;Ef06KJ;AACF;Aev6KE;EACE,kBAAA;Afy6KJ;Aet6KE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;Afw6KJ;;Aen6KE;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;Afs6KJ;Aen6KE;EACE,WAAA;EACA,SAAA;Afq6KJ;Ael6KE;EACE,WAAA;EACA,SAAA;Afo6KJ;Aej6KE;EAjBF;IAkBI,aAAA;Efo6KF;AACF;;Aej6KA;EACE;IACE,YAAA;Efo6KF;AACF;Aej6KA;EACE;IACE,YAAA;Efm6KF;AACF;Aeh6KA;EACE,yBAAA;Afk6KF;;Ae/5KA;EACE,oBAAA;Afk6KF;;Ae/5KA;EACE,kBAAA;EACA,uBAAA;EACA,gCAAA;Afk6KF;Aeh6KE;EACE,cZ9PU;AHgqLd;Ae/5KE;EACE,eAAA;EACA,6BAAA;Afi6KJ;Ae/5KI;EACE,2BAAA;Afi6KN;Ae75KE;EACE,qBAAA;Af+5KJ;Ae55KE;EACE,0BAAA;Af85KJ;Ae35KE;EACE,0BAAA;EACA,uBAAA;Af65KJ;;Aex5KE;EACE,cZvRW;AHkrLf;Aex5KE;EACE,kBAAA;Af05KJ;Aex5KI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,yBZxQG;ECKL,kBWoQyB;Af05K7B;Aer5KE;EACE,kCAAA;EACA,qCAAA;EACA,gCAAA;EACA,6BAAA;Afu5KJ;;Ael5KE;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,kDAAA;EXnVF,wCWoVE;EXnVF,mCWmVE;EXlVF,gCWkVE;Afu5KJ;Aep5KE;EACE,UAAA;EACA,iDAAA;EACA,mBAAA;Afs5KJ;;Aej5KE;EACE,YAAA;EACA,iBAAA;Afo5KJ;Ael5KI;EACE,yBZ3SI;AH+rLV;Aeh5KE;EACE,kBAAA;EACA,kBAAA;EACA,sBZlTM;EYmTN,mBAAA;EXjTA,kCWkTuB;Afk5K3B;;Ae94KA;EXzVE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BWkUqB;EXjUrB,mBWiUqB;Af45KvB;;Aez5KA;EACE,kBAAA;EACA,aAAA;Af45KF;;AgBzzLA,gBAAA;AAEE;EZ2DA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJ4wLnE;;AgBj0LA;EACE,kBAAA;AhBo0LF;AgBl0LE;EACE,kBAAA;AhBo0LJ;AgBh0LM;EACE,UAAA;EACA,mBAAA;EACA,SAAA;AhBk0LR;AgB/zLM;EACE,cboCM;AH6xLd;AgB7zLI;EACE,cAAA;EACA,cboCe;EanCf,eAAA;EACA,eAAA;AhB+zLN;AgB5zLI;EAEE,qBAAA;EACA,cbsBQ;AHuyLd;AgB1zLI;EACE,gBAAA;AhB4zLN;AgBzzLI;EZkBF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EYf7D,UAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;AhBq0LN;AgBn0LM;EACE,UAAA;EACA,eAAA;AhBq0LR;AgB9zLM;EACE,UAAA;EACA,QAAA;AhBg0LR;AgB7zLM;EACE,UAAA;EACA,WAAA;EACA,SAAA;AhB+zLR;AgB5zLM;;EAEE,MAAA;AhB8zLR;AgBzzLE;EACE,eAAA;AhB2zLJ;AgBzzLI;EACE,eAAA;AhB2zLN;AgBxzLI;EACE,cb3BQ;AHq1Ld;AgBtzLE;EAIE,cbnCU;AHw1Ld;AgBlzLE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,sBX9FI;EW+FJ,kBAAA;EZTA,kBYUuB;EZrEzB,wCYsEE;EZrEF,mCYqEE;EZpEF,gCYoEE;AhBszLJ;AgBnzLM;EACE,iBAAA;EACA,YAAA;EACA,eAAA;AhBqzLR;AgBnzLQ;EACE,cb1DI;AH+2Ld;AgBjzLM;EACE,UAAA;EACA,WAAA;EACA,SAAA;AhBmzLR;AgBhzLM;EAEE,MAAA;AhBizLR;AgB9yLM;EACE,kBAAA;AhBgzLR;AgB7yLM;EACE,cb9EM;AH63Ld;AgBzyLI;EACE,kBAAA;AhB2yLN;AgBzyLM;EACE,cblFa;EamFb,gBAAA;EACA,qBAAA;EACA,YAAA;EAEE,0CAAA;EACA,eAAA;EAEF,iBAAA;EACA,kBAAA;EZtHN,yCYuHM;EZtHN,oCYsHM;EZrHN,iCYqHM;EACA,mBAAA;AhB2yLR;AgBryLM;EACE,cb1GM;AHi5Ld;AgBhyLM;EACE,cblHM;AHo5Ld;AgB7xLE;EZpHA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EYuH/D,YAAA;AhByyLJ;AgBvyLI;EACE,UAAA;AhByyLN;AgBvyLM;EACE,WAAA;AhByyLR;AgBvyLQ;EAHF;IAII,eAAA;EhB0yLR;AACF;AgBtyLI;EAhBF;IAiBI,YAAA;EhByyLJ;AACF;;AgBryLA;EACE,2BAAA;AhBwyLF;;AgBryLA;EACE,yBblJY;AH07Ld;AgBryLI;EACE,eAAA;AhBuyLN;AgBpyLI;EACE,WX1ME;EW2MF,eAAA;AhBsyLN;AgBnyLI;EAKE,cbjKM;AHk8LZ;AgB9xLI;EACE,aAAA;AhBgyLN;;AiBjgMA,sBAAA;AACA;EACE,OAAA;EACA,WAAA;AjBogMF;AiBlgME;EAJF;IAKI,UAAA;EjBqgMF;AACF;;AiBlgMA;EACE,yBAAA;EACA,WAAA;AjBqgMF;AiBngME;EAJF;IAKI,aAAA;EjBsgMF;AACF;;AkBthMA,gBAAA;AAEA;EACE,eAAA;EACA,8CAAA;EACA,sBfyFQ;EexFR,cf0DmB;EezDnB,iBfwHc;EevHd,gBfuHc;AHi6LhB;AkBthME;EACE,cfqDiB;AHm+LrB;AkBvhMI;EACE,cf6CQ;AH4+Ld;AkBrhME;EAfF;IAgBI,aAAA;ElBwhMF;AACF;AkBthME;EAnBF;IAoBI,eAAA;ElByhMF;AACF;;AmBhjMA,uBAAA;AACA;Ef4DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,ae/DsB;EfgEtB,8BehE4B;EfiE5B,0BejE4B;EfkE5B,sBelE4B;EfmE5B,yBenEoC;EfoEpC,qBepEoC;EfqEpC,iBerEoC;EACpC,gBAAA;EACA,YAAA;AnB6jMF;AmB3jME;EALF;IAMI,gBAAA;EnB8jMF;AACF;;AmB3jMA;EACE,yBhB8CY;EgB7CZ,WdHM;EcIN,uBAAA;EACA,yBAAA;Ef8CA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BerEqB;EfsErB,mBetEqB;EfgErB,sCe/DyB;EfgEzB,8BehEyB;AnB0kM3B;AmBxkME;EACE,gBAAA;AnB0kMJ;;AmBtkMA;EACE,kBAAA;AnBykMF;AmBvkME;EACE,mBAAA;AnBykMJ;AmBtkME;EAPF;IAQI,kBAAA;EnBykMF;AACF;;AmBtkMA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AnBykMF;AmBvkME;EACE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AnBykMJ;AmBtkME;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;AnBwkMJ;AmBtkMI;EACE,gBAAA;EACA,0CAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WdzDE;Ec0DF,kBAAA;EACA,aAAA;EACA,UAAA;AnBwkMN;AmBnkMI;EACE,cAAA;AnBqkMN;;AmB9jMI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,yBhBKO;EgBJP,UAAA;AnBikMN;;AmB3jMA;EACE,eAAA;EACA,QAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EfqBE,2BDpFY;ECqFZ,8BDrFY;ECrCd,kDesGA;EfrGA,+CeqGA;EfpGA,6CeoGA;EfnGA,0CemGA;EACA,Wd/FM;ALiqMR;AmBhkME;EACE,kBAAA;EACA,aAAA;AnBkkMJ;;AmB9jMA;EACE,aAAA;EACA,chBpBW;EgBqBX,sBd1GM;AL2qMR;;AmB7jMA;EACE,mBAAA;AnBgkMF;AmB9jME;EACE,aAAA;AnBgkMJ;AmB7jME;EACE,eAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;AnB+jMJ;AmB7jMI;EACE,wBAAA;EACA,6CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;AnB+jMN;AmB5jMI;EACE,8BAAA;EACA,mBAAA;EACA,sCAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;AnB8jMN;AmB1jME;EACE,gBd9II;Ec+IJ,YAAA;AnB4jMJ;AmBzjME;EACE,mBdtJO;EcuJP,UAAA;AnB2jMJ;;AmBvjMA;EACE;IACE,6BAAA;EnB0jMF;AACF;AoBzuMA;+EAAA;ACAA,eAAA;AACA;EACE,cAAA;EACA,kBAAA;EjB6FE,kBDxDe;EkBnCjB,kBAAA;ArB6uMF;AqB3uME;EACE,oBAAA;EACA,gBhB8NgB;AL+gMpB;AqB1uME;EACE,WlBgJM;EkB/IN,oCAAA;EjB+CF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aiBlDwB;EjBmDxB,8BiBnD8B;EjBoD9B,0BiBpD8B;EjBqD9B,sBiBrD8B;EjBsD9B,yBiBtDsC;EjBuDtC,qBiBvDsC;EjBwDtC,iBiBxDsC;EjBkEtC,+BiBjE2B;EjBkE3B,uBiBlE2B;EjBsE3B,2BiBrEuB;EjBsEvB,mBiBtEuB;EACrB,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;ArBwvMJ;;AqBpvMA;EACE,mBlBkIQ;AHqnMV;;AqBpvMA;EACE,kBlB+HQ;AHwnMV;;AsBtxMA,gBAAA;AACA;EAEE,4BAAA;EACA,2BAAA;EACA,oBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;ElBoEA,+BkBnEyB;ElBoEzB,uBkBpEyB;ElBwEzB,2BkBvEqB;ElBwErB,mBkBxEqB;EACrB,sBAAA;EACA,cAAA;ElB+EE,kBkB9EqB;EACvB,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBnB2DU;AH+tMZ;AsBxxME;EACE,cAAA;AtB0xMJ;;AsBtxMA;ElBgCE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,+BkBvDqB;ElBwDrB,uBkBxDqB;AtBoyMvB;AsBlyME;EACE,eAAA;EACA,OAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;AtBoyMJ;;AsB/xME;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;AtBkyMJ;AsBhyME;EACE,eAAA;EACA,gBAAA;EACA,cjBpCO;ALs0MX;;AsB9xMA;EACE,kBAAA;AtBiyMF;AsB/xME;EACE,iBAAA;AtBiyMJ;;AuB51MA,gBAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EnB2FE,kBD1De;AH+zMnB;AuB71ME;EACE,kBAAA;AvB+1MJ;AuB51ME;EACE,gBAAA;AvB81MJ;;AuB11MA;EnB+EI,mBmB9EqB;AvB61MzB;;AuB11MA;EACE,4BAAA;AvB61MF;;AuB11MA;EACE,6BAAA;EACA,yBpBsDU;AHuyMZ;;AwBx3MA,qBAAA;AACA;EACE,yBAAA;EACA,0BAAA;AxB23MF;AwBz3ME;EACE,0BAAA;AxB23MJ;;AwBv3MA;EACE,8BAAA;AxB03MF;;AwBv3MA;EACE,mBAAA;EACA,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AxB03MF;;AyB74MA,2BAAA;AAEE;EACE,0BAAA;AzB+4MJ;;A0Bl5MA,oBAAA;AACA;EtB+FI,kBD1De;AHi3MnB;;A0Bl5MA;EACE,gBAAA;EAEE,0CAAA;EACA,eAAA;EAEF,cAAA;EACA,sBAAA;A1Bm5MF;;A2B/5MA,gBAAA;AACA;EACE,0BAAA;EACA,eAAA;EACA,6BAAA;A3Bk6MF;;A2B/5MA;EACE,kBAAA;EACA,qBAAA;EACA,exBUe;EwBTf,gBtB6NmB;EsB3NnB,gBxBwIgB;ECrDd,kBDzDY;EwBxBd,mBAAA;EACA,eAAA;EACA,kBAAA;A3Bi6MF;A2B/5ME;EAGE,eAAA;EACA,qBAAA;EvBrBF,mCuBsBE;EvBrBF,gCuBqBE;EvBpBF,8BuBoBE;EvBnBF,2BuBmBE;A3Bk6MJ;A2B/5ME;EACE,kBAAA;A3Bi6MJ;;A2B55ME;EAGE,eAAA;EACA,qBAAA;EvBnCF,mCuBoCE;EvBnCF,gCuBmCE;EvBlCF,8BuBkCE;EvBjCF,2BuBiCE;A3Bg6MJ;A2B75ME;EACE,kBAAA;A3B+5MJ;;A2B35MA;;;;;;;;;EvB5CE,mCuBsDA;EvBrDA,gCuBqDA;EvBpDA,8BuBoDA;EvBnDA,2BuBmDA;A3Bg6MF;;A2Bn5MI;;;;;;;;;EvBnEF,mCuBoEI;EvBnEJ,gCuBmEI;EvBlEJ,8BuBkEI;EvBjEJ,2BuBiEI;A3Bi6MN;;A2B55MA;;;;EAIE,kBAAA;A3B+5MF;A2B55ME;;;;EACE,kBAAA;A3Bi6MJ;A2B95ME;;;;EACE,gBAAA;EACA,gBAAA;A3Bm6MJ;A2Bh6ME;;;;EACE,gBAAA;A3Bq6MJ;;A2Bj6MA;EACE,2BAAA;A3Bo6MF;;A2Bj6MA;;EAEE,eAAA;EACA,gBAAA;EACA,oBAAA;A3Bo6MF;;A2Bj6MA;EACE,kBAAA;EACA,oBAAA;EvBbE,kBDtDmB;ECuCrB,+BuB+ByB;EvB9BzB,uBuB8ByB;EvB1BzB,2BuB2BqB;EvB1BrB,mBuB0BqB;EACrB,yBAAA;EACA,gBAAA;A3Bq6MF;A2Bn6ME;EAEE,eAAA;EACA,qBAAA;A3Bo6MJ;;A2Bh6MA;;EAEE,kBxBeY;AHo5Md;A2Bj6ME;;;EAEE,gBAAA;A3Bo6MJ;;A2Bh6MA;EACE,6BAAA;EACA,cxBzCW;AH48Mb;A2Bl6ME;EAGE,yBAAA;EACA,cxB9CS;AHg9Mb;;A2B95MA;EACE,cAAA;A3Bi6MF;A2B/5ME;EACE,mBAAA;A3Bi6MJ;A2B95ME;EAEE,kBAAA;A3B+5MJ;;A2B35MA;EvB9DI,8BuB+DqB;A3B85MzB;;A2B35MA;EACE,kBxBvBe;AHq7MjB;;A2B35MA;EACE,iBxBzBe;AHu7MjB;;A2B35MA;EACE,iBxB5Be;AH07MjB;;A2B94MA;;;EAEE,exBxKa;AH0jNf;A2Bj5ME;;;EACE,eAAA;A3Bq5MJ;;A2Bj5MA;;;EAEE,eAAA;A3Bq5MF;A2Bp5ME;;;EACE,eAAA;A3Bw5MJ;;A2Bp5MA;;EAEE,exBnEiB;AH09MnB;A2Bt5ME;;EACE,exBrEe;AH89MnB;;A2Br5MA;EvBtJE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,auBmJsB;EvBlJtB,2BuBkJ4B;EvBjJ5B,uBuBiJ4B;EvBhJ5B,mBuBgJ4B;EvB/I5B,uBuB+IiC;EvB9IjC,mBuB8IiC;EvB7IjC,euB6IiC;EACjC,gBAAA;EACA,WAAA;A3Bk6MF;;A2B/5MA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;A3Bk6MF;A2Bh6ME;EAPF;IAQI,WAAA;IACA,aAAA;E3Bm6MF;AACF;A2Bl6ME;EACE,UAAA;A3Bo6MJ;A2Bn6MI;EACE,aAAA;A3Bq6MN;A2Bl6MI;EACE,UAAA;A3Bo6MN;A2Bj6MI;EACE,8BAAA;A3Bm6MN;A2B/5ME;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EvBnKF,2BuBoKuB;EvBnKvB,mBuBmKuB;EvBzKvB,+BuB0K2B;EvBzK3B,uBuByK2B;EACzB,WtBlPI;ALqpNR;A2Bj6ME;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,sBAAA;EACA,+BAAA;A3Bm6MJ;A2Bh6ME;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,gBtB1PI;EsB2PJ,YAAA;EvB1OF,yDuB2OE;EvB1OF,oDuB0OE;EvBzOF,iDuByOE;A3Bo6MJ;A2Bj6ME;EACE,kBAAA;EACA,uBAAA;A3Bm6MJ;A2Bj6ME;EACE,WAAA;EACA,WAAA;EACA,gBtBhRI;EsBiRJ,kBAAA;EACA,YAAA;EACA,qBAAA;EvBxPF,yDuByPE;EvBxPF,oDuBwPE;EvBvPF,iDuBuPE;A3Bq6MJ;;A2Bj6MA;EACE,cAAA;A3Bo6MF;A2Bl6ME;EAEE,iBAAA;A3Bm6MJ;;A2B75MA;EACE,0CAAA;EACA,WxBpJQ;EwBqJR,YAAA;EACA,iBAAA;EACA,kBAAA;A3Bg6MF;;A2B75MA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;A3Bg6MF;;A2B75MA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;A3Bg6MF;;A2B75MA;EACE,iBxB5KQ;AH4kNV;;A2B75MA;EACE,kBxBhLQ;EwBiLR,cAAA;A3Bg6MF;;A2B75MA;EACE,iBAAA;A3Bg6MF;;A2B75MA;EACE,iBAAA;A3Bg6MF;;A2B75MA;EACE,iBAAA;EACA,WxB9LQ;AH8lNV;;A2Bz5MM;EACE,yBpBVS;EoBWT,WtBvVA;ALmvNR;A2B35MQ;EAEE,mEAAA;EACA,WtB3VF;ALuvNR;;A2Bl6MM;EACE,yBpBVS;EoBWT,WtBvVA;AL4vNR;A2Bp6MQ;EAEE,mEAAA;EACA,WtB3VF;ALgwNR;;A2B36MM;EACE,yBpBVS;EoBWT,WtBvVA;ALqwNR;A2B76MQ;EAEE,0DAAA;EACA,WtB3VF;ALywNR;;A2Bp7MM;EACE,yBpBVS;EoBWT,WtBvVA;AL8wNR;A2Bt7MQ;EAEE,oEAAA;EACA,WtB3VF;ALkxNR;;A2B77MM;EACE,yBpBVS;EoBWT,WtBvVA;ALuxNR;A2B/7MQ;EAEE,kEAAA;EACA,WtB3VF;AL2xNR;;A2Bt8MM;EACE,yBpBVS;EoBWT,WtBvVA;ALgyNR;A2Bx8MQ;EAEE,mEAAA;EACA,WtB3VF;ALoyNR;;A2B/8MM;EACE,yBpBVS;EoBWT,WtBvVA;ALyyNR;A2Bj9MQ;EAEE,oEAAA;EACA,WtB3VF;AL6yNR;;A2Bx9MM;EACE,yBpBVS;EoBWT,WtBvVA;ALkzNR;A2B19MQ;EAEE,mEAAA;EACA,WtB3VF;ALszNR;;A2Bj+MM;EACE,yBpBVS;EoBWT,WtBvVA;AL2zNR;A2Bn+MQ;EAEE,+CAAA;EACA,WtB3VF;AL+zNR;;A2B1+MM;EACE,yBpBVS;EoBWT,WtBvVA;ALo0NR;A2B5+MQ;EAEE,uCAAA;EACA,WtB3VF;ALw0NR;;A2Bn/MM;EACE,yBpBVS;EoBWT,WtBvVA;AL60NR;A2Br/MQ;EAEE,mEAAA;EACA,WtB3VF;ALi1NR;;A2B5/MM;EACE,yBpBVS;EoBWT,WtBvVA;ALs1NR;A2B9/MQ;EAEE,kEAAA;EACA,WtB3VF;AL01NR;;A2BrgNM;EACE,yBpBVS;EoBWT,WtBvVA;AL+1NR;A2BvgNQ;EAEE,oEAAA;EACA,WtB3VF;ALm2NR;;A2B9gNM;EACE,yBpBVS;EoBWT,WtBvVA;ALw2NR;A2BhhNQ;EAEE,gDAAA;EACA,WtB3VF;AL42NR;;A2BvhNM;EACE,yBpBVS;EoBWT,WtBvVA;ALi3NR;A2BzhNQ;EAEE,wCAAA;EACA,WtB3VF;ALq3NR;;A2BhiNM;EACE,yBpBVS;EoBWT,WtBvVA;AL03NR;A2BliNQ;EAEE,sCAAA;EACA,WtB3VF;AL83NR;;A2BziNM;EACE,yBpBVS;EoBWT,WtBvVA;ALm4NR;A2B3iNQ;EAEE,8CAAA;EACA,WtB3VF;ALu4NR;;A2BljNM;EACE,yBpBVS;EoBWT,WtBvVA;AL44NR;A2BpjNQ;EAEE,mEAAA;EACA,WtB3VF;ALg5NR;;A2B3jNM;EACE,yBpBVS;EoBWT,WtBvVA;ALq5NR;A2B7jNQ;EAEE,oEAAA;EACA,WtB3VF;ALy5NR;;A2BpkNM;EACE,yBpBVS;EoBWT,WtBvVA;AL85NR;A2BtkNQ;EAEE,6CAAA;EACA,WtB3VF;ALk6NR;;A2BhkNA;EvB1WE,kIuB2WA;EvB1WA,+HuB0WA;EvBzWA,6HuByWA;EvBxWA,0HuBwWA;A3BskNF;A2BrkNE;EvB5WA,kIuB8WE;EvB7WF,+HuB6WE;EvB5WF,6HuB4WE;EvB3WF,0HuB2WE;A3BykNJ;A2BtkNE;EvBjXA,mCuBkXE;EvBjXF,gCuBiXE;EvBhXF,8BuBgXE;EvB/WF,2BuB+WE;A3B2kNJ;;A2BvkNA;;EAEE,oBAAA;EACA,aAAA;A3B0kNF;;A2BvkNA;EACE,sBtBrXM;EsBsXN,cxBjSW;EwBkSX,yBAAA;A3B0kNF;A2BzkNE;EAEE,6CAAA;EACA,cxBtSS;AHg3Nb;;A2BtkNA;EACE,yBxB9UU;EwB+UV,WtBjYM;AL08NR;A2BxkNE;EAEE,0DAAA;EACA,WtBrYI;AL88NR;;A2BrkNA;EACE,6BAAA;EACA,cxB3VY;AHm6Nd;A2BtkNE;EAEE,yCAAA;EACA,cxBhWU;AHu6Nd;;A2BlkNE;EACE,6BAAA;EACA,WtBvZI;AL49NR;A2BnkNI;EAEE,2CAAA;EACA,WtB5ZE;ALg+NR;;A2B/jNA;EACE,6BAAA;EACA,cxBjXU;AHm7NZ;A2BhkNE;EAEE,yCAAA;EACA,cxBtXQ;AHu7NZ;;A2B5jNE;EACE,6BAAA;EACA,WtB/aI;AL8+NR;A2B7jNI;EAEE,2CAAA;EACA,WtBpbE;ALk/NR;;A2BzjNA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;EACA,qCAAA;A3B4jNF;;A2BzjNA;EACE,wBAAA;EACA,uBAAA;A3B4jNF;;A2BzjNA;EACE,YxB1TQ;EwB2TR,WxB3TQ;EwB4TR,4BAAA;EACA,2BAAA;EACA,oBAAA;EvBnYA,2BuBoYqB;EvBnYrB,mBuBmYqB;EvBzYrB,+BuB0YyB;EvBzYzB,uBuByYyB;EACzB,eAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;A3B8jNF;A2B5jNE;EAGE,qBAAA;EACA,0BAAA;A3B4jNJ;A2BzjNE;EACE,YAAA;EACA,WAAA;EACA,eAAA;A3B2jNJ;A2BxjNE;EACE,WtBreI;AL+hOR;;A2BtjNA;EACE,eAAA;EACA,iBAAA;EACA,gCAAA;A3ByjNF;;A2BpjNE;;EvBzfA,mCuB0fE;EvBzfF,gCuByfE;EvBxfF,8BuBwfE;EvBvfF,2BuBufE;A3B2jNJ;;A4BvjOA,sBAAA;AAKA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A5BsjOF;A4BpjOE;;EACE,kBAAA;EACA,cAAA;EACA,qBvBDO;ALwjOX;AIx7NE;;EwB1HI,UAAA;A5BsjON;A4BpjOI;;;;EAGE,UAAA;A5BujON;A4BpjOI;;EACE,yBzB8BQ;EyB7BR,WvBnBE;EuBoBF,qBzB4BQ;AH2hOd;A4BpjOI;;EACE,yBAAA;A5BujON;A4BtjOM;;EACE,6BAAA;EACA,czBqBM;AHoiOd;A4BvjOQ;;;EAEE,yCAAA;EACA,czBgBI;AH0iOd;A4BljOE;;;;;;;;EAIE,iBAAA;A5BwjOJ;;A4BjjOE;;;;EAGE,yBAAA;A5BqjOJ;;A4BhjOA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A5BmjOF;A4BjjOE;EACE,WAAA;A5BmjOJ;;A4B/iOA;EACE,gBAAA;A5BkjOF;;A4B7iOA;EACE,cAAA;A5BgjOF;A4B9iOE;ExBqBE,0BwBpB6B;ExBqB7B,6BwBrB6B;A5BijOjC;;A4B3iOA;;ExB4BI,yBwB1B0B;ExB2B1B,4BwB3B0B;A5B+iO9B;;A4B1iOA;EACE,WAAA;A5B6iOF;;A4B1iOA;EACE,gBAAA;A5B6iOF;;A4BziOE;;ExBFE,0BwBI6B;ExBH7B,6BwBG6B;A5B6iOjC;;A4BziOA;ExBMI,yBwBL0B;ExBM1B,4BwBN0B;A5B6iO9B;;A4B7hOA;EACE,wBAAA;EACA,uBAAA;A5BgiOF;A4B9hOE;EACE,cAAA;A5BgiOJ;;A4B5hOA;EACE,uBAAA;EACA,sBAAA;A5B+hOF;;A4B5hOA;EACE,sBAAA;EACA,qBAAA;A5B+hOF;;A4B1hOA;ExBzJE,wDwB0JA;ExBzJA,qDwByJA;ExBxJA,mDwBwJA;ExBvJA,gDwBuJA;A5BgiOF;A4B7hOE;ExB7JA,wBwB8JE;ExB7JF,qBwB6JE;ExB5JF,mBwB4JE;ExB3JF,gBwB2JE;A5BkiOJ;;A4BzhOA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A5B4hOF;A4B1hOE;;EAEE,WAAA;A5B4hOJ;A4BzhOE;;;;EAIE,gBAAA;EACA,cAAA;A5B2hOJ;A4BvhOI;EACE,gBAAA;A5ByhON;A4BthOI;ExB5EA,6BwB6EgC;ExB5EhC,4BwB4EgC;A5ByhOpC;A4BthOI;ExB9FA,yBwB+F6B;ExB9F7B,0BwB8F6B;A5ByhOjC;A4BrhOE;EACE,gBAAA;A5BuhOJ;A4BnhOI;;ExB1FA,6BwB4FgC;ExB3FhC,4BwB2FgC;A5BshOpC;A4BlhOE;ExB9GE,yBwB+G2B;ExB9G3B,0BwB8G2B;A5BqhO/B;;A4B5gOI;;;;EAEE,kBAAA;EACA,sBAAA;A5BihON;;A4BtgOE;;;;EAEE,eAAA;EACA,gBAAA;A5B2gOJ;;A6B1vOA,iBAAA;AAKE;EACE,mBAAA;A7ByvOJ;;A6B7uOA,6BAAA;AAEA;EACE,kBAAA;EACA,gBAAA;EzBuCA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2ByB9DqB;EzB+DrB,mByB/DqB;EzByDrB,+ByBxDyB;EzByDzB,uByBzDyB;EACzB,iBAAA;A7B2vOF;A6BzvOE;EACE,gBAAA;A7B2vOJ;;A6BvvOA;EACE,QAAA;EACA,UAAA;A7B0vOF;;A6BvvOA;EACE,QAAA;A7B0vOF;;A6BvvOA;EACE,kBAAA;A7B0vOF;;A6BvvOA;EACE,mBAAA;A7B0vOF;;A6BvvOA;EACE,WAAA;A7B0vOF;;A6BvvOA;EACE,mBAAA;A7B0vOF;;A6BvvOA;EACE;IACE,mBAAA;E7B0vOF;AACF;A6BvvOA;EACE;IACE,mBAAA;E7ByvOF;E6BvvOA;IACE,kBAAA;E7ByvOF;E6BvvOA;IACE,mBAAA;E7ByvOF;AACF;A6BtvOA;EAEI;IACE,oBAAA;E7BuvOJ;AACF;A6BnvOA;EACE;IzBxBA,qBAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IACA,ayBqBwB;IzBpBxB,8ByBoB8B;IzBnB9B,0ByBmB8B;IzBlB9B,sByBkB8B;IzBjB9B,uBATiE;IAUjE,mBAViE;IAWjE,eAXiE;IyB2B/D,kBAAA;E7B+vOF;E6B7vOE;IACE,kBAAA;E7B+vOJ;E6B3vOA;IACE,eAAA;E7B6vOF;E6B1vOA;;IAEE,QAAA;IACA,WAAA;E7B4vOF;E6B1vOA;IACE,mBAAA;E7B4vOF;E6BxvOE;IACE,mBAAA;E7B0vOJ;AACF;A8Bx2OA,eAAA;AACA;EACE,sBzBQM;EDsFJ,kBDxDe;E2BpCjB,gBAAA;A9B02OF;A8Bx2OE;EACE,qBAAA;E1ByFA,kB0BvFuB;E1BPzB,mD0BQE;E1BPF,gD0BOE;E1BNF,8C0BME;E1BLF,2C0BKE;EACA,kBAAA;EACA,cAAA;EACA,mCAAA;EACA,+BAAA;EACA,2BAAA;E1BsBF,wC0BrBE;E1BsBF,mC0BtBE;E1BuBF,gC0BvBE;EACA,UAAA;A9B82OJ;A8B12OI;E1BgBF,gD0BfI;E1BgBJ,2C0BhBI;E1BiBJ,wC0BjBI;E1B0EF,kB0BzEyB;A9B82O7B;;A8Bx2OE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;E1BoBA,6DAAA;EACA,kC0BpB4D;E1BqB5D,4BAJ8C;EAK9C,sBAL+D;AJ61OnE;A8B52OE;EACE,uBAAA;A9B82OJ;A8B32OE;EACE,oBAAA;A9B62OJ;A8B32OE;EACE,qBAAA;E1BNF,oC0BOE;E1BNF,+B0BME;E1BLF,4B0BKE;EACA,cAAA;A9B+2OJ;A8B72OI;EAGE,6BAAA;EACA,yBAAA;EACA,qBAAA;A9B62ON;A8Bz2OE;EACE,kBAAA;A9B22OJ;;A8Bt2OE;EACE,cAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;A9By2OJ;;A8Br2OA;;EAEE,yBAAA;A9Bw2OF;A8Bt2OE;EAJF;;IAKI,YAAA;E9B02OF;AACF;;A8Bp2OE;EACE,eAAA;A9Bu2OJ;A8Bp2OE;EACE,aAAA;A9Bs2OJ;A8Bn2OE;EACE,qBAAA;A9Bq2OJ;A8Bn2OI;E1BJA,0B0BKyB;A9Bq2O7B;A8Bj2OE;EAnBF;IAoBI,mBAAA;E9Bo2OF;AACF;;A8Bj2OA;EACE,mBAAA;A9Bo2OF;A8Bl2OE;EACE,kBAAA;A9Bo2OJ;A8Bj2OE;EACE,gBAAA;A9Bm2OJ;A8Bj2OI;EACE,iBAAA;A9Bm2ON;A8B/1OE;EAfF;IAgBI,mBAAA;E9Bk2OF;AACF;;A8B/1OA;EACE,mBAAA;A9Bk2OF;A8Bh2OE;EACE,kBAAA;A9Bk2OJ;A8B/1OE;EACE,gBAAA;EACA,eAAA;EACA,czB5HO;AL69OX;A8B91OE;EAbF;IAcI,mBAAA;E9Bi2OF;AACF;;A8B91OA;EACE,mB3BtEe;AHu6OjB;A8B/1OE;EAHF;IAII,mBAAA;E9Bk2OF;AACF;;A8B/1OA;EACE,eAAA;A9Bk2OF;A8Bh2OE;EACE,gBAAA;A9Bk2OJ;A8Bh2OI;EACE,iBAAA;A9Bk2ON;;A8B71OA;EACE,e3B/Ia;E2BgJb,0BAAA;A9Bg2OF;;A8B71OA;EACE,eAAA;EACA,czB9JS;AL8/OX;A8B91OE;EACE,mB3BxJW;AHw/Of;;A8B51OA;EACE,oBAAA;EACA,iBAAA;A9B+1OF;;A8B51OA;EACE,eAAA;EACA,iBAAA;A9B+1OF;;A8B51OA;EACE,gBAAA;EACA,eAAA;E1BrIA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B0B8GqB;E1B7GrB,mB0B6GqB;EACrB,mBAAA;A9B02OF;A8Bx2OE;EACE,cAAA;EACA,kBAAA;A9B02OJ;A8Bv2OE;EACE,c3B9GS;AHu9Ob;A8Bt2OE;EAGE,c3BvJQ;AH6/OZ;A8Bn2OE;EACE,gBAAA;E1BtIF,qC0BuI2B;E1BtI3B,6B0BsI2B;A9Bs2O7B;;A8Bl2OA;E1B/JE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B0BwIqB;E1BvIrB,mB0BuIqB;E1B7IrB,qC0B8IyB;E1B7IzB,6B0B6IyB;EACzB,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WzB5NM;EyB6NN,e3B7Ma;AH8jPf;A8B/2OE;EACE,sBAAA;EACA,eAAA;A9Bi3OJ;;A8B72OA;E1B/II,kBDxDe;E2ByMjB,mB3BlKe;AHkhPjB;A8B92OE;EACE;IACE,iBAAA;E9Bg3OJ;AACF;A8B72OE;EACE;IACE,iBAAA;E9B+2OJ;AACF;A8B52OE;EAhBF;IAiBI,mBAAA;E9B+2OF;AACF;;A+BhnPA,gBAAA;AAEA;EACE,kBAAA;A/BknPF;A+BhnPI;EACE,W1BIE;E0BHF,kBAAA;A/BknPN;A+B9mPE;EACE,kBAAA;A/BgnPJ;A+B9mPE;EACE,kBAAA;A/BgnPJ;;AgC/nPA,eAAA;AACA;EACE,wCAAA;EACA,oCAAA;AhCkoPF;;AiCroPA,kBAAA;AAGE;EACE,e9BqBW;AHinPf;;AkC1oPA,sBAAA;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AlC4oPF;;AkCzoPA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;E9BTA,gD8BUA;E9BTA,6C8BSA;E9BRA,2C8BQA;E9BPA,wC8BOA;EACA,qBAAA;EACA,eAAA;AlC+oPF;;AkC5oPA;EACE,kBAAA;EACA,UAAA;AlC+oPF;;AkC5oPA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AlC+oPF;;AkC5oPA;;;;EAIE,sBAAA;AlC+oPF;;AkC5oPA;EACE,sBAAA;EACA,uBAAA;AlC+oPF;;AkC5oPA;EACE,uBAAA;AlC+oPF;;AkC5oPA;EACE,qBAAA;EACA,mBAAA;AlC+oPF;;AmC7rPA;;EAEE,kCAAA;AnCgsPF;;AmC5rPA;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,kCAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,sCAAA;EACA,wBAAA;EACA,wCAAA;EACA,gCAAA;AnC+rPF;;AmC5rPA;EACE,uBAAA;AnC+rPF;;AmC5rPA;EACE,qBAAA;AnC+rPF;;AmC7rPA;EACE,qBAAA;AnCgsPF;;AmC7rPA;EACE,0BAAA;EACA,gCAAA;AnCgsPF;;AmC5rPA;;EAEE,kCAAA;AnC+rPF;;AmC3rPA;EACE,0BAAA;EACA,qBAAA;EACA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,wCAAA;EACA,kCAAA;EACA,gCAAA;AnC8rPF;;AmC3rPA;EACE,uBAAA;EACA,oCAAA;EACA,8BAAA;AnC8rPF;;AmC3rPA;EACE,yBAAA;EACA,oCAAA;EACA,8BAAA;AnC8rPF;;AmC3rPA;EACE,yBAAA;EACA,oCAAA;EACA,8BAAA;AnC8rPF;;AmC3rPA;EACE,yBAAA;EACA,oCAAA;EACA,8BAAA;AnC8rPF;;AmC3rPA;EACE,yBAAA;EACA,oCAAA;EACA,8BAAA;AnC8rPF;;AmC3rPA;EACE,yBAAA;EACA,oCAAA;EACA,8BAAA;AnC8rPF;;AmC3rPA;EACE,yBAAA;EACA,wCAAA;EACA,kCAAA;AnC8rPF;;AmC3rPA;EACE,0BAAA;EACA,gCAAA;AnC8rPF;;AoCzyPA,gBAAA;AAEA;EACE,YAAA;ApC2yPF;;AoCxyPA;EACE,WAAA;ApC2yPF;;AqClzPA,oBAAA;AAEA;EACE,gBAAA;ArCozPF;;AqC9yPE;EACE,oBAAA;ArCizPJ;AqC/yPI;EAHF;IAII,mBAAA;ErCkzPJ;AACF;AqChzPI;EAPF;IAQI,oBAAA;ErCmzPJ;AACF;AqCjzPI;EAXF;IAYI,oBAAA;ErCozPJ;AACF;AqClzPI;EAfF;IAgBI,mBAAA;ErCqzPJ;AACF;;AsC/0PA,oBAAA;AAEA;;;;ElC2DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EAqBjE,qCkC1EyB;ElC2EzB,6BkC3EyB;EACzB,gBAAA;AtC41PF;;AsCz1PA;EACE,eAAA;EACA,iBAAA;EAEA,wBAAA;AtC21PF;AsCz1PE;EACE,cAAA;AtC21PJ;AsCz1PI;EAEE,kBAAA;EACA,iBAAA;EACA,kBAAA;AtC01PN;;AsCp1PE;EACE,qBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AtCu1PJ;;AsCn1PA;EACE,+HAAA;EACA,0HAAA;EACA,uHAAA;AtCs1PF;;AsCn1PA;EACE,4HAAA;EACA,uHAAA;EACA,oHAAA;AtCs1PF;;AsCn1PA;EACE,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uDAAA;AtCs1PF;;AsCn1PA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AtCs1PF;AsCp1PE;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;AtCs1PJ;;AsCl1PA;EACE,aAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;AtCq1PF;;AsCl1PA;EACE,uDAAA;EACA,eAAA;EACA,YAAA;AtCq1PF;;AsCl1PA;EACE,aAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uDAAA;EACA,+GAAA;EACA,iHAAA;EACA,uGAAA;AtCq1PF;;AsCl1PA;EACE,aAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uDAAA;EAEA,iHAAA;EACA,oHAAA;EACA,yGAAA;AtCo1PF;;AsCj1PA;EACE,iBAAA;AtCo1PF;;AsCj1PA;EACE,kBAAA;AtCo1PF;;AuCv9PA,eAAA;AAEA;EACE,qBAAA;EAEA,kBAAA;AvCw9PF;;AuCr9PA;EACE,qBAAA;AvCw9PF;AuCv9PE;EACE,iBAAA;AvCy9PJ;;AwCp+PA,eAAA;AACA;EACE,gBAAA;AxCu+PF;;AyCz+PA,cAAA;AAEA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;AzC2+PF;;AyCx+PA;EACE,WAAA;EACA,uBAAA;AzC2+PF;AyCz+PE;EACE,kBAAA;AzC2+PJ;AyCz+PI;EAHF;IAII,kBAAA;EzC4+PJ;AACF;AyCz+PE;EACE,kBAAA;EACA,mBAAA;AzC2+PJ;AyCv+PE;EACE,gBAAA;EACA,kBAAA;AzCy+PJ;AyCt+PE;EACE,iBAAA;AzCw+PJ;AyCr+PE;EACE,qBAAA;AzCu+PJ;AyCp+PE;EACE,qBAAA;EACA,ctCqDS;EsCpDT,etCvBa;EsCwBb,gBAAA;AzCs+PJ;;AyCj+PE;EACE,YAAA;AzCo+PJ;AyCn+PI;EAFF;IAGI,WAAA;EzCs+PJ;AACF;AyCn+PE;EACE,yBAAA;AzCq+PJ;AyCp+PI;EAFF;IAGI,WAAA;EzCu+PJ;AACF;AyCn+PI;EACE,kBAAA;AzCq+PN;AyCl+PI;EACE,6CAAA;EACA,yCAAA;EACA,ctCwBO;EsCvBP,gBAAA;AzCo+PN;AyCl+PM;EAGE,0CAAA;EACA,sCAAA;AzCk+PR;AyC79PM;EACE,eAAA;AzC+9PR;;AyCz9PA;EACE,iBAAA;EACA,kBAAA;AzC49PF;AyC39PE;EACE,cAAA;EACA,qBAAA;AzC69PJ;AyC39PI;EACE,aAAA;AzC69PN;;AyCx9PA;EACE,gCAAA;EACA,mBAAA;AzC29PF;;AyCx9PA;EACE,kBAAA;AzC29PF;;AyCx9PA;EAEI,eAAA;EACA,YAAA;AzC09PJ;;A0C5kQA;EACE,eAAA;EACA,eAAA;A1C+kQF;;A0C3kQE;EACE,WrCEI;AL4kQR;A0C5kQI;EAGE,WrCOE;EqCNF,sBrCJE;ALglQR;A0CzkQI;EACE,crCPK;ALklQX;A0CxkQI;EACE,crCHK;AL6kQX;;A2ChmQA,iBAAA;AAME;;;;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EvCuFA,mBuCtFuB;EvC2BzB,wCuC1BE;EvC2BF,mCuC3BE;EvC4BF,gCuC5BE;A3CmmQJ;A2CjmQI;;;;;;;;;;EAGE,8BAAA;EACA,0BAAA;EACA,sBAAA;A3C0mQN;A2CxmQI;;;;EACE,8BAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;A3C6mQN;A2C1mQE;;;;EACE,aAAA;EACA,kBAAA;A3C+mQJ;A2C7mQI;;;;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;A3CknQN;A2CjnQM;;;;EACE,qBAAA;EACA,iBAAA;EACA,iBAAA;A3CsnQR;A2ClnQI;;;;EACE,cAAA;A3CunQN;A2CnnQE;;;;EACE,gBAAA;EACA,eAAA;EACA,SAAA;EACA,wBAAA;A3CwnQJ;A2CtnQI;;;;EACE,mBAAA;EAEA,oBAAA;A3C0nQN;AI5pQE;;;;;;;EAEE,YAAA;EACA,cAAA;AJmqQJ;AIjqQE;;;;EACE,WAAA;AJsqQJ;A2CzoQM;;;;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;A3C8oQR;A2C3oQM;;;;EACE,cAAA;EACA,gBAAA;A3CgpQR;A2C3oQE;;;;EACE,SAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;A3CgpQJ;A2C9oQI;;;;EACE,cAAA;EACA,kBAAA;EACA,cAAA;A3CmpQN;;A2C9oQA;EACE,cAAA;EvCKE,gBuCJqB;A3CipQzB;;A2C5oQI;EvCDA,mBuCEyB;A3C+oQ7B;;A2CzoQE;EvCRE,kBuCSuB;EACvB,aAAA;EACA,YAAA;EACA,mBAAA;EvCtBF,2BuCuBuB;EvCtBvB,mBuCsBuB;A3C6oQzB;A2C3oQI;EACE,gBAAA;A3C6oQN;;A2CxoQA;EAKI;;;;IACE,kBAAA;E3C0oQJ;E2CxoQE;;;;IACE,wBAAA;E3C6oQJ;E2CxoQE;IACE,aAAA;IACA,YAAA;E3C0oQJ;AACF;A2CtoQA;EAMM;;;;;;;;;;;;;IAIE,2BAAA;IACA,uBAAA;IACA,mBAAA;E3C4oQN;AACF;A4CnyQA,qBAAA;AAEA;EACE,aAAA;EACA,mBAAA;A5CoyQF;;A4CjyQA;EACE,WAAA;EACA,kBAAA;A5CoyQF;A4CnyQE;EACE,yBAAA;A5CqyQJ;A4CpyQI;EACE,yBAAA;A5CsyQN;;A4CjyQA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;A5CoyQF;;A4CjyQA;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;A5CoyQF;;A6Cp0QA,iBAAA;AACA;EACE,aAAA;EACA,iBAAA;A7Cu0QF;;A6Cp0QA;EACE,iBAAA;A7Cu0QF;;A6Cp0QA;EACE,6BAAA;EACA,qBAAA;EACA,WxCOM;EwCNN,e1CWa;E0CVb,oBAAA;A7Cu0QF;;A6Cp0QA;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;A7Cu0QF;;A8C51QA,gBAAA;AAEA;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;A9C81QF;A8C51QE;EACE,cAAA;EACA,yBAAA;A9C81QJ;A8C51QE;EACE,WzCHI;EyCIJ,yBAAA;A9C81QJ;;A8C11QA;E1CyDE,sBAAA;EACA,kBAAA;EACA,cAAA;AJqyQF;;A8C51QA;EACE,cAAA;A9C+1QF;;A8C51QA;E1CiDE,sBAAA;EACA,kBAAA;EACA,cAAA;AJ+yQF;;A8C91QA;EACE,0CAAA;A9Ci2QF;;A8C91QA;EACE,sBAAA;EACA,0BAAA;EACA,wCAAA;A9Ci2QF;A8C/1QE;;EAEE,2BAAA;EACA,8BAAA;EACA,wCAAA;A9Ci2QJ;A8C91QE;EACE,iCAAA;EACA,2CAAA;A9Cg2QJ;A8C71QE;EACE,wCAAA;A9C+1QJ;A8C51QE;EACE,iCAAA;A9C81QJ;;A8C11QA;E1C0BE,4B0CzBqB;E1C0BrB,oB0C1BqB;EACrB,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;A9C81QF;;A8C31QA;EACE,gBAAA;A9C81QF;A8C71QE;EACE,gBAAA;EACA,eAAA;A9C+1QJ;A8C71QE;EACE,sBAAA;A9C+1QJ;;A8C11QE;EAEE,yBAAA;A9C41QJ;A8Cz1QE;EACE,2CAAA;A9C21QJ;;A8Cv1QA;EACE,iBAAA;EACA,gBAAA;A9C01QF;;A8Cv1QA;EACE;IACE,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,4CAAA;IACA,sBAAA;E9C01QF;E8Cx1QA;IACE,gBAAA;E9C01QF;E8Cx1QA;;;;;;IAME,mBAAA;E9C01QF;E8Cx1QA;IACE,SAAA;E9C01QF;E8Cx1QA;;;;;;IAME,cAAA;E9C01QF;E8Cx1QA;;;;;;IAME,eAAA;E9C01QF;E8Cx1QA;;;;IAIE,gBAAA;E9C01QF;AACF;A8Ct1QE;EACE,kBAAA;A9Cw1QJ;;A+C5+QA,cAAA;AAEA;EACE,0BAAA;A/C8+QF;;A+C3+QA;E3CuDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJm8QnE;;AgD//QA,qBAAA;AAEA;EACE,oCAAA;EACA,2CAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AhDigRF;AgD//QE;EAPF;IAQI,mBAAA;EhDkgRF;AACF;AgDhgRE;EACE,qBAAA;EACA,W7C+IM;E6C9IN,Y7C8IM;EC9DN,kB4C/EuB;EACvB,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;AhDkgRJ;AgDhgRI;EAXF;IAYI,W7CmII;I6ClIJ,Y7CkII;EHi4QR;AACF;AgDjgRE;EACE,WAAA;EACA,YAAA;AhDmgRJ;AgDjgRE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AhDmgRJ;AgDjgRI;EACE,gBAAA;EAEE,0CAAA;EACA,eAAA;EAEF,0BAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AhDigRN;AgD9/QE;EACE,cAAA;EACA,kBAAA;AhDggRJ;;AgD3/QA;EACE,kBAAA;AhD8/QF;AgD5/QE;EACE,cAAA;EACA,mBAAA;EACA,Y7C4FO;E6C3FP,a7C2FO;AHm6QX;AgD5/QI;EANF;IAOI,W7CsFI;I6CrFJ,Y7CqFI;EH06QR;AACF;AgD7/QE;EACE,WAAA;EACA,YAAA;AhD+/QJ;;AiD7kRA,mBAAA;AAEA;EACE,WAAA;EACA,kBAAA;AjD+kRF;;AiD5kRA;EACE,YAAA;EACA,iBAAA;AjD+kRF;;AiD5kRA;E7CoFI,kB6CnFqB;AjD+kRzB;;AiD5kRA;EACE,mBAAA;AjD+kRF;;AiD5kRA;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;AjD+kRF;AiD7kRE;EACE,8BAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;AjD+kRJ;AiD7kRE;EACE,yBAAA;AjD+kRJ;AiD7kRE;EACE,yBAAA;EACA,YAAA;AjD+kRJ;;AiD3kRA;EAGE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,W5C1CM;E4C2CN,kBAAA;E7C2CE,kBDtDmB;AHwlRvB;AiD1kRE;EACE,6BAAA;AjD4kRJ;AiD1kRE;EACE,iCAAA;AjD4kRJ;;AiDvkRE;EACE,aAAA;AjD0kRJ;AiDvkRE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,sBAAA;E7CqBA,kBDtDmB;E8CmCnB,SAAA;EACA,QAAA;EACA,UAAA;AjDykRJ;;AiDrkRA;;EAEE,qBAAA;EACA,eAAA;EACA,YAAA;AjDwkRF;;AiDrkRA;EACE,kBAAA;EACA,kBAAA;EACA,sB5CnFM;EDsFJ,kBDxDe;E8CuDjB,yBAAA;AjDwkRF;AiDtkRE;EAEE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;AjDukRJ;AiDpkRE;EACE,iCAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;AjDskRJ;AiDnkRE;EACE,8BAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;AjDqkRJ;;AiDjkRA;EACE,UAAA;AjDokRF;;AiDjkRA;E7C1HE,wB6C2HA;E7C1HA,qB6C0HA;E7CzHA,mB6CyHA;E7CxHA,gB6CwHA;AjDukRF;AiDtkRE;EAEE,aAAA;AjDukRJ;;AiDnkRA;EACE,mBAAA;AjDskRF;;AiDlkRE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AjDqkRJ;;AiDjkRA;EACE,gBAAA;EACA,mBAAA;AjDokRF;;AiDjkRA;EACE,WAAA;AjDokRF;;AiDjkRA,oBAAA;AAEE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AjDmkRJ;AiDjkRI;EACE,OAAA;AjDmkRN;;AiD7jRE;EACE,WAAA;EACA,WAAA;AjDgkRJ;AiD7jRE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AjD+jRJ;AiD5jRE;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AjD8jRJ;AiD5jRI;EACE,mBAAA;EACA,+BAAA;EACA,UAAA;EACA,WAAA;AjD8jRN;AiD5jRI;EACE,UAAA;EACA,YAAA;AjD8jRN;AiD1jRM;EACE,8BAAA;EACA,UAAA;EACA,YAAA;AjD4jRR;AiDzjRM;EACE,8BAAA;EACA,UAAA;EACA,YAAA;AjD2jRR;AiDvjRI;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;AjDyjRN;;AiDpjRA,oBAAA;AAEE;EACE,mBAAA;AjDsjRJ;AiDpjRI;EACE,iBAAA;AjDsjRN;AiDljRE;EACE,WAAA;EACA,YAAA;EACA,SAAA;AjDojRJ;AiDnjRI;EACE,WAAA;AjDqjRN;AiDjjRE;EACE,qBAAA;AjDmjRJ;AiDhjRE;E7C1MA,gCAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;E6CyME,SAAA;EACA,YAAA;AjDqjRJ;AiDljRE;EACE,eAAA;EACA,oBAAA;AjDojRJ;AiDnjRI;E7CnNF,iCAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;AJywRF;AiDpjRE;EACE,wBAAA;AjDsjRJ;AiDnjRE;EACE,aAAA;AjDqjRJ;;AiDjjRA;EACE,YAAA;AjDojRF;;AiDjjRA;EACE;IACE,iBAAA;EjDojRF;EiDjjRA;IACE,SAAA;EjDmjRF;EiD/iRE;IACE,mBAAA;EjDijRJ;EiD9iRE;IACE,oBAAA;IACA,eAAA;EjDgjRJ;AACF;AiD5iRA;EAEI;IACE,WAAA;IACA,kBAAA;IACA,WAAA;EjD6iRJ;EiD5iRI;IACE,UAAA;EjD8iRN;EiD1iRE;IACE,OAAA;EjD4iRJ;EiDziRE;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;EjD2iRJ;EiDziRI;IACE,8BAAA;IACA,oBAAA;IACA,UAAA;IACA,WAAA;EjD2iRN;EiDziRI;IACE,WAAA;IACA,OAAA;EjD2iRN;EiDviRM;IACE,8BAAA;IACA,WAAA;IACA,WAAA;EjDyiRR;EiDviRM;IACE,8BAAA;IACA,WAAA;IACA,WAAA;EjDyiRR;EiDliRE;IACE,WAAA;EjDoiRJ;EiDjiRE;IACE,WAAA;IACA,cAAA;IACA,kBAAA;EjDmiRJ;EiD9hRE;IACE,gBAAA;IACA,gBAAA;IACA,mBAAA;EjDgiRJ;EiD7hRE;IACE,mBAAA;EjD+hRJ;EiD9hRI;IACE,aAAA;EjDgiRN;EiD7hRI;IACE,eAAA;IACA,SAAA;IACA,aAAA;IACA,UAAA;EjD+hRN;EiD5hRI;IACE,SAAA;EjD8hRN;EiD3hRE;IACE,eAAA;EjD6hRJ;EiDxhRE;IAEE,kBAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;IACA,kBAAA;EjDyhRJ;EiDthRE;IACE,SAAA;EjDwhRJ;EiDrhRE;IACE,SAAA;EjDuhRJ;AACF;AiDnhRA;EACE;IACE,WAAA;IACA,eAAA;EjDqhRF;EiDlhRA;IACE,WAAA;IACA,cAAA;EjDohRF;EiDhhRE;IACE,WAAA;IACA,eAAA;EjDkhRJ;AACF;AkDj7RA,cAAA;AACA;EAEI;IAEE,UAAA;IACA,kBAAA;IACA,eAAA;ElDi7RJ;EkD76RI;IAEE,UAAA;IACA,mBAAA;ElD86RN;EkD16RE;I9C2CF,qBAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IACA,a8C7C0B;I9C8C1B,8B8C9CgC;I9C+ChC,0B8C/CgC;I9CgDhC,sB8ChDgC;I9CiDhC,yB8CjDwC;I9CkDxC,qB8ClDwC;I9CmDxC,iB8CnDwC;ElDq7RxC;EkDl7RE;IAIE,UAAA;IACA,mBAAA;ElDi7RJ;EkD76RA;IACE,0BAAA;IACA,2BAAA;ElD+6RF;AACF;AmDl9RA;EACE,kBAAA;EACA,UAAA;AnDo9RF;;AmDj9RA;EACE,YAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AnDo9RF;;AmDj9RA;EACE,YAAA;EACA,WAAA;AnDo9RF;;AmDj9RA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;AnDo9RF;;AmDj9RA;EACE,yBAAA;EACA,kBAAA;EACA,chD0BY;EgDzBZ,eAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AnDo9RF;;AmDj9RA;EACE,yBAAA;EACA,kBAAA;EACA,chDcY;EgDbZ,eAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AnDo9RF;;AmDj9RA;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;AnDo9RF;;AmDj9RA;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;AnDo9RF;;AmDj9RA;EACE,cAAA;EACA,UAAA;AnDo9RF;;AmDj9RA,4BAAA;AAEA;EACE,kBAAA;AnDm9RF;;AmDh9RA;;EAEE,kBAAA;EACA,kBAAA;AnDm9RF;;AmDh9RA;EACE,iBAAA;AnDm9RF;;AmDh9RA;;EAEE,kBAAA;AnDm9RF;;AmDh9RA;EACE,eAAA;AnDm9RF;;AmDh9RA;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AnDm9RF;;AmDh9RA;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,sB9C7GM;ED2BN,qE+CmFA;E/ClFA,gE+CkFA;E/CjFA,6D+CiFA;AnDq9RF;;AmDl9RA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,c9CnHS;ALwkSX;;AmDl9RA;EACE,UAAA;EACA,UAAA;EACA,eAAA;AnDq9RF;;AmDl9RA;EACE,eAAA;AnDq9RF;;AmDl9RA;EACE,yB9CpIS;E8CqIT,WAAA;AnDq9RF;;AmDl9RA;EACE,aAAA;AnDq9RF;;AmDl9RA;EACE,sB9CjJM;E8CkJN,mBAAA;AnDq9RF;;AmDl9RA;EACE,aAAA;AnDq9RF;;AmDl9RA;EACE,qBhD1GY;AH+jSd;;AmDl9RA;EACE,yBhD9GY;AHmkSd;;AmDl9RA;EACE,qBhDhHU;AHqkSZ;;AmDl9RA;EACE,qBhDpHU;AHykSZ;;AmDl9RA;EACE,qBhD3FK;AHgjSP;;AmDl9RA;EACE,qBhD/FK;AHojSP;;AmDl9RA;EACE,qBhDlGQ;AHujSV;;AmDl9RA;EACE,qBhDtGQ;AH2jSV;;AmDl9RA;EACE,qBhD5GQ;AHikSV;;AmDl9RA;EACE,qBhDhHQ;AHqkSV;;AmDl9RA;EACE,kBAAA;AnDq9RF;;AmDl9RA;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AnDq9RF;;AmDl9RA;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,sB9CxNM;ED2BN,4C+C8LA;E/C7LA,uC+C6LA;E/C5LA,oC+C4LA;AnDu9RF;;AmDp9RA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,yB9ClOS;ED6BT,sCAAA;EACA,kCAAA;EACA,iCAAA;EACA,8BAAA;EATA,sE+C6MA;E/C5MA,iE+C4MA;E/C3MA,8D+C2MA;AnD49RF;;AmDz9RA;EACE,UAAA;EACA,UAAA;EACA,eAAA;AnD49RF;;AmDz9RA;EACE,eAAA;AnD49RF;;AmDz9RA;E/CpNE,sCAAA;EACA,kCAAA;EACA,iCAAA;EACA,8BAAA;AJirSF;;AmD39RA;EACE,aAAA;AnD89RF;;AmD39RA;EACE,mBAAA;AnD89RF;;AmD39RA;EACE,aAAA;AnD89RF;;AmD39RA;EACE,yBhDvNY;AHqrSd;;AmD39RA;EACE,qBhD3NY;AHyrSd;;AmD39RA;EACE,yBhD/NY;AH6rSd;;AmD39RA;EACE,yBhDjOU;AH+rSZ;;AmD39RA;EACE,qBhDrOU;AHmsSZ;;AmD39RA;EACE,yBhDzOU;AHusSZ;;AmD39RA;EACE,yBhDhNK;AH8qSP;;AmD39RA;EACE,qBhDpNK;AHkrSP;;AmD39RA;EACE,yBhDxNK;AHsrSP;;AmD39RA;EACE,yBhD3NQ;AHyrSV;;AmD39RA;EACE,qBhD/NQ;AH6rSV;;AmD39RA;EACE,yBhDnOQ;AHisSV;;AmD39RA;EACE,yBhDzOQ;AHusSV;;AmD39RA;EACE,qBhD7OQ;AH2sSV;;AmD39RA;EACE,yBhDjPQ;AH+sSV;;AmD39RA;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;AnD89RF;;AmD39RA;;;;EAIE,cAAA;AnD89RF;;AmD39RA;EACE,gBAAA;AnD89RF;;AmD39RA;EACE,iBAAA;AnD89RF;;AmD39RA;EACE,gBAAA;AnD89RF;;AmD39RA;EACE,sBAAA;AnD89RF;;AmD39RA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,mBAAA;AnD89RF;;AmD39RA;EACE,mBAAA;EACA,SAAA;EACA,kBAAA;AnD89RF;;AmD39RA;EACE,chD3TmB;EgD4TnB,kBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AnD89RF;;AmD39RA;EACE,yB9CvXS;E8CwXT,kBAAA;EAEA,c9CvXS;E8CwXT,cAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;E/CzWA,4C+C0WA;E/CzWA,uC+CyWA;E/CxWA,oC+CwWA;EACA,WAAA;EACA,UAAA;AnD+9RF;;AmD59RA;EACE,yBhD3VY;EgD4VZ,W9C5YM;AL22SR;;AmD59RA;EACE,yBhD9VU;EgD+VV,W9CjZM;ALg3SR;;AmD59RA;;EAEE,c9ChZS;AL+2SX;;AmD59RA;;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yB9C7ZS;E8C8ZT,UAAA;EACA,OAAA;AnD+9RF;;AmD59RA;EACE,UAAA;EACA,QAAA;AnD+9RF;;AmD59RA;;EAEE,yBhDzXU;AHw1SZ;;AmD59RA;;EAEE,yBhDhYY;AH+1Sd;;AmD59RA;EACE,cAAA;EACA,chDpWO;EgDqWP,gBAAA;EACA,aAAA;AnD+9RF;;AmD59RA;EACE;IACE,kBAAA;EnD+9RF;EmD59RA;IACE,mBAAA;EnD89RF;AACF;AmD39RA;E/CjZE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B+C0XqB;E/CzXrB,mB+CyXqB;EACrB,mBAAA;AnDw+RF;;AmDr+RA;EACE,kBAAA;AnDw+RF;;AmDr+RA;EACE,sBAAA;EACA,gBAAA;AnDw+RF;;AoDl8SA,eAAA;AACA,8BAAA,wBAAA;EACE,eAAA;EACA,+BAAA;ApDq8SF;;AoDl8SA,qBAAA,gBAAA;EACE,eAAA;EACA,+BAAA;ApDq8SF;;AoDl8SA,yBAAA,WAAA;EACE,eAAA;EACA,+BAAA;ApDq8SF;;AoDl8SA,oBAAA,gBAAA;EACE,eAAA;EACA,+BAAA;ApDq8SF;;AoDl8SA,iDAAA,wBAAA;EACE,eAAA;ApDq8SF;;AoDl8SA,wCAAA,gBAAA;EACE,eAAA;ApDq8SF;;AoDl8SA,4CAAA,WAAA;EACE,eAAA;ApDq8SF;;AoDl8SA,uCAAA,gBAAA;EACE,eAAA;ApDq8SF;;AoDj8SA;EACE,sB/C7BM;E+C8BN,kBAAA;ApDo8SF;AoDn8SE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;ApDq8SJ;AoDn8SE;EACE,mBAAA;ApDq8SJ;AoDl8SE;EACE,6BAAA;EACA,cAAA;EACA,0DAAA;EACA,YAAA;EACA,WAAA;ApDo8SJ;AoDj8SE;EACE,gBAAA;ApDm8SJ;AoDl8SI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;ApDo8SN;AoDh8SE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;ApDk8SJ;AoD97SI;EACE,mBAAA;EACA,kBAAA;ApDg8SN;AoD77SI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;ApD+7SN;AoD57SI;EACE,gBAAA;ApD87SN;AoD77SM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;ApD+7SR;;AoDv7SI;EACE,4BAAA;ApD07SN;;AoDr7SA,yEAAA;AACA;;EAEE,wBAAA;EACA,SAAA;ApDw7SF;;AoDr7SA,qDAAA;AACA;EACE,0BAAA;ApDw7SF;;AoDr7SA;EAEI;IACE,YAAA;EpDu7SJ;AACF;AqD/iTA;+EAAA;ACAA,eAAA;AACA,eAAA;AAEA;EACE,yBAAA;EACA,aAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;AtDkjTF;AsDjjTE;EARF;IASI,YAAA;EtDojTF;AACF;;AsDjjTA;EACE,sBAAA;EACA,aAAA;EACA,iCAAA;EACA,4BAAA;EACA,sBAAA;AtDojTF;AsDnjTE;EANF;IAOI,YAAA;EtDsjTF;AACF;;AsDnjTA;EACE,kBAAA;EACA,YAAA;AtDsjTF;;AsDnjTA;EACE,YAAA;EACA,YAAA;EACA,uBAAA;EACA,sBjD1BM;EDsFJ,kBDxDe;EmDFjB,yBAAA;EACA,eAAA;EACA,cAAA;AtDsjTF;;AsDnjTA;EACE,mBAAA;AtDsjTF;;AsDnjTA;EACE,yBAAA;AtDsjTF;AsDpjTE;EACE,gBAAA;EACA,qBnDMU;AHgjTd;;AsDljTA;EACE,6BAAA;AtDqjTF;;AsDljTA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AtDqjTF;AsDnjTE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;AtDqjTJ;;AsDjjTA;ElDhBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EkDmBjE,sBjDrEM;EDRN,mDkD8EA;ElD7EA,gDkD6EA;ElD5EA,8CkD4EA;ElD3EA,2CkD2EA;ElDgBE,mBkDfqB;EACvB,eAAA;EACA,gBAAA;AtDikTF;;AsD9jTA;EACE,uBAAA;EACA,UAAA;EACA,QAAA;AtDikTF;AsD/jTE;EALF;IAMI,WAAA;IACA,QAAA;EtDkkTF;AACF;;AsD/jTA;EACE,mBAAA;AtDkkTF;;AsD/jTA;EACE,yBAAA;AtDkkTF;AsDhkTE;EACE,gBAAA;EACA,qBnDhDU;AHknTd;;AsD9jTA;EACE,6BAAA;AtDikTF;;AsD9jTA;EACE,yBnDzDY;EmD0DZ,uBAAA;EACA,UAAA;EACA,QAAA;AtDikTF;AsD/jTE;EANF;IAOI,WAAA;IACA,QAAA;EtDkkTF;AACF;;AsD/jTA;ElDjEE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BkD0CqB;ElDzCrB,mBkDyCqB;ElD/CrB,sCkDgDyB;ElD/CzB,8BkD+CyB;AtD8kT3B;AsD5kTE;EAEE,SAAA;AtD6kTJ;AsD1kTE;EACE,yBAAA;ElDzCA,kBkD0CuB;EACvB,cnDjFU;AH6pTd;AsD1kTI;EAEE,WjDrIE;EiDsIF,yBnDtFQ;AHiqTd;AsDvkTE;EACE,gBAAA;AtDykTJ;;AuD9tTA,eAAA;AAEA;EACE,eAAA;EACA,kBAAA;AvDguTF;AuD9tTE;EAJF;IAKI,eAAA;EvDiuTF;AACF;;AuD9tTA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AvDiuTF;AuD/tTE;EANF;IAOI,eAAA;EvDkuTF;AACF;AuDhuTE;EAVF;IAWI,UAAA;EvDmuTF;AACF;;AuDhuTA;EACE,clDRS;EkDST,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kDAAA;AvDmuTF;AuDjuTE;EARF;IASI,gBAAA;EvDouTF;AACF;AuDluTE;EAZF;IAaI,gBAAA;EvDquTF;AACF;AuDnuTE;EAhBF;IAiBI,eAAA;EvDsuTF;AACF;;AuDnuTA;EACE,mBpD4GQ;AH0nTV;AuDpuTE;EAHF;IAII,mBAAA;EvDuuTF;AACF;;AwD3xTA,gBAAA;AACA;EpD4DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJ8uTnE;;AwDryTA;EACE,kBAAA;AxDwyTF;;AyD9yTA,sBAAA;AAEA;EACE,aAAA;AzDgzTF;;AyD5yTE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;ErDmDF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BqD1EuB;ErD2EvB,mBqD3EuB;EACrB,8BAAA;EACA,uBAAA;EACA,sBAAA;AzD0zTJ;AyDxzTI;ErD0DF,mBAAA;EACA,eAAA;EACA,WAAA;EqD1DI,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,qBAAA;AzD4zTN;AyD1zTM;EACE,cAAA;AzD4zTR;AyDzzTM;EACE,WAAA;EACA,eAAA;EACA,iBAAA;AzD2zTR;AyDxzTM;EACE,gBAAA;AzD0zTR;AyDzzTQ;EACE,gBAAA;EACA,cAAA;AzD2zTV;AyDxzTQ;EACE,yBAAA;EACA,WpDjCF;EDsFJ,kBqDpD6B;EACvB,iBAAA;EACA,kBAAA;AzD0zTV;AyDzzTU;EACE,eAAA;AzD2zTZ;AyDvzTQ;EACE,yBAAA;AzDyzTV;AyDtzTQ;EACE,yBAAA;AzDwzTV;AyDrzTQ;EACE,yBAAA;AzDuzTV;AyDlzTI;EACE,cAAA;EACA,gBAAA;AzDozTN;AyDnzTM;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;AzDqzTR;AyDnzTQ;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AzDqzTV;;AyD7yTA;EACE;IACE,aAAA;EzDgzTF;EyD5yTE;IACE,cAAA;IACA,gBAAA;EzD8yTJ;EyD7yTI;IACE,iBAAA;IACA,oBAAA;IACA,gCAAA;IACA,mBAAA;EzD+yTN;EyD7yTM;IACE,cAAA;IACA,gBAAA;IACA,iBAAA;EzD+yTR;EyDzyTA;IACE,oBAAA;IACA,kBAAA;EzD2yTF;EyD1yTE;IACE,eAAA;EzD4yTJ;EyD1yTE;IACE,eAAA;EzD4yTJ;AACF;A0Dl6TA,mBAAA;AAGE;EACE,mBAAA;A1Dk6TJ;A0Dj6TI;EACE,WAAA;EtD+BJ,mCsD9BI;EtD+BJ,8BsD/BI;EtDgCJ,2BsDhCI;A1Dq6TN;A0Dl6TM;EACE,8BAAA;EACA,0BAAA;EACA,sBAAA;A1Do6TR;;A0D75TE;EACE,eAAA;EACA,oBAAA;A1Dg6TJ;A0D/5TI;EACE,qBAAA;EACA,mBAAA;EACA,eAAA;A1Di6TN;A0D95TI;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;A1Dg6TN;A0D75TI;EAGE,eAAA;EACA,yBvDgBQ;EuDfR,qBvDeQ;EuDdR,WrDlCE;AL+7TR;A0D15TI;EA3BF;IA4BI,mBAAA;E1D65TJ;AACF;;A2D98TA,cAAA;AAEA;EACE,mBAAA;A3Dg9TF;;A2D58TA;EACE,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;A3D+8TF;A2D78TE;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;A3D+8TJ;A2D78TI;EACE,gBAAA;A3D+8TN;;A2Dz8TA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EvDiEE,kBuDhEqB;EACvB,mBAAA;EACA,WtDxBM;ALo+TR;A2D18TE;EACE,gBAAA;EAEE,0CAAA;EACA,eAAA;EAEF,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,2BAAA;A3D08TJ;A2Dv8TE;EvD+CE,0BuD9CuB;A3Dy8T3B;A2Dx8TI;EACE,0BAAA;A3D08TN;;A2Dp8TA;EACE,gBAAA;A3Du8TF;A2Dt8TE;EACE,mBAAA;A3Dw8TJ;A2Dv8TI;EACE,gBAAA;A3Dy8TN;A2Dt8TE;EACE,cxDTU;AHi9Td;A2Dt8TE;EACE,cAAA;A3Dw8TJ;;A2Dn8TE;EACE,mBAAA;A3Ds8TJ;A2Dr8TI;EACE,gBAAA;A3Du8TN;;A2Dl8TA;EACE,cAAA;EACA,mBAAA;A3Dq8TF;A2Dp8TE;EvDUE,kBuDTuB;EACvB,WAAA;A3Ds8TJ;;A2Dj8TE;EACE,gBAAA;EACA,kBAAA;A3Do8TJ;;A2Dh8TA;EACE,mBAAA;A3Dm8TF;;A2Dh8TA;;EAEE,eAAA;EACA,ctD3FS;EsD4FT,qBAAA;A3Dm8TF;A2Dl8TE;;EACE,qBAAA;EACA,iBAAA;A3Dq8TJ;;A2Dh8TE;EACE,iBAAA;A3Dm8TJ;;A4DvjUA,mBAAA;AACA;EACE,kBAAA;A5D0jUF;A4DxjUE;;EAEE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBvDqPc;ALq0TlB;A4DzjUI;;EACE,eAAA;EACA,gBAAA;A5D4jUN;A4D1jUI;;EACE,eAAA;EACA,iBAAA;A5D6jUN;A4DzjUE;EACE,yCAAA;A5D2jUJ;A4DxjUE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;A5D0jUJ;A4DxjUI;EACE,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBvD7BE;EuD8BF,qCAAA;EACA,eAAA;EACA,cvD1BK;EuD2BL,kBAAA;A5D0jUN;A4DzjUM;EACE,iBAAA;EACA,eAAA;A5D2jUR;;A4DrjUA;EACE,mBAAA;A5DwjUF;A4DtjUE;EACE,kBAAA;EACA,cAAA;A5DwjUJ;A4DrjUE;EACE,mBAAA;A5DujUJ;;A4DjjUE;;EAEE,eAAA;A5DojUJ;;A4D/iUE;EACE,oCAAA;A5DkjUJ;A4DhjUE;EACE,iBAAA;EACA,oBAAA;A5DkjUJ;;A4D9iUA;EACE,gBAAA;EACA,gBAAA;EACA,8BAAA;A5DijUF;A4DhjUE;EACE,eAAA;A5DkjUJ;;A4D9iUA;EACE,gBAAA;A5DijUF;A4DhjUE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;A5DkjUJ;A4DhjUI;EANF;IAOI,UAAA;E5DmjUJ;AACF;A4DjjUI;EAVF;IAWI,cAAA;E5DojUJ;AACF;;A4D/iUE;EACE,oBAAA;A5DkjUJ;;A4D9iUA,6BAAA;AACA;EACE,eAAA;A5DijUF;A4D/iUE;EAHF;IAII,eAAA;E5DkjUF;AACF;;A4D/iUA;EACE,eAAA;A5DkjUF;A4DhjUE;EAHF;IAII,eAAA;E5DmjUF;AACF;;A4D/iUE;EACE,QAAA;EACA,kBAAA;A5DkjUJ;A4DhjUI;EAJF;IAKI,QAAA;E5DmjUJ;AACF;A4DhjUE;EACE,QAAA;A5DkjUJ;A4DhjUI;EAHF;IAII,QAAA;E5DmjUJ;AACF;;A4D/iUA;EACE,kBAAA;EACA,mBAAA;EACA,gCAAA;A5DkjUF;A4DhjUE;EACE;;IAEE,0BAAA;E5DkjUJ;AACF;;A4D7iUE;EACE,eAAA;EACA,kBAAA;A5DgjUJ;;A4D5iUA;EACE,WAAA;A5D+iUF;;A4D3iUE;EACE,kBAAA;A5D8iUJ;;A4D1iUA,4BAAA;AACA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;ExD/HA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BwDwGqB;ExDvGrB,mBwDuGqB;A5DwjUvB;A4DtjUE;EACE,SAAA;EACA,WzDtCM;EyDuCN,YzDvCM;EyDwCN,WvD1LI;EuD2LJ,eAAA;ExDrGA,kBDtDmB;ECmBrB,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,awDsIwB;ExDrIxB,8BwDqI8B;ExDpI9B,0BwDoI8B;ExDnI9B,sBwDmI8B;ExDlI9B,yBwDkIsC;ExDjItC,qBwDiIsC;ExDhItC,iBwDgIsC;ExDtHtC,+BwDuH2B;ExDtH3B,uBwDsH2B;ExDlH3B,2BwDmHuB;ExDlHvB,mBwDkHuB;ExDpKvB,kCwDqKE;ExDpKF,6BwDoKE;ExDnKF,0BwDmKE;EACA,kBAAA;EACA,UAAA;A5DskUJ;A4DnkUE;EACE,WAAA;EACA,YAAA;EACA,eAAA;ExDlHA,gBwDmHuB;EACvB,kBAAA;EACA,OAAA;A5DqkUJ;;A4DjkUA;ExD5JE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BwDqIqB;ExDpIrB,mBwDoIqB;EACrB,iBzD5DS;EyD6DT,kBAAA;EACA,gBAAA;A5D+kUF;A4D7kUE;EACE,8BAAA;EACA,gBAAA;A5D+kUJ;A4D5kUE;EACE,oBAAA;A5D8kUJ;A4D3kUE;EACE,yBAAA;A5D6kUJ;;A4DzkUA;EACE,eAAA;A5D4kUF;;A4DzkUA;EACE,iBzDnFS;AH+pUX;;A4DzkUA;ExDzLE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2BwDkKqB;ExDjKrB,mBwDiKqB;EACrB,mBAAA;A5DulUF;;A4DplUA;EACE,uBAAA;EACA,wBAAA;A5DulUF;;A4DllUI;EACE,kBAAA;A5DqlUN;;A4DhlUA;EACE,kBAAA;A5DmlUF;A4DjlUE;EACE,8BAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;A5DmlUJ;;A4D9kUA;EACE,kBAAA;EACA,kBAAA;A5DilUF;A4D/kUE;EACE,8BAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;A5DilUJ;;A4D7kUA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;ExD7ME,kBwD8MqB;EACvB,YAAA;EACA,WAAA;EACA,yBvDlSS;ALk3UX;;A4D7kUA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;ExDvNE,kBDtDmB;AH81UvB;;A4D7kUA;EACE,cAAA;A5DglUF;A4D9kUE;EACE,mBAAA;A5DglUJ;A4D7kUE;EACE,eAAA;EACA,kBAAA;A5D+kUJ;A4D5kUE;EACE,cAAA;EACA,kBAAA;EACA,czD3OS;AHyzUb;A4D5kUI;EAEE,czDpRQ;EyDqRR,qBAAA;A5D6kUN;;A4DvkUE;EACE,kBAAA;A5D0kUJ;A4DxkUE;EACE,yBvD7UO;EuD8UP,gBAAA;EACA,iBAAA;EACA,cvD5UO;EuD6UP,eAAA;EACA,yBzD7QQ;AHu1UZ;A4DxkUI;EACE,yBzDvSQ;EyDwSR,WvDxVE;EuDyVF,qBzDzSQ;AHm3Ud;A4DxkUM;EAEE,WvD7VA;ALs6UR;A4DpkUE;ExDjPE,2BDpFY;ECqFZ,8BDrFY;AH64UhB;A4DpkUE;ExDnQE,4BDtEY;ECuEZ,+BDvEY;AHi5UhB;;A4DnkUA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,0DAAA;A5DskUF;A4DpkUE;EACE,mBAAA;A5DskUJ;A4DrkUI;EAFF;IAGI,mBAAA;E5DwkUJ;AACF;A4DrkUE;EACE,WAAA;EACA,YAAA;A5DukUJ;A4DpkUE;EACE,qBAAA;A5DskUJ;A4DpkUI;EACE,cAAA;A5DskUN;A4DpkUM;EAHF;IAII,cAAA;E5DukUN;AACF;A4DrkUM;EAPF;IAQI,aAAA;E5DwkUN;AACF;A4DtkUM;EAXF;IAYI,cAAA;E5DykUN;AACF;;A4DlkUE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;A5DqkUJ;A4DnkUI;EAEE,cAAA;A5DokUN;;A6Dz+UA,kBAAA;AACA;EACE,kBAAA;A7D4+UF;;A6Dz+UA;EACE,mBAAA;A7D4+UF;A6D1+UE;EACE,cAAA;EACA,aAAA;EzDmDF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,ayDtDwB;EzDuDxB,8ByDvD8B;EzDwD9B,0ByDxD8B;EzDyD9B,sByDzD8B;EzD0D9B,yByD1DsC;EzD2DtC,qByD3DsC;EzD4DtC,iByD5DsC;EzDsEtC,+ByDrE2B;EzDsE3B,uByDtE2B;A7Du/U7B;A6Dr/UI;EACE,gBAAA;A7Du/UN;A6Dn/UE;EACE,gBAAA;A7Dq/UJ;;A6Dj/UA;EACE,gBAAA;EACA,eAAA;A7Do/UF;A6Dl/UE;EACE,kBAAA;A7Do/UJ;;A6D/+UE;EACE,kBAAA;A7Dk/UJ;A6D/+UE;EACE,gBAAA;EACA,cAAA;A7Di/UJ;;A8DzhVA;+EAAA;AAEA;EAEE,yBAAA;EACA,sBzDKM;EDsFJ,kBDxDe;E2DjCjB,mBAAA;EACA,mBAAA;A9D2hVF;A8DzhVE;EAEE,kBAAA;A9D0hVJ;A8DxhVI;EACE,WAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;A9D0hVN;A8DvhVI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;A9DyhVN;A8DrhVE;E1DMA,6C0DLE;E1DMF,wC0DNE;E1DOF,qC0DPE;EACA,6CAAA;A9DyhVJ;A8DthVE;EAlCF;IAmCI,mBAAA;E9DyhVF;AACF;;A8DrhVE;EACE,qBAAA;EACA,WAAA;A9DwhVJ;;A8DnhVE;EACE,eAAA;A9DshVJ;;A+DxkVA;+EAAA;ACAA,qBAAA;AAEA;E5D2DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4D9DsB;E5D+DtB,8B4D/D4B;E5DgE5B,0B4DhE4B;E5DiE5B,sB4DjE4B;E5DkE5B,yB4DlEoC;E5DmEpC,qB4DnEoC;E5DoEpC,iB4DpEoC;E5DmFpC,4B4DlFqB;E5DmFrB,oB4DnFqB;EACrB,YAAA;AhEulVF;;AgEplVA;EACE,kBAAA;E5DoDA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DvDsB;E5DwDtB,2B4DxD4B;E5DyD5B,uB4DzD4B;E5D0D5B,mB4D1D4B;E5D2D5B,yB4D3DiC;E5D4DjC,qB4D5DiC;E5D6DjC,iB4D7DiC;EACjC,2BAAA;AhEimVF;AgE/lVE;EALF;IAMI,aAAA;EhEkmVF;AACF;;AgE/lVA;EACE,kBAAA;EACA,UAAA;E5DyCA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4D5CsB;E5D6CtB,8B4D7C4B;E5D8C5B,0B4D9C4B;E5D+C5B,sB4D/C4B;E5DgD5B,yB4DhDoC;E5DiDpC,qB4DjDoC;E5DkDpC,iB4DlDoC;E5DsDpC,uBAAA;EACA,mBAAA;EACA,eAAA;E4DtDA,gBAAA;EACA,gBAAA;AhE8mVF;;AgE3mVA;EACE,gCAAA;E5DiCA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DpCsB;E5DqCtB,8B4DrC4B;E5DsC5B,0B4DtC4B;E5DuC5B,sB4DvC4B;E5DwC5B,yB4DxCoC;E5DyCpC,qB4DzCoC;E5D0CpC,iB4D1CoC;AhEwnVtC;AgEtnVE;EACE,kBAAA;EACA,kBAAA;AhEwnVJ;;AgEpnVA;EACE,aAAA;E5DuBA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B4D9CqB;E5D+CrB,mB4D/CqB;E5DyCrB,+B4DxCyB;E5DyCzB,uB4DzCyB;EACzB,gBAAA;EACA,eAAA;EACA,kDAAA;EACA,8CAAA;AhEmoVF;AgEloVE;EACE,eAAA;AhEooVJ;;AgEhoVA;E5DUE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DbsB;E5DctB,8B4Dd4B;E5De5B,0B4Df4B;E5DgB5B,sB4DhB4B;E5DiB5B,yB4DjBoC;E5DkBpC,qB4DlBoC;E5DmBpC,iB4DnBoC;AhE6oVtC;;AgE1oVA;EACE,eAAA;AhE6oVF;;AgEtoVA;E5DFE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;E4DKjE,aAAA;AhEmpVF;;AgEhpVA;EACE,gBAAA;EACA,eAAA;E5DTA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DMsB;E5DLtB,8B4DK4B;E5DJ5B,0B4DI4B;E5DH5B,sB4DG4B;E5DF5B,yB4DEoC;E5DDpC,qB4DCoC;E5DApC,iBAAA;EAUA,+B4DTyB;E5DUzB,uB4DVyB;AhE8pV3B;AgE5pVE;E5DbA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DUwB;E5DTxB,8B4DS8B;E5DR9B,0B4DQ8B;E5DP9B,sB4DO8B;E5DN9B,yB4DMsC;E5DLtC,qB4DKsC;E5DJtC,iB4DIsC;AhEwqVxC;AgErqVE;EACE,kBAAA;EACA,cAAA;E5DnBF,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B4DJuB;E5DKvB,mB4DLuB;EACrB,qBAAA;AhEkrVJ;AgEhrVI;EAEE,c7DQO;AHyqVb;AgE9qVI;EACE,c7DjCQ;AHitVd;AgE5qVE;EACE,kBAAA;EACA,eAAA;AhE8qVJ;AgE3qVE;EACE,qBAAA;EACA,sBAAA;AhE6qVJ;AgE1qVE;EACE,kBAAA;AhE4qVJ;;AgExqVA;EACE,kBAAA;EACA,UAAA;E5DnDA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DgDsB;E5D/CtB,8B4D+C4B;E5D9C5B,0B4D8C4B;E5D7C5B,sB4D6C4B;E5D5C5B,yB4D4CoC;E5D3CpC,qB4D2CoC;E5D1CpC,iB4D0CoC;E5DtCpC,sBAAA;EACA,kBAAA;EACA,cAAA;E4DsCA,6BAAA;AhEurVF;;AgEprVA;EACE,kBAAA;EACA,gBAAA;E5D3DA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DwDsB;E5DvDtB,8B4DuD4B;E5DtD5B,0B4DsD4B;E5DrD5B,sB4DqD4B;E5DpD5B,yB4DoDoC;E5DnDpC,qB4DmDoC;E5DlDpC,iB4DkDoC;E5DxCpC,+B4DyCyB;E5DxCzB,uB4DwCyB;EACzB,sB3DjHM;E2DkHN,gCAAA;AhEksVF;AgEhsVE;EACE,gBAAA;AhEksVJ;AgEhsVI;E5DjCA,gB4DkCyB;EACvB,YAAA;EACA,4BAAA;AhEksVN;AgEhsVM;EACE,yB3D5HG;AL8zVX;AgE9rVI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,MAAA;EACA,UAAA;AhEgsVN;;AgE3rVA;E5DzFE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B4DkEqB;E5DjErB,mB4DiEqB;E5DvErB,sC4DwEyB;E5DvEzB,8B4DuEyB;AhE0sV3B;;AgEvsVA;EACE,sB3DnJM;EDmDN,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4D6FsB;E5D5FtB,8B4D4F4B;E5D3F5B,0B4D2F4B;E5D1F5B,sB4D0F4B;E5DzF5B,yB4DyFoC;E5DxFpC,qB4DwFoC;E5DvFpC,iB4DuFoC;AhEotVtC;;AgEjtVA;EACE,iBAAA;E5DrGA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;E4DwGjE,gCAAA;AhE8tVF;AgE5tVE;E5DtEE,gB4DuEuB;AhE8tV3B;;AgE1tVA;EACE,kBAAA;AhE6tVF;AgE3tVE;EAHF;IAII,kBAAA;EhE8tVF;AACF;;AgE3tVA;E5DtHE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B4D+FqB;E5D9FrB,mB4D8FqB;EACrB,mBAAA;AhEyuVF;;AgEtuVA;EACE,kBAAA;AhEyuVF;;AgEtuVA;EACE,8BAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;AhEyuVF;;AgEtuVA;EACE,iBAAA;AhEyuVF;;AgEtuVA;E5D3IE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DwIsB;E5DvItB,8B4DuI4B;E5DtI5B,0B4DsI4B;E5DrI5B,sB4DqI4B;E5DpI5B,yB4DoIoC;E5DnIpC,qB4DmIoC;E5DlIpC,iB4DkIoC;E5DxHpC,+B4DyHyB;E5DxHzB,uB4DwHyB;AhEovV3B;;AgEjvVA;E5DhJE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B4DyHqB;E5DxHrB,mB4DwHqB;EACrB,kBAAA;EACA,gCAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AhE+vVF;AgE7vVE;EACE,cAAA;EACA,gBAAA;AhE+vVJ;AgE5vVE;EACE,kBAAA;E5DtIF,0B4DuIuB;E5DtIvB,kB4DsIuB;AhE+vVzB;;AgE3vVA;EACE,mBAAA;AhE8vVF;AgE5vVE;EACE,kBAAA;AhE8vVJ;;AgE1vVA;E5D9JE,mBAAA;EACA,eAAA;EACA,WAAA;EAhBA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4D0KsB;E5DzKtB,8B4DyK4B;E5DxK5B,0B4DwK4B;E5DvK5B,sB4DuK4B;E5DtK5B,yB4DsKoC;E5DrKpC,qB4DqKoC;E5DpKpC,iB4DoKoC;EACpC,6BAAA;AhEywVF;;AgEtwVA;EACE,kBAAA;AhEywVF;AgEvwVE;EACE,kBAAA;AhEywVJ;;AgErwVA;EACE,iBAAA;AhEwwVF;;AgErwVA;EACE,sB3DlPM;E2DmPN,+BAAA;EACA,kBAAA;EACA,UAAA;AhEwwVF;AgEtwVE;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;AhEwwVJ;;AgEpwVA;EACE,gBAAA;AhEuwVF;AgErwVE;EACE,aAAA;AhEuwVJ;;AgEnwVA;EACE,kBAAA;AhEswVF;;AgEnwVA;EACE,eAAA;AhEswVF;;AgEnwVA;EACE,kBAAA;AhEswVF;;AgEnwVA;E5D/NE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EAqBjE,sC4D6MyB;E5D5MzB,8B4D4MyB;E5DxMzB,2B4DyMqB;E5DxMrB,mB4DwMqB;EACrB,WAAA;EACA,eAAA;AhEkxVF;;AgE/wVA;E5DvOE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a4DoOsB;E5DnOtB,8B4DmO4B;E5DlO5B,0B4DkO4B;E5DjO5B,sB4DiO4B;E5DhO5B,yB4DgOoC;E5D/NpC,qB4D+NoC;E5D9NpC,iB4D8NoC;E5DpNpC,+B4DqNyB;E5DpNzB,uB4DoNyB;E5DhNzB,2B4DiNqB;E5DhNrB,mB4DgNqB;AhE8xVvB;;AgEtxVA;E5DzNE,2B4D0NqB;E5DzNrB,mB4DyNqB;AhE0xVvB;;AgEvxVA;EACE;I5DvPA,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,iBAAA;IACA,c4DoPwB;I5DnPxB,2B4DmP+B;I5DlP/B,uB4DkP+B;I5DjP/B,mB4DiP+B;I5DhP/B,yB4DgPoC;I5D/OpC,qB4D+OoC;I5D9OpC,iB4D8OoC;I5D1OpC,sBAAA;IACA,kBAAA;IACA,cAAA;I4D0OE,gB7D/La;I6DgMb,gB7DhMa;I6DiMb,sB3D/SI;ELqlWN;EgEnyVA;IACE,kBAAA;IACA,gBAAA;IACA,0BAAA;EhEqyVF;EgEnyVE;IACE,kBAAA;IACA,OAAA;IACA,MAAA;IACA,UAAA;IACA,+BAAA;IACA,YAAA;IACA,WAAA;I5DxOF,gB4DyOyB;IACvB,eAAA;EhEqyVJ;EgElyVE;IACE,YAAA;IACA,0BAAA;EhEoyVJ;EgEjyVE;IACE,YAAA;EhEmyVJ;EgE/xVA;IACE,2BAAA;EhEiyVF;EgE9xVA;IACE,eAAA;EhEgyVF;AACF;AgE7xVA;EACE;IACE,gBAAA;EhE+xVF;AACF;AgE5xVA;EACE;IACE,cAAA;EhE8xVF;AACF;AgE3xVA;EACE;IACE,cAAA;IACA,eAAA;EhE6xVF;EgE3xVE;IACE,gBAAA;EhE6xVJ;AACF;AgEzxVA;EACE;IACE,kBAAA;EhE2xVF;EgExxVA;IACE,eAAA;EhE0xVF;EgEtxVE;IACE,sBAAA;IACA,kBAAA;EhEwxVJ;EgErxVE;IACE,gBAAA;EhEuxVJ;EgErxVI;I5DzSF,sB4D0S2B;EhEuxV7B;EgElxVI;IACE,WAAA;IACA,SAAA;EhEoxVN;EgEjxVI;IACE,WAAA;IACA,SAAA;EhEmxVN;EgE/wVE;IACE,kBAAA;EhEixVJ;AACF;AgE7wVA;EAEI;IACE,gBAAA;EhE8wVJ;AACF;AgE1wVA;EACE;IACE,wBAAA;EhE4wVF;AACF;AiEvrWA,qBAAA;AAEA;E7DyEE,sBAAA;EACA,kBAAA;EACA,cAAA;AJgnWF;AiExrWE;EACE,WAAA;AjE0rWJ;;AiEtrWA;E7DmDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DtDsB;E7DuDtB,2B6DvD4B;E7DwD5B,uB6DxD4B;E7DyD5B,mB6DzD4B;E7D0D5B,yB6D1DiC;E7D2DjC,qB6D3DiC;E7D4DjC,iB6D5DiC;E7DgEjC,sBAAA;EACA,kBAAA;EACA,cAAA;E6DhEA,yB5DFS;E4DGT,kBAAA;EACA,WAAA;AjEqsWF;;AiElsWA;E7D2CE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6D9CsB;E7D+CtB,8B6D/C4B;E7DgD5B,0B6DhD4B;E7DiD5B,sB6DjD4B;E7DkD5B,yB6DlDoC;E7DmDpC,qB6DnDoC;E7DoDpC,iB6DpDoC;E7DwDpC,uBAAA;EACA,mBAAA;EACA,eAAA;E6DxDA,gBAAA;EACA,+BAAA;AjEitWF;;AiE9sWA;E7DoCE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DvCsB;E7DwCtB,8B6DxC4B;E7DyC5B,0B6DzC4B;E7D0C5B,sB6D1C4B;E7D2C5B,yB6D3CoC;E7D4CpC,qB6D5CoC;E7D6CpC,iB6D7CoC;E7DiDpC,sBAAA;EACA,kBAAA;EACA,cAAA;E6DjDA,eAAA;EACA,kBAAA;EACA,UAAA;AjE6tWF;;AiE1tWA;E7D4BE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6D/BsB;E7DgCtB,8B6DhC4B;E7DiC5B,0B6DjC4B;E7DkC5B,sB6DlC4B;E7DmC5B,yB6DnCoC;E7DoCpC,qB6DpCoC;E7DqCpC,iB6DrCoC;EACpC,uBAAA;EACA,kDAAA;AjEuuWF;;AiEpuWA;E7DsBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;E6DnBjE,mBAAA;AjEivWF;;AiE9uWA;E7DiBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DpBsB;E7DqBtB,8B6DrB4B;E7DsB5B,0B6DtB4B;E7DuB5B,sB6DvB4B;E7DwB5B,yB6DxBoC;E7DyBpC,qB6DzBoC;E7D0BpC,iB6D1BoC;EACpC,gBAAA;AjE2vWF;AiEzvWE;E7D2BA,sBAAA;EACA,kBAAA;EACA,cAAA;AJiuWF;AiE3vWI;E7DjDF,wB6DkDI;E7DjDJ,qB6DiDI;E7DhDJ,mB6DgDI;E7D/CJ,gB6D+CI;E7D4CF,gB6D3CyB;EACvB,kBAAA;EACA,YAAA;AjEgwWN;AiE7vWI;EACE,UAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;AjE+vWN;;AiE1vWA;EACE,e9DwFQ;AHqqWV;AiE3vWE;EACE,cAAA;EACA,eAAA;AjE6vWJ;AiE1vWE;EACE,eAAA;AjE4vWJ;;AiExvWA;EACE,kBAAA;EACA,e9D0EQ;AHirWV;AiEzvWE;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AjE2vWJ;AiEzvWI;EACE,UAAA;EACA,WAAA;AjE2vWN;AiExvWI;EACE,yBAAA;AjE0vWN;AiEtvWI;EACE,sB5D/FE;E4DgGF,yBAAA;AjEwvWN;AiEpvWI;EACE,yBAAA;AjEsvWN;AiEjvWE;EACE,e9DwCM;AH2sWV;;AiE/uWA;EACE,sB5DhHM;ALk2WR;;AiE/uWA;EACE,kBAAA;EACA,e9D3Ge;E8D4Gf,c9DvCK;EC5BL,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DgEsB;E7D/DtB,8B6D+D4B;E7D9D5B,0B6D8D4B;E7D7D5B,sB6D6D4B;E7D5D5B,yB6D4DoC;E7D3DpC,qB6D2DoC;E7D1DpC,iB6D0DoC;E7DhDpC,+B6DiDyB;E7DhDzB,uB6DgDyB;AjE6vW3B;;AiE1vWA;EACE,6DAAA;AjE6vWF;;AiE1vWA;E7D5EE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DyEsB;E7DxEtB,8B6DwE4B;E7DvE5B,0B6DuE4B;E7DtE5B,sB6DsE4B;E7DrE5B,yB6DqEoC;E7DpEpC,qB6DoEoC;E7DnEpC,iB6DmEoC;AjEuwWtC;AiErwWE;E7D3DA,+B6D4D2B;E7D3D3B,uB6D2D2B;E7DvD3B,2B6DwDuB;E7DvDvB,mB6DuDuB;AjEywWzB;AiEvwWI;EACE,iBAAA;AjEywWN;;AiEpwWA;EACE,gCAAA;EACA,aAAA;E7D3FA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DwFsB;E7DvFtB,8B6DuF4B;E7DtF5B,0B6DsF4B;E7DrF5B,sB6DqF4B;E7DpF5B,yB6DoFoC;E7DnFpC,qB6DmFoC;E7DlFpC,iB6DkFoC;E7DxEpC,+B6DyEyB;E7DxEzB,uB6DwEyB;EACzB,eAAA;EACA,gBAAA;AjEkxWF;AiEhxWE;EAEE,qEAAA;AjEixWJ;;AiE7wWA;EACE,cAAA;E7D/EA,2B6DgFqB;E7D/ErB,mB6D+EqB;AjEixWvB;;AiE9wWA;EACE,cAAA;AjEixWF;AiE/wWE;EACE,gBAAA;AjEixWJ;AiE9wWE;EACE,cAAA;EACA,kBAAA;AjEgxWJ;;AiE5wWA;EACE,c5DvKS;E4DwKT,eAAA;AjE+wWF;;AiE5wWA;EACE,cAAA;EACA,iBAAA;AjE+wWF;;AiExwWA;E7DvIE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DoIsB;E7DnItB,8B6DmI4B;E7DlI5B,0B6DkI4B;E7DjI5B,sB6DiI4B;E7DhI5B,yB6DgIoC;E7D/HpC,qB6D+HoC;E7D9HpC,iB6D8HoC;E7DpHpC,+B6DqHyB;E7DpHzB,uB6DoHyB;EACzB,YAAA;AjEsxWF;;AiEnxWA;E7D7IE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6D0IsB;E7DzItB,8B6DyI4B;E7DxI5B,0B6DwI4B;E7DvI5B,sB6DuI4B;E7DtI5B,yB6DsIoC;E7DrIpC,qB6DqIoC;E7DpIpC,iB6DoIoC;E7D1HpC,+B6D2HyB;E7D1HzB,uB6D0HyB;E7DtHzB,2B6DuHqB;E7DtHrB,mB6DsHqB;EACrB,YAAA;EACA,aAAA;AjEkyWF;;AiE/xWA;EACE,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,6BAAA;EACA,mBAAA;AjEkyWF;;AiE/xWA;E7D7JE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6D0JsB;E7DzJtB,8B6DyJ4B;E7DxJ5B,0B6DwJ4B;E7DvJ5B,sB6DuJ4B;E7DtJ5B,yB6DsJoC;E7DrJpC,qB6DqJoC;E7DpJpC,iB6DoJoC;AjE4yWtC;;AiEzyWA;E7DjKE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B6D0IqB;E7DzIrB,mB6DyIqB;EACrB,gCAAA;EACA,aAAA;EACA,sB5DzNM;E4D0NN,WAAA;AjEuzWF;;AiEpzWA;E7D1KE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B6DmJqB;E7DlJrB,mB6DkJqB;EACrB,kBAAA;AjEk0WF;;AiE/zWA;EACE,eAAA;EACA,gBAAA;AjEk0WF;;AiE/zWA;E7DrLE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a6DkLsB;E7DjLtB,8B6DiL4B;E7DhL5B,0B6DgL4B;E7D/K5B,sB6D+K4B;E7D9K5B,yB6D8KoC;E7D7KpC,qB6D6KoC;E7D5KpC,iB6D4KoC;EACpC,6BAAA;EACA,aAAA;EACA,sB5D5OM;E4D6ON,WAAA;AjE40WF;AiE10WE;EACE,gBAAA;AjE40WJ;;AiEx0WA;EACE,iBAAA;AjE20WF;;AiEx0WA;EACE,aAAA;AjE20WF;AiEz0WE;EACE,iBAAA;EACA,sB5D7PI;EDsFJ,iC6DwKuB;EACvB,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AjE20WJ;AiEv0WI;EACE,kBAAA;EACA,cAAA;EACA,qEAAA;E7DnLF,+B6DoLyB;AjEy0W7B;;AiEp0WA;EACE,0BAAA;EACA,qBAAA;AjEu0WF;;AiEp0WA;EACE,YAAA;E7D7RA,wB6D8RA;E7D7RA,qB6D6RA;E7D5RA,mB6D4RA;E7D3RA,gB6D2RA;E7DhME,gB6DiMqB;AjE00WzB;;AiEv0WA;EACE,eAAA;EACA,c5DvRS;ALimXX;;AiEv0WA;EACE;IACE,2BAAA;IACA,uBAAA;IACA,wBAAA;IACA,6BAAA;EjE00WF;AACF;AiEv0WA;EACE;IACE,yBAAA;IACA,cAAA;EjEy0WF;EiEt0WA;IACE,iBAAA;EjEw0WF;EiEt0WE;IACE,uBAAA;IACA,sBAAA;IACA,iBAAA;EjEw0WJ;EiEr0WE;IACE,gBAAA;EjEu0WJ;EiEl0WE;IACE,eAAA;EjEo0WJ;EiEh0WA;;IAEE,eAAA;EjEk0WF;EiE/zWA;IACE,iBAAA;EjEi0WF;EiE9zWA;IACE,2BAAA;IACA,uBAAA;IACA,wBAAA;IACA,6BAAA;EjEg0WF;AACF;AiE7zWA;EACE;IACE,2BAAA;IACA,uBAAA;IACA,wBAAA;IACA,6BAAA;IACA,mBAAA;EjE+zWF;AACF;AiE5zWA;EACE;;IAEE,eAAA;EjE8zWF;EiE3zWA;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;EjE6zWF;AACF;AiE1zWA;EAEI;IACE,eAAA;EjE2zWJ;EiExzWA;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;EjE0zWF;AACF;AkE1rXA,sBAAA;AAEA;E9D2DE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;E8DxDjE,WAAA;AlEqsXF;;AkElsXA;E9DsDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a8DzDsB;E9D0DtB,8B8D1D4B;E9D2D5B,0B8D3D4B;E9D4D5B,sB8D5D4B;E9D6D5B,yB8D7DoC;E9D8DpC,qB8D9DoC;E9D+DpC,iB8D/DoC;EACpC,WAAA;AlE+sXF;;AkE5sXA;E9DiDE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B8DxEqB;E9DyErB,mB8DzEqB;AlE0tXvB;AkExtXE;EACE,kBAAA;AlE0tXJ;AkEvtXE;EAEE,iBAAA;AlEwtXJ;AkErtXE;EACE,gBAAA;AlEutXJ;;AkEntXA;E9D+BE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJmsXnE;;AkE7tXA;EACE,wBAAA;AlEguXF;;AkE7tXA;E9DuBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B8D9CqB;E9D+CrB,mB8D/CqB;AlE2uXvB;;AkExuXA;E9DkBE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a8DrBsB;E9DsBtB,8B8DtB4B;E9DuB5B,0B8DvB4B;E9DwB5B,sB8DxB4B;E9DyB5B,yB8DzBoC;E9D0BpC,qB8D1BoC;E9D2BpC,iB8D3BoC;AlEqvXtC;AkEnvXE;EACE,kBAAA;AlEqvXJ;;AkEjvXA;EACE,eAAA;AlEovXF;;AkEjvXA;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlEovXF;;AkE5uXE;E9DNA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,a8DGwB;E9DFxB,8B8DE8B;E9DD9B,0B8DC8B;E9DA9B,sBAAA;EACA,yB8DDsC;E9DEtC,qB8DFsC;E9DGtC,iB8DHsC;EACpC,iDAAA;EACA,eAAA;AlEyvXJ;AkEvvXI;EAEE,kBAAA;AlEwvXN;;AkEnvXA;EACE,aAAA;AlEsvXF;;AkEnvXA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AlEsvXF;;AkEnvXA;EACE,iBAAA;EACA,gBAAA;E9D9BA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;AJgyXnE;AkE9vXE;EACE,iBAAA;AlEgwXJ;;AkE5vXA;EACE;IACE,mBAAA;ElE+vXF;AACF;AkE5vXA;EACE;I9D/BA,sBAAA;IACA,kBAAA;IACA,cAAA;I8D+BE,eAAA;IACA,oBAAA;ElEgwXF;EkE7vXA;I9DrCA,sBAAA;IACA,kBAAA;IACA,cAAA;I8DqCE,eAAA;ElEiwXF;EkE/vXE;IACE,aAAA;ElEiwXJ;AACF;AkE7vXA;EACE;IACE,cAAA;I9DtCF,+B8DuCuB;I9DtCvB,uB8DsCuB;IACrB,2BAAA;IACA,uBAAA;IACA,mBAAA;IACA,yBAAA;IACA,qBAAA;IACA,iBAAA;ElEgwXF;EkE7vXA;IACE,gBAAA;IACA,eAAA;ElE+vXF;EkE5vXA;IACE,2BAAA;ElE8vXF;AACF;AmE34XA,wBAAA;AAEA;E/DoFE,2B+DnFqB;E/DoFrB,mB+DpFqB;E/D0DrB,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;E+DvDjE,gCAAA;EACA,iBAAA;AnEu5XF;;AmEp5XA;EACE,eAAA;AnEu5XF;;AmEp5XA;EACE,kBAAA;AnEu5XF;;AmEp5XA;EACE,gBAAA;EACA,gBAAA;AnEu5XF;AmEr5XE;EACE,gBAAA;AnEu5XJ;;AmEn5XA;EACE,W9DjBM;ED4FJ,2B+D1EyB;E/D2EzB,4B+D3EyB;AnEu5X7B;;AmEp5XA;EACE,W9DtBM;E8DuBN,kBAAA;AnEu5XF;AmEr5XE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,W9D9BI;ALq7XR;;AmEn5XA;EACE,aAAA;AnEs5XF;AmEp5XE;EACE,cAAA;AnEs5XJ;;AmEl5XA;EACE,oBAAA;AnEq5XF;AmEn5XE;E/DMA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aALyB;EAMzB,2BANgD;EAOhD,uBAPgD;EAQhD,mBARgD;EAShD,uBATiE;EAUjE,mBAViE;EAWjE,eAXiE;EA0BjE,2B+D7BuB;E/D8BvB,mB+D9BuB;EACrB,mBAAA;AnEg6XJ;;AmE55XA;EACE,0BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AnE+5XF;;AmE55XA;EACE,kBAAA;EACA,c9DvDS;ALs9XX;AmE75XE;EAGE,kBAAA;EACA,c9D1DO;ALu9XX;;AmEz5XA;EACE,eAAA;AnE45XF;;AmEz5XA;EAEI;IACE,gBAAA;EnE25XJ;EmEv5XA;IACE,eAAA;EnEy5XF;AACF;AmEt5XA;EACE;IACE,gBAAA;EnEw5XF;EmEt5XE;IACE,gBAAA;EnEw5XJ;EmEp5XA;IACE,eAAA;EnEs5XF;AACF;AmEn5XA;EACE;IACE,gBAAA;EnEq5XF;EmEn5XE;IACE,gBAAA;EnEq5XJ;AACF;AmEj5XA;EACE;IACE,0BAAA;EnEm5XF;AACF;AoE/gYA,0BAAA;AAGE;EhE0DA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,agE7DwB;EhE8DxB,8BgE9D8B;EhE+D9B,0BgE/D8B;EhEgE9B,sBgEhE8B;EhEiE9B,yBgEjEsC;EhEkEtC,qBgElEsC;EhEmEtC,iBgEnEsC;EhEuEtC,sBAAA;EACA,kBAAA;EACA,cAAA;EgEvEE,+BAAA;ApE2hYJ;AoExhYE;EACE,+BAAA;ApE0hYJ;;AoEthYA;EACE,yBjE2CY;AH8+Xd;;AoEthYA;EACE,mEAAA;ApEyhYF;;AoEthYA;EACE,wCAAA;ApEyhYF;;AoEthYA;;EAEE,W/DlBM;E+DmBN,sBAAA;EhE3BA,wBgE4BA;EhE3BA,qBgE2BA;EhE1BA,mBgE0BA;EhEzBA,gBgEyBA;EACA,wCAAA;EACA,qBjE0BY;AHkgYd;;AoEzhYA;;;;EAIE,W/D7BM;E+D8BN,wCAAA;EACA,qBjEiBY;AH2gYd;;AoEzhYA;EACE,W/DnCM;E+DoCN,wCAAA;EACA,qBjEWY;AHihYd;;AoEzhYA;EACE,W/DzCM;E+D0CN,wCAAA;EACA,qBjEKY;AHuhYd;;AoEzhYA;EACE,iBAAA;ApE4hYF;;AoEzhYA;EACE,gBAAA;ApE4hYF;;AoEzhYA;EACE;IhEJA,qBAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IACA,agECwB;IhEAxB,8BAAA;IACA,0BgED8B;IhEE9B,sBgEF8B;IhEG9B,yBgEHsC;IhEItC,qBgEJsC;IhEKtC,iBgELsC;IhEoBtC,+BgEnBuB;IhEoBvB,uBgEpBuB;EpEuiYvB;EoEpiYA;IACE,aAAA;EpEsiYF;AACF;AoEniYA;EAEI;IACE,iBAAA;EpEoiYJ;EoEjiYE;IACE,iBAAA;EpEmiYJ;AACF;AoE/hYA;EACE;IACE,eAAA;EpEiiYF;EoE9hYA;IACE,iBAAA;EpEgiYF;AACF","sourcesContent":["/*\r\nAuthor         : G-axon\r\nTemplate Name  : Jumbo React - Admin Template\r\nVersion        : 1.0\r\n*/\r\n/*=============================================================\r\n    Table of Contents:\r\n    =============================\r\n    A. Globals\r\n        01. Custom Animation\r\n    B. Base\r\n        01. Base Styles\r\n        02. Typography Styles\r\n    C. Layouts\r\n        01. App Layout Styles\r\n        02. Sidebar Styles\r\n        03. Header Styles\r\n        04. Main Content Styles\r\n        05. Footer Styles\r\n        06. Right Sidebar Styles\r\n    D. UI Components\r\n        01. Alert Styles\r\n        02. Avatar Styles\r\n        03. Badges Styles\r\n        04. Blockquotes Styles\r\n        05. Bottom Navigation Styles\r\n        06. Breadcrumb Styles\r\n        07. Button Styles\r\n        08. Button Group Styles\r\n        09. Callout Styles\r\n        10. Cards Styles\r\n        11. Charts Styles\r\n        12. Chips Styles\r\n        13. Carousel Styles\r\n        14. Color Picker Styles\r\n        15. Drawer Styles\r\n        16. E-commerce Styles\r\n        17. Grids List Styles\r\n        18. Icons Styles\r\n        19. Label Styles\r\n        20. List Styles\r\n        21. Nav Style\r\n        22. Pricing Styles\r\n        23. Progressbar Styles\r\n        24. Popover Styles\r\n        25. React Joyride Styles\r\n        26. Tables Styles\r\n        27. Tabs Styles\r\n        28. Testimonial Styles\r\n        29. Time Lines Style\r\n        30. Joyride Tour Styles\r\n        31. Form Styles\r\n    E. Pages\r\n        01. Login Styles\r\n        02. Error Styles\r\n        03. Editor Styles\r\n        04. Contact Page Styles\r\n        05. Portfolio Styles\r\n        06. Faqs Styles\r\n        07. Dashboard Styles\r\n    F. Slider\r\n    G. Modules\r\n        01. App Module Style\r\n        02. Chat Module Styles\r\n        03. Mails Module Styles\r\n        04. Contact Module Styles\r\n        05. Calendar Module Style\r\n  =============================================================*/\r\n//Custom Variables\r\n@import \"global/_global-dir\";\r\n//Custom Files\r\n@import \"base/_base-dir\";\r\n@import \"layout/_layout-dir\";\r\n@import \"ui/_ui-dir\";\r\n@import \"pages/_pages-dir\";\r\n@import \"slider/owl-carousel\";\r\n@import \"module/_module-dir\";","/* Globals\r\n   ========================================================================== */\r\n@import \"variables\";\r\n@import \"mixin\";\r\n@import \"place-holder\";\r\n@import \"sizes\";\r\n@import \"color\";\r\n@import \"custom-animation\";\r\n","//Place Holders\r\n%jr-menu-icon {\r\n  .menu-icon {\r\n    position: relative;\r\n    width: 70%;\r\n    height: 1px;\r\n    min-height: 1px;\r\n    color: inherit;\r\n    background-color: $gray-default;\r\n    display: block;\r\n    @include transition(all 0.4s ease);\r\n    margin: 6px 0;\r\n    cursor: pointer;\r\n\r\n    &:after,\r\n    &:before {\r\n      position: absolute;\r\n      display: block;\r\n      color: inherit;\r\n      background-color: inherit;\r\n      left: 0;\r\n      height: 1px;\r\n      min-height: 1px;\r\n      content: \"\";\r\n      @include transition(all 0.4s ease);\r\n    }\r\n\r\n    &:after {\r\n      width: 120%;\r\n      bottom: -6px;\r\n    }\r\n\r\n    &:before {\r\n      width: 130%;\r\n      top: -6px;\r\n    }\r\n  }\r\n  &:hover {\r\n    & .menu-icon {\r\n      width: 100%;\r\n      &:after,\r\n      &:before {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n%size-50 {\r\n  height: $size-50 !important;\r\n  width: $size-50 !important;\r\n  line-height: $size-50;\r\n}\r\n\r\n%size-60 {\r\n  height: $size-60 !important;\r\n  width: $size-60 !important;\r\n  line-height: $size-60;\r\n}\r\n\r\n%size-80 {\r\n  height: $size-80 !important;\r\n  width: $size-80 !important;\r\n  line-height: $size-80;\r\n}\r\n\r\n%size-100 {\r\n  height: $size-100 !important;\r\n  width: $size-100 !important;\r\n  line-height: $size-100;\r\n}\r\n\r\n%size-20 {\r\n  height: $size-20 !important;\r\n  width: $size-20 !important;\r\n  line-height: $size-20;\r\n}\r\n\r\n\r\n%size-30 {\r\n  height: $size-30 !important;\r\n  width: $size-30 !important;\r\n  line-height: $size-30;\r\n}\r\n\r\n%size-40 {\r\n  height: $size-40 !important;\r\n  width: $size-40 !important;\r\n  line-height: $size-40;\r\n}\r\n\r\n%size-120 {\r\n  height: $size-120 !important;\r\n  width: $size-120 !important;\r\n  line-height: $size-120;\r\n}\r\n\r\n%icon-addon {\r\n  display: inline-block;\r\n  text-align: center;\r\n  background-color: inherit;\r\n}\r\n\r\n%jr-card-style {\r\n  padding: $jr-card-padding;\r\n  margin-bottom: $jr-card-margin;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  border: $jr-border;\r\n  position: relative;\r\n}\r\n\r\n/* Ripple magic */\r\n%ripple-effect {\r\n  position: relative;\r\n  overflow: hidden;\r\n  &:after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 5px;\r\n    height: 5px;\r\n    background: rgba($white, 0.5);\r\n    opacity: 0;\r\n    @include border-radius(100%);\r\n    transform: scale(1, 1) translate(-50%);\r\n    transform-origin: 50% 50%;\r\n  }\r\n\r\n  &:hover:after {\r\n    animation: ripple 1s ease-out;\r\n  }\r\n}\r\n\r\n@keyframes ripple {\r\n  0% {\r\n    transform: scale(0, 0);\r\n    opacity: 0.5;\r\n  }\r\n  20% {\r\n    transform: scale(60, 60);\r\n    opacity: 0.3;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: scale(100, 100);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes ripple {\r\n  0% {\r\n    transform: scale(0, 0);\r\n    opacity: 0.5;\r\n  }\r\n  20% {\r\n    transform: scale(60, 60);\r\n    opacity: 0.3;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: scale(100, 100);\r\n  }\r\n}\r\n\r\n//Pulse Effect\r\n%pulse-effect {\r\n  display: block;\r\n  @include box-shadow (0 0 0 rgba($danger, 0.4));\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n@-webkit-keyframes pulse {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($danger, 0.4);\r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 10px rgba($danger, 0);\r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($danger, 0);\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($danger, 0.4);\r\n    box-shadow: 0 0 0 0 rgba($danger, 0.4);\r\n  }\r\n  70% {\r\n    -moz-box-shadow: 0 0 0 10px rgba($danger, 0);\r\n    box-shadow: 0 0 0 10px rgba($danger, 0);\r\n  }\r\n  100% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($danger, 0);\r\n    box-shadow: 0 0 0 0 rgba($danger, 0);\r\n  }\r\n}\r\n\r\n//Online Effect\r\n%online-effect {\r\n  display: block;\r\n  @include box-shadow (0 0 0 rgba($green, 0.4));\r\n  animation: online 2s infinite;\r\n}\r\n\r\n@-webkit-keyframes online {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($green, 0.4);\r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 10px rgba($green, 0);\r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($green, 0);\r\n  }\r\n}\r\n\r\n@keyframes online {\r\n  0% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($green, 0.4);\r\n    box-shadow: 0 0 0 0 rgba($green, 0.4);\r\n  }\r\n  70% {\r\n    -moz-box-shadow: 0 0 0 10px rgba($green, 0);\r\n    box-shadow: 0 0 0 10px rgba($green, 0);\r\n  }\r\n  100% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($green, 0);\r\n    box-shadow: 0 0 0 0 rgba($green, 0);\r\n  }\r\n}\r\n\r\n//Away Effect\r\n%away-effect {\r\n  display: block;\r\n  @include box-shadow (0 0 0 rgba($yellow, 0.4));\r\n  animation: away 2s infinite;\r\n}\r\n\r\n@-webkit-keyframes away {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($yellow, 0.4);\r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 10px rgba($yellow, 0);\r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($yellow, 0);\r\n  }\r\n}\r\n\r\n@keyframes away {\r\n  0% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($yellow, 0.4);\r\n    box-shadow: 0 0 0 0 rgba($yellow, 0.4);\r\n  }\r\n  70% {\r\n    -moz-box-shadow: 0 0 0 10px rgba($yellow, 0);\r\n    box-shadow: 0 0 0 10px rgba($yellow, 0);\r\n  }\r\n  100% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($yellow, 0);\r\n    box-shadow: 0 0 0 0 rgba($yellow, 0);\r\n  }\r\n}\r\n\r\n/*Different size images set in Equal block height and width*/\r\n%thumb-equal {\r\n  position: relative;\r\n  padding-bottom: 68%;\r\n  height: 0;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n%thumb-cover {\r\n  display: block;\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n%thumb-cover-img {\r\n  height: auto;\r\n  max-width: 100%;\r\n  min-height: 100%;\r\n  object-fit: cover;\r\n  width: 100%;\r\n}\r\n\r\n// Hover Effect On Bootstrap Components\r\n%link-hover {\r\n  color: $white !important;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    color: $white !important;\r\n  }\r\n}\r\n\r\n// Pointer\r\n%pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n//Remove Botton Shadow\r\n\r\n%btn-no-shadow {\r\n  &:not([disabled]):not(.disabled):active,\r\n  &:not([disabled]):not(.disabled).active {\r\n    background-image: none;\r\n    @include box-shadow(none);\r\n\r\n    &:focus {\r\n      @include box-shadow(none);\r\n    }\r\n  }\r\n}","@import \"../bootstrap/functions\";\r\n@import \"../bootstrap/variables\";\r\n@import \"../bootstrap/mixins\";\r\n// Fonts\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n// @import url('https://fonts.googleapis.com/css?family=Nunito+Sans:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i');\r\n@import url(\"https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\r\n\r\n//# sourceMappingURL=roboto.css.map\r\n\r\n// import material icons\r\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: 'Roboto', sans-serif;\r\n$font-family-base: $font-family-sans-serif;\r\n\r\n// stylelint-enable value-keyword-case\r\n$font-size-base: 13px; // Assumes the browser default, typically `16px`\r\n$font-size-lg: ($font-size-base + 4);\r\n$font-size-sm: $font-size-base;\r\n\r\n$h1-font-size: 24px;\r\n$h2-font-size: 18px;\r\n$h3-font-size: 16px;\r\n$h4-font-size: 15px;\r\n$h5-font-size: 13px;\r\n$h6-font-size: 12px;\r\n\r\n$headings-margin-bottom: ($h1-font-size / 2);\r\n$headings-font-family: inherit;\r\n$headings-font-weight: 400;\r\n$headings-line-height: 1.2;\r\n$headings-color: inherit;\r\n\r\n//Border Radius\r\n$border-radius-sm: 2px;\r\n$border-radius: 4px;\r\n$border-radius-lg: 8px;\r\n$border-radius-xl: 10px !default;\r\n$border-radius-circle: 50% !default;\r\n\r\n//Bootstrap Card Variables\r\n$card-spacer-y: 24px;\r\n$card-spacer-x: 30px;\r\n$card-border-color: $border-color;\r\n$card-border-radius: $border-radius-lg;\r\n$card-inner-border-radius: $border-radius-lg;\r\n$list-group-border-radius: $border-radius-lg;\r\n\r\n//Grid Gutter Space Between\r\n$grid-gutter-width: 34px;\r\n\r\n//Mixin Values True and False\r\n$enable-shadows: true;\r\n\r\n$app-primary: #3f51b5 !default;\r\n$primary: $app-primary;\r\n$secondary: #E91E63;\r\n$gray-default: #808080 !default;\r\n\r\n$sidebar-bg: #f5f7f9 !default;\r\n$sidebar-text-color: #868e96 !default;\r\n$sidebar-bg-darken: darken($sidebar-bg, 3%);\r\n$sidebar-hover-color: $app-primary;\r\n\r\n$top-nav-bg: $app-primary !default;\r\n\r\n//Default shadow\r\n$shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\r\n$shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);\r\n$shadow-lg: 0 1px 8px -1px rgba(0, 0, 0, 0.20);\r\n$shadow-xl: 0 0 16px 0px rgba(0, 0, 0, 0.20);\r\n$avatar-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.50);\r\n\r\n//Custom Card Variables\r\n$jr-card-shadow: $shadow !default;\r\n$jr-card-margin: 34px !default;\r\n$jr-card-padding: 24px 30px !default;\r\n$jr-border: 1px solid $gray-400 !default;\r\n\r\n// Links\r\n$link-color: $app-primary;\r\n$link-hover-color: darken($app-primary, 10%);\r\n\r\n//Color Variables\r\n$success: #4caf50;\r\n$info: #00bcd4;\r\n$warning: #ff9800;\r\n$danger: #f44336;\r\n$light: #e8eaf6;\r\n$dark: $gray-800;\r\n$body-bg: #fff;\r\n$body-color: #5c5c5c;\r\n\r\n$theme-colors: (\r\n        \"primary\": $primary,\r\n        \"secondary\": $secondary,\r\n        \"success\": $success,\r\n        \"info\": $info,\r\n        \"warning\": $warning,\r\n        \"danger\": $danger,\r\n        \"light\": $light,\r\n        \"dark\": $dark\r\n);\r\n\r\n//Default Image Location\r\n$image_path: \"../assets/images\" !default;\r\n\r\n// Motion\r\n// https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves\r\n$transition-bezier: .05, .74, .27, .99 !default; // for nav, quickview\r\n\r\n$transition-ease: cubic-bezier(0.4, 0.0, 0.2, 1) !default;\r\n$transition-ease-out: cubic-bezier(0.0, 0.0, 0.2, 1) !default;\r\n$transition-ease-in: cubic-bezier(0.4, 0.0, 1, 1) !default;\r\n\r\n//Side Nav Width\r\n$side-nav-width: 200px !default;\r\n$mini-drawer-width: 80px !default;\r\n\r\n//App Bar Height\r\n$app-bar-height: 60px !default;\r\n\r\n//Footer Height\r\n$footer-height: 50px !default;\r\n\r\n//latter Spacing variables\r\n$letter-spacing-base: 3px !default;\r\n$letter-spacing-lg: 6px !default;\r\n$letter-spacing-xl: 8px !default;\r\n\r\n//Button Variables\r\n$btn-font-size-lg: $font-size-lg !default;\r\n$btn-font-size: $font-size-base !default;\r\n$btn-font-size-sm: $font-size-sm !default;\r\n$btn-font-size-xs: 10px !default;\r\n\r\n$btn-padding-lg: 16px 24px !default;\r\n$btn-padding: 12px 20px !default;\r\n$btn-padding-sm: 8px 15px !default;\r\n$btn-padding-xs: 6px 10px !default;\r\n\r\n$btn-fab-size-lg: 70px !default;\r\n$btn-fab-size-sm: 46px !default;\r\n$btn-fab-size-xs: 40px !default;\r\n\r\n$btn-line-height: 1.2;\r\n\r\n//Sizes Variables\r\n\r\n$size-20: 20px !default;\r\n$size-30: 30px !default;\r\n$size-40: 40px !default;\r\n$size-50: 50px !default;\r\n$size-60: 60px !default;\r\n$size-80: 80px !default;\r\n$size-100: 100px !default;\r\n$size-120: 120px !default;","// Box Shadow\r\n@mixin box-shadow($shadow...) {\r\n  -webkit-box-shadow: $shadow;\r\n  -moz-box-shadow: $shadow;\r\n  -o-box-shadow: $shadow;\r\n  box-shadow: $shadow;\r\n}\r\n\r\n// Single side border-radius\r\n@mixin border-radius($radius...) {\r\n  -webkit-border-radius: $radius;\r\n  -moz-border-radius: $radius;\r\n  border-radius: $radius;\r\n}\r\n\r\n// Single side box-sizing\r\n@mixin box-sizing($box-sizing) {\r\n  -webkit-box-sizing: $box-sizing;\r\n  -moz-box-sizing: $box-sizing;\r\n  box-sizing: $box-sizing;\r\n}\r\n\r\n// Clearfix\r\n\r\n@mixin clearfix() {\r\n  &:before,\r\n  &:after {\r\n    content: \" \"; // 1\r\n    display: table; // 2\r\n  }\r\n  &:after {\r\n    clear: both;\r\n  }\r\n}\r\n\r\n// Transitions\r\n@mixin transition($transition...) {\r\n  -webkit-transition: $transition;\r\n  -o-transition: $transition;\r\n  transition: $transition;\r\n}\r\n\r\n@mixin rotate($degrees) {\r\n  -webkit-transform: rotate($degrees);\r\n  -ms-transform: rotate($degrees); // IE9 only\r\n  -o-transform: rotate($degrees);\r\n  transform: rotate($degrees);\r\n}\r\n\r\n//Background Image\r\n@mixin background($imgpath,$position:0 0,$repeat: no-repeat,$size: cover) {\r\n  background: {\r\n    image: url($imgpath);\r\n    position: $position;\r\n    repeat: $repeat;\r\n    size: $size;\r\n  }\r\n}\r\n\r\n// Flex\r\n@mixin display-flex($flex: flex, $flex-direction: row, $flex-wrap: wrap) {\r\n  display: #{'-webkit'}-#{$flex};\r\n  display: #{'-moz'}-#{$flex};\r\n  display: #{'-ms'}-#{$flex};\r\n  display: #{'-o'}-#{$flex};\r\n  display: $flex;\r\n  -webkit-flex-direction: $flex-direction;\r\n  -ms-flex-direction: $flex-direction;\r\n  flex-direction: $flex-direction;\r\n  -webkit-flex-wrap: $flex-wrap;\r\n  -ms-flex-wrap: $flex-wrap;\r\n  flex-wrap: $flex-wrap;\r\n}\r\n\r\n@mixin flex($flex-grow: 1, $flex-shrink: 1, $flex-basis: auto) {\r\n  -webkit-flex: $flex-grow $flex-shrink $flex-basis;\r\n  -ms-flex: $flex-grow $flex-shrink $flex-basis;\r\n  flex: $flex-grow $flex-shrink $flex-basis;\r\n}\r\n\r\n@mixin justify-content($justify-content) {\r\n  -webkit-justify-content: $justify-content;\r\n  justify-content: $justify-content;\r\n}\r\n\r\n@mixin align-items($align-items) {\r\n  -webkit-align-items: $align-items;\r\n  align-items: $align-items;\r\n}\r\n\r\n//Border Radius\r\n\r\n// Single side border-radius\r\n\r\n@mixin border-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-top-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-top-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-right-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-right-radius: $radius;\r\n    border-bottom-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-bottom-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-bottom-right-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-left-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n\r\n//Mixin Hover\r\n\r\n// stylelint-disable indentation\r\n@mixin hover {\r\n  // TODO: re-enable along with mq4-hover-shim\r\n  //  @if $enable-hover-media-query {\r\n  //    // See Media Queries Level 4: https://drafts.csswg.org/mediaqueries/#hover\r\n  //    // Currently shimmed by https://github.com/twbs/mq4-hover-shim\r\n  //    @media (hover: hover) {\r\n  //      &:hover { @content }\r\n  //    }\r\n  //  }\r\n  //  @else {\r\n  &:hover {\r\n    @content;\r\n  }\r\n  //  }\r\n}\r\n\r\n@mixin hover-focus {\r\n  @if $enable-hover-media-query {\r\n    &:focus {\r\n      @content;\r\n    }\r\n    @include hover {\r\n      @content;\r\n    }\r\n  } @else {\r\n    &:focus,\r\n    &:hover {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin plain-hover-focus {\r\n  @if $enable-hover-media-query {\r\n    &,\r\n    &:focus {\r\n      @content;\r\n    }\r\n    @include hover {\r\n      @content;\r\n    }\r\n  } @else {\r\n    &,\r\n    &:focus,\r\n    &:hover {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin hover-focus-active {\r\n  @if $enable-hover-media-query {\r\n    &:focus,\r\n    &:active {\r\n      @content;\r\n    }\r\n    @include hover {\r\n      @content;\r\n    }\r\n  } @else {\r\n    &:focus,\r\n    &:active,\r\n    &:hover {\r\n      @content;\r\n    }\r\n  }\r\n}","// Variables\r\n//\r\n// Variables should follow the `$component-state-property-size` formula for\r\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\r\n\r\n//\r\n// Color system\r\n//\r\n\r\n// stylelint-disable\r\n$white: #fff !default;\r\n$gray-100: #f8f9fa !default;\r\n$gray-200: #e9ecef !default;\r\n$gray-300: #dee2e6 !default;\r\n$gray-400: #ced4da !default;\r\n$gray-500: #adb5bd !default;\r\n$gray-600: #6c757d !default;\r\n$gray-700: #495057 !default;\r\n$gray-800: #343a40 !default;\r\n$gray-900: #212529 !default;\r\n$black: #000 !default;\r\n\r\n$grays: () !default;\r\n$grays: map-merge((\r\n        \"100\": $gray-100,\r\n        \"200\": $gray-200,\r\n        \"300\": $gray-300,\r\n        \"400\": $gray-400,\r\n        \"500\": $gray-500,\r\n        \"600\": $gray-600,\r\n        \"700\": $gray-700,\r\n        \"800\": $gray-800,\r\n        \"900\": $gray-900\r\n), $grays);\r\n\r\n$blue: #007bff !default;\r\n$indigo: #6610f2 !default;\r\n$purple: #6f42c1 !default;\r\n$pink: #e83e8c !default;\r\n$red: #dc3545 !default;\r\n$orange: #fd7e14 !default;\r\n$yellow: #ffc107 !default;\r\n$green: #28a745 !default;\r\n$teal: #20c997 !default;\r\n$cyan: #17a2b8 !default;\r\n\r\n$colors: () !default;\r\n$colors: map-merge((\r\n        \"blue\": $blue,\r\n        \"indigo\": $indigo,\r\n        \"purple\": $purple,\r\n        \"pink\": $pink,\r\n        \"red\": $red,\r\n        \"orange\": $orange,\r\n        \"yellow\": $yellow,\r\n        \"green\": $green,\r\n        \"teal\": $teal,\r\n        \"cyan\": $cyan,\r\n        \"white\": $white,\r\n        \"gray\": $gray-600,\r\n        \"gray-dark\": $gray-800\r\n), $colors);\r\n\r\n$primary: $blue !default;\r\n$secondary: $gray-600 !default;\r\n$success: $green !default;\r\n$info: $cyan !default;\r\n$warning: $yellow !default;\r\n$danger: $red !default;\r\n$light: $gray-100 !default;\r\n$dark: $gray-800 !default;\r\n\r\n$theme-colors: () !default;\r\n$theme-colors: map-merge((\r\n        \"primary\": $primary,\r\n        \"secondary\": $secondary,\r\n        \"success\": $success,\r\n        \"info\": $info,\r\n        \"warning\": $warning,\r\n        \"danger\": $danger,\r\n        \"light\": $light,\r\n        \"dark\": $dark\r\n), $theme-colors);\r\n// stylelint-enable\r\n\r\n// Set a specific jump point for requesting color jumps\r\n$theme-color-interval: 8% !default;\r\n\r\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\r\n$yiq-contrasted-threshold: 150 !default;\r\n\r\n// Customize the light and dark text colors for use in our YIQ color contrast function.\r\n$yiq-text-dark: $gray-900 !default;\r\n$yiq-text-light: $white !default;\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n\r\n$enable-caret: true !default;\r\n$enable-rounded: true !default;\r\n$enable-shadows: false !default;\r\n$enable-gradients: false !default;\r\n$enable-transitions: true !default;\r\n$enable-hover-media-query: false !default; // Deprecated, no longer affects any compiled CSS\r\n$enable-grid-classes: true !default;\r\n$enable-print-styles: true !default;\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n\r\n// stylelint-disable\r\n$spacer: 1rem !default;\r\n$spacers: () !default;\r\n$spacers: map-merge((\r\n        0: 0,\r\n        1: ($spacer * .25),\r\n        2: ($spacer * .5),\r\n        3: $spacer,\r\n        4: ($spacer * 1.5),\r\n        5: ($spacer * 3)\r\n), $spacers);\r\n\r\n// This variable affects the `.h-*` and `.w-*` classes.\r\n$sizes: () !default;\r\n$sizes: map-merge((\r\n        25: 25%,\r\n        50: 50%,\r\n        75: 75%,\r\n        100: 100%\r\n), $sizes);\r\n// stylelint-enable\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n\r\n$body-bg: $white !default;\r\n$body-color: $gray-900 !default;\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n\r\n$link-color: theme-color(\"primary\") !default;\r\n$link-decoration: none !default;\r\n$link-hover-color: darken($link-color, 15%) !default;\r\n$link-hover-decoration: underline !default;\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n\r\n$paragraph-margin-bottom: 1rem !default;\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n\r\n$grid-breakpoints: (\r\n        xs: 0,\r\n        sm: 576px,\r\n        md: 768px,\r\n        lg: 992px,\r\n        xl: 1200px\r\n) !default;\r\n\r\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\r\n@include _assert-starts-at-zero($grid-breakpoints);\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n$container-max-widths: (\r\n        sm: 540px,\r\n        md: 720px,\r\n        lg: 960px,\r\n        xl: 1140px\r\n) !default;\r\n\r\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\r\n\r\n// Grid columns\r\n//\r\n// Set the number of columns and specify the width of the gutters.\r\n\r\n$grid-columns: 12 !default;\r\n$grid-gutter-width: 30px !default;\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n\r\n$line-height-lg: 1.5 !default;\r\n$line-height-sm: 1.5 !default;\r\n\r\n$border-width: 1px !default;\r\n$border-color: $gray-300 !default;\r\n\r\n$border-radius: .25rem !default;\r\n$border-radius-lg: .3rem !default;\r\n$border-radius-sm: .2rem !default;\r\n\r\n$component-active-color: $white !default;\r\n$component-active-bg: theme-color(\"primary\") !default;\r\n\r\n$caret-width: .3em !default;\r\n\r\n$transition-base: all .2s ease-in-out !default;\r\n$transition-fade: opacity .15s linear !default;\r\n$transition-collapse: height .35s ease !default;\r\n\r\n// Fonts\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !default;\r\n$font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\r\n$font-family-base: $font-family-sans-serif !default;\r\n// stylelint-enable value-keyword-case\r\n\r\n$font-size-base: 1rem !default; // Assumes the browser default, typically `16px`\r\n$font-size-lg: ($font-size-base * 1.25) !default;\r\n$font-size-sm: ($font-size-base * .875) !default;\r\n\r\n$font-weight-light: 300 !default;\r\n$font-weight-normal: 400 !default;\r\n$font-weight-bold: 700 !default;\r\n\r\n$font-weight-base: $font-weight-normal !default;\r\n$line-height-base: 1.5 !default;\r\n\r\n$h1-font-size: $font-size-base * 2.5 !default;\r\n$h2-font-size: $font-size-base * 2 !default;\r\n$h3-font-size: $font-size-base * 1.75 !default;\r\n$h4-font-size: $font-size-base * 1.5 !default;\r\n$h5-font-size: $font-size-base * 1.25 !default;\r\n$h6-font-size: $font-size-base !default;\r\n\r\n$headings-margin-bottom: ($spacer / 2) !default;\r\n$headings-font-family: inherit !default;\r\n$headings-font-weight: 500 !default;\r\n$headings-line-height: 1.2 !default;\r\n$headings-color: inherit !default;\r\n\r\n$display1-size: 6rem !default;\r\n$display2-size: 5.5rem !default;\r\n$display3-size: 4.5rem !default;\r\n$display4-size: 3.5rem !default;\r\n\r\n$display1-weight: 300 !default;\r\n$display2-weight: 300 !default;\r\n$display3-weight: 300 !default;\r\n$display4-weight: 300 !default;\r\n$display-line-height: $headings-line-height !default;\r\n\r\n$lead-font-size: ($font-size-base * 1.25) !default;\r\n$lead-font-weight: 300 !default;\r\n\r\n$small-font-size: 80% !default;\r\n\r\n$text-muted: $gray-600 !default;\r\n\r\n$blockquote-small-color: $gray-600 !default;\r\n$blockquote-font-size: ($font-size-base * 1.25) !default;\r\n\r\n$hr-border-color: rgba($black, .1) !default;\r\n$hr-border-width: $border-width !default;\r\n\r\n$mark-padding: .2em !default;\r\n\r\n$dt-font-weight: $font-weight-bold !default;\r\n\r\n$kbd-box-shadow: inset 0 -.1rem 0 rgba($black, .25) !default;\r\n$nested-kbd-font-weight: $font-weight-bold !default;\r\n\r\n$list-inline-padding: .5rem !default;\r\n\r\n$mark-bg: #fcf8e3 !default;\r\n\r\n$hr-margin-y: $spacer !default;\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n$table-cell-padding: .75rem !default;\r\n$table-cell-padding-sm: .3rem !default;\r\n\r\n$table-bg: transparent !default;\r\n$table-accent-bg: rgba($black, .05) !default;\r\n$table-hover-bg: rgba($black, .075) !default;\r\n$table-active-bg: $table-hover-bg !default;\r\n\r\n$table-border-width: $border-width !default;\r\n$table-border-color: $gray-300 !default;\r\n\r\n$table-head-bg: $gray-200 !default;\r\n$table-head-color: $gray-700 !default;\r\n\r\n$table-dark-bg: $gray-900 !default;\r\n$table-dark-accent-bg: rgba($white, .05) !default;\r\n$table-dark-hover-bg: rgba($white, .075) !default;\r\n$table-dark-border-color: lighten($gray-900, 7.5%) !default;\r\n$table-dark-color: $body-bg !default;\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n\r\n$input-btn-padding-y: .375rem !default;\r\n$input-btn-padding-x: .75rem !default;\r\n$input-btn-line-height: $line-height-base !default;\r\n\r\n$input-btn-focus-width: .2rem !default;\r\n$input-btn-focus-color: rgba($component-active-bg, .25) !default;\r\n$input-btn-focus-box-shadow: 0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\r\n\r\n$input-btn-padding-y-sm: .25rem !default;\r\n$input-btn-padding-x-sm: .5rem !default;\r\n$input-btn-line-height-sm: $line-height-sm !default;\r\n\r\n$input-btn-padding-y-lg: .5rem !default;\r\n$input-btn-padding-x-lg: 1rem !default;\r\n$input-btn-line-height-lg: $line-height-lg !default;\r\n\r\n$input-btn-border-width: $border-width !default;\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n\r\n$btn-padding-y: $input-btn-padding-y !default;\r\n$btn-padding-x: $input-btn-padding-x !default;\r\n$btn-line-height: $input-btn-line-height !default;\r\n\r\n$btn-padding-y-sm: $input-btn-padding-y-sm !default;\r\n$btn-padding-x-sm: $input-btn-padding-x-sm !default;\r\n$btn-line-height-sm: $input-btn-line-height-sm !default;\r\n\r\n$btn-padding-y-lg: $input-btn-padding-y-lg !default;\r\n$btn-padding-x-lg: $input-btn-padding-x-lg !default;\r\n$btn-line-height-lg: $input-btn-line-height-lg !default;\r\n\r\n$btn-border-width: $input-btn-border-width !default;\r\n\r\n$btn-font-weight: $font-weight-normal !default;\r\n$btn-box-shadow: inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\r\n$btn-focus-width: $input-btn-focus-width !default;\r\n$btn-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n$btn-disabled-opacity: .65 !default;\r\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, .125) !default;\r\n\r\n$btn-link-disabled-color: $gray-600 !default;\r\n\r\n$btn-block-spacing-y: .5rem !default;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius: $border-radius !default;\r\n$btn-border-radius-lg: $border-radius-lg !default;\r\n$btn-border-radius-sm: $border-radius-sm !default;\r\n\r\n$btn-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n// Forms\r\n\r\n$input-padding-y: $input-btn-padding-y !default;\r\n$input-padding-x: $input-btn-padding-x !default;\r\n$input-line-height: $input-btn-line-height !default;\r\n\r\n$input-padding-y-sm: $input-btn-padding-y-sm !default;\r\n$input-padding-x-sm: $input-btn-padding-x-sm !default;\r\n$input-line-height-sm: $input-btn-line-height-sm !default;\r\n\r\n$input-padding-y-lg: $input-btn-padding-y-lg !default;\r\n$input-padding-x-lg: $input-btn-padding-x-lg !default;\r\n$input-line-height-lg: $input-btn-line-height-lg !default;\r\n\r\n$input-bg: $white !default;\r\n$input-disabled-bg: $gray-200 !default;\r\n\r\n$input-color: $gray-700 !default;\r\n$input-border-color: $gray-400 !default;\r\n$input-border-width: $input-btn-border-width !default;\r\n$input-box-shadow: inset 0 1px 1px rgba($black, .075) !default;\r\n\r\n$input-border-radius: $border-radius !default;\r\n$input-border-radius-lg: $border-radius-lg !default;\r\n$input-border-radius-sm: $border-radius-sm !default;\r\n\r\n$input-focus-bg: $input-bg !default;\r\n$input-focus-border-color: lighten($component-active-bg, 25%) !default;\r\n$input-focus-color: $input-color !default;\r\n$input-focus-width: $input-btn-focus-width !default;\r\n$input-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$input-placeholder-color: $gray-600 !default;\r\n\r\n$input-height-border: $input-border-width * 2 !default;\r\n\r\n$input-height-inner: ($font-size-base * $input-btn-line-height) + ($input-btn-padding-y * 2) !default;\r\n$input-height: calc(#{$input-height-inner} + #{$input-height-border}) !default;\r\n\r\n$input-height-inner-sm: ($font-size-sm * $input-btn-line-height-sm) + ($input-btn-padding-y-sm * 2) !default;\r\n$input-height-sm: calc(#{$input-height-inner-sm} + #{$input-height-border}) !default;\r\n\r\n$input-height-inner-lg: ($font-size-lg * $input-btn-line-height-lg) + ($input-btn-padding-y-lg * 2) !default;\r\n$input-height-lg: calc(#{$input-height-inner-lg} + #{$input-height-border}) !default;\r\n\r\n$input-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n$form-text-margin-top: .25rem !default;\r\n\r\n$form-check-input-gutter: 1.25rem !default;\r\n$form-check-input-margin-y: .3rem !default;\r\n$form-check-input-margin-x: .25rem !default;\r\n\r\n$form-check-inline-margin-x: .75rem !default;\r\n$form-check-inline-input-margin-x: .3125rem !default;\r\n\r\n$form-group-margin-bottom: 1rem !default;\r\n\r\n$input-group-addon-color: $input-color !default;\r\n$input-group-addon-bg: $gray-200 !default;\r\n$input-group-addon-border-color: $input-border-color !default;\r\n\r\n$custom-control-gutter: 1.5rem !default;\r\n$custom-control-spacer-x: 1rem !default;\r\n\r\n$custom-control-indicator-size: 1rem !default;\r\n$custom-control-indicator-bg: $gray-300 !default;\r\n$custom-control-indicator-bg-size: 50% 50% !default;\r\n$custom-control-indicator-box-shadow: inset 0 .25rem .25rem rgba($black, .1) !default;\r\n\r\n$custom-control-indicator-disabled-bg: $gray-200 !default;\r\n$custom-control-label-disabled-color: $gray-600 !default;\r\n\r\n$custom-control-indicator-checked-color: $component-active-color !default;\r\n$custom-control-indicator-checked-bg: $component-active-bg !default;\r\n$custom-control-indicator-checked-disabled-bg: rgba(theme-color(\"primary\"), .5) !default;\r\n$custom-control-indicator-checked-box-shadow: none !default;\r\n\r\n$custom-control-indicator-focus-box-shadow: 0 0 0 1px $body-bg, $input-btn-focus-box-shadow !default;\r\n\r\n$custom-control-indicator-active-color: $component-active-color !default;\r\n$custom-control-indicator-active-bg: lighten($component-active-bg, 35%) !default;\r\n$custom-control-indicator-active-box-shadow: none !default;\r\n\r\n$custom-checkbox-indicator-border-radius: $border-radius !default;\r\n$custom-checkbox-indicator-icon-checked: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$custom-checkbox-indicator-indeterminate-bg: $component-active-bg !default;\r\n$custom-checkbox-indicator-indeterminate-color: $custom-control-indicator-checked-color !default;\r\n$custom-checkbox-indicator-icon-indeterminate: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$custom-checkbox-indicator-indeterminate-box-shadow: none !default;\r\n\r\n$custom-radio-indicator-border-radius: 50% !default;\r\n$custom-radio-indicator-icon-checked: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='#{$custom-control-indicator-checked-color}'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$custom-select-padding-y: .375rem !default;\r\n$custom-select-padding-x: .75rem !default;\r\n$custom-select-height: $input-height !default;\r\n$custom-select-indicator-padding: 1rem !default; // Extra padding to account for the presence of the background-image based indicator\r\n$custom-select-line-height: $input-btn-line-height !default;\r\n$custom-select-color: $input-color !default;\r\n$custom-select-disabled-color: $gray-600 !default;\r\n$custom-select-bg: $white !default;\r\n$custom-select-disabled-bg: $gray-200 !default;\r\n$custom-select-bg-size: 8px 10px !default; // In pixels because image dimensions\r\n$custom-select-indicator-color: $gray-800 !default;\r\n$custom-select-indicator: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$custom-select-border-width: $input-btn-border-width !default;\r\n$custom-select-border-color: $input-border-color !default;\r\n$custom-select-border-radius: $border-radius !default;\r\n\r\n$custom-select-focus-border-color: $input-focus-border-color !default;\r\n$custom-select-focus-box-shadow: inset 0 1px 2px rgba($black, .075), 0 0 5px rgba($custom-select-focus-border-color, .5) !default;\r\n\r\n$custom-select-font-size-sm: 75% !default;\r\n$custom-select-height-sm: $input-height-sm !default;\r\n\r\n$custom-select-font-size-lg: 125% !default;\r\n$custom-select-height-lg: $input-height-lg !default;\r\n\r\n$custom-file-height: $input-height !default;\r\n$custom-file-focus-border-color: $input-focus-border-color !default;\r\n$custom-file-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$custom-file-padding-y: $input-btn-padding-y !default;\r\n$custom-file-padding-x: $input-btn-padding-x !default;\r\n$custom-file-line-height: $input-btn-line-height !default;\r\n$custom-file-color: $input-color !default;\r\n$custom-file-bg: $input-bg !default;\r\n$custom-file-border-width: $input-btn-border-width !default;\r\n$custom-file-border-color: $input-border-color !default;\r\n$custom-file-border-radius: $input-border-radius !default;\r\n$custom-file-box-shadow: $input-box-shadow !default;\r\n$custom-file-button-color: $custom-file-color !default;\r\n$custom-file-button-bg: $input-group-addon-bg !default;\r\n$custom-file-text: (\r\n        en: \"Browse\"\r\n) !default;\r\n\r\n// Form validation\r\n$form-feedback-margin-top: $form-text-margin-top !default;\r\n$form-feedback-font-size: $small-font-size !default;\r\n$form-feedback-valid-color: theme-color(\"success\") !default;\r\n$form-feedback-invalid-color: theme-color(\"danger\") !default;\r\n\r\n// Dropdowns\r\n//\r\n// Dropdown menu container and contents.\r\n\r\n$dropdown-min-width: 10rem !default;\r\n$dropdown-padding-y: .5rem !default;\r\n$dropdown-spacer: .125rem !default;\r\n$dropdown-bg: $white !default;\r\n$dropdown-border-color: rgba($black, .15) !default;\r\n$dropdown-border-radius: $border-radius !default;\r\n$dropdown-border-width: $border-width !default;\r\n$dropdown-divider-bg: $gray-200 !default;\r\n$dropdown-box-shadow: 0 .5rem 1rem rgba($black, .175) !default;\r\n\r\n$dropdown-link-color: $gray-900 !default;\r\n$dropdown-link-hover-color: darken($gray-900, 5%) !default;\r\n$dropdown-link-hover-bg: $gray-100 !default;\r\n\r\n$dropdown-link-active-color: $component-active-color !default;\r\n$dropdown-link-active-bg: $component-active-bg !default;\r\n\r\n$dropdown-link-disabled-color: $gray-600 !default;\r\n\r\n$dropdown-item-padding-y: .25rem !default;\r\n$dropdown-item-padding-x: 1.5rem !default;\r\n\r\n$dropdown-header-color: $gray-600 !default;\r\n\r\n// Z-index master list\r\n//\r\n// Warning: Avoid customizing these values. They're used for a bird's eye view\r\n// of components dependent on the z-axis and are designed to all work together.\r\n\r\n$zindex-dropdown: 1000 !default;\r\n$zindex-sticky: 1020 !default;\r\n$zindex-fixed: 1030 !default;\r\n$zindex-modal-backdrop: 1040 !default;\r\n$zindex-modal: 1050 !default;\r\n$zindex-popover: 1060 !default;\r\n$zindex-tooltip: 1070 !default;\r\n\r\n// Navs\r\n\r\n$nav-link-padding-y: .5rem !default;\r\n$nav-link-padding-x: 1rem !default;\r\n$nav-link-disabled-color: $gray-600 !default;\r\n\r\n$nav-tabs-border-color: $gray-300 !default;\r\n$nav-tabs-border-width: $border-width !default;\r\n$nav-tabs-border-radius: $border-radius !default;\r\n$nav-tabs-link-hover-border-color: $gray-200 $gray-200 $nav-tabs-border-color !default;\r\n$nav-tabs-link-active-color: $gray-700 !default;\r\n$nav-tabs-link-active-bg: $body-bg !default;\r\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\r\n\r\n$nav-pills-border-radius: $border-radius !default;\r\n$nav-pills-link-active-color: $component-active-color !default;\r\n$nav-pills-link-active-bg: $component-active-bg !default;\r\n\r\n// Navbar\r\n\r\n$navbar-padding-y: ($spacer / 2) !default;\r\n$navbar-padding-x: $spacer !default;\r\n\r\n$navbar-nav-link-padding-x: .5rem !default;\r\n\r\n$navbar-brand-font-size: $font-size-lg !default;\r\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\r\n$nav-link-height: ($font-size-base * $line-height-base + $nav-link-padding-y * 2) !default;\r\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base !default;\r\n$navbar-brand-padding-y: ($nav-link-height - $navbar-brand-height) / 2 !default;\r\n\r\n$navbar-toggler-padding-y: .25rem !default;\r\n$navbar-toggler-padding-x: .75rem !default;\r\n$navbar-toggler-font-size: $font-size-lg !default;\r\n$navbar-toggler-border-radius: $btn-border-radius !default;\r\n\r\n$navbar-dark-color: rgba($white, .5) !default;\r\n$navbar-dark-hover-color: rgba($white, .75) !default;\r\n$navbar-dark-active-color: $white !default;\r\n$navbar-dark-disabled-color: rgba($white, .25) !default;\r\n$navbar-dark-toggler-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-dark-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$navbar-dark-toggler-border-color: rgba($white, .1) !default;\r\n\r\n$navbar-light-color: rgba($black, .5) !default;\r\n$navbar-light-hover-color: rgba($black, .7) !default;\r\n$navbar-light-active-color: rgba($black, .9) !default;\r\n$navbar-light-disabled-color: rgba($black, .3) !default;\r\n$navbar-light-toggler-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\r\n\r\n// Pagination\r\n\r\n$pagination-padding-y: .5rem !default;\r\n$pagination-padding-x: .75rem !default;\r\n$pagination-padding-y-sm: .25rem !default;\r\n$pagination-padding-x-sm: .5rem !default;\r\n$pagination-padding-y-lg: .75rem !default;\r\n$pagination-padding-x-lg: 1.5rem !default;\r\n$pagination-line-height: 1.25 !default;\r\n\r\n$pagination-color: $link-color !default;\r\n$pagination-bg: $white !default;\r\n$pagination-border-width: $border-width !default;\r\n$pagination-border-color: $gray-300 !default;\r\n\r\n$pagination-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$pagination-hover-color: $link-hover-color !default;\r\n$pagination-hover-bg: $gray-200 !default;\r\n$pagination-hover-border-color: $gray-300 !default;\r\n\r\n$pagination-active-color: $component-active-color !default;\r\n$pagination-active-bg: $component-active-bg !default;\r\n$pagination-active-border-color: $pagination-active-bg !default;\r\n\r\n$pagination-disabled-color: $gray-600 !default;\r\n$pagination-disabled-bg: $white !default;\r\n$pagination-disabled-border-color: $gray-300 !default;\r\n\r\n// Jumbotron\r\n\r\n$jumbotron-padding: 2rem !default;\r\n$jumbotron-bg: $gray-200 !default;\r\n\r\n// Cards\r\n\r\n$card-spacer-y: .75rem !default;\r\n$card-spacer-x: 1.25rem !default;\r\n$card-border-width: $border-width !default;\r\n$card-border-radius: $border-radius !default;\r\n$card-border-color: rgba($black, .125) !default;\r\n$card-inner-border-radius: calc(#{$card-border-radius} - #{$card-border-width}) !default;\r\n$card-cap-bg: rgba($black, .03) !default;\r\n$card-bg: $white !default;\r\n\r\n$card-img-overlay-padding: 1.25rem !default;\r\n\r\n$card-group-margin: ($grid-gutter-width / 2) !default;\r\n$card-deck-margin: $card-group-margin !default;\r\n\r\n$card-columns-count: 3 !default;\r\n$card-columns-gap: 1.25rem !default;\r\n$card-columns-margin: $card-spacer-y !default;\r\n\r\n// Tooltips\r\n\r\n$tooltip-font-size: $font-size-sm !default;\r\n$tooltip-max-width: 200px !default;\r\n$tooltip-color: $white !default;\r\n$tooltip-bg: $black !default;\r\n$tooltip-border-radius: $border-radius !default;\r\n$tooltip-opacity: .9 !default;\r\n$tooltip-padding-y: .25rem !default;\r\n$tooltip-padding-x: .5rem !default;\r\n$tooltip-margin: 0 !default;\r\n\r\n$tooltip-arrow-width: .8rem !default;\r\n$tooltip-arrow-height: .4rem !default;\r\n$tooltip-arrow-color: $tooltip-bg !default;\r\n\r\n// Popovers\r\n\r\n$popover-font-size: $font-size-sm !default;\r\n$popover-bg: $white !default;\r\n$popover-max-width: 276px !default;\r\n$popover-border-width: $border-width !default;\r\n$popover-border-color: rgba($black, .2) !default;\r\n$popover-border-radius: $border-radius-lg !default;\r\n$popover-box-shadow: 0 .25rem .5rem rgba($black, .2) !default;\r\n\r\n$popover-header-bg: darken($popover-bg, 3%) !default;\r\n$popover-header-color: $headings-color !default;\r\n$popover-header-padding-y: .5rem !default;\r\n$popover-header-padding-x: .75rem !default;\r\n\r\n$popover-body-color: $body-color !default;\r\n$popover-body-padding-y: $popover-header-padding-y !default;\r\n$popover-body-padding-x: $popover-header-padding-x !default;\r\n\r\n$popover-arrow-width: 1rem !default;\r\n$popover-arrow-height: .5rem !default;\r\n$popover-arrow-color: $popover-bg !default;\r\n\r\n$popover-arrow-outer-color: fade-in($popover-border-color, .05) !default;\r\n\r\n// Badges\r\n\r\n$badge-font-size: 75% !default;\r\n$badge-font-weight: $font-weight-bold !default;\r\n$badge-padding-y: .25em !default;\r\n$badge-padding-x: .4em !default;\r\n$badge-border-radius: $border-radius !default;\r\n\r\n$badge-pill-padding-x: .6em !default;\r\n// Use a higher than normal value to ensure completely rounded edges when\r\n// customizing padding or font-size on labels.\r\n$badge-pill-border-radius: 10rem !default;\r\n\r\n// Modals\r\n\r\n// Padding applied to the modal body\r\n$modal-inner-padding: 1rem !default;\r\n\r\n$modal-dialog-margin: .5rem !default;\r\n$modal-dialog-margin-y-sm-up: 1.75rem !default;\r\n\r\n$modal-title-line-height: $line-height-base !default;\r\n\r\n$modal-content-bg: $white !default;\r\n$modal-content-border-color: rgba($black, .2) !default;\r\n$modal-content-border-width: $border-width !default;\r\n$modal-content-box-shadow-xs: 0 .25rem .5rem rgba($black, .5) !default;\r\n$modal-content-box-shadow-sm-up: 0 .5rem 1rem rgba($black, .5) !default;\r\n\r\n$modal-backdrop-bg: $black !default;\r\n$modal-backdrop-opacity: .5 !default;\r\n$modal-header-border-color: $gray-200 !default;\r\n$modal-footer-border-color: $modal-header-border-color !default;\r\n$modal-header-border-width: $modal-content-border-width !default;\r\n$modal-footer-border-width: $modal-header-border-width !default;\r\n$modal-header-padding: 1rem !default;\r\n\r\n$modal-lg: 800px !default;\r\n$modal-md: 500px !default;\r\n$modal-sm: 300px !default;\r\n\r\n$modal-transition: transform .3s ease-out !default;\r\n\r\n// Alerts\r\n//\r\n// Define alert colors, border radius, and padding.\r\n\r\n$alert-padding-y: .75rem !default;\r\n$alert-padding-x: 1.25rem !default;\r\n$alert-margin-bottom: 1rem !default;\r\n$alert-border-radius: $border-radius !default;\r\n$alert-link-font-weight: $font-weight-bold !default;\r\n$alert-border-width: $border-width !default;\r\n\r\n$alert-bg-level: -10 !default;\r\n$alert-border-level: -9 !default;\r\n$alert-color-level: 6 !default;\r\n\r\n// Progress bars\r\n\r\n$progress-height: 1rem !default;\r\n$progress-font-size: ($font-size-base * .75) !default;\r\n$progress-bg: $gray-200 !default;\r\n$progress-border-radius: $border-radius !default;\r\n$progress-box-shadow: inset 0 .1rem .1rem rgba($black, .1) !default;\r\n$progress-bar-color: $white !default;\r\n$progress-bar-bg: theme-color(\"primary\") !default;\r\n$progress-bar-animation-timing: 1s linear infinite !default;\r\n$progress-bar-transition: width .6s ease !default;\r\n\r\n// List group\r\n\r\n$list-group-bg: $white !default;\r\n$list-group-border-color: rgba($black, .125) !default;\r\n$list-group-border-width: $border-width !default;\r\n$list-group-border-radius: $border-radius !default;\r\n\r\n$list-group-item-padding-y: .75rem !default;\r\n$list-group-item-padding-x: 1.25rem !default;\r\n\r\n$list-group-hover-bg: $gray-100 !default;\r\n$list-group-active-color: $component-active-color !default;\r\n$list-group-active-bg: $component-active-bg !default;\r\n$list-group-active-border-color: $list-group-active-bg !default;\r\n\r\n$list-group-disabled-color: $gray-600 !default;\r\n$list-group-disabled-bg: $list-group-bg !default;\r\n\r\n$list-group-action-color: $gray-700 !default;\r\n$list-group-action-hover-color: $list-group-action-color !default;\r\n\r\n$list-group-action-active-color: $body-color !default;\r\n$list-group-action-active-bg: $gray-200 !default;\r\n\r\n// Image thumbnails\r\n\r\n$thumbnail-padding: .25rem !default;\r\n$thumbnail-bg: $body-bg !default;\r\n$thumbnail-border-width: $border-width !default;\r\n$thumbnail-border-color: $gray-300 !default;\r\n$thumbnail-border-radius: $border-radius !default;\r\n$thumbnail-box-shadow: 0 1px 2px rgba($black, .075) !default;\r\n\r\n// Figures\r\n\r\n$figure-caption-font-size: 90% !default;\r\n$figure-caption-color: $gray-600 !default;\r\n\r\n// Breadcrumbs\r\n\r\n$breadcrumb-padding-y: .75rem !default;\r\n$breadcrumb-padding-x: 1rem !default;\r\n$breadcrumb-item-padding: .5rem !default;\r\n\r\n$breadcrumb-margin-bottom: 1rem !default;\r\n\r\n$breadcrumb-bg: $gray-200 !default;\r\n$breadcrumb-divider-color: $gray-600 !default;\r\n$breadcrumb-active-color: $gray-600 !default;\r\n$breadcrumb-divider: \"/\" !default;\r\n\r\n// Carousel\r\n\r\n$carousel-control-color: $white !default;\r\n$carousel-control-width: 15% !default;\r\n$carousel-control-opacity: .5 !default;\r\n\r\n$carousel-indicator-width: 30px !default;\r\n$carousel-indicator-height: 3px !default;\r\n$carousel-indicator-spacer: 3px !default;\r\n$carousel-indicator-active-bg: $white !default;\r\n\r\n$carousel-caption-width: 70% !default;\r\n$carousel-caption-color: $white !default;\r\n\r\n$carousel-control-icon-width: 20px !default;\r\n\r\n$carousel-control-prev-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$carousel-control-next-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$carousel-transition: transform .6s ease !default;\r\n\r\n// Close\r\n\r\n$close-font-size: $font-size-base * 1.5 !default;\r\n$close-font-weight: $font-weight-bold !default;\r\n//$close-color: $black !default;\r\n//$close-text-shadow: 0 1px 0 $white !default;\r\n\r\n// Code\r\n\r\n$code-font-size: 87.5% !default;\r\n$code-color: $pink !default;\r\n\r\n$kbd-padding-y: .2rem !default;\r\n$kbd-padding-x: .4rem !default;\r\n$kbd-font-size: $code-font-size !default;\r\n$kbd-color: $white !default;\r\n$kbd-bg: $gray-900 !default;\r\n\r\n$pre-color: $gray-900 !default;\r\n$pre-scrollable-max-height: 340px !default;\r\n\r\n// Printing\r\n$print-page-size: a3 !default;\r\n$print-body-min-width: map-get($grid-breakpoints, \"lg\") !default;\r\n","// Width and height Styles\r\n\r\n@each $prop, $abbrev in (width: w, height: h, max-width: mw, max-height: mh) {\r\n  @each $size, $length in $sizes {\r\n    .#{$abbrev}-#{$size} {\r\n      #{$prop}: $length !important;\r\n    }\r\n  }\r\n}\r\n","// Utility Color Classes\r\n\r\n//.success {\r\n//\r\n//}\r\n\r\n// Google Color Palette defined: http://www.google.com/design/spec/style/color.html\r\n\r\n$primary: (\r\n        \"base\": #3f51b5,\r\n        \"lighten-5\": #e8eaf6,\r\n        \"lighten-4\": #c5cae9,\r\n        \"lighten-3\": #9fa8da,\r\n        \"lighten-2\": #7986cb,\r\n        \"lighten-1\": #5c6bc0,\r\n        \"darken-1\": #3949ab,\r\n        \"darken-2\": #303f9f,\r\n        \"darken-3\": #283593,\r\n        \"darken-4\": #1a237e,\r\n        \"accent-1\": #8c9eff,\r\n        \"accent-2\": #536dfe,\r\n        \"accent-3\": #3d5afe,\r\n        \"accent-4\": #304ffe\r\n);\r\n\r\n$red: (\r\n        \"base\": #F44336,\r\n        \"lighten-5\": #FFEBEE,\r\n        \"lighten-4\": #FFCDD2,\r\n        \"lighten-3\": #EF9A9A,\r\n        \"lighten-2\": #E57373,\r\n        \"lighten-1\": #EF5350,\r\n        \"darken-1\": #E53935,\r\n        \"darken-2\": #D32F2F,\r\n        \"darken-3\": #C62828,\r\n        \"darken-4\": #B71C1C,\r\n        \"accent-1\": #FF8A80,\r\n        \"accent-2\": #FF5252,\r\n        \"accent-3\": #FF1744,\r\n        \"accent-4\": #D50000\r\n);\r\n\r\n$pink: (\r\n        \"base\": #e91e63,\r\n        \"lighten-5\": #fce4ec,\r\n        \"lighten-4\": #f8bbd0,\r\n        \"lighten-3\": #f48fb1,\r\n        \"lighten-2\": #f06292,\r\n        \"lighten-1\": #ec407a,\r\n        \"darken-1\": #d81b60,\r\n        \"darken-2\": #c2185b,\r\n        \"darken-3\": #ad1457,\r\n        \"darken-4\": #880e4f,\r\n        \"accent-1\": #ff80ab,\r\n        \"accent-2\": #ff4081,\r\n        \"accent-3\": #f50057,\r\n        \"accent-4\": #c51162\r\n);\r\n\r\n$purple: (\r\n        \"base\": #9C27B0,\r\n        \"lighten-5\": #f3e5f5,\r\n        \"lighten-4\": #e1bee7,\r\n        \"lighten-3\": #ce93d8,\r\n        \"lighten-2\": #ba68c8,\r\n        \"lighten-1\": #ab47bc,\r\n        \"darken-1\": #8e24aa,\r\n        \"darken-2\": #7b1fa2,\r\n        \"darken-3\": #6a1b9a,\r\n        \"darken-4\": #4a148c,\r\n        \"accent-1\": #ea80fc,\r\n        \"accent-2\": #e040fb,\r\n        \"accent-3\": #d500f9,\r\n        \"accent-4\": #aa00ff\r\n);\r\n\r\n$deep-purple: (\r\n        \"base\": #673ab7,\r\n        \"lighten-5\": #ede7f6,\r\n        \"lighten-4\": #d1c4e9,\r\n        \"lighten-3\": #b39ddb,\r\n        \"lighten-2\": #9575cd,\r\n        \"lighten-1\": #7e57c2,\r\n        \"darken-1\": #5e35b1,\r\n        \"darken-2\": #512da8,\r\n        \"darken-3\": #4527a0,\r\n        \"darken-4\": #311b92,\r\n        \"accent-1\": #b388ff,\r\n        \"accent-2\": #7c4dff,\r\n        \"accent-3\": #651fff,\r\n        \"accent-4\": #6200ea\r\n);\r\n\r\n$indigo: (\r\n        \"base\": #3f51b5,\r\n        \"lighten-5\": #e8eaf6,\r\n        \"lighten-4\": #c5cae9,\r\n        \"lighten-3\": #9fa8da,\r\n        \"lighten-2\": #7986cb,\r\n        \"lighten-1\": #5c6bc0,\r\n        \"darken-1\": #3949ab,\r\n        \"darken-2\": #303f9f,\r\n        \"darken-3\": #283593,\r\n        \"darken-4\": #1a237e,\r\n        \"accent-1\": #8c9eff,\r\n        \"accent-2\": #536dfe,\r\n        \"accent-3\": #3d5afe,\r\n        \"accent-4\": #304ffe\r\n);\r\n\r\n$blue: (\r\n        \"base\": #2196F3,\r\n        \"lighten-5\": #E3F2FD,\r\n        \"lighten-4\": #BBDEFB,\r\n        \"lighten-3\": #90CAF9,\r\n        \"lighten-2\": #64B5F6,\r\n        \"lighten-1\": #42A5F5,\r\n        \"darken-1\": #1E88E5,\r\n        \"darken-2\": #1976D2,\r\n        \"darken-3\": #1565C0,\r\n        \"darken-4\": #0D47A1,\r\n        \"accent-1\": #82B1FF,\r\n        \"accent-2\": #448AFF,\r\n        \"accent-3\": #2979FF,\r\n        \"accent-4\": #2962FF\r\n);\r\n\r\n$light-blue: (\r\n        \"base\": #03a9f4,\r\n        \"lighten-5\": #e1f5fe,\r\n        \"lighten-4\": #b3e5fc,\r\n        \"lighten-3\": #81d4fa,\r\n        \"lighten-2\": #4fc3f7,\r\n        \"lighten-1\": #29b6f6,\r\n        \"darken-1\": #039be5,\r\n        \"darken-2\": #0288d1,\r\n        \"darken-3\": #0277bd,\r\n        \"darken-4\": #01579b,\r\n        \"accent-1\": #80d8ff,\r\n        \"accent-2\": #40c4ff,\r\n        \"accent-3\": #00b0ff,\r\n        \"accent-4\": #0091ea\r\n);\r\n\r\n$cyan: (\r\n        \"base\": #00bcd4,\r\n        \"lighten-5\": #e0f7fa,\r\n        \"lighten-4\": #b2ebf2,\r\n        \"lighten-3\": #80deea,\r\n        \"lighten-2\": #4dd0e1,\r\n        \"lighten-1\": #26c6da,\r\n        \"darken-1\": #00acc1,\r\n        \"darken-2\": #0097a7,\r\n        \"darken-3\": #00838f,\r\n        \"darken-4\": #006064,\r\n        \"accent-1\": #84ffff,\r\n        \"accent-2\": #18ffff,\r\n        \"accent-3\": #00e5ff,\r\n        \"accent-4\": #00b8d4\r\n);\r\n\r\n$teal: (\r\n        \"base\": #009688,\r\n        \"lighten-5\": #e0f2f1,\r\n        \"lighten-4\": #b2dfdb,\r\n        \"lighten-3\": #80cbc4,\r\n        \"lighten-2\": #4db6ac,\r\n        \"lighten-1\": #26a69a,\r\n        \"darken-1\": #00897b,\r\n        \"darken-2\": #00796b,\r\n        \"darken-3\": #00695c,\r\n        \"darken-4\": #004d40,\r\n        \"accent-1\": #a7ffeb,\r\n        \"accent-2\": #64ffda,\r\n        \"accent-3\": #1de9b6,\r\n        \"accent-4\": #00bfa5\r\n);\r\n\r\n$green: (\r\n        \"base\": #4CAF50,\r\n        \"lighten-5\": #E8F5E9,\r\n        \"lighten-4\": #C8E6C9,\r\n        \"lighten-3\": #A5D6A7,\r\n        \"lighten-2\": #81C784,\r\n        \"lighten-1\": #66BB6A,\r\n        \"darken-1\": #43A047,\r\n        \"darken-2\": #388E3C,\r\n        \"darken-3\": #2E7D32,\r\n        \"darken-4\": #1B5E20,\r\n        \"accent-1\": #B9F6CA,\r\n        \"accent-2\": #69F0AE,\r\n        \"accent-3\": #00E676,\r\n        \"accent-4\": #00C853\r\n);\r\n\r\n$light-green: (\r\n        \"base\": #8bc34a,\r\n        \"lighten-5\": #f1f8e9,\r\n        \"lighten-4\": #dcedc8,\r\n        \"lighten-3\": #c5e1a5,\r\n        \"lighten-2\": #aed581,\r\n        \"lighten-1\": #9ccc65,\r\n        \"darken-1\": #7cb342,\r\n        \"darken-2\": #689f38,\r\n        \"darken-3\": #558b2f,\r\n        \"darken-4\": #33691e,\r\n        \"accent-1\": #ccff90,\r\n        \"accent-2\": #b2ff59,\r\n        \"accent-3\": #76ff03,\r\n        \"accent-4\": #64dd17\r\n);\r\n\r\n$lime: (\r\n        \"base\": #cddc39,\r\n        \"lighten-5\": #f9fbe7,\r\n        \"lighten-4\": #f0f4c3,\r\n        \"lighten-3\": #e6ee9c,\r\n        \"lighten-2\": #dce775,\r\n        \"lighten-1\": #d4e157,\r\n        \"darken-1\": #c0ca33,\r\n        \"darken-2\": #afb42b,\r\n        \"darken-3\": #9e9d24,\r\n        \"darken-4\": #827717,\r\n        \"accent-1\": #f4ff81,\r\n        \"accent-2\": #eeff41,\r\n        \"accent-3\": #c6ff00,\r\n        \"accent-4\": #aeea00\r\n);\r\n\r\n$yellow: (\r\n        \"base\": #ffeb3b,\r\n        \"lighten-5\": #fffde7,\r\n        \"lighten-4\": #fff9c4,\r\n        \"lighten-3\": #fff59d,\r\n        \"lighten-2\": #fff176,\r\n        \"lighten-1\": #ffee58,\r\n        \"darken-1\": #fdd835,\r\n        \"darken-2\": #fbc02d,\r\n        \"darken-3\": #f9a825,\r\n        \"darken-4\": #f57f17,\r\n        \"accent-1\": #ffff8d,\r\n        \"accent-2\": #ffff00,\r\n        \"accent-3\": #ffea00,\r\n        \"accent-4\": #ffd600\r\n);\r\n\r\n$amber: (\r\n        \"base\": #ffc107,\r\n        \"lighten-5\": #fff8e1,\r\n        \"lighten-4\": #ffecb3,\r\n        \"lighten-3\": #ffe082,\r\n        \"lighten-2\": #ffd54f,\r\n        \"lighten-1\": #ffca28,\r\n        \"darken-1\": #ffb300,\r\n        \"darken-2\": #ffa000,\r\n        \"darken-3\": #ff8f00,\r\n        \"darken-4\": #ff6f00,\r\n        \"accent-1\": #ffe57f,\r\n        \"accent-2\": #ffd740,\r\n        \"accent-3\": #ffc400,\r\n        \"accent-4\": #ffab00\r\n);\r\n\r\n$orange: (\r\n        \"base\": #ff9800,\r\n        \"lighten-5\": #fff3e0,\r\n        \"lighten-4\": #ffe0b2,\r\n        \"lighten-3\": #ffcc80,\r\n        \"lighten-2\": #ffb74d,\r\n        \"lighten-1\": #ffa726,\r\n        \"darken-1\": #fb8c00,\r\n        \"darken-2\": #f57c00,\r\n        \"darken-3\": #ef6c00,\r\n        \"darken-4\": #e65100,\r\n        \"accent-1\": #ffd180,\r\n        \"accent-2\": #ffab40,\r\n        \"accent-3\": #ff9100,\r\n        \"accent-4\": #ff6d00\r\n);\r\n\r\n$deep-orange: (\r\n        \"base\": #ff5722,\r\n        \"lighten-5\": #fbe9e7,\r\n        \"lighten-4\": #ffccbc,\r\n        \"lighten-3\": #ffab91,\r\n        \"lighten-2\": #ff8a65,\r\n        \"lighten-1\": #ff7043,\r\n        \"darken-1\": #f4511e,\r\n        \"darken-2\": #e64a19,\r\n        \"darken-3\": #d84315,\r\n        \"darken-4\": #bf360c,\r\n        \"accent-1\": #ff9e80,\r\n        \"accent-2\": #ff6e40,\r\n        \"accent-3\": #ff3d00,\r\n        \"accent-4\": #dd2c00\r\n);\r\n\r\n$brown: (\r\n        \"base\": #795548,\r\n        \"lighten-5\": #efebe9,\r\n        \"lighten-4\": #d7ccc8,\r\n        \"lighten-3\": #bcaaa4,\r\n        \"lighten-2\": #a1887f,\r\n        \"lighten-1\": #8d6e63,\r\n        \"darken-1\": #6d4c41,\r\n        \"darken-2\": #5d4037,\r\n        \"darken-3\": #4e342e,\r\n        \"darken-4\": #3e2723\r\n);\r\n\r\n$blue-gray: (\r\n        \"base\": #607d8b,\r\n        \"lighten-5\": #eceff1,\r\n        \"lighten-4\": #cfd8dc,\r\n        \"lighten-3\": #b0bec5,\r\n        \"lighten-2\": #90a4ae,\r\n        \"lighten-1\": #78909c,\r\n        \"darken-1\": #546e7a,\r\n        \"darken-2\": #455a64,\r\n        \"darken-3\": #37474f,\r\n        \"darken-4\": #263238\r\n);\r\n\r\n$gray: (\r\n        \"base\": #9e9e9e,\r\n        \"lighten-5\": #fafafa,\r\n        \"lighten-4\": #f5f5f5,\r\n        \"lighten-3\": #eeeeee,\r\n        \"lighten-2\": #e0e0e0,\r\n        \"lighten-1\": #bdbdbd,\r\n        \"darken-1\": #757575,\r\n        \"darken-2\": #616161,\r\n        \"darken-3\": #424242,\r\n        \"darken-4\": #212121\r\n);\r\n\r\n$shades: (\r\n        \"black\": #000000,\r\n        \"white\": #FFFFFF,\r\n        \"transparent\": transparent\r\n);\r\n\r\n$colors_palette: (\r\n        \"primary\": $primary,\r\n        \"red\": $red,\r\n        \"pink\": $pink,\r\n        \"purple\": $purple,\r\n        \"deep-purple\": $deep-purple,\r\n        \"indigo\": $indigo,\r\n        \"blue\": $blue,\r\n        \"light-blue\": $light-blue,\r\n        \"cyan\": $cyan,\r\n        \"teal\": $teal,\r\n        \"green\": $green,\r\n        \"light-green\": $light-green,\r\n        \"lime\": $lime,\r\n        \"yellow\": $yellow,\r\n        \"amber\": $amber,\r\n        \"orange\": $orange,\r\n        \"deep-orange\": $deep-orange,\r\n        \"brown\": $brown,\r\n        \"blue-grey\": $blue-gray,\r\n        \"grey\": $gray,\r\n        \"shades\": $shades\r\n) !default;\r\n\r\n// Color Classes\r\n\r\n@each $color_name, $color in $colors_palette {\r\n  @each $color_type, $color_value in $color {\r\n    @if $color_type == \"base\" {\r\n      .bg-#{$color_name} {\r\n        background-color: $color_value !important;\r\n      }\r\n      .text-#{$color_name} {\r\n        color: $color_value !important;\r\n        &.icon-outline {\r\n          border-color: $color_value !important;\r\n        }\r\n      }\r\n    } @else if $color_name != \"shades\" {\r\n      .bg-#{$color_name}.#{$color_type} {\r\n        background-color: $color_value !important;\r\n      }\r\n      .text-#{$color_name}.text-#{$color_type} {\r\n        color: $color_value !important;\r\n        &.icon-outline {\r\n          border-color: $color_value !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Shade classes\r\n@each $color, $color_value in $shades {\r\n  .bg-#{$color} {\r\n    background-color: $color_value !important;\r\n  }\r\n  .text-#{$color} {\r\n    color: $color_value !important;\r\n    &.icon-outline {\r\n      border-color: $color_value !important;\r\n    }\r\n  }\r\n}\r\n\r\n// usage: color(\"name_of_color\", \"type_of_color\")\r\n// to avoid to repeating map-get($colors, ...)\r\n\r\n@function color($color, $type) {\r\n  @if map-has-key($colors_palette, $color) {\r\n    $curr_color: map-get($colors_palette, $color);\r\n    @if map-has-key($curr_color, $type) {\r\n      @return map-get($curr_color, $type);\r\n    }\r\n  }\r\n  @warn \"Unknown `#{$color}` - `#{$type}` in $colors.\";\r\n  @return null;\r\n}\r\n\r\n\r\n","/*Custom Animation*/\r\n\r\n@keyframes flipCenter {\r\n  0% {\r\n    animation-timing-function: ease-in;\r\n    opacity: 0;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);\r\n  }\r\n  40% {\r\n    animation-timing-function: ease-in;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  60% {\r\n    opacity: 1;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  80% {\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  100% {\r\n    transform: perspective(100000px);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes flipCenter {\r\n  0% {\r\n    animation-timing-function: ease-in;\r\n    opacity: 0;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);\r\n  }\r\n  40% {\r\n    animation-timing-function: ease-in;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  60% {\r\n    opacity: 1;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  80% {\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  100% {\r\n    transform: perspective(100000px);\r\n  }\r\n}\r\n\r\n.flipCenter {\r\n  animation-name: flipCenter;\r\n  backface-visibility: visible;\r\n}\r\n\r\n@keyframes desployDown {\r\n  0% {\r\n    transform: scaleY(0);\r\n    transform-origin: center top 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scaleY(1);\r\n    transform-origin: center top 0;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes desployDown {\r\n  0% {\r\n    transform: scaleY(0);\r\n    transform-origin: center top 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scaleY(1);\r\n    transform-origin: center top 0;\r\n  }\r\n}\r\n\r\n.desployDown {\r\n  animation-name: desployDown;\r\n  backface-visibility: visible;\r\n}\r\n\r\n@keyframes fadeInRightTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes fadeInRightTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.fadeInRightTiny {\r\n  animation-name: fadeInRightTiny;\r\n}\r\n\r\n@keyframes fadeInLeftTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes fadeInLeftTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.fadeInLeftTiny {\r\n  animation-name: fadeInLeftTiny;\r\n}\r\n\r\n@keyframes slideInRightTiny {\r\n  0% {\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes slideInRightTiny {\r\n  0% {\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.slideInRightTiny {\r\n  animation-name: slideInRightTiny;\r\n}\r\n\r\n@keyframes slideInLeftTiny {\r\n  0% {\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes slideInLeftTiny {\r\n  0% {\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.slideInLeftTiny {\r\n  animation-name: slideInLeftTiny;\r\n}\r\n\r\n@keyframes slideInUpTiny {\r\n  0% {\r\n    transform: translate3d(0px, 5%, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes slideInUpTiny {\r\n  0% {\r\n    transform: translate3d(0px, 5%, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.slideInUpTiny {\r\n  animation-name: slideInUpTiny;\r\n}\r\n\r\n/*Animation Durations*/\r\n.animation-duration-1 {\r\n  animation-duration: 0.1s;\r\n}\r\n\r\n.animation-duration-2 {\r\n  animation-duration: 0.2s;\r\n}\r\n\r\n.animation-duration-3 {\r\n  animation-duration: 0.3s;\r\n}\r\n\r\n.animation-duration-4 {\r\n  animation-duration: 0.4s;\r\n}\r\n\r\n.animation-duration-5 {\r\n  animation-duration: 0.5s;\r\n}\r\n\r\n.animation-duration-6 {\r\n  animation-duration: 0.6s;\r\n}\r\n\r\n.animation-duration-7 {\r\n  animation-duration: 0.7s;\r\n}\r\n\r\n.animation-duration-8 {\r\n  animation-duration: 0.8s;\r\n}\r\n\r\n.animation-duration-9 {\r\n  animation-duration: 0.9s;\r\n}\r\n\r\n.animation-duration-10 {\r\n  animation-duration: 1s;\r\n}\r\n\r\n.animation-duration-11 {\r\n  animation-duration: 1.1s;\r\n}\r\n\r\n.animation-duration-12 {\r\n  animation-duration: 1.2s;\r\n}\r\n\r\n.animation-duration-13 {\r\n  animation-duration: 1.3s;\r\n}\r\n\r\n.animation-duration-14 {\r\n  animation-duration: 1.4s;\r\n}\r\n\r\n.animation-duration-15 {\r\n  animation-duration: 1.5s;\r\n}\r\n\r\n.animation-duration-16 {\r\n  animation-duration: 1.6s;\r\n}\r\n\r\n.animation-duration-17 {\r\n  animation-duration: 1.7s;\r\n}\r\n\r\n.animation-duration-18 {\r\n  animation-duration: 1.8s;\r\n}\r\n\r\n.animation-duration-19 {\r\n  animation-duration: 1.9s;\r\n}\r\n\r\n.animation-duration-20 {\r\n  animation-duration: 2s;\r\n}\r\n\r\n.animation-duration-21 {\r\n  animation-duration: 2.1s;\r\n}\r\n\r\n.animation-duration-22 {\r\n  animation-duration: 2.2s;\r\n}\r\n\r\n.animation-duration-23 {\r\n  animation-duration: 2.3s;\r\n}\r\n\r\n.animation-duration-24 {\r\n  animation-duration: 2.4s;\r\n}\r\n\r\n.animation-duration-25 {\r\n  animation-duration: 2.5s;\r\n}\r\n\r\n.animation-duration-26 {\r\n  animation-duration: 2.6s;\r\n}\r\n\r\n.animation-duration-27 {\r\n  animation-duration: 2.7s;\r\n}\r\n\r\n.animation-duration-28 {\r\n  animation-duration: 2.8s;\r\n}\r\n\r\n.animation-duration-29 {\r\n  animation-duration: 2.9s;\r\n}\r\n\r\n.animation-duration-30 {\r\n  animation-duration: 3s;\r\n}\r\n\r\n.animation-duration-31 {\r\n  animation-duration: 3.1s;\r\n}\r\n\r\n.animation-duration-32 {\r\n  animation-duration: 3.2s;\r\n}\r\n\r\n.animation-duration-33 {\r\n  animation-duration: 3.3s;\r\n}\r\n\r\n.animation-duration-34 {\r\n  animation-duration: 3.4s;\r\n}\r\n\r\n.animation-duration-35 {\r\n  animation-duration: 3.5s;\r\n}\r\n\r\n.animation-duration-36 {\r\n  animation-duration: 3.6s;\r\n}\r\n\r\n.animation-duration-37 {\r\n  animation-duration: 3.7s;\r\n}\r\n\r\n.animation-duration-38 {\r\n  animation-duration: 3.8s;\r\n}\r\n\r\n.animation-duration-39 {\r\n  animation-duration: 3.9s;\r\n}\r\n\r\n.animation-duration-40 {\r\n  animation-duration: 4s;\r\n}\r\n\r\n//Animation Delay\r\n\r\n.animation-delay-1 {\r\n  animation-delay: 0.1s;\r\n}\r\n\r\n.animation-delay-2 {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.animation-delay-3 {\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n.animation-delay-4 {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n.animation-delay-5 {\r\n  animation-delay: 0.5s;\r\n}\r\n\r\n.animation-delay-6 {\r\n  animation-delay: 0.6s;\r\n}\r\n\r\n.animation-delay-7 {\r\n  animation-delay: 0.7s;\r\n}\r\n\r\n.animation-delay-8 {\r\n  animation-delay: 0.8s;\r\n}\r\n\r\n.animation-delay-9 {\r\n  animation-delay: 0.9s;\r\n}\r\n\r\n.animation-delay-10 {\r\n  animation-delay: 1s;\r\n}\r\n\r\n.animation-delay-11 {\r\n  animation-delay: 1.1s;\r\n}\r\n\r\n.animation-delay-12 {\r\n  animation-delay: 1.2s;\r\n}\r\n\r\n.animation-delay-13 {\r\n  animation-delay: 1.3s;\r\n}\r\n\r\n.animation-delay-14 {\r\n  animation-delay: 1.4s;\r\n}\r\n\r\n.animation-delay-15 {\r\n  animation-delay: 1.5s;\r\n}\r\n\r\n.animation-delay-16 {\r\n  animation-delay: 1.6s;\r\n}\r\n\r\n.animation-delay-17 {\r\n  animation-delay: 1.7s;\r\n}\r\n\r\n.animation-delay-18 {\r\n  animation-delay: 1.8s;\r\n}\r\n\r\n.animation-delay-19 {\r\n  animation-delay: 1.9s;\r\n}\r\n\r\n.animation-delay-20 {\r\n  animation-delay: 2s;\r\n}\r\n\r\n.animation-delay-21 {\r\n  animation-delay: 2.1s;\r\n}\r\n\r\n.animation-delay-22 {\r\n  animation-delay: 2.2s;\r\n}\r\n\r\n.animation-delay-23 {\r\n  animation-delay: 2.3s;\r\n}\r\n\r\n.animation-delay-24 {\r\n  animation-delay: 2.4s;\r\n}\r\n\r\n.animation-delay-25 {\r\n  animation-delay: 2.5s;\r\n}\r\n\r\n.animation-delay-26 {\r\n  animation-delay: 2.6s;\r\n}\r\n\r\n.animation-delay-27 {\r\n  animation-delay: 2.6s;\r\n}\r\n\r\n.animation-delay-28 {\r\n  animation-delay: 2.8s;\r\n}\r\n\r\n.animation-delay-29 {\r\n  animation-delay: 2.9s;\r\n}\r\n\r\n.animation-delay-30 {\r\n  animation-delay: 3s;\r\n}\r\n\r\n.animation-delay-31 {\r\n  animation-delay: 3.1s;\r\n}\r\n\r\n.animation-delay-32 {\r\n  animation-delay: 3.2s;\r\n}\r\n\r\n.animation-delay-33 {\r\n  animation-delay: 3.3s;\r\n}\r\n\r\n.animation-delay-34 {\r\n  animation-delay: 3.4s;\r\n}\r\n\r\n.animation-delay-35 {\r\n  animation-delay: 3.5s;\r\n}\r\n\r\n.animation-delay-36 {\r\n  animation-delay: 3.6s;\r\n}\r\n\r\n.animation-delay-37 {\r\n  animation-delay: 3.7s;\r\n}\r\n\r\n.animation-delay-38 {\r\n  animation-delay: 3.8s;\r\n}\r\n\r\n.animation-delay-39 {\r\n  animation-delay: 3.9s;\r\n}\r\n\r\n.animation-delay-40 {\r\n  animation-delay: 4s;\r\n}\r\n\r\n.animation-delay-41 {\r\n  animation-delay: 4.1s;\r\n}\r\n\r\n.animation-delay-42 {\r\n  animation-delay: 4.2s;\r\n}\r\n\r\n.animation-delay-43 {\r\n  animation-delay: 4.3s;\r\n}\r\n\r\n.animation-delay-44 {\r\n  animation-delay: 4.4s;\r\n}\r\n\r\n.animation-delay-45 {\r\n  animation-delay: 4.5s;\r\n}\r\n\r\n.animation-delay-46 {\r\n  animation-delay: 4.6s;\r\n}\r\n\r\n.animation-delay-47 {\r\n  animation-delay: 4.7s;\r\n}\r\n\r\n.animation-delay-48 {\r\n  animation-delay: 4.8s;\r\n}\r\n\r\n.animation-delay-49 {\r\n  animation-delay: 4.9s;\r\n}\r\n\r\n.animation-delay-50 {\r\n  animation-delay: 5s;\r\n}","/* Base\r\n   ========================================================================== */\r\n@import \"base\";\r\n@import \"typography\";","/*Base Styles*/\r\n\r\nhtml {\r\n  height: 100%;\r\n}\r\n\r\nbody {\r\n  font: {\r\n    family: $font-family-base;\r\n    size: $font-size-base;\r\n    weight: $font-weight-base;\r\n  }\r\n  color: $body-color;\r\n  background-color: $body-bg;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\nbody.ios-mobile-view-height {\r\n  height: auto !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n#nprogress .bar {\r\n  z-index: 5000 !important;\r\n  background: $app-primary !important;\r\n}\r\n\r\n#nprogress .peg {\r\n  @include box-shadow(0 0 10px $app-primary, 0 0 5px $app-primary !important);\r\n}\r\n\r\n#nprogress .spinner {\r\n  z-index: 5000 !important;\r\n}\r\n\r\n#nprogress .spinner-icon {\r\n  border-top-color: $app-primary !important;\r\n  border-left-color: $app-primary !important;\r\n}\r\n\r\n.ripple-effect {\r\n  @extend %ripple-effect;\r\n}\r\n\r\n.text-transform-none {\r\n  text-transform: none;\r\n}\r\n\r\n.br-break {\r\n  word-break: break-all !important;\r\n}\r\n\r\n.font-weight-semibold {\r\n  font-weight: 500 !important;\r\n}\r\n\r\n.z-index-20 {\r\n  z-index: 20;\r\n}\r\n\r\n.size-120 {\r\n  @extend %size-120;\r\n}\r\n\r\n.size-100 {\r\n  @extend %size-100;\r\n}\r\n\r\n.size-80 {\r\n  @extend %size-80;\r\n}\r\n\r\n.size-60 {\r\n  @extend %size-60;\r\n}\r\n\r\n.size-50 {\r\n  @extend %size-50;\r\n}\r\n\r\n.size-40 {\r\n  @extend %size-40;\r\n}\r\n\r\n.size-30 {\r\n  @extend %size-30;\r\n}\r\n\r\n.size-20 {\r\n  @extend %size-20;\r\n}\r\n\r\n.border-bottom {\r\n  border-bottom: solid 1px $gray-300;\r\n}\r\n\r\n.col-with-divider div[class*=\"col-\"] {\r\n  border-left: solid 1px $gray-300;\r\n  &:first-child {\r\n    border: 0 none;\r\n  }\r\n}\r\n\r\n.height-100 {\r\n  height: 100px !important;\r\n}\r\n\r\n.height-150 {\r\n  height: 150px !important;\r\n}\r\n\r\n.height-130 {\r\n  height: 130px !important;\r\n}\r\n\r\n.height-200 {\r\n  height: 200px !important;\r\n}\r\n\r\n.max-width-100 {\r\n  max-width: 100px !important;\r\n}\r\n\r\n.max-height-120 {\r\n  max-height: 120px !important;\r\n}\r\n\r\n.right-arrow {\r\n  display: inline-block;\r\n  color: $app-primary;\r\n  text-transform: capitalize;\r\n  &:after {\r\n    content: \"\\f30f\";\r\n    font-family: \"Material-Design-Iconic-Font\";\r\n    color: $app-primary;\r\n    margin-left: 8px;\r\n    font-size: 20px;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  &:hover,\r\n  &:focus {\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n.letter-spacing-base {\r\n  letter-spacing: $letter-spacing-base;\r\n}\r\n\r\n.letter-spacing-lg {\r\n  letter-spacing: $letter-spacing-lg;\r\n}\r\n\r\n.letter-spacing-xl {\r\n  letter-spacing: $letter-spacing-xl;\r\n}\r\n\r\n.page-heading {\r\n  margin-bottom: $jr-card-margin + 4px;\r\n\r\n  & .title {\r\n    text-transform: capitalize;\r\n    font-weight: 600;\r\n  }\r\n\r\n  & .breadcrumb {\r\n    padding: 0;\r\n    background-color: transparent;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.sub-heading {\r\n  font-size: $font-size-base;\r\n  color: $gray-500;\r\n  margin-bottom: 0;\r\n  &:not(:last-child) {\r\n    margin-bottom: 16px !important;\r\n  }\r\n}\r\n\r\n.manage-margin {\r\n  margin-bottom: 0;\r\n  & > * {\r\n    margin-bottom: 6px;\r\n    &:not(:last-child) {\r\n      margin-right: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n//Shadow\r\n.no-shadow {\r\n  @include box-shadow(none !important);\r\n}\r\n\r\n.shadow-sm {\r\n  @include box-shadow($shadow-sm);\r\n}\r\n\r\n.shadow {\r\n  @include box-shadow($shadow);\r\n}\r\n\r\n.shadow-lg {\r\n  @include box-shadow($shadow-lg);\r\n}\r\n\r\n.shadow-xl {\r\n  @include box-shadow($shadow-xl);\r\n}\r\n\r\n.avatar-shadow {\r\n  @include box-shadow($avatar-shadow);\r\n}\r\n\r\n.remove-table-border {\r\n  td, th {\r\n    border: 0 none;\r\n  }\r\n}\r\n\r\n//Media Object list\r\n.media-list {\r\n  margin-bottom: 10px;\r\n  &:not(:last-child) {\r\n    border-bottom: solid 1px $gray-200;\r\n    padding-bottom: 15px;\r\n    margin-bottom: 20px;\r\n    position: relative;\r\n  }\r\n}\r\n\r\n.border-2 {\r\n  border: 2px solid $gray-400 !important;\r\n}\r\n\r\n.border-w2 {\r\n  border-width: 2px;\r\n}\r\n\r\n// Border Color Classes\r\n\r\n@each $color_name, $color in $colors_palette {\r\n  @each $color_type, $color_value in $color {\r\n    @if $color_type == \"base\" {\r\n      .border-#{$color_name} {\r\n        border-color: $color_value !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n//Center Crop image\r\n\r\n.center-crop-img {\r\n  position: relative;\r\n  width: 100%;\r\n  min-height: 120px;\r\n  overflow: hidden;\r\n\r\n  & img {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    height: 100%;\r\n    width: auto;\r\n    -webkit-transform: translate(-50%, -50%);\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  & img.portrait {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n}\r\n\r\n//Bootstrap Components Override\r\n\r\n//Buttons\r\n\r\na.btn-info {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-danger {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-warning {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-success {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-dark {\r\n  @extend %link-hover;\r\n}\r\n\r\n//Badges\r\na.badge-success {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-danger {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-warning {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-info {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-dark {\r\n  @extend %link-hover;\r\n}\r\n\r\n.pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.icon-btn {\r\n  height: 48px;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 48px;\r\n  justify-content: center;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  color: $gray-600;\r\n\r\n  .header-notifications & {\r\n    padding: 0 4px;\r\n  }\r\n}\r\n\r\n.avatar {\r\n  width: 60px;\r\n  height: 60px;\r\n  text-align: center;\r\n  line-height: 60px;\r\n  color: #fafafa;\r\n}\r\n\r\n.avatar-lg {\r\n  width: 80px;\r\n  height: 80px;\r\n  line-height: 80px;\r\n  text-align: center;\r\n  color: #fafafa;\r\n}\r\n\r\n.avatar-sm {\r\n  width: 40px;\r\n  height: 40px;\r\n  text-align: center;\r\n  color: #fafafa;\r\n}\r\n.animated {\r\n  -webkit-animation-fill-mode: none !important;\r\n  animation-fill-mode: none !important\r\n}\r\n\r\n.overflow-hidden {\r\n  overflow: hidden;\r\n}\r\n\r\n.icons-showcase > div {\r\n  cursor: pointer;\r\n  padding: 7px 15px;\r\n  @include border-radius($border-radius);\r\n  overflow: hidden;\r\n  text-align: left;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.text-decoration {\r\n  text-decoration: none !important;\r\n}\r\n\r\n.row-5 {\r\n  margin-left: -5px;\r\n  margin-right: -5px;\r\n\r\n  & > [class*='col-'] {\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n  }\r\n}\r\n\r\n.font-size-16 {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.material-icons {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  vertical-align: middle;\r\n  text-align: center;\r\n  padding-bottom: 3px;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  -webkit-appearance: none;\r\n  width: 10px;\r\n  height: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  border-radius: 4px;\r\n  background-image: linear-gradient(to bottom right, #ebebeb, #bebebe);\r\n  border: solid 1px #ababab;\r\n}\r\n\r\n::selection {\r\n  background-color:#006FC9;\r\n  color: #fff;\r\n}\r\n\r\nselect {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  padding: 2px 30px 2px 2px;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.my-tooltip > .tooltip-inner {\r\n  background-color: #fff;\r\n  color: #808080;\r\n  border: 1px solid #d8dcdf;\r\n}\r\n\r\n.my-tooltip [class$=\"arrow\"] {\r\n  display: none;\r\n  // border-top: 5px solid red !important;\r\n}\r\n\r\n::-ms-clear {\r\n  display: none;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.hs-button {\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n  margin:0;\r\n  cursor:pointer;\r\n  display:inline-block;\r\n  font-weight:700;\r\n  line-height:12px;\r\n  position:relative;\r\n  text-align:center;\r\n  transition:all .15s linear;\r\n  background-color:#ff7a59;\r\n  border-color:#ff7a59;\r\n  color:#fff;\r\n  border-radius:3px;\r\n  border-style:solid;\r\n  border-width:1px;\r\n  font-size:14px;\r\n  padding:12px 24px\r\n}\r\n.hs-button:hover,.hs-button:focus {\r\n  background-color:#ff8f73;\r\n  border-color:#ff8f73\r\n}\r\n.hs-button:active {\r\n  background-color:#e66e50;\r\n  border-color:#e66e50\r\n}\r\nlabel {\r\n  font-size:14px;\r\n  width:130px;\r\n  text-align:right;\r\n  color:#33475b;\r\n  display:block;\r\n  float:none;\r\n  width:auto;\r\n  font-weight:500;\r\n  text-align:left;\r\n  line-height:20px;\r\n  padding-top:0;\r\n  margin-bottom:4px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.hs-video-form label {\r\n  color:#fff !important\r\n}\r\n.hs-video-form .hs-back-button{ \r\n  background-color:#fff;\r\n  width:20%;\r\n  height:38px;\r\n  margin-right:10px;\r\n  border:1px solid;\r\n  -webkit-border-radius:3px;\r\n  -moz-border-radius:3px;\r\n  -ms-border-radius:3px;\r\n  border-radius:3px\r\n}\r\n.hs-video-form .hs-button {\r\n  width:70%\r\n}\r\n.hs-video-form .hs-button span {\r\n  font-size:15px\r\n}\r\n.hs-video-form .hs-richtext {\r\n  color:#fff !important\r\n}\r\n.hs-video-form .legal-consent-container {\r\n  max-height:180px !important;\r\n  overflow-y:scroll !important\r\n}\r\n.hs-video-form .legal-consent-container:after {\r\n  content:\"\";\r\n  display:block;\r\n  height:100px;\r\n  width:100%\r\n}.hs-video-form .legal-consent-wrapper {\r\n  position:relative\r\n}\r\n.hs-video-form .legal-consent-overlay {\r\n  position:absolute;\r\n  pointer-events:none;\r\n  left:0;\r\n  bottom:0;\r\n  height:100px;\r\n  width:100%;\r\n  background:linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #292929 100%)\r\n}\r\n.hs-error-msgs label {\r\n  color:#f2545b\r\n}\r\n.hs-input {\r\n  display:inline-block;\r\n  width:90%;\r\n  max-width:500px;\r\n  height:40px;\r\n  padding:9px 10px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n  font-size:16px;\r\n  font-weight:normal;\r\n  line-height:22px;\r\n  color:#33475b;\r\n  border:1px solid #cbd6e2;\r\n  box-sizing:border-box;\r\n  -webkit-border-radius:3px;\r\n  -moz-border-radius:3px;\r\n  -ms-border-radius:3px;\r\n  border-radius:3px\r\n}\r\n.hs-input:not([type=file]) {\r\n  background-color:#f5f8fa\r\n}\r\n.hs-input[type=checkbox],.hs-input[type=radio] {\r\n  cursor:pointer;\r\n  width:auto;\r\n  height:auto;\r\n  padding:0;\r\n  margin:3px 5px 3px 0px;\r\n  line-height:normal;\r\n  border:none\r\n}\r\n.hs-input[type=file] {\r\n  padding:initial;\r\n  border:initial;\r\n  line-height:initial;\r\n  box-shadow:none\r\n}\r\nselect.is-placeholder {\r\n  color:#bfbfbf\r\n}\r\nselect.is-placeholder:focus {\r\n  color:#33475b\r\n}\r\n.hs-input:-moz-placeholder {\r\n  color:#bfbfbf\r\n}\r\n.hs-input::-webkit-input-placeholder {\r\n  color:#bfbfbf\r\n}\r\n.hs-input option:disabled {\r\n  color:#bfbfbf\r\n}\r\n.hs-input input,.hs-input textarea {\r\n  transition:border .2s linear\r\n}\r\n.hs-input:focus {\r\n  outline:none;\r\n  border-color:rgba(82,168,236,.8)\r\n}\r\ntextarea.hs-input{height:auto}select[multiple].hs-input {\r\n  height:inherit\r\n}\r\ninput.hs-input.error,div.field.error input,div.field.error textarea,div.field.error .chzn-choices,textarea.hs-input.error,select.hs-input.error {\r\n  border-color:#c87872 !important;\r\n}\r\ninput.hs-input.error:focus,div.field.error input:focus,div.field.error textarea:focus,div.field.error .chzn-choices:focus,textarea.hs-input.error:focus,select.hs-input.error:focus {\r\n  border-color:#b9554d !important;\r\n}\r\n.actions {\r\n  margin-top:18px;\r\n  margin-bottom:18px;\r\n  padding:17px 0px\r\n}\r\n.inputs-list {\r\n  margin:0 0 5px;\r\n  width:100%;\r\n  padding-left:5px\r\n}\r\n.inputs-list>li {\r\n  display:block;\r\n  padding:0;\r\n  width:100%;\r\n  padding-top:0\r\n}\r\n.inputs-list label {\r\n  display:block;\r\n  float:none;\r\n  width:auto;\r\n  padding:0;\r\n  line-height:18px;\r\n  text-align:left;\r\n  white-space:normal;\r\n  font-weight:normal\r\n}\r\n.inputs-list:first-child {\r\n  padding-top:6px\r\n}\r\n.inputs-list>li+li {\r\n  padding-top:2px\r\n}\r\nul.no-list {\r\n  list-style:none\r\n}\r\n.field {\r\n  margin-bottom:18px\r\n}\r\n.hs-field-desc {\r\n  color:#7c98b6;\r\n  margin:0px 0px 6px;\r\n  font-size:14px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.hs-form-required {\r\n  color:red\r\n}\r\n.hs-richtext {\r\n  margin-bottom:3px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n  line-height:24px;\r\n  font-size:14px;\r\n  color:#33475b\r\n}\r\n.hs-richtext hr {\r\n  text-align:left;\r\n  margin-left:0;\r\n  width:91%\r\n}\r\n.email-correction,.email-validation {\r\n  padding-top:3px;\r\n  font-size:12px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.email-correction a,.email-validation a {\r\n  cursor:pointer\r\n}\r\n@media(max-width: 400px),(min-device-width: 320px)and (max-device-width: 480px) {\r\n  .email-correction form .form-columns-2 .hs-form-field,.email-correction form .form-columns-3 .hs-form-field,.email-validation form .form-columns-2 .hs-form-field,.email-validation form .form-columns-3 .hs-form-field {\r\n    float:none;width:100%\r\n  }\r\n  .email-correction form .form-columns-2 .hs-form-field .hs-input,.email-correction form .form-columns-3 .hs-form-field .hs-input,.email-validation form .form-columns-2 .hs-form-field .hs-input,.email-validation form .form-columns-3 .hs-form-field .hs-input {\r\n    width:90%\r\n  }\r\n  .email-correction form .form-columns-2 .hs-form-field input[type=checkbox],.email-correction form .form-columns-2 .hs-form-field input[type=radio],.email-correction form .form-columns-3 .hs-form-field input[type=checkbox],.email-correction form .form-columns-3 .hs-form-field input[type=radio],.email-validation form .form-columns-2 .hs-form-field input[type=checkbox],.email-validation form .form-columns-2 .hs-form-field input[type=radio],.email-validation form .form-columns-3 .hs-form-field input[type=checkbox],.email-validation form .form-columns-3 .hs-form-field input[type=radio] {\r\n    width:24px\r\n  }\r\n}\r\n.hs-button,.hs-form-field input[type=text],.hs-form-field input[type=email],.hs-form-field input[type=phone],.hs-form-field input[type=number],.hs-form-field input[type=tel],.hs-form-field input[type=date],.hs-form-field textarea {\r\n  -webkit-appearance:none;\r\n  -moz-appearance:none\r\n}\r\n.hs-default-font-element,.hs-main-font-element {\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.hs-form label {\r\n  margin: 0!important;\r\n  font-family: 'Poppins', sans-serif!important;\r\n  // font-weight: bold!important;\r\n}\r\n.hs-form input[type=\"checkbox\"] {\r\n  margin: 0 10px 0 0!important;\r\n}\r\n.hs-form fieldset {\r\n  max-width: unset!important;\r\n}\r\n.hs-input {\r\n  max-width: unset!important;\r\n  font-family: 'Poppins', sans-serif!important;\r\n}\r\n.hs-form .input textarea {\r\n  width: 100%!important;\r\n}\r\n.hs-form .input select {\r\n  width: 100%!important;\r\n}\r\n.hs-form select {\r\n  margin: 0!important;\r\n}\r\n.hs-form textarea {\r\n  margin: 0!important;\r\n}\r\n.hs-form input[type=\"text\"], .hs-form input[type=\"email\"], .hs-form input[type=\"tel\"] {\r\n  margin: 0!important;\r\n}\r\n.hs-form input[type=\"file\" i]::-webkit-file-upload-button {\r\n  cursor: pointer!important;\r\n}\r\n.hs-form ::placeholder {\r\n  color: #bfbfbf!important;\r\n  font-weight: 400!important;\r\n  font-size: 14px!important;\r\n}\r\n.hs-form .input input[type=\"file\"] {\r\n  width: 100%!important;\r\n  margin: 0!important;\r\n}\r\n.hs-form .input input[type=\"text\"] {\r\n  width: 100%!important;\r\n  border: 1px solid #cbd6e2;\r\n  border-radius: 3px!important;\r\n}\r\n.hs-form .input input[type=\"text\"]::placeholder {\r\n  font-size: 14px!important;\r\n}\r\n.hs-field-desc {\r\n  text-align: left!important;\r\n}\r\n.hs-form body .hs-button.primary, body input[type=\"submit\"], body input[type=\"button\"] {\r\n  float: none!important;\r\n  margin: 0!important;\r\n}\r\n.hs-form .actions {\r\n  margin: 0!important;\r\n  text-align: left!important;\r\n}\r\n\r\n\r\n// .hs-form input[type=\"text\"],\r\n// .hs-form input[type=\"email\"],\r\n// .hs-form input[type=\"tel\"] {\r\n//     border: none;\r\n//     box-shadow: none;\r\n//     border-radius: 0;\r\n//     padding: '5px 0 5px 0';\r\n//     font-weight: 400;\r\n//     font-size: 14px;\r\n//     font-family: 'Roboto';\r\n//     letter-spacing: 2;\r\n//     line-height: 1.5;\r\n//     margin: 5px 0 10px 0;\r\n//     color: #0071B9;\r\n//     padding-bottom: 5px;\r\n//     border-bottom: solid #d8dcdf 1px;\r\n//     width: 100%;\r\n// }\r\n\r\n// .hs-form input[type=\"checkbox\"] {\r\n//     margin: 10px 10px 10px 0;\r\n// }\r\n\r\n// .hs-form input[type=\"text\"]:focus {\r\n//     outline: 0;\r\n// }\r\n\r\n// .hs-form input[type=\"email\"]:focus {\r\n//     outline: 0;\r\n// }\r\n\r\n// .hs-form input[type=\"tel\"]:focus {\r\n//     outline: 0;\r\n// }\r\n\r\n// .hs-form label {\r\n//     color: #0071B9;\r\n//     font-family: 'Roboto';\r\n//     margin: 10px 0;\r\n// }\r\n// .hs-form .hs-form-field > label {\r\n//     color: #0071B9;\r\n//     font-family: 'Roboto';\r\n//     margin: 10px 0;\r\n// }\r\n\r\n// .hs-form .hs-field-desc {\r\n//     color: #0071B9;\r\n//     font-family: 'Roboto';\r\n//     margin: 5px 0;\r\n// }\r\n\r\n// .hs-form select {\r\n//     background: whitesmoke;\r\n//     margin: 15px 0 25px 0;\r\n//     color: #5e7993;\r\n//     border-radius: 3px;\r\n//     font-family: 'Roboto';\r\n// }\r\n\r\n// .hs-form select:focus {\r\n//     outline: none;\r\n//     border: none;\r\n// }\r\n\r\n// .hs-form select:active {\r\n//     outline: none;\r\n//     border: none;\r\n// }\r\n\r\n\r\n\r\n// .hs-form .hs-richtext {\r\n//     color: #5e7993;\r\n//     font-family: 'Roboto';\r\n//     margin: 5px 0 20px 0;\r\n//     font-size: 14px;\r\n// }\r\n\r\n// .hs-form textarea {\r\n//     margin: 10px 0;\r\n//     color: #0071B9;\r\n//     border: 1px solid #d8dcdf;\r\n//     border-radius: 0.2rem;\r\n//     width: 100%;\r\n// }\r\n\r\n// .hs-form textarea:focus {\r\n//     outline: none;\r\n// }\r\n\r\n// body .hs-button.primary,\r\n// body input[type=\"submit\"],\r\n// body input[type=\"button\"] {\r\n//     background: #0071B9;\r\n//     color: #ffffff;\r\n//     border-radius: .2rem;\r\n//     padding: 1em;\r\n//     font-size: 14px;\r\n//     font-weight: 400;\r\n//     padding: 10px 20px;\r\n//     // margin: 0 5px;\r\n//     margin-bottom: -70px;\r\n//     font-family: 'Roboto';\r\n//     border: 1px solid #0071B9;\r\n//     -webkit-transition: all .3s ease-in-out;\r\n//     -moz-transition: all .3s ease-in-out;\r\n//     -ms-transition: all .3s ease-in-out;\r\n//     -o-transition: all .3s ease-in-out;\r\n//     transition: all .3s ease-in-out;\r\n//     margin: 30px 0 0 10px;\r\n// }\r\n\r\n// body .hs-button.primary:hover,\r\n// body input[type=\"submit\"]:hover,\r\n// body input[type=\"button\"]:hover {\r\n//     cursor: pointer;\r\n//     opacity: .8\r\n// }\r\n\r\n// body input[type=\"file\"] {\r\n//     margin: 25px 0 25px 0;\r\n//     font-family: 'Roboto';\r\n// }\r\n\r\n// .hs-form .hs-error-msgs label {\r\n//     color: #d8000c;\r\n//     font-size: 13px;\r\n//     padding-bottom: 5px;\r\n// }\r\n\r\n/* OVERRIDE DEFAULT REACT-DATES STYLES */\r\n/*# sourceMappingURL=app.css.map */\r\n\r\n/* Will edit everything selected including everything between a range of dates */\r\n.CalendarDay__selected_span {\r\n  background: #3392E6 !important;\r\n  border: 1px double #3392E6 !important;\r\n  color: white !important;\r\n}\r\n\r\n/* Will edit selected date or the endpoints of a range of dates */\r\n.CalendarDay__selected {\r\n  background: #3392E6 !important;\r\n  border: 1px double #3392E6 !important;\r\n  color: white !important;\r\n}\r\n \r\n/* Will edit when hovered over. _span style also has this property */\r\n.CalendarDay__selected:hover {\r\n  opacity: 0.8 !important;\r\n}\r\n \r\n/* Will edit when the second date (end date) in a range of dates */\r\n/* is not yet selected. Edits the dates between your mouse and said date */\r\n.CalendarDay__hovered_span:hover,\r\n.CalendarDay__hovered_span {\r\n  background: #3392E6 !important;\r\n}\r\n\r\n// Help Icon in lower right corner\r\n.DayPickerKeyboardShortcuts_show__bottomRight::before {\r\n  border-right: 33px solid #3392E6 !important;\r\n  border-right-color: #3392E6 !important;\r\n}\r\n\r\n.SingleDatePicker_picker {\r\n  z-index: 100 !important;\r\n}\r\n\r\n.SingleDatePicker {\r\n  display: block !important;\r\n}\r\n\r\n.SingleDatePickerInput {\r\n  display: block !important;\r\n}\r\n\r\n.DateInput {\r\n  display: block !important;\r\n  width: 100% !important;\r\n}\r\n\r\n.DateInput_input {\r\n  font-size: 14px !important;\r\n  color: #808080 !important;\r\n  border: 1px solid #ced4da !important;\r\n  box-shadow: none !important;\r\n  border-radius: .25rem !important;\r\n  padding: 10px 0 5px 10px !important;\r\n  font-weight: 400 !important;\r\n  display: block !important;\r\n  width: 100% !important;\r\n  height: calc(2.25rem + 2px) !important;\r\n}\r\n\r\n.DateInput_input__focused {\r\n  border: 1px solid #ced4da !important;\r\n  border-radius: .25rem !important;\r\n}\r\n\r\n.DateRangePicker {\r\n  display: block !important;\r\n}\r\n\r\n.DateRangePickerInput {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: space-between !important;\r\n}\r\n\r\n.DateRangePickerInput_arrow {\r\n  padding: 0 10px !important;\r\n}\r\n\r\n.DateInput_input__disabled {\r\n  font-style: normal !important\r\n}\r\n\r\n// Hubspot Styling\r\n\r\n.hs-form input[type=\"text\"],\r\n.hs-form input[type=\"email\"],\r\n.hs-form input[type=\"tel\"] {\r\n    border: none;\r\n    box-shadow: none;\r\n    border-radius: 5;\r\n    padding: '5px 0 5px 0';\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    font-family: 'Roboto';\r\n    letter-spacing: 2;\r\n    line-height: 1.5;\r\n    margin: 5px 0 10px 0;\r\n    color: #0071B9;\r\n    padding-bottom: 5px;\r\n    border: 1px solid #cbd6e2;\r\n    width: 100%;\r\n}\r\n\r\n.hs-form input[type=\"checkbox\"] {\r\n    margin: 10px 10px 10px 0;\r\n}\r\n\r\n.hs-form input[type=\"text\"]:focus {\r\n    outline: 0;\r\n}\r\n\r\n.hs-form input[type=\"email\"]:focus {\r\n    outline: 0;\r\n}\r\n\r\n.hs-form input[type=\"tel\"]:focus {\r\n    outline: 0;\r\n}\r\n\r\n.hs-form label {\r\n    // color: #0071B9;\r\n    font-family: 'Roboto';\r\n    margin: 10px 0;\r\n}\r\n.hs-form .hs-form-field > label {\r\n    color: #0071B9;\r\n    font-family: 'Roboto';\r\n    margin: 10px 0;\r\n}\r\n\r\n.hs-form .hs-field-desc {\r\n    color: #33475b;\r\n    font-family: 'Roboto';\r\n    margin: 5px 0;\r\n}\r\n\r\n.hs-form select {\r\n    background: whitesmoke;\r\n    margin: 15px 0 25px 0;\r\n    color: #5e7993;\r\n    border-radius: 3px;\r\n    font-family: 'Roboto';\r\n}\r\n\r\n.hs-form select:focus {\r\n    outline: none;\r\n}\r\n\r\n.hs-form select:active {\r\n    outline: none;\r\n}\r\n\r\n\r\n\r\n.hs-form .hs-richtext {\r\n    color: #5e7993;\r\n    font-family: 'Roboto';\r\n    margin: 5px 0 20px 0;\r\n    font-size: 14px;\r\n}\r\n\r\n.hs-form textarea {\r\n    margin: 10px 0;\r\n    color: #0071B9;\r\n    border: 1px solid #d8dcdf;\r\n    border-radius: 0.2rem;\r\n    width: 100%;\r\n}\r\n\r\n.hs-form textarea:focus {\r\n    outline: none;\r\n}\r\n\r\nbody .hs-button.primary,\r\nbody input[type=\"submit\"],\r\nbody input[type=\"button\"] {\r\n    background: #0071B9;\r\n    color: #ffffff;\r\n    border-radius: .2rem;\r\n    padding: 1em;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    padding: 10px 20px;\r\n    // margin: 0 5px;\r\n    margin-bottom: -70px;\r\n    font-family: 'Roboto';\r\n    border: 1px solid #0071B9;\r\n    -webkit-transition: all .3s ease-in-out;\r\n    -moz-transition: all .3s ease-in-out;\r\n    -ms-transition: all .3s ease-in-out;\r\n    -o-transition: all .3s ease-in-out;\r\n    transition: all .3s ease-in-out;\r\n    margin: 30px 0 0 10px;\r\n}\r\n\r\nbody .hs-button.primary:hover,\r\nbody input[type=\"submit\"]:hover,\r\nbody input[type=\"button\"]:hover {\r\n    cursor: pointer;\r\n    opacity: .8\r\n}\r\n\r\nbody input[type=\"file\"] {\r\n    margin: 25px 0 25px 0;\r\n    font-family: 'Roboto';\r\n}\r\n\r\n.hs-form .hs-error-msgs label {\r\n    color: #d8000c;\r\n    font-size: 13px;\r\n    padding-bottom: 5px;\r\n}\r\n\r\n.material-icons {\r\n  user-select: none;\r\n}\r\n\r\n.d-inline-block {\r\n  user-select: none;\r\n}\r\n\r\n","/*Typography Styles*/\r\nh1, h2, h3, h4, h5, h6,\r\n.h1, .h2, .h3, .h4, .h5, .h6 {\r\n  font-weight: $headings-font-weight;\r\n  margin: 0 0 $headings-margin-bottom;\r\n  color: $headings-color;\r\n}\r\n\r\nh1, .h1 {\r\n  font-size: $h1-font-size;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\nh2, .h2 {\r\n  font-size: $h2-font-size;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\nh3, .h3 {\r\n  font-size: $h3-font-size;\r\n}\r\n\r\nh4, .h4 {\r\n  font-size: $h4-font-size;\r\n}\r\n\r\nh5, .h5 {\r\n  font-size: $h5-font-size;\r\n}\r\n\r\nh6, .h6 {\r\n  font-size: $h6-font-size;\r\n}\r\n\r\n.text-strikethrough {\r\n  text-decoration: line-through !important;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  h1, .h1 {\r\n    font-size: $h2-font-size;\r\n    font-family: 'Poppins', sans-serif;\r\n  }\r\n\r\n  h2, .h2 {\r\n    font-size: $h3-font-size;\r\n    font-family: 'Poppins', sans-serif;\r\n  }\r\n\r\n  h3, .h3 {\r\n    font-size: $h4-font-size;\r\n  }\r\n}\r\n\r\n.desc-list {\r\n  margin-bottom: 0;\r\n  li {\r\n    padding: $jr-card-padding;\r\n    border-bottom: 1px solid $gray-400;\r\n    margin-left: -$jr-card-margin + 4px;\r\n    margin-right: -$jr-card-margin + 4px;\r\n\r\n    &:last-child {\r\n      border-bottom: 0 none;\r\n    }\r\n\r\n    & .card-title {\r\n      margin-bottom: 6px;\r\n    }\r\n\r\n  }\r\n\r\n  &.even-odd {\r\n    li {\r\n      border-bottom: 0 none;\r\n\r\n      &:nth-child(2n) {\r\n        background-color: $gray-300;\r\n      }\r\n    }\r\n  }\r\n}","/* Layouts\r\n   ========================================================================== */\r\n@import \"app-layout\";\r\n@import \"sidebar\";\r\n@import \"header\";\r\n@import \"navbar\";\r\n@import \"main-content\";\r\n@import \"footer\";\r\n@import \"right-sidebar\";","/*App Layout Styles*/\r\n\r\n#app-site,\r\n.app-main {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.app-container {\r\n  @include display-flex(flex, row, nowrap);\r\n  width: 100%;\r\n}\r\n\r\n.app-sidebar {\r\n  @include display-flex(flex, column, nowrap);\r\n  width: $side-nav-width;\r\n  min-width: $side-nav-width;\r\n  max-width: $side-nav-width;\r\n}\r\n\r\n.app-main-container {\r\n  @include display-flex(flex, column, nowrap);\r\n  width: 100%;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.app-header {\r\n  min-height: $app-bar-height;\r\n  z-index: 99;\r\n  position: relative;\r\n}\r\n\r\n.app-main-content-wrapper {\r\n  flex: 1;\r\n  @include display-flex(flex, column, nowrap);\r\n  width: 100%;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.app-container {\r\n  &.fixed-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n  }\r\n\r\n  &.collapsible-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n\r\n    & .app-main-container {\r\n      position: relative;\r\n    }\r\n  }\r\n\r\n  &.mini-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n\r\n    .app-sidebar {\r\n      width: $mini-drawer-width;\r\n      min-width: $mini-drawer-width;\r\n      max-width: $mini-drawer-width;\r\n    }\r\n  }\r\n}\r\n","/*Sidebar Styles*/\r\n\r\n.side-nav {\r\n  width: $side-nav-width;\r\n  background-color: $sidebar-bg !important;\r\n  color: $sidebar-text-color !important;\r\n  border-right: solid 1px $gray-200 !important;\r\n  z-index: 1250 !important;\r\n  height: 100%;\r\n\r\n  & .user-profile {\r\n    background-color: $sidebar-bg-darken;\r\n    padding: 13px 20px !important;\r\n  }\r\n\r\n  & .user-avatar {\r\n    margin: 0 15px 0 0 !important;\r\n    height: 44px !important;\r\n    width: 44px !important;\r\n    line-height: 44px;\r\n  }\r\n\r\n  & .user-detail {\r\n    & .user-name {\r\n      color: $sidebar-hover-color;\r\n      cursor: pointer;\r\n      font-size: $font-size-base;\r\n      font-weight: 400;\r\n      white-space: nowrap;\r\n    }\r\n  }\r\n}\r\n\r\n.user-detail {\r\n  & .user-name {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n/*Navbar Styles*/\r\nul.nav-menu {\r\n  position: relative;\r\n  font-size: $font-size-base;\r\n  list-style: outside none none;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\nul.nav-menu li {\r\n  position: relative;\r\n  margin-bottom: 1px;\r\n}\r\n\r\nul.nav-menu li.menu {\r\n  & + .nav-header {\r\n    margin-top: 40px;\r\n  }\r\n  & .sub-menu {\r\n    display: none;\r\n  }\r\n  &.open > .sub-menu {\r\n    display: block;\r\n  }\r\n\r\n  &.open {\r\n    & .menu.active > .sub-menu {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\nul.nav-menu li a {\r\n  color: $sidebar-text-color;\r\n  display: block;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  // text-transform: capitalize;\r\n  text-decoration: none;\r\n  @include border-radius(0);\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n    padding: 3px 8px 2px;\r\n  }\r\n}\r\n\r\nul.nav-menu {\r\n  & .nav-header {\r\n    color: $sidebar-text-color;\r\n    padding: 4px 22px;\r\n    font-size: 11px;\r\n    text-transform: uppercase;\r\n\r\n    &:first-child {\r\n      margin-top: 30px;\r\n    }\r\n  }\r\n}\r\n\r\nul.nav-menu > li.selected > a,\r\nul.nav-menu > li.open > a,\r\nul.nav-menu > li > a:hover,\r\nul.nav-menu > li > a:focus {\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\nul.nav-menu li.menu > a {\r\n  padding: 16px 20px;\r\n  border-left: 2px solid transparent;\r\n}\r\n\r\nul.nav-menu li.menu.open > a {\r\n  border-color: transparent;\r\n}\r\n\r\nul.nav-menu li.menu > a:focus:before,\r\nul.nav-menu li.menu > a:hover:before {\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\nul.nav-menu li i {\r\n  margin-right: 12px;\r\n  font-size: 15px;\r\n}\r\n\r\nul.nav-menu li ul {\r\n  list-style: outside none none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu li > a {\r\n  padding: 7px 20px 7px 56px;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu > li > ul > li > a {\r\n  padding-left: 76px;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu > li > ul > li > ul > li > a {\r\n  padding-left: 96px;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu > li > ul > li > ul > li > ul > li > a {\r\n  padding-left: 116px;\r\n}\r\n\r\nul.nav-menu li.menu > a:before {\r\n  color: $sidebar-text-color;\r\n  content: \"\\f2fb\";\r\n  display: inline-block;\r\n  float: right;\r\n  font: {\r\n    family: 'Material-Design-Iconic-Font';\r\n    size: 15px;\r\n  }\r\n  margin-left: 10px;\r\n  position: relative;\r\n  @include transition(all 300ms ease-in-out);\r\n  font-weight: normal;\r\n}\r\nul.nav-menu li.menu.no-arrow > a:before {\r\n  display: none;\r\n}\r\n\r\nul.nav-menu li.menu.selected > a:before,\r\nul.nav-menu li.menu.open > a:before,\r\nul.nav-menu li.menu > a:focus:before,\r\nul.nav-menu li.menu li > a:hover:before {\r\n  background-color: transparent;\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\nul.nav-menu li.menu.open > a:before,\r\nul.nav-menu li.menu.active > a:before {\r\n  @include rotate(90deg);\r\n}\r\n\r\nul.nav-menu li.menu .sub-menu li > a.active .nav-text {\r\n  padding: 3px 7px;\r\n  margin-left: -7px;\r\n  background-color: $sidebar-hover-color;\r\n  color: $white;\r\n  @include border-radius($border-radius);\r\n  display: inline-block;\r\n}\r\n\r\nul.nav-menu li.menu .sub-menu li > a:hover,\r\nul.nav-menu li.menu .sub-menu li > a:focus,\r\nul.nav-menu li.menu.open .sub-menu li > a.active:before,\r\nul.nav-menu li.menu .sub-menu li > a:focus:before,\r\nul.nav-menu li.menu .sub-menu li > a:hover:before {\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\n.app-container.mini-drawer {\r\n  & .side-nav {\r\n    @include transition($transition-base);\r\n    width: $mini-drawer-width;\r\n\r\n    & .nav-menu li span.nav-text,\r\n    & .customizer {\r\n      display: none;\r\n    }\r\n\r\n    & .user-profile .user-detail {\r\n      display: none !important;\r\n    }\r\n\r\n    & .nav-menu .menu.open > .sub-menu {\r\n      display: none !important;\r\n    }\r\n\r\n    & .nav-menu li {\r\n      text-align: center;\r\n      i {\r\n        margin-right: 0;\r\n      }\r\n\r\n      &.nav-header {\r\n        padding: 4px 5px;\r\n      }\r\n    }\r\n\r\n    & ul.nav-menu {\r\n      & li a {\r\n        padding: 16px 20px;\r\n      }\r\n      & ul.sub-menu li a {\r\n        padding-left: 30px;\r\n      }\r\n    }\r\n\r\n    & ul.nav-menu > li > a {\r\n      &:before {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    & .mini-logo-img-hover {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.app-container.mini-drawer {\r\n  & .side-nav:hover {\r\n    width: $side-nav-width;\r\n\r\n    & .nav-menu li span.nav-text {\r\n      display: inline-block !important;\r\n    }\r\n\r\n    & .user-profile .user-detail {\r\n      display: flex !important;\r\n    }\r\n\r\n    & .nav-menu .menu.open > .sub-menu {\r\n      display: block !important;\r\n    }\r\n\r\n    & .customizer {\r\n      display: flex !important;\r\n    }\r\n\r\n    & ul.nav-menu {\r\n      & li {\r\n        text-align: left;\r\n        & i {\r\n          margin-right: 16px;\r\n        }\r\n\r\n        & a {\r\n          padding: 16px 20px;\r\n        }\r\n\r\n        &.nav-header {\r\n          padding: 4px 22px;\r\n        }\r\n      }\r\n\r\n      & ul.sub-menu li a {\r\n        padding: 7px 20px 7px 56px;\r\n      }\r\n\r\n      & ul.sub-menu > li > ul > li > a {\r\n        padding-left: 76px;\r\n      }\r\n\r\n      & ul.sub-menu > li > ul > li > ul > li > a {\r\n        padding-left: 96px;\r\n      }\r\n\r\n      & ul.sub-menu > li > ul > li > ul > li > ul > li > a {\r\n        padding-left: 116px;\r\n      }\r\n    }\r\n\r\n    & ul.nav-menu > li > a {\r\n      &:before {\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    & .mini-logo-img {\r\n      display: none;\r\n    }\r\n\r\n    & .mini-logo-img-hover {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\n.customizer {\r\n  padding: 20px 35px;\r\n  & img {\r\n    padding: 5px;\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.user-info {\r\n  & ul {\r\n    & li {\r\n      font-size: 15px;\r\n    }\r\n  }\r\n}\r\n\r\n.rmc-drawer {\r\n  &-left &-sidebar,\r\n  &-right &-sidebar {\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.rmc-drawer-sidebar {\r\n  position: fixed;\r\n  transition: -webkit-transform 0.3s ease-out;\r\n  transition: transform 0.3s ease-out;\r\n  overflow: hidden;\r\n\r\n  .rmc-drawer.rmc-drawer-left & {\r\n    left: 0;\r\n    -webkit-transform: translateX(-100%);\r\n    transform: translateX(-100%);\r\n    z-index: 903;\r\n  }\r\n\r\n  .rmc-drawer.rmc-drawer-right & {\r\n    right: 0;\r\n    -webkit-transform: translateX(100%);\r\n    transform: translateX(100%);\r\n    z-index: 903;\r\n  }\r\n\r\n  .rmc-drawer.rmc-drawer-top & {\r\n    z-index: 903;\r\n  }\r\n\r\n  .rmc-drawer.rmc-drawer-bottom & {\r\n    z-index: 903;\r\n  }\r\n}\r\n\r\n.rmc-drawer-draghandle {\r\n  @media (max-width: 1025px) {\r\n    background-color: transparent;\r\n  }\r\n}\r\n\r\n.drawer-container {\r\n  position: relative;\r\n  & .main {\r\n    position: relative;\r\n    padding: 10px;\r\n    box-sizing: border-box;\r\n  }\r\n}\r\n\r\n.rmc-drawer-overlay {\r\n  z-index: 902;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: opacity 0.3s ease-out;\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n  height: 100%;\r\n  min-width: 100% !important;\r\n}\r\n\r\n.app-sidebar {\r\n  &.rmc-drawer.rmc-drawer-docked {\r\n    position: relative;\r\n  }\r\n}","/*Header Styles*/\r\n.jr-menu-icon {\r\n  outline: none !important;\r\n  @include justify-content(flex-start !important);\r\n  @extend %size-30;\r\n  padding: 0 5px !important;\r\n  @extend %jr-menu-icon;\r\n  margin-right: 15px;\r\n  display: flex;\r\n  cursor: pointer;\r\n  align-items: center;\r\n}\r\n\r\n.app-main-header {\r\n  background-color: $white;\r\n  color: $gray-default;\r\n  max-height: 70px;\r\n  position: relative;\r\n\r\n  & .search-bar input {\r\n    @include transition($transition-base);\r\n    background-color: transparent;\r\n    color: $gray-default;\r\n    // font-size: 18px;\r\n    font-weight: 200;\r\n    & + .search-icon {\r\n      top: 0;\r\n      & i {\r\n        color: rgba($gray-default, 0.8);\r\n        font-size: 32px;\r\n      }\r\n    }\r\n    &::placeholder {\r\n      color: grey;\r\n\r\n    }\r\n\r\n    &:focus {\r\n      background-color: $body-bg;\r\n      color: $gray-default;\r\n      + .search-icon {\r\n        & i {\r\n          color: rgba($gray-default, 0.8);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .app-header & {\r\n    //box-shadow: rgb(222, 226, 230) 1px 1px 10px;\r\n    // border-bottom: 1px solid $border-color;\r\n  }\r\n\r\n  .jr-card & {\r\n    border: 1px solid $gray-400;\r\n    @include border-radius($border-radius-lg);\r\n  }\r\n}\r\n\r\n.app-logo {\r\n  margin-right: 12px;\r\n\r\n  & img {\r\n    height: 35px;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      height: 28px;\r\n    }\r\n  }\r\n\r\n  .app-header & {\r\n    margin-right: 20px;\r\n\r\n    @media screen and (max-width: 991px) {\r\n      margin-right: auto;\r\n    }\r\n  }\r\n}\r\n\r\n//Logo disable condition\r\n.react-logo-white.d-block {\r\n  display: none !important;\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n  .react-logo-white.d-lg-block {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.sidebar-header {\r\n  min-height: 70px;\r\n  padding: 10px 22px;\r\n  // border-bottom: 1px solid $border-color;\r\n}\r\n\r\n.app-toolbar {\r\n  min-height: $app-bar-height;\r\n  padding: 0 17px 0 0;\r\n\r\n  & .search-bar {\r\n    margin-right: auto;\r\n    max-width: 320px;\r\n    width: 300px;\r\n\r\n    @media screen and (max-width: 1199px) {\r\n      width: 240px;\r\n    }\r\n\r\n    @media screen and (max-width: 1099px) {\r\n      width: 200px;\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n      margin-left: 40px;\r\n      width: 180px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 0 17px;\r\n  }\r\n\r\n  @media screen and (max-width: 1199px) {\r\n    padding: 0 17px;\r\n  }\r\n\r\n  .app-top-nav & {\r\n    min-height: 40px;\r\n  }\r\n}\r\n\r\n.app-header-horizontal {\r\n  & .app-toolbar .search-bar {\r\n    @media screen and (max-width: 1199px) {\r\n      margin-right: 10px;\r\n    }\r\n  }\r\n}\r\n\r\n.app-toolbar-special {\r\n  & .search-bar {\r\n    width: 200px;\r\n\r\n    @media screen and (max-width: 991px) {\r\n      width: 280px;\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n      width: 200px;\r\n    }\r\n  }\r\n}\r\n\r\n.app-toolbar {\r\n  & .nav-searchbox {\r\n    & .search-bar {\r\n      margin-left: 0;\r\n      width: 100%;\r\n    }\r\n\r\n    & .search-bar input {\r\n      @include transition($transition-base);\r\n      background-color: $white;\r\n      color: $body-color;\r\n      & + .search-icon {\r\n        & i {\r\n          color: rgba($body-color, 0.8);\r\n        }\r\n      }\r\n\r\n      &:focus {\r\n        background-color: transparent;\r\n        color: $body-color;\r\n        + .search-icon {\r\n          & i {\r\n            color: rgba($body-color, 0.8);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.header-notifications {\r\n  margin-bottom: 0;\r\n\r\n  & li {\r\n    vertical-align: middle;\r\n  }\r\n\r\n  & .list-inline-item:not(:last-child) {\r\n    @media screen and (max-width: 449px) {\r\n      margin-right: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-menu {\r\n  @include box-shadow(none);\r\n}\r\n\r\n.quick-menu {\r\n\r\n  & .dropdown-menu {\r\n    padding: 5px 10px;\r\n    width: 350px;\r\n\r\n    & .jr-card-header {\r\n      margin: -5px -10px 5px;\r\n      padding: 10px 10px 10px 20px;\r\n      border-bottom: 1px solid $gray-300;\r\n      z-index: 10;\r\n    }\r\n\r\n    &:after {\r\n      border-left: 5px solid transparent;\r\n      border-right: 5px solid transparent;\r\n      border-bottom: 5px solid $white;\r\n      top: -9px;\r\n      content: \"\";\r\n      height: 9px;\r\n      position: absolute;\r\n      right: 8px;\r\n      width: 10px;\r\n    }\r\n\r\n    &:before {\r\n      border-left: 5px solid transparent;\r\n      border-right: 5px solid transparent;\r\n      border-bottom: 5px solid $black;\r\n      top: -10px;\r\n      content: \"\";\r\n      height: 10px;\r\n      position: absolute;\r\n      right: 8px;\r\n      width: 10px;\r\n    }\r\n\r\n    @media screen and (max-width: 449px) {\r\n      width: 230px;\r\n    }\r\n\r\n    @media screen and (max-width: 359px) {\r\n      width: 180px;\r\n    }\r\n  }\r\n\r\n  & .messages-list .user-avatar {\r\n    position: relative;\r\n  }\r\n\r\n  & .messages-list .badge {\r\n    position: absolute;\r\n    left: -4px;\r\n    top: -4px;\r\n    height: 16px;\r\n    width: 16px;\r\n    line-height: 16px;\r\n    text-align: center;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.app-header .nav-searchbox.quick-menu {\r\n  & .dropdown-menu {\r\n    width: 200px;\r\n    left: 0 !important;\r\n    right: auto !important;\r\n  }\r\n\r\n  & .dropdown-menu:after {\r\n    right: auto;\r\n    left: 8px;\r\n  }\r\n\r\n  & .dropdown-menu:before {\r\n    right: auto;\r\n    left: 8px;\r\n  }\r\n\r\n  @media screen and (max-width: 400px) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .app-header .nav-searchbox.quick-menu .dropdown-menu {\r\n    width: 200px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .app-header .nav-searchbox.quick-menu .dropdown-menu {\r\n    width: 100px;\r\n  }\r\n}\r\n\r\n.language-list li {\r\n  display: block !important;\r\n}\r\n\r\n.messages-list.language-list ul li {\r\n  padding: 7px 6px 6px;\r\n}\r\n\r\n.messages-list ul li {\r\n  position: relative;\r\n  padding: 20px 10px 14px;\r\n  border-bottom: 1px solid $gray-300;\r\n\r\n  & .user-name a {\r\n    color: $app-primary;\r\n  }\r\n\r\n  & .sub-heading {\r\n    font-size: 11px;\r\n    margin-bottom: 6px !important;\r\n\r\n    &.mb-0 {\r\n      margin-bottom: 0 !important;\r\n    }\r\n  }\r\n\r\n  &:last-child {\r\n    border-bottom: 0 none;\r\n  }\r\n\r\n  & .jr-btn {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  & .jr-btn-xs {\r\n    font-size: 11px !important;\r\n    padding: 5px !important;\r\n  }\r\n}\r\n\r\n.quick-menu {\r\n  & .icon-btn {\r\n    color: $gray-default;\r\n  }\r\n\r\n  & .icon-alert {\r\n    position: relative;\r\n\r\n    &:after {\r\n      display: block;\r\n      position: absolute;\r\n      content: \"\";\r\n      right: 0;\r\n      top: 0;\r\n      z-index: 10;\r\n      width: 8px;\r\n      height: 8px;\r\n      background-color: $danger;\r\n      @include border-radius(50%);\r\n      @extend %pulse-effect;\r\n    }\r\n  }\r\n\r\n  & i.animated.infinite {\r\n    -moz-animation-iteration-count: 25;\r\n    -webkit-animation-iteration-count: 25;\r\n    -o-animation-iteration-count: 25;\r\n    animation-iteration-count: 25;\r\n  }\r\n}\r\n\r\n.quick-menu {\r\n  & .dropdown-menu {\r\n    display: block;\r\n    visibility: hidden;\r\n    left: auto !important;\r\n    right: 0 !important;\r\n    opacity: 0;\r\n    transform: translate3d(0px, 100px, 0px) !important;\r\n    @include transition(all 200ms linear 0ms);\r\n  }\r\n\r\n  &.show .dropdown-menu {\r\n    opacity: 1;\r\n    transform: translate3d(0px, 30px, 0px) !important;\r\n    visibility: visible;\r\n  }\r\n}\r\n\r\n.user-nav .quick-menu {\r\n  & .dropdown-menu {\r\n    width: 200px;\r\n    padding: 0 0 15px;\r\n\r\n    &:after {\r\n      border-bottom-color: $body-bg;\r\n    }\r\n  }\r\n\r\n  & .user-profile {\r\n    position: relative;\r\n    padding: 20px 25px;\r\n    background-color: $body-bg;\r\n    margin-bottom: 15px;\r\n    @include border-radius(0.25rem 0.25rem 0 0);\r\n  }\r\n}\r\n\r\n.module-box-header-right {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n}\r\n\r\n.app-top-header {\r\n  position: relative;\r\n  z-index: 9999;\r\n}\r\n","/*Navbar Styles*/\r\n.app-main-menu {\r\n  & .navbar-nav {\r\n    @include display-flex();\r\n  }\r\n}\r\n\r\n.navbar-nav {\r\n  position: relative;\r\n\r\n  & li {\r\n    position: relative;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      & > ul.sub-menu {\r\n        opacity: 1;\r\n        visibility: visible;\r\n        top: 100%;\r\n      }\r\n\r\n      & > a {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n\r\n    & a {\r\n      display: block;\r\n      color: $sidebar-text-color;\r\n      padding: 10px 0;\r\n      font-size: 14px;\r\n    }\r\n\r\n    & a:hover,\r\n    & a:focus {\r\n      text-decoration: none;\r\n      color: $app-primary;\r\n    }\r\n\r\n    &.mega-menu {\r\n      position: static;\r\n    }\r\n\r\n    &.mega-menu ul.sub-menu {\r\n      @include display-flex();\r\n      width: 85%;\r\n      margin: 0 auto;\r\n      left: 0;\r\n      right: 0;\r\n\r\n      & li {\r\n        width: 25%;\r\n        padding: 0 15px;\r\n      }\r\n    }\r\n  }\r\n\r\n  & > li {\r\n    &:last-child {\r\n      ul.sub-menu {\r\n        left: auto;\r\n        right: 0;\r\n      }\r\n\r\n      ul.sub-menu ul.sub-menu {\r\n        left: auto;\r\n        right: 100%;\r\n        top: 50px;\r\n      }\r\n\r\n      ul.sub-menu li:hover > ul.sub-menu,\r\n      ul.sub-menu li:focus > ul.sub-menu {\r\n        top: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  & li.nav-item {\r\n    padding: 0 10px;\r\n\r\n    & > a {\r\n      padding: 23px 0;\r\n    }\r\n\r\n    &.active > a {\r\n      color: $app-primary;\r\n    }\r\n  }\r\n\r\n  & li.nav-item:hover > a,\r\n  & li.nav-item:focus > a,\r\n  & li.nav-item > a:hover,\r\n  & li.nav-item > a:focus {\r\n    color: $app-primary;\r\n  }\r\n\r\n  ul.sub-menu {\r\n    list-style: none;\r\n    border: solid 1px $gray-400;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 100px;\r\n    opacity: 0;\r\n    padding: 10px 0;\r\n    background-color: $white;\r\n    visibility: hidden;\r\n    @include border-radius(4px);\r\n    @include transition(all 0.5s ease-in-out);\r\n\r\n    & li {\r\n      & a {\r\n        padding: 5px 15px;\r\n        width: 200px;\r\n        font-size: 14px;\r\n\r\n        &.active {\r\n          color: $app-primary;\r\n        }\r\n      }\r\n\r\n      & > ul.sub-menu {\r\n        left: 100%;\r\n        right: auto;\r\n        top: 50px;\r\n      }\r\n\r\n      &:hover > ul.sub-menu,\r\n      &:focus > ul.sub-menu {\r\n        top: 0;\r\n      }\r\n\r\n      & a i {\r\n        margin-right: 10px;\r\n      }\r\n\r\n      &.active > a {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n  }\r\n\r\n  & .nav-arrow {\r\n    & > a {\r\n      position: relative;\r\n\r\n      &:before {\r\n        color: $sidebar-text-color;\r\n        content: \"\\f2fb\";\r\n        display: inline-block;\r\n        float: right;\r\n        font: {\r\n          family: 'Material-Design-Iconic-Font';\r\n          size: 15px;\r\n        }\r\n        margin-left: 10px;\r\n        position: relative;\r\n        @include transition(all 300ms ease-in-out);\r\n        font-weight: normal;\r\n      }\r\n    }\r\n\r\n    & a:hover,\r\n    & a:focus {\r\n      &:before {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &.active {\r\n      & > a:before {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n  }\r\n\r\n  ul.sub-menu-half {\r\n    @include display-flex();\r\n    width: 300px;\r\n\r\n    & li {\r\n      width: 50%;\r\n\r\n      & a {\r\n        width: 100%;\r\n\r\n        @media screen and (max-width: 1099px) {\r\n          font-size: 13px;\r\n        }\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 1099px) {\r\n      width: 262px;\r\n    }\r\n  }\r\n}\r\n\r\n.navbar-nav-mega {\r\n  position: static !important;\r\n}\r\n\r\n.app-top-nav {\r\n  background-color: $top-nav-bg;\r\n\r\n  & .navbar-nav {\r\n    & li.nav-item {\r\n      padding: 0 30px;\r\n    }\r\n\r\n    & li.nav-item > a {\r\n      color: $white;\r\n      padding: 13px 0;\r\n    }\r\n\r\n    & li.nav-item:hover > a,\r\n    & li.nav-item:focus > a,\r\n    & li.nav-item > a:hover,\r\n    & li.nav-item > a:focus,\r\n    & li.nav-item.active > a {\r\n      color: $secondary;\r\n    }\r\n\r\n    & ul.sub-menu {\r\n      margin-top: 0;\r\n    }\r\n  }\r\n}","/*Main Content Styles*/\r\n.app-main-content {\r\n  flex: 1;\r\n  width: 100%;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.app-wrapper {\r\n  padding: 36px 40px 0 40px;\r\n  width: 100%;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 20px;\r\n  }\r\n}","/*Footer Styles*/\r\n\r\n.app-footer {\r\n  padding: 0 40px;\r\n  border-top: solid 1px darken($body-bg, 10%);\r\n  background-color: $body-bg;\r\n  color: $sidebar-text-color;\r\n  line-height: $footer-height;\r\n  min-height: $footer-height;\r\n\r\n  & a {\r\n    color: $sidebar-text-color;\r\n    &:hover {\r\n      color: $sidebar-hover-color;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 20px;\r\n  }\r\n\r\n  @media screen and (max-width: 400px) {\r\n    font-size: 12px;\r\n  }\r\n}","/*Right Sidebar Styles*/\r\n.color-theme {\r\n  @include display-flex(flex, column, nowrap);\r\n  max-width: 300px;\r\n  height: 100%;\r\n\r\n  @media screen and (max-width: 499px) {\r\n    max-width: 250px;\r\n  }\r\n}\r\n\r\n.color-theme-header {\r\n  background-color: $app-primary;\r\n  color: $white;\r\n  padding: 19px 25px 20px;\r\n  text-transform: uppercase;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-between);\r\n\r\n  & .color-theme-title {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.color-theme-body {\r\n  padding: 28px 25px;\r\n\r\n  & h3 {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  @media screen and (max-width: 499px) {\r\n    padding: 25px 15px;\r\n  }\r\n}\r\n\r\n.color-option {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  margin: 0 -7px 10px;\r\n\r\n  & li {\r\n    position: relative;\r\n    display: inline-block;\r\n    padding: 0 7px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  & li a {\r\n    height: 45px;\r\n    width: 45px;\r\n    line-height: 45px;\r\n    display: inline-block;\r\n    color: transparent !important;\r\n    position: relative;\r\n\r\n    &:before {\r\n      content: \"\\f26b\";\r\n      font-family: \"Material-Design-Iconic-Font\";\r\n      font-size: 20px;\r\n      height: 45px;\r\n      width: 45px;\r\n      line-height: 45px;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      color: $white;\r\n      text-align: center;\r\n      display: none;\r\n      z-index: 2;\r\n    }\r\n  }\r\n\r\n  & li a.active {\r\n    &:before {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\n.cr-op-dark-sidebar {\r\n  & li a {\r\n    &:after {\r\n      content: '';\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      bottom: 0;\r\n      z-index: 1;\r\n      background-color: $body-color;\r\n      width: 8px;\r\n    }\r\n  }\r\n}\r\n\r\n//Coustomizer css\r\n.theme-option {\r\n  position: fixed;\r\n  top: 10%;\r\n  right: 0;\r\n  z-index: 1500;\r\n  background-color: #0070cd;\r\n  @include border-left-radius($border-radius);\r\n  @include box-shadow(1px 1px 4px rgba($black, 0.5));\r\n  color: $white;\r\n\r\n  & span.icon-btn {\r\n    position: relative;\r\n    z-index: 1505;\r\n  }\r\n}\r\n\r\n.app-sidebar-content.right-sidebar .rmc-drawer-sidebar {\r\n  z-index: 1506;\r\n  color: $body-color;\r\n  background-color: $white;\r\n}\r\n\r\n//Switch button\r\n.material-switch {\r\n  margin-bottom: 24px;\r\n\r\n  & > input[type=\"checkbox\"] {\r\n    display: none;\r\n  }\r\n\r\n  & > label {\r\n    cursor: pointer;\r\n    height: 0;\r\n    position: relative;\r\n    width: 40px;\r\n\r\n    &:before {\r\n      background: rgb(0, 0, 0);\r\n      box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);\r\n      border-radius: 8px;\r\n      content: '';\r\n      height: 16px;\r\n      margin-top: -8px;\r\n      position: absolute;\r\n      opacity: 0.3;\r\n      transition: all 0.4s ease-in-out;\r\n      width: 40px;\r\n    }\r\n\r\n    &:after {\r\n      background: rgb(255, 255, 255);\r\n      border-radius: 16px;\r\n      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\r\n      content: '';\r\n      height: 24px;\r\n      left: -4px;\r\n      margin-top: -8px;\r\n      position: absolute;\r\n      top: -4px;\r\n      transition: all 0.3s ease-in-out;\r\n      width: 24px;\r\n    }\r\n  }\r\n\r\n  & > input[type=\"checkbox\"]:checked + label::before {\r\n    background: $black;\r\n    opacity: 0.5;\r\n  }\r\n\r\n  & > input[type=\"checkbox\"]:checked + label::after {\r\n    background: $gray-700;\r\n    left: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 499px) {\r\n  .color-theme .jr-btn {\r\n    padding: 10px 15px !important;\r\n  }\r\n}\r\n","/* UI Components\r\n   ========================================================================== */\r\n@import \"alert\";\r\n@import \"avatar\";\r\n@import \"badges\";\r\n@import \"blockquotes\";\r\n@import \"bottom-navigation\";\r\n@import \"breadcrumb\";\r\n@import \"button\";\r\n@import \"button-group\";\r\n@import \"callout\";\r\n@import \"card\";\r\n@import \"charts\";\r\n@import \"chip\";\r\n@import \"carousel\";\r\n@import \"color-picker\";\r\n@import \"date-input\";\r\n@import \"drawer\";\r\n@import \"e-commerce\";\r\n@import \"grid-list\";\r\n@import \"icons\";\r\n@import \"label\";\r\n@import \"list\";\r\n@import \"nav\";\r\n@import \"pricing-tables\";\r\n@import \"progressbar\";\r\n@import \"popover\";\r\n@import \"tables\";\r\n@import \"tabs\";\r\n@import \"testimonial\";\r\n@import \"timeline\";\r\n@import \"form\";\r\n@import \"ad-form\";\r\n@import \"input\";","/*Alert Styles*/\r\n.alert {\r\n  border: 0 none;\r\n  padding: 20px 24px;\r\n  @include border-radius($border-radius-lg);\r\n  position: relative;\r\n\r\n  & .close {\r\n    line-height: inherit;\r\n    font-weight: $font-weight-light;\r\n  }\r\n\r\n  & .alert-addon {\r\n    width: $size-60;\r\n    background-color: rgba($black, 0.2);\r\n    @include display-flex(flex, column, nowrap);\r\n    @include justify-content(center);\r\n    @include align-items(center);\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n.alert-dismissible {\r\n  padding-right: $size-60;\r\n}\r\n\r\n.alert-addon-card {\r\n  padding-left: $size-80;\r\n}","/*Avatar Styles*/\r\n.user-avatar {\r\n  @extend %size-50;\r\n  display: -webkit-inline-flex;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-flex-wrap: nowrap;\r\n  -ms-flex-wrap: nowrap;\r\n  flex-wrap: nowrap;\r\n  position: relative;\r\n  overflow: hidden;\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n  -webkit-flex-shrink: 0;\r\n  flex-shrink: 0;\r\n  @include border-radius(50%);\r\n  -moz-user-select: none;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n  border: $jr-border;\r\n\r\n  &.avatar-shadow {\r\n    border: 0 none;\r\n  }\r\n}\r\n\r\n.user-profile {\r\n  @include display-flex();\r\n  @include align-items(flex-start);\r\n\r\n  & .user-detail {\r\n    -webkit-flex: 1;\r\n    flex: 1;\r\n    -ms-flex-align: center;\r\n    -webkit-align-self: center;\r\n    align-self: center;\r\n  }\r\n}\r\n\r\n.user-detail {\r\n  & .user-name {\r\n    margin-bottom: 2px;\r\n    font-weight: 400;\r\n    text-transform: capitalize;\r\n  }\r\n  & .user-description {\r\n    font-size: 12px;\r\n    margin-bottom: 0;\r\n    color: $gray-500;\r\n  }\r\n}\r\n\r\n.user-thumb {\r\n  position: relative;\r\n\r\n  .messages-list & {\r\n    margin-right: 8px;\r\n  }\r\n}\r\n","/*Badges Styles*/\r\n.badge {\r\n  font-weight: 400;\r\n  padding: 3px 8px;\r\n  line-height: inherit;\r\n  margin-bottom: 6px;\r\n  @include border-radius($border-radius-sm);\r\n\r\n  &:not(:last-child) {\r\n    margin-right: 15px;\r\n  }\r\n\r\n  table & {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.badge-pill {\r\n  @include border-radius(20px);\r\n}\r\n\r\n.badge-border {\r\n  border: 2px solid !important;\r\n}\r\n\r\n.badge-outline {\r\n  background-color: transparent;\r\n  border: $jr-border;\r\n}","/*Blockquotes Styles*/\r\nblockquote {\r\n  padding: 10px 0 10px 20px;\r\n  font-size: $font-size-base !important;\r\n\r\n  .blockquote-footer {\r\n    font-size: $font-size-base !important;\r\n  }\r\n}\r\n\r\n.blockquote {\r\n  border-left: 5px solid $gray-200;\r\n}\r\n\r\n.blockquote-reverse {\r\n  border-left: 0 none;\r\n  border-right: 5px solid $gray-200;\r\n  text-align: right;\r\n  padding-left: 0;\r\n  padding-right: 20px;\r\n}","/*Bottom Navigation Styles*/\r\n.bottom-navigation {\r\n  button {\r\n    min-width: 10px !important;\r\n  }\r\n}","/*Breadcrumb Styles*/\r\n.breadcrumb {\r\n  @include border-radius($border-radius-sm);\r\n}\r\n\r\n.breadcrumb-item + .breadcrumb-item::before {\r\n  content: '\\F2FB';\r\n  font: {\r\n    family: 'Material-Design-Iconic-Font';\r\n    size: 16px;\r\n  }\r\n  line-height: 1;\r\n  vertical-align: middle;\r\n}","/*Button Styles*/\r\nbutton {\r\n  outline: 0 none !important;\r\n  cursor: pointer;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.jr-btn {\r\n  position: relative;\r\n  display: inline-block;\r\n  font-size: $btn-font-size;\r\n  font-weight: $btn-font-weight;\r\n  // text-transform: capitalize;\r\n  line-height: $btn-line-height;\r\n  @include border-radius($border-radius);\r\n  vertical-align: top;\r\n  cursor: pointer;\r\n  text-align: center;\r\n\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    outline: 0 none;\r\n    text-decoration: none;\r\n    @include box-shadow(none !important);\r\n  }\r\n\r\n  .login-content & {\r\n    padding: 10px 35px;\r\n  }\r\n}\r\n\r\n.btn {\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    outline: 0 none;\r\n    text-decoration: none;\r\n    @include box-shadow(none !important);\r\n  }\r\n\r\n  .login-content & {\r\n    padding: 10px 35px;\r\n  }\r\n}\r\n\r\n.btn,\r\n.btn-info,\r\n.btn-success,\r\n.btn-warning,\r\n.btn-danger,\r\n.btn-light,\r\n.btn-dark,\r\n.btn-primary,\r\n.btn-secondary {\r\n  @extend %btn-no-shadow;\r\n  @include box-shadow(none !important);\r\n}\r\n\r\n.show > {\r\n  .btn,\r\n  .btn-info,\r\n  .btn-success,\r\n  .btn-warning,\r\n  .btn-danger,\r\n  .btn-light,\r\n  .btn-dark,\r\n  .btn-primary,\r\n  .btn-secondary {\r\n    &.dropdown-toggle:focus {\r\n      @include box-shadow(none !important);\r\n    }\r\n  }\r\n}\r\n\r\n.jr-btn,\r\n.jr-fab-btn,\r\n.jr-flat-btn,\r\n.btn {\r\n  margin-bottom: 6px;\r\n  // text-transform: capitalize;\r\n\r\n  &:not(:last-child) {\r\n    margin-right: 15px;\r\n  }\r\n\r\n  .form-inline & {\r\n    margin-bottom: 0;\r\n    min-height: 35px;\r\n  }\r\n\r\n  .navbar & {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.btn-primary:focus, .btn-primary.focus {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.input-group > .input-group-prepend > .btn,\r\n.input-group > .input-group-append > .btn {\r\n  margin-right: 0;\r\n  margin-bottom: 0;\r\n  line-height: inherit;\r\n}\r\n\r\n.jr-fab-btn {\r\n  position: relative;\r\n  display: inline-flex;\r\n  @extend %size-50;\r\n  @include border-radius($border-radius-circle);\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n  background-color: map_get($gray, lighten-3);\r\n  overflow: hidden;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    outline: 0 none;\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n.jr-btn,\r\n.jr-flat-btn {\r\n  padding: $btn-padding;\r\n\r\n  & i + span,\r\n  & span + i {\r\n    margin-left: 6px;\r\n  }\r\n}\r\n\r\n.jr-flat-btn {\r\n  background-color: transparent;\r\n  color: $body-color;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    background-color: map_get($gray, lighten-4);\r\n    color: $body-color;\r\n  }\r\n}\r\n\r\n.jr-btn-group {\r\n  margin: 0 -8px;\r\n\r\n  &:not(:last-child) {\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  & .jr-btn,\r\n  & .jr-fab-btn {\r\n    margin: 0 8px 18px;\r\n  }\r\n}\r\n\r\n.jr-btn-rounded {\r\n  @include border-radius(50px !important);\r\n}\r\n\r\n.jr-btn-lg {\r\n  padding: $btn-padding-lg;\r\n}\r\n\r\n.jr-btn-sm {\r\n  padding: $btn-padding-sm;\r\n}\r\n\r\n.jr-btn-xs {\r\n  padding: $btn-padding-xs;\r\n}\r\n\r\n// Fab Button\r\n.jr-btn-fab-lg {\r\n  @extend %size-60;\r\n}\r\n\r\n.jr-btn-fab-sm {\r\n  @extend %size-40;\r\n}\r\n\r\n.jr-btn-fab-xs {\r\n  @extend %size-30;\r\n}\r\n\r\n.jr-btn-fab-lg,\r\n.jr-btn-lg {\r\n  font-size: $btn-font-size-lg;\r\n  & i {\r\n    font-size: ($btn-font-size-lg + 2px);\r\n  }\r\n}\r\n\r\n.jr-btn-fab-sm,\r\n.jr-btn-sm {\r\n  font-size: ($btn-font-size-sm - 2px);\r\n  & i {\r\n    font-size: ($btn-font-size-sm - 2px);\r\n  }\r\n}\r\n\r\n.jr-btn-fab-xs,\r\n.jr-btn-xs {\r\n  font-size: $btn-font-size-xs;\r\n  & i {\r\n    font-size: $btn-font-size-xs;\r\n  }\r\n}\r\n\r\n.complex-btn-wrapper {\r\n  @include display-flex(flex, row, wrap);\r\n  min-width: 200px;\r\n  width: 100%;\r\n}\r\n\r\n.complex-btn {\r\n  position: relative;\r\n  height: 200px;\r\n  overflow: hidden;\r\n  width: 33.333%;\r\n  border: 0 none;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    width: 100%;\r\n    height: 100px;\r\n  }\r\n  &:hover {\r\n    z-index: 1;\r\n    & .img-btn-overlay {\r\n      opacity: 0.15;\r\n    }\r\n\r\n    & .img-marked {\r\n      opacity: 0;\r\n    }\r\n\r\n    & .img-title {\r\n      border: 4px solid currentColor;\r\n    }\r\n  }\r\n\r\n  .img-btn {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    display: flex;\r\n    @include align-items(center);\r\n    @include justify-content(center);\r\n    color: $white;\r\n  }\r\n  .img-src {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background-size: cover;\r\n    background-position: center 40%;\r\n  }\r\n\r\n  .img-btn-overlay {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background: $black;\r\n    opacity: 0.4;\r\n    @include transition(all 0.5s $transition-ease);\r\n  }\r\n\r\n  .img-title {\r\n    position: relative;\r\n    padding: 16px 32px 14px;\r\n  }\r\n  .img-marked {\r\n    height: 3px;\r\n    width: 18px;\r\n    background: $white;\r\n    position: absolute;\r\n    bottom: -2px;\r\n    left: calc(50% - 9px);\r\n    @include transition(all 0.5s $transition-ease);\r\n  }\r\n}\r\n\r\n.btn-group-mins {\r\n  margin: 0 -5px;\r\n\r\n  & .btn,\r\n  & .jr-btn {\r\n    margin: 0 5px 5px;\r\n  }\r\n}\r\n\r\n//buttons in label\r\n\r\n.jr-btn.jr-btn-label i {\r\n  background-color: rgba($white, 0.2);\r\n  width: $size-40;\r\n  height: 100%;\r\n  line-height: 42px;\r\n  text-align: center;\r\n}\r\n\r\n.jr-btn.jr-btn-label.left i {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.jr-btn.jr-btn-label.right i {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.jr-btn.jr-btn-label.left i + span {\r\n  margin-left: $size-30;\r\n}\r\n\r\n.jr-btn.jr-btn-label.right i + span {\r\n  margin-right: $size-30;\r\n  margin-left: 0;\r\n}\r\n\r\n.jr-btn.jr-btn-label.jr-btn-lg i {\r\n  line-height: 54px;\r\n}\r\n\r\n.jr-btn.jr-btn-label.jr-btn-sm i {\r\n  line-height: 32px;\r\n}\r\n\r\n.jr-btn.jr-btn-label.jr-btn-xs i {\r\n  line-height: 24px;\r\n  width: $size-30;\r\n}\r\n\r\n//Button function\r\n@each $color_name, $color in $colors_palette {\r\n  @each $color_type, $color_value in $color {\r\n    @if $color_type == \"base\" {\r\n      .btn-#{$color_name} {\r\n        background-color: $color_value;\r\n        color: $white;\r\n        &:hover,\r\n        &:focus {\r\n          background-color: darken($color_value, 5%);\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.jr-btn-shadow {\r\n  @include box-shadow(0 1px 5px 0 rgba($black, 0.2), 0 2px 2px 0 rgba($black, 0.14), 0 3px 1px -2px rgba($black, 0.12) !important);\r\n  &:hover,\r\n  &:focus {\r\n    @include box-shadow(0 1px 5px 0 rgba($black, 0.2), 0 2px 2px 0 rgba($black, 0.14), 0 3px 1px -2px rgba($black, 0.12) !important);\r\n  }\r\n\r\n  &:active {\r\n    @include box-shadow(none !important);\r\n  }\r\n}\r\n\r\n.jr-btn.disabled,\r\n.jr-btn.disabled {\r\n  pointer-events: none;\r\n  opacity: 0.65;\r\n}\r\n\r\n.jr-btn-default {\r\n  background-color: $white;\r\n  color: $body-color;\r\n  border: 1px solid $gray-300;\r\n  &:hover,\r\n  &:focus {\r\n    background-color: darken($white, 5%);\r\n    color: $body-color;\r\n  }\r\n}\r\n\r\n.jr-btn-secondary {\r\n  background-color: $secondary;\r\n  color: $white;\r\n  &:hover,\r\n  &:focus {\r\n    background-color: darken($secondary, 5%);\r\n    color: $white;\r\n  }\r\n}\r\n\r\n.jr-flat-btn.jr-btn-primary {\r\n  background-color: transparent;\r\n  color: $app-primary;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    background-color: rgba($app-primary, 0.12);\r\n    color: $app-primary;\r\n  }\r\n}\r\n\r\n.bg-primary {\r\n  & .jr-flat-btn.jr-btn-primary {\r\n    background-color: transparent;\r\n    color: $white;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      background-color: rgba($white, 0.12);\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.jr-flat-btn.jr-btn-secondary {\r\n  background-color: transparent;\r\n  color: $secondary;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    background-color: rgba($secondary, 0.12);\r\n    color: $secondary;\r\n  }\r\n}\r\n\r\n.bg-secondary {\r\n  & .jr-flat-btn.jr-btn-secondary {\r\n    background-color: transparent;\r\n    color: $white;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      background-color: rgba($white, 0.12);\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.jr-btn-hover:hover:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 1;\r\n  display: inline-block;\r\n  background-color: rgba($black, 0.06);\r\n}\r\n\r\n.dropdown-toggle-split {\r\n  padding-right: 0.5625rem;\r\n  padding-left: 0.5625rem;\r\n}\r\n\r\n.action-btn {\r\n  height: $size-40;\r\n  width: $size-40;\r\n  display: -webkit-inline-flex;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  @include align-items(center);\r\n  @include justify-content(center);\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n  color: rgba($black, 0.54);\r\n\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    text-decoration: none;\r\n    color: rgba($black, 0.64);\r\n  }\r\n\r\n  .circle-check & {\r\n    height: 24px;\r\n    width: 24px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .chat-main-header & {\r\n    color: $white;\r\n  }\r\n}\r\n\r\n.action-replay .jr-btn-default {\r\n  font-size: 14px;\r\n  padding: 5px 10px;\r\n  border-color: $gray-600 !important;\r\n}\r\n\r\n.btn-outline-primary,\r\n.btn-outline-secondary {\r\n  &:focus {\r\n    @include box-shadow(none !important);\r\n  }\r\n}","/*Button Group Styles*/\r\n\r\n// stylelint-disable selector-no-qualifying-type\r\n\r\n// Make the div behave like a button\r\n.btn-group,\r\n.btn-group-vertical {\r\n  position: relative;\r\n  display: inline-flex;\r\n  vertical-align: middle; // match .btn alignment given font-size hack above\r\n\r\n  > .jr-btn {\r\n    position: relative;\r\n    flex: 0 1 auto;\r\n    border-color: $border-color;\r\n\r\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\r\n    // the borders properly\r\n    @include hover {\r\n      z-index: 2;\r\n    }\r\n    &:focus,\r\n    &:active,\r\n    &.active {\r\n      z-index: 2;\r\n    }\r\n\r\n    &.active {\r\n      background-color: $app-primary;\r\n      color: $white;\r\n      border-color: $app-primary;\r\n    }\r\n\r\n    &.jr-flat-btn {\r\n      border-color: transparent;\r\n      &.active {\r\n        background-color: transparent;\r\n        color: $app-primary;\r\n\r\n        &:hover,\r\n        &:focus {\r\n          background-color: rgba($app-primary, 0.12);\r\n          color: $app-primary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  // Prevent double borders when buttons are next to each other\r\n  .jr-btn + .jr-btn,\r\n  .jr-btn + .btn-group,\r\n  .btn-group + .jr-btn,\r\n  .btn-group + .btn-group {\r\n    margin-left: -$input-btn-border-width;\r\n  }\r\n}\r\n\r\n.btn-group,\r\n.btn-group-vertical {\r\n\r\n  &.no-border > .btn-group > .jr-btn,\r\n  &.no-border > .btn-group-vertical > .jr-btn,\r\n  &.no-border > .jr-btn {\r\n    border-color: transparent;\r\n  }\r\n}\r\n\r\n// Optional: Group multiple button groups together for a toolbar\r\n.btn-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n\r\n  .input-group {\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.btn-group > .jr-btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\r\n  border-radius: 0;\r\n}\r\n\r\n// Set corners individual because sometimes a single button can be in a .btn-group\r\n// and we need :first-child and :last-child to both match\r\n.btn-group > .jr-btn:first-child {\r\n  margin-left: 0;\r\n\r\n  &:not(:last-child):not(.dropdown-toggle) {\r\n    @include border-right-radius(0);\r\n  }\r\n}\r\n\r\n// Need .dropdown-toggle since :last-child doesn't apply given a .dropdown-menu\r\n// immediately after it\r\n.btn-group > .jr-btn:last-child:not(:first-child),\r\n.btn-group > .dropdown-toggle:not(:first-child) {\r\n  @include border-left-radius(0);\r\n}\r\n\r\n// Custom edits for including btn-groups within btn-groups (useful for including\r\n// dropdown buttons within a btn-group)\r\n.btn-group > .btn-group {\r\n  float: left;\r\n}\r\n\r\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .jr-btn {\r\n  border-radius: 0;\r\n}\r\n\r\n.btn-group > .btn-group:first-child:not(:last-child) {\r\n  > .jr-btn:last-child,\r\n  > .dropdown-toggle {\r\n    @include border-right-radius(0);\r\n  }\r\n}\r\n\r\n.btn-group > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {\r\n  @include border-left-radius(0);\r\n}\r\n\r\n\r\n// Sizing\r\n//\r\n// Remix the default button sizing classes into new ones for easier manipulation.\r\n\r\n.btn-group-sm > .jr-btn { @extend .jr-btn-sm; }\r\n.btn-group-lg > .jr-btn { @extend .jr-btn-lg; }\r\n\r\n\r\n//\r\n// Split button dropdowns\r\n//\r\n\r\n.jr-btn + .dropdown-toggle-split {\r\n  padding-right: $input-btn-padding-x * .75;\r\n  padding-left: $input-btn-padding-x * .75;\r\n\r\n  &::after {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.jr-btn-sm + .dropdown-toggle-split {\r\n  padding-right: $input-btn-padding-x-sm * .75;\r\n  padding-left: $input-btn-padding-x-sm * .75;\r\n}\r\n\r\n.jr-btn-lg + .dropdown-toggle-split {\r\n  padding-right: $input-btn-padding-x-lg * .75;\r\n  padding-left: $input-btn-padding-x-lg * .75;\r\n}\r\n\r\n// The clickable button for toggling the menu\r\n// Set the same inset shadow as the :active state\r\n.btn-group.show .dropdown-toggle {\r\n  @include box-shadow($btn-active-box-shadow);\r\n\r\n  // Show no shadow for `.btn-link` since it has no other button styles.\r\n  &.btn-link {\r\n    @include box-shadow(none);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Vertical button groups\r\n//\r\n\r\n.btn-group-vertical {\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n\r\n  .jr-btn,\r\n  .btn-group {\r\n    width: 100%;\r\n  }\r\n\r\n  > .jr-btn + .jr-btn,\r\n  > .jr-btn + .btn-group,\r\n  > .btn-group + .jr-btn,\r\n  > .btn-group + .btn-group {\r\n    margin-top: -$input-btn-border-width;\r\n    margin-left: 0;\r\n  }\r\n\r\n  > .jr-btn {\r\n    &:not(:first-child):not(:last-child) {\r\n      border-radius: 0;\r\n    }\r\n\r\n    &:first-child:not(:last-child) {\r\n      @include border-bottom-radius(0);\r\n    }\r\n\r\n    &:last-child:not(:first-child) {\r\n      @include border-top-radius(0);\r\n    }\r\n  }\r\n\r\n  > .btn-group:not(:first-child):not(:last-child) > .jr-btn {\r\n    border-radius: 0;\r\n  }\r\n\r\n  > .btn-group:first-child:not(:last-child) {\r\n    > .jr-btn:last-child,\r\n    > .dropdown-toggle {\r\n      @include border-bottom-radius(0);\r\n    }\r\n  }\r\n\r\n  > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {\r\n    @include border-top-radius(0);\r\n  }\r\n}\r\n\r\n\r\n\r\n[data-toggle=\"buttons\"] {\r\n  > .jr-btn,\r\n  > .btn-group > .jr-btn {\r\n    input[type=\"radio\"],\r\n    input[type=\"checkbox\"] {\r\n      position: absolute;\r\n      clip: rect(0,0,0,0);\r\n      //pointer-events: none;\r\n    }\r\n  }\r\n}\r\n\r\n// Make the div behave like a button\r\n.btn-group,\r\n.btn-group-vertical {\r\n\r\n  // Over Write To jr btn Margin\r\n  > .jr-btn,\r\n  > .btn {\r\n    margin-right: 0;\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n","/*Callout Styles*/\r\n\r\n.grid-thumb-equal {\r\n  @extend %thumb-equal;\r\n\r\n  .card-image & {\r\n    padding-bottom: 82%;\r\n  }\r\n}\r\n\r\n.grid-thumb-cover {\r\n  @extend %thumb-cover;\r\n}\r\n\r\n.grid-thumb-cover img {\r\n  @extend %thumb-cover-img;\r\n}\r\n\r\n/*Product listing page style*/\r\n\r\n.product-row {\r\n  position: relative;\r\n  overflow: hidden;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(center);\r\n  text-align: right;\r\n\r\n  &.even {\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.product-col {\r\n  order: 1;\r\n  width: 50%;\r\n}\r\n\r\n.odd .product-thumb {\r\n  order: 2;\r\n}\r\n\r\n.product-content {\r\n  padding: 20px 55px;\r\n}\r\n\r\n.product-row .grid-thumb-equal {\r\n  padding-bottom: 69%;\r\n}\r\n\r\n.product-thumb img {\r\n  width: 100%;\r\n}\r\n\r\n.product-content h4 {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n@media screen and (max-width: 1230px) {\r\n  .product-row .grid-thumb-equal {\r\n    padding-bottom: 71%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1199px) {\r\n  .product-content h4 {\r\n    margin-bottom: 10px;\r\n  }\r\n  .product-content {\r\n    padding: 20px 35px;\r\n  }\r\n  .product-row .grid-thumb-equal {\r\n    padding-bottom: 85%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .grid-thumb-equal {\r\n    .card-image & {\r\n      padding-bottom: 120%;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .product-row {\r\n    @include display-flex(flex, column);\r\n    text-align: center;\r\n\r\n    &.even {\r\n      text-align: center;\r\n    }\r\n  }\r\n\r\n  .product-content {\r\n    padding: 20px 0;\r\n  }\r\n\r\n  .product-col,\r\n  .odd .product-thumb {\r\n    order: 1;\r\n    width: 100%;\r\n  }\r\n  .product-row .grid-thumb-equal {\r\n    padding-bottom: 44%;\r\n  }\r\n\r\n  .grid-thumb-equal {\r\n    .card-image & {\r\n      padding-bottom: 44%;\r\n    }\r\n  }\r\n}","/*Cards Styles*/\r\n.profile-intro {\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  overflow: hidden;\r\n\r\n  img.avatar-circle {\r\n    display: inline-block;\r\n    @extend %size-120;\r\n    @include border-radius(50%);\r\n    @include box-shadow($shadow);\r\n    position: relative;\r\n    margin: 0 auto;\r\n    -webkit-transform: translateY(50px);\r\n    -ms-transform: translateY(50px);\r\n    transform: translateY(50px);\r\n    @include transition(all 0.4s ease-in-out);\r\n    z-index: 1;\r\n  }\r\n\r\n  &:hover {\r\n    & .avatar-circle {\r\n      @include transition(border-radius 0.4s ease 0.1s);\r\n      @include border-radius(25%);\r\n    }\r\n  }\r\n}\r\n\r\n.profile-intro {\r\n  & .card-image {\r\n    position: relative;\r\n    width: 100%;\r\n    min-height: 100%;\r\n    @include background('http://via.placeholder.com/1920x1072', center center);\r\n  }\r\n  & .pi-content {\r\n    padding: 70px 40px 24px;\r\n  }\r\n\r\n  & .pi-footer {\r\n    padding: 0 40px 24px;\r\n  }\r\n  & .icon {\r\n    display: inline-block;\r\n    @include transition(all 0.2s ease 0s);\r\n    color: theme-color(\"primary\");\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      -webkit-transform: scale(1.2);\r\n      -ms-transform: scale(1.2);\r\n      transform: scale(1.2);\r\n    }\r\n  }\r\n\r\n  & .icon:not(:last-child) {\r\n    margin-right: 10px;\r\n  }\r\n}\r\n\r\n.layer {\r\n  &:before {\r\n    display: block;\r\n    content: \"\";\r\n    background-color: rgba($black, 0.3);\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 0;\r\n  }\r\n}\r\n\r\n.card.jr-card-full-height,\r\n.jr-card.jr-card-full-height {\r\n  height: calc(100% - #{$jr-card-margin});\r\n\r\n  @media screen and (max-width: 575px) {\r\n    height: auto;\r\n  }\r\n}\r\n\r\n.jr-card {\r\n  @extend %jr-card-style;\r\n\r\n  & > .jr-card-body:first-child {\r\n    margin-top: 6px;\r\n  }\r\n\r\n  &.p-0 > .jr-card-body:first-child {\r\n    margin-top: 0;\r\n  }\r\n\r\n  & .jr-card-thumb {\r\n    margin: -24px -30px 0;\r\n\r\n    & .card-img {\r\n      @include border-radius($border-radius-lg $border-radius-lg 0 0);\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.jr-card-header {\r\n  margin-bottom: 24px;\r\n\r\n  .card-heading {\r\n    margin-bottom: (24px / 6);\r\n  }\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n\r\n    &:last-child {\r\n      margin-left: 10px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.jr-entry-header {\r\n  margin-bottom: 24px;\r\n\r\n  .entry-heading {\r\n    margin-bottom: (24px / 6);\r\n  }\r\n\r\n  .entry-description {\r\n    margin-bottom: 0;\r\n    font-size: 13px;\r\n    color: $gray-600;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.card {\r\n  margin-bottom: $jr-card-margin;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.card-header {\r\n  font-size: 16px;\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n\r\n    &:last-child {\r\n      margin-left: 10px;\r\n    }\r\n  }\r\n}\r\n\r\n.card-title {\r\n  font-size: $h3-font-size;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.card-subtitle {\r\n  font-size: 14px;\r\n  color: $gray-700;\r\n\r\n  &:not(:last-child) {\r\n    margin-bottom: $h3-font-size;\r\n  }\r\n}\r\n\r\n.card-mt-footer {\r\n  padding: 0 15px 20px;\r\n  margin-top: -10px;\r\n}\r\n\r\n.jr-card-social {\r\n  font-size: 22px;\r\n  padding-top: 26px;\r\n}\r\n\r\n.social-link {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin: 0 -5px 10px;\r\n\r\n  & li {\r\n    padding: 0 5px;\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  & li a {\r\n    color: $body-color;\r\n  }\r\n\r\n  & li.active a,\r\n  & li a:hover,\r\n  & li a:focus {\r\n    color: $secondary;\r\n  }\r\n\r\n  .jr-card-social & {\r\n    margin-bottom: 0;\r\n    @include justify-content(space-around);\r\n  }\r\n}\r\n\r\n.jr-cart-ab {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-around);\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n  color: $white;\r\n  font-size: $h3-font-size;\r\n\r\n  & i {\r\n    vertical-align: middle;\r\n    font-size: 25px;\r\n  }\r\n}\r\n\r\n.img-overlay-card {\r\n  @include border-radius($border-radius-lg);\r\n  margin-bottom: $jr-card-margin;\r\n\r\n  @media screen and (max-width: 1199px) {\r\n    & .center-crop-img {\r\n      min-height: 135px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 767px) {\r\n    & .center-crop-img {\r\n      min-height: 160px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}","/*Charts Styles*/\r\n\r\n.chart-header {\r\n  padding: 15px 18px;\r\n  & .card-title {\r\n    h4 {\r\n      color: $white;\r\n      margin-bottom: 4px;\r\n    }\r\n  }\r\n\r\n  & .title h4 {\r\n    margin-bottom: 4px;\r\n  }\r\n  & p {\r\n    margin-bottom: 4px;\r\n  }\r\n}","/*Chips Styles*/\r\n.chip-outline {\r\n  background-color: transparent !important;\r\n  border: 1px solid $gray-500 !important;\r\n}\r\n","/*Carousel Styles*/\r\n\r\n.carousel-caption {\r\n  & h3 {\r\n    font-size: $h2-font-size;\r\n  }\r\n}\r\n\r\n.carousel-control-prev {\r\n  @extend %pointer;\r\n}\r\n\r\n.carousel-control-next {\r\n  @extend %pointer;\r\n}\r\n","/*Color Picker Styles*/\r\n\r\n.cp-color {\r\n  width: 36px;\r\n  height: 14px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.cp-swatch {\r\n  padding: 5px;\r\n  background: $white;\r\n  border-radius: 1px;\r\n  @include box-shadow(0 0 0 1px rgba($black, .1));\r\n  display: inline-block;\r\n  cursor: pointer;\r\n}\r\n\r\n.cp-popover {\r\n  position: absolute;\r\n  z-index: 2;\r\n}\r\n\r\n.cp-cover {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n}\r\n\r\n.photoshop-picker,\r\n.swatches-picker,\r\n.alpha-picker,\r\n.hue-picker {\r\n  width: 100% !important;\r\n}\r\n\r\n.material-picker {\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n}\r\n\r\n.rc-time-picker-input {\r\n  height: 31px !important;\r\n}\r\n\r\n.date-btn {\r\n  display: inline-block;\r\n  vertical-align: top;\r\n}","// custom styling for the SingleDatePicker from the 'react-dates' package\n\n.dateInputCreateUser .DateInput, \n.dateInputCreateUser .SingleDatePickerInput { \n  background: transparent !important; \n}\n\n// user create form\n.dateInputCreateUser .DateInput_input {\n  font-size: 15px !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  border: none !important;\n  padding: 10px 0 5px 0px !important;\n  font-weight: 400 !important;\n  display: block !important;\n  width: 100% !important;\n  height: calc(2.25rem + 2px) !important;\n  outline: none !important;\n  background-color: transparent !important;\n  transition: .2s all ease-in-out;\n}\n\n.dateInputCreateUserDark .DateInput_input {\n  color: white !important;\n}\n\n.dateInputCreateUserWarn .DateInput_input {\n  color: red !important;\n}\n.dateInputCreateUserWarn .DateInput_input::placeholder {\n  color: red !important;\n}\n\n.dateInputCreateUser .DateInput_input::placeholder {\n  font-size: 15px !important;\n  transition: .2s all ease-in-out;\n  // color: rgb(216, 216, 216) !important;\n}\n\n.dateInputCreateUser .DateInput, \n.dateInputCreateUser .SingleDatePickerInput { \n  background: transparent !important; \n}\n\n// user edit form\n.dateInputEditUser .DateInput_input {\n  font-size: 12px !important;\n  font-family: 'roboto';\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  border: none !important;\n  padding: 5px 0px !important;\n  font-weight: 400 !important;\n  display: block !important;\n  width: 100% !important;\n  height: 28px !important;\n  outline: none !important;\n  background-color: transparent !important;\n  background: transparent !important;\n  transition: .2s all ease-in-out;\n}\n\n.dateInputEditUserDark .DateInput_input {\n  color: white !important;\n  background-color: #1c2938 !important;\n  background: #1c2938 !important;\n}\n\n.dateInputEditUserDark1 .DateInput_input {\n  color: #d5d5d5 !important;\n  background-color: #1C1C1C !important;\n  background: #1C1C1C !important;\n}\n\n.dateInputEditUserDark2 .DateInput_input {\n  color: #ebebed !important;\n  background-color: #333333 !important;\n  background: #333333 !important;\n}\n\n.dateInputEditUserDark3 .DateInput_input {\n  color: #e7e7e7 !important;\n  background-color: #262335 !important;\n  background: #262335 !important;\n}\n\n.dateInputEditUserLight1 .DateInput_input {\n  color: #949494 !important;\n  background-color: #ffffff !important;\n  background: #ffffff !important;\n}\n\n.dateInputEditUserLight2 .DateInput_input {\n  color: #333333 !important;\n  background-color: #fafafa !important;\n  background: #fafafa !important;\n}\n\n.dateInputEditUserContrast .DateInput_input {\n  color: #000000 !important;\n  background-color: transparent !important;\n  background: transparent !important;\n}\n\n.dateInputEditUser .DateInput_input::placeholder {\n  font-size: 12px !important;\n  transition: .2s all ease-in-out;\n  // color: rgb(216, 216, 216) !important;\n}\n","/*Drawer Styles*/\r\n\r\n.drawer {\r\n  width: 250px;\r\n}\r\n\r\n.full-drawer {\r\n  width: 100%;\r\n}","/*E-commerce Styles*/\r\n\r\n.product-item {\r\n  overflow: hidden;\r\n}\r\n\r\n.product-item-vertical {\r\n  @extend .product-item;\r\n\r\n  & .card-image .grid-thumb-equal {\r\n    padding-bottom: 110%;\r\n\r\n    @media screen and (max-width: 1199px) {\r\n      padding-bottom: 74%;\r\n    }\r\n\r\n    @media screen and (max-width: 991px) {\r\n      padding-bottom: 110%;\r\n    }\r\n\r\n    @media screen and (max-width: 829px) {\r\n      padding-bottom: 120%;\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n      padding-bottom: 44%;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n","/*Grids List Styles*/\r\n\r\n.gl-image,\r\n.gl-list,\r\n.gl-advanced,\r\n.gl-single-line {\r\n  @include display-flex();\r\n  @include justify-content(space-around);\r\n  overflow: hidden;\r\n}\r\n\r\n.gl {\r\n  max-width: 100%;\r\n  max-height: 360px;\r\n  // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.\r\n  transform: translateZ(0);\r\n\r\n  &.row.no-gutters {\r\n    margin: 0 -2px;\r\n\r\n    & .col,\r\n    & > [class*=\"col-\"] {\r\n      padding-right: 2px;\r\n      padding-left: 2px;\r\n      margin-bottom: 4px;\r\n    }\r\n  }\r\n}\r\n\r\n.gl-single-line {\r\n  & .slg {\r\n    -ms-flex-wrap: nowrap;\r\n    -webkit-flex-wrap: nowrap;\r\n    flex-wrap: nowrap;\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n.title-gradient {\r\n  background: -webkit-linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: -o-linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n}\r\n\r\n.title-gradient-bottom {\r\n  background: -webkit-linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: -o-linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n}\r\n\r\n.g-title {\r\n  left: 0;\r\n  right: 0;\r\n  height: 48px;\r\n  display: flex;\r\n  position: absolute;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  align-items: center;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n}\r\n\r\n.grid {\r\n  height: 100%;\r\n  display: block;\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  & > img {\r\n    top: 50%;\r\n    left: 50%;\r\n    position: relative;\r\n    transform: translate(-50%, -50%);\r\n    display: flex;\r\n    padding: 0;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n\r\n.g-ul {\r\n  display: flex;\r\n  padding: 0;\r\n  flex-wrap: wrap;\r\n  overflow-y: auto;\r\n  list-style: none;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.gradient-text {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-size: 20px;\r\n  color: white;\r\n}\r\n\r\n.title-gradient-bottom {\r\n  padding: 20px;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 48px;\r\n  display: flex;\r\n  position: absolute;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  align-items: center;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  background: -webkit-linear-gradient(0deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n  background: -o-linear-gradient(to top, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent 100%) !important;\r\n  background: linear-gradient(0deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n}\r\n\r\n.title-gradient-top {\r\n  padding: 10px;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 48px;\r\n  display: flex;\r\n  position: absolute;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  align-items: center;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n\r\n  background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent 100%) !important;\r\n  background: linear-gradient(180deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n}\r\n\r\n.grid-thumb img {\r\n  max-height: 185px;\r\n}\r\n\r\n.gl-advanced-grid {\r\n  position: relative;\r\n}\r\n","/*Icons Styles*/\r\n\r\n.icon {\r\n  display: inline-block;\r\n  @extend %size-30;\r\n  text-align: center;\r\n}\r\n\r\n.icons-wrapper {\r\n  display: inline-block;\r\n  & + .icons-wrapper {\r\n    margin-left: 25px;\r\n  }\r\n}\r\n\r\n.icon-addon {\r\n  @extend %icon-addon;\r\n}","/*Label Styles*/\r\nlabel {\r\n  margin-bottom: 0;\r\n}\r\n","/*List Styles*/\r\n\r\n.pinned-list {\r\n  position: relative;\r\n  height: 370px;\r\n  overflow: auto;\r\n  width: auto;\r\n}\r\n\r\n.user-list {\r\n  width: 100%;\r\n  padding: 20px 15px 10px;\r\n\r\n  &.card {\r\n    padding-left: 30px;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      padding-left: 15px;\r\n    }\r\n  }\r\n\r\n  & .user-avatar {\r\n    margin-right: 20px;\r\n    margin-bottom: 10px;\r\n    @extend %size-50;\r\n  }\r\n\r\n  & h3 {\r\n    font-weight: 700;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  & a[class*=\"meta-\"] i {\r\n    margin-right: 6px;\r\n  }\r\n\r\n  & a[class*=\"meta-\"]:hover {\r\n    text-decoration: none;\r\n  }\r\n\r\n  & a[class*=\"meta-\"] {\r\n    display: inline-block;\r\n    color: $body-color;\r\n    font-size: $font-size-sm;\r\n    font-weight: 700;\r\n  }\r\n}\r\n\r\n.user-list {\r\n  & .img-section {\r\n    width: 230px;\r\n    @media screen and (max-width: 649px) {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  & .description {\r\n    width: calc(100% - 300px);\r\n    @media screen and (max-width: 649px) {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  & .jr-btn-list {\r\n    & li:not(:last-child) {\r\n      margin-right: 10px;\r\n    }\r\n\r\n    & .btn-light {\r\n      background-color: darken(map_get($gray, lighten-2), 5%);\r\n      border-color: darken(map_get($gray, lighten-2), 5%);\r\n      color: $body-color;\r\n      font-weight: 600;\r\n\r\n      &:hover,\r\n      &:focus,\r\n      &:active {\r\n        background-color: darken(map_get($gray, lighten-2), 10%);\r\n        border-color: darken(map_get($gray, lighten-2), 10%);\r\n      }\r\n    }\r\n\r\n    &.badge-list {\r\n      & li:not(:last-child) {\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.list-inline {\r\n  margin-left: -5px;\r\n  margin-right: -5px;\r\n  & li {\r\n    padding: 0 5px;\r\n    display: inline-block;\r\n\r\n    &.media {\r\n      display: flex;\r\n    }\r\n  }\r\n}\r\n\r\n.card-strip {\r\n  border-bottom: solid 1px $gray-300;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.jr-mbtn-list {\r\n  margin-left: -20px;\r\n}\r\n\r\n.img-res {\r\n\r\n    max-width: 100%;\r\n    height: auto;\r\n\r\n}","// Nav Style\r\n.nav-link {\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n}\r\n\r\n.card-header.bg-primary {\r\n  & .nav-link {\r\n    color: $white;\r\n\r\n    &.active,\r\n    &:hover,\r\n    &:focus {\r\n      color: $black;\r\n      background-color: $white;\r\n    }\r\n\r\n    &.disabled {\r\n      color: $gray-100;\r\n    }\r\n\r\n    &.disabled:hover {\r\n      color: $gray-900;\r\n    }\r\n  }\r\n}","/*Pricing Styles*/\r\n.pt-classic,\r\n.pt-default,\r\n.pt-dark,\r\n.pt-circle {\r\n\r\n  & .package {\r\n    position: relative;\r\n    padding: 0;\r\n    overflow: hidden;\r\n    @include border-radius(10px);\r\n    @include transition(all 0.5s ease-in-out);\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      -webkit-transform: scale(1.05);\r\n      -ms-transform: scale(1.05);\r\n      transform: scale(1.05);\r\n    }\r\n    &.highlight {\r\n      -webkit-transform: scale(1.05);\r\n      -ms-transform: scale(1.05); // IE9 only\r\n      -o-transform: scale(1.05);\r\n      transform: scale(1.05);\r\n      z-index: 2;\r\n    }\r\n  }\r\n  & .package-header {\r\n    padding: 35px;\r\n    text-align: center;\r\n\r\n    & > .price {\r\n      display: inline-block;\r\n      font-size: 36px;\r\n      font-weight: 700;\r\n      margin-left: 0;\r\n      margin-bottom: 12px;\r\n      & > i {\r\n        display: inline-block;\r\n        margin-right: 6px;\r\n        font-weight: bold;\r\n      }\r\n    }\r\n\r\n    & h5 {\r\n      color: inherit;\r\n    }\r\n  }\r\n\r\n  & .package-items {\r\n    list-style: none;\r\n    font-size: 14px;\r\n    margin: 0;\r\n    padding: 50px 50px 120px;\r\n\r\n    & li {\r\n      margin-bottom: 16px;\r\n      @include clearfix();\r\n      line-height: inherit;\r\n      & i {\r\n        float: left;\r\n        min-width: 20px;\r\n        margin-right: 16px;\r\n        line-height: inherit;\r\n      }\r\n\r\n      & span {\r\n        display: block;\r\n        overflow: hidden;\r\n      }\r\n    }\r\n  }\r\n\r\n  & .package-footer {\r\n    bottom: 0;\r\n    left: 0;\r\n    position: absolute;\r\n    right: 0;\r\n    padding: 40px 50px;\r\n    text-align: center;\r\n\r\n    & .btn {\r\n      color: inherit;\r\n      padding: 10px 30px;\r\n      border: 0 none;\r\n    }\r\n  }\r\n}\r\n\r\n.pt-classic .package {\r\n  border: 0 none;\r\n  @include border-radius(0);\r\n}\r\n\r\n.pt-dark {\r\n  & .package {\r\n    &:hover {\r\n      @include border-radius(20px);\r\n    }\r\n  }\r\n}\r\n\r\n.pt-circle {\r\n  & .package-header {\r\n    @include border-radius(50%);\r\n    height: 224px;\r\n    width: 224px;\r\n    margin: 40px auto 0;\r\n    @include align-items(center);\r\n\r\n    & .price {\r\n      margin-top: 30px;\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 991px) {\r\n  .pt-classic,\r\n  .pt-default,\r\n  .pt-dark,\r\n  .pt-circle {\r\n    & .package-header {\r\n      padding: 30px 20px;\r\n    }\r\n    & .package-items {\r\n      padding: 30px 20px 120px;\r\n    }\r\n  }\r\n\r\n  .pt-circle {\r\n    & .package-header {\r\n      height: 204px;\r\n      width: 204px;\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n  .pt-classic,\r\n  .pt-default,\r\n  .pt-dark,\r\n  .pt-circle {\r\n    & .package {\r\n      &:hover,\r\n      &:focus,\r\n      &:active,\r\n      &.highlight {\r\n        -webkit-transform: scale(1);\r\n        -ms-transform: scale(1);\r\n        transform: scale(1);\r\n      }\r\n    }\r\n  }\r\n}\r\n","/*Progressbar Styles*/\r\n\r\n.pb-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.pb-btn-wrapper {\r\n  margin: 8px;\r\n  position: relative;\r\n  .btn-success {\r\n    background-color: map_get($green, base);\r\n    &:hover {\r\n      background-color: map_get($green, darken-2);\r\n    }\r\n  }\r\n}\r\n\r\n.fab-progress {\r\n  color: map_get($green, base);\r\n  position: absolute;\r\n  top: -6px;\r\n  left: -6px;\r\n  z-index: 1;\r\n}\r\n\r\n.btn-progress {\r\n  color: map_get($green, base);\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  margin-top: -12px;\r\n  margin-left: -12px;\r\n}","/*Popover Styles*/\r\n.popover {\r\n  z-index: 1510;\r\n  max-height: 400px;\r\n}\r\n\r\n.popover-inner {\r\n  max-height: 400px;\r\n}\r\n\r\n.popover-header {\r\n  background-color: transparent;\r\n  border-bottom: 0 none;\r\n  color: $black;\r\n  font-size: $h2-font-size;\r\n  padding: 15px 20px 0;\r\n}\r\n\r\n.popover-body {\r\n  padding: 15px 20px;\r\n  max-height: 355px;\r\n  overflow: auto;\r\n}\r\n\r\n\r\n","/*Tables Styles*/\r\n\r\n.table-header {\r\n  padding-right: 2px !important;\r\n  min-height: 64px;\r\n  padding-left: 24px;\r\n  align-items: center;\r\n\r\n  &.highlight-light {\r\n    color: map_get($gray, darken-2);\r\n    background-color: map_get($gray, lighten-2);\r\n  }\r\n  &.highlight-dark {\r\n    color: $white;\r\n    background-color: map_get($gray, darken-2);\r\n  }\r\n}\r\n\r\n.spacer {\r\n  @include flex(1, 1, 100%);\r\n}\r\n\r\n.actions {\r\n  color: map_get($red, base);\r\n}\r\n\r\n.title {\r\n  @include flex(0, 0, auto);\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n  background-color: rgba($app-primary, 0.075);\r\n}\r\n\r\n.table-material {\r\n  width: 100% !important;\r\n  max-width: 100% !important;\r\n  background-color: $table-bg !important; // Reset for nesting within parents with `background-color`.\r\n\r\n  th,\r\n  td {\r\n    padding: $table-cell-padding !important;\r\n    vertical-align: top !important;\r\n    border-top: $table-border-width solid $table-border-color !important;\r\n  }\r\n\r\n  thead th {\r\n    vertical-align: bottom !important;\r\n    border-bottom: (2 * $table-border-width) solid $table-border-color !important;\r\n  }\r\n\r\n  tbody + tbody {\r\n    border-top: (2 * $table-border-width) solid $table-border-color !important;\r\n  }\r\n\r\n  .table-material {\r\n    background-color: $body-bg !important;\r\n  }\r\n}\r\n\r\n.d-flex-stretch {\r\n  @include align-items(stretch);\r\n  display: -webkit-flex;\r\n  display: -webkit-box;\r\n  display: -moz-flex;\r\n  display: -moz-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-flex-wrap: wrap;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.default-table {\r\n  margin-bottom: 0;\r\n  & thead th {\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n  }\r\n  & td {\r\n    vertical-align: middle;\r\n  }\r\n}\r\n\r\n.table-unbordered {\r\n  & th,\r\n  & td {\r\n    border: 0 none !important;\r\n  }\r\n\r\n  & .th-border-b th {\r\n    border-bottom: 2px solid $gray-400 !important;\r\n  }\r\n}\r\n\r\n.table-responsive-material {\r\n  min-height: .01%;\r\n  overflow-x: auto;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .table-responsive-material {\r\n    width: 100%;\r\n    margin-bottom: 15px;\r\n    overflow-y: hidden;\r\n    -ms-overflow-style: -ms-autohiding-scrollbar;\r\n    border: 1px solid #ddd;\r\n  }\r\n  .table-responsive-material > .table {\r\n    margin-bottom: 0;\r\n  }\r\n  .table-responsive-material > .table > thead > tr > th,\r\n  .table-responsive-material > .table > tbody > tr > th,\r\n  .table-responsive-material > .table > tfoot > tr > th,\r\n  .table-responsive-material > .table > thead > tr > td,\r\n  .table-responsive-material > .table > tbody > tr > td,\r\n  .table-responsive-material > .table > tfoot > tr > td {\r\n    white-space: nowrap;\r\n  }\r\n  .table-responsive-material > .table-bordered {\r\n    border: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > thead > tr > th:first-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > th:first-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > th:first-child,\r\n  .table-responsive-material > .table-bordered > thead > tr > td:first-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > td:first-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > td:first-child {\r\n    border-left: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > thead > tr > th:last-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > th:last-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > th:last-child,\r\n  .table-responsive-material > .table-bordered > thead > tr > td:last-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > td:last-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > td:last-child {\r\n    border-right: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > tbody > tr:last-child > th,\r\n  .table-responsive-material > .table-bordered > tfoot > tr:last-child > th,\r\n  .table-responsive-material > .table-bordered > tbody > tr:last-child > td,\r\n  .table-responsive-material > .table-bordered > tfoot > tr:last-child > td {\r\n    border-bottom: 0;\r\n  }\r\n}\r\n\r\n.fst-td-br-tp-0 tr:first-child {\r\n  & td {\r\n    border-top: 0 none;\r\n  }\r\n}","/*Tabs Styles*/\r\n\r\n.tab {\r\n  min-width: 10px !important;\r\n}\r\n\r\n.tab-icon > span {\r\n  @include display-flex();\r\n}","/*Testimonial Styles*/\r\n\r\n.testimonial-in-bg {\r\n  background-color: rgba($black, 0.8);\r\n  box-shadow: 5px 5px 6px rgba($black, 0.06);\r\n  padding: 30px 30px 30px 150px;\r\n  overflow: hidden;\r\n  position: relative;\r\n\r\n  @media screen and (max-width: 450px) {\r\n    padding-left: 100px;\r\n  }\r\n\r\n  & .pic {\r\n    display: inline-block;\r\n    width: $size-80;\r\n    height: $size-80;\r\n    @include border-radius(50%);\r\n    overflow: hidden;\r\n    position: absolute;\r\n    top: 30px;\r\n    left: 20px;\r\n    border: 4px solid map_get($amber, darken-2);\r\n\r\n    @media screen and (max-width: 450px) {\r\n      width: $size-50;\r\n      height: $size-50;\r\n    }\r\n  }\r\n  & .pic img {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n  & .description {\r\n    color: map_get($gray, lighten-1);\r\n    font-style: italic;\r\n    font-weight: 400;\r\n    line-height: 25px;\r\n    margin-bottom: 15px;\r\n    position: relative;\r\n\r\n    &:before {\r\n      content: \"\\f1b2\";\r\n      font: {\r\n        family: 'Material-Design-Iconic-Font';\r\n        size: 24px;\r\n      }\r\n      -moz-transform: scaleX(-1);\r\n      -webkit-transform: scaleX(-1);\r\n      -o-transform: scaleX(-1);\r\n      transform: scaleX(-1);\r\n      position: absolute;\r\n      left: -24px;\r\n    }\r\n  }\r\n  & .title {\r\n    color: map_get($amber, darken-2);\r\n    margin-bottom: 2px;\r\n  }\r\n}\r\n\r\n// Testimonials Simple\r\n.classic-testimonial {\r\n  text-align: center;\r\n\r\n  & .pic {\r\n    margin: 0 auto;\r\n    margin-bottom: 30px;\r\n    width: $size-120;\r\n    height: $size-120;\r\n\r\n    @media screen and (max-width: 500px) {\r\n      width: $size-80;\r\n      height: $size-80;\r\n    }\r\n  }\r\n  & .pic img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n}\r\n","/*Time Lines Style*/\r\n\r\n.timeline-left {\r\n  float: left;\r\n  margin-right: 20px;\r\n}\r\n\r\n.timeline-right {\r\n  float: right;\r\n  margin-left: 20px;\r\n}\r\n\r\n.timeline-circle {\r\n  @include border-radius(50%);\r\n}\r\n\r\n.timeline-section {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.timeline-item {\r\n  padding-bottom: 25px;\r\n  padding-left: 80px;\r\n  position: relative;\r\n\r\n  &:before {\r\n    border-left: solid 2px $gray-300;\r\n    content: \"\";\r\n    left: 25px;\r\n    position: absolute;\r\n    top: 25px;\r\n    bottom: -20px;\r\n    width: 2px;\r\n    z-index: 1;\r\n  }\r\n  &:first-child:before {\r\n    border-left-style: dashed;\r\n  }\r\n  &:last-child:before {\r\n    border-left-style: dashed;\r\n    bottom: 25px;\r\n  }\r\n}\r\n\r\n.timeline-badge {\r\n  //background-color: $gray-300;\r\n  @extend %size-50;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 16px;\r\n  z-index: 2;\r\n  font-size: 16px;\r\n  color: $white;\r\n  text-align: center;\r\n  @include border-radius($border-radius-circle);\r\n\r\n  &.timeline-img {\r\n    background-color: transparent;\r\n  }\r\n  & svg {\r\n    vertical-align: calc(100% - 56px);\r\n  }\r\n}\r\n\r\n.timeline-badge {\r\n  &.timeline-img:after {\r\n    display: none;\r\n  }\r\n\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 42px;\r\n    height: 42px;\r\n    background-color: transparent;\r\n    border: 4px solid $body-bg;\r\n    @include border-radius($border-radius-circle);\r\n    left: 4px;\r\n    top: 4px;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n.timeline-img > img,\r\n.timeline-header-img > img {\r\n  display: inline-block;\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.timeline-panel {\r\n  padding: 20px 30px;\r\n  position: relative;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  border: solid 1px $gray-200;\r\n\r\n  &:after,\r\n  &:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    border-style: solid;\r\n    display: inline-block;\r\n  }\r\n\r\n  &:before {\r\n    border-color: transparent $gray-300;\r\n    border-width: 10px 17px 10px 0;\r\n    left: -17px;\r\n    top: 30px;\r\n  }\r\n\r\n  &:after {\r\n    border-color: transparent $white;\r\n    border-width: 10px 16px 10px 0;\r\n    left: -16px;\r\n    top: 30px;\r\n  }\r\n}\r\n\r\n.timeline-no-padding {\r\n  padding: 0;\r\n}\r\n\r\n.timeline-no-shadow {\r\n  @include box-shadow(none);\r\n  &:before,\r\n  &:after {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.timeline-panel-header, .timeline-header-img {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.timeline-inverted {\r\n  & .timeline-left {\r\n    float: right;\r\n    margin-right: 0;\r\n    margin-left: 20px;\r\n  }\r\n}\r\n\r\n.timeline-heading {\r\n  overflow: hidden;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.timeline-body {\r\n  clear: both;\r\n}\r\n\r\n/*Gxtl Center Style*/\r\n.timeline-center {\r\n  & .timeline-item {\r\n    clear: both;\r\n    float: right;\r\n    width: 50%;\r\n    padding-left: 55px;\r\n\r\n    &:before {\r\n      left: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.timeline-center {\r\n  & .timeline-badge {\r\n    left: -25px;\r\n    right: auto;\r\n  }\r\n\r\n  & .timeline-time {\r\n    position: absolute;\r\n    top: 32px;\r\n    left: -150px;\r\n    right: auto;\r\n    z-index: 2;\r\n  }\r\n\r\n  & .timeline-inverted {\r\n    float: left;\r\n    text-align: right;\r\n    padding-left: 0;\r\n    padding-right: 55px;\r\n\r\n    &:before {\r\n      border-left: 0 none;\r\n      border-right: solid 2px $gray-300;\r\n      left: auto;\r\n      right: -2px;\r\n    }\r\n    & .timeline-badge {\r\n      left: auto;\r\n      right: -25px;\r\n    }\r\n\r\n    & .timeline-panel {\r\n      &:before {\r\n        border-width: 10px 0 10px 17px;\r\n        left: auto;\r\n        right: -17px;\r\n      }\r\n\r\n      &:after {\r\n        border-width: 10px 0 10px 16px;\r\n        left: auto;\r\n        right: -16px;\r\n      }\r\n    }\r\n\r\n    & .timeline-time {\r\n      position: absolute;\r\n      top: 32px;\r\n      right: -150px;\r\n      left: auto;\r\n      z-index: 2;\r\n    }\r\n  }\r\n}\r\n\r\n/*Gxtl Zigzag Style*/\r\n.timeline-zigzag {\r\n  & .timeline-item {\r\n    padding-left: 150px;\r\n\r\n    & + .timeline-item {\r\n      margin-top: -80px;\r\n    }\r\n  }\r\n\r\n  & .timeline-img {\r\n    width: 90px;\r\n    height: 90px;\r\n    left: 5px;\r\n    & > img {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  & .timeline-inverted .timeline-img {\r\n    right: 5px !important;\r\n  }\r\n\r\n  & .timeline-item:before {\r\n    @include rotate(35deg);\r\n    top: 20px;\r\n    bottom: 20px;\r\n  }\r\n\r\n  & .timeline-inverted {\r\n    padding-left: 0;\r\n    padding-right: 150px;\r\n    &:before {\r\n      @include rotate(-35deg);\r\n    }\r\n  }\r\n\r\n  & .timeline-item:first-child:before {\r\n    border-left-style: solid;\r\n  }\r\n\r\n  & .timeline-item:last-child:before {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.timeline-item:last-child:before {\r\n  bottom: 25px;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .timeline-zigzag .timeline-item + .timeline-item {\r\n    margin-top: -60px;\r\n  }\r\n\r\n  .timeline-zigzag .timeline-item:before {\r\n    bottom: 0;\r\n  }\r\n\r\n  .timeline-zigzag {\r\n    & .timeline-item {\r\n      padding-left: 120px;\r\n    }\r\n\r\n    & .timeline-inverted {\r\n      padding-right: 120px;\r\n      padding-left: 0;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .timeline-center {\r\n    & .timeline-item {\r\n      float: none;\r\n      padding-left: 80px;\r\n      width: auto;\r\n      &:before {\r\n        left: 25px;\r\n      }\r\n    }\r\n\r\n    & .timeline-badge {\r\n      left: 0;\r\n    }\r\n\r\n    & .timeline-inverted {\r\n      float: none;\r\n      text-align: left;\r\n      padding-right: 0;\r\n\r\n      &:before {\r\n        border-left: solid 2px $gray-300;\r\n        border-right: 0 none;\r\n        left: 24px;\r\n        right: auto;\r\n      }\r\n      & .timeline-badge {\r\n        right: auto;\r\n        left: 0;\r\n      }\r\n\r\n      & .timeline-panel {\r\n        &:before {\r\n          border-width: 10px 17px 10px 0;\r\n          left: -17px;\r\n          right: auto;\r\n        }\r\n        &:after {\r\n          border-width: 10px 16px 10px 0;\r\n          left: -16px;\r\n          right: auto;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .timeline-inverted {\r\n    & .timeline-panel-header {\r\n      float: none;\r\n    }\r\n\r\n    & .timeline-left {\r\n      float: left;\r\n      margin-left: 0;\r\n      margin-right: 20px;\r\n    }\r\n  }\r\n\r\n  .timeline-zigzag {\r\n    & .timeline-panel {\r\n      max-height: none;\r\n      min-height: 10px;\r\n      overflow-y: visible;\r\n    }\r\n\r\n    & .timeline-item {\r\n      padding-left: 100px;\r\n      & + .timeline-item {\r\n        margin-top: 0;\r\n      }\r\n\r\n      &:before {\r\n        transform: none;\r\n        top: 25px;\r\n        bottom: -25px;\r\n        left: 45px;\r\n      }\r\n\r\n      &:last-child:before {\r\n        bottom: 0;\r\n      }\r\n    }\r\n    & .timeline-inverted:before {\r\n      transform: none;\r\n    }\r\n  }\r\n\r\n  .timeline-center {\r\n    & .timeline-time,\r\n    & .timeline-inverted .timeline-time {\r\n      position: relative;\r\n      top: auto;\r\n      left: auto;\r\n      right: auto;\r\n      margin-bottom: 6px;\r\n    }\r\n\r\n    .timeline-time-item .timeline-panel::before {\r\n      top: 10px;\r\n    }\r\n\r\n    .timeline-time-item .timeline-panel::after {\r\n      top: 11px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .timeline-left {\r\n    float: none;\r\n    margin-right: 0;\r\n  }\r\n\r\n  .timeline-right {\r\n    float: none;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .timeline-inverted {\r\n    & .timeline-left {\r\n      float: none;\r\n      margin-right: 0;\r\n    }\r\n  }\r\n}","/*Form Styles*/\r\n@media screen and (max-width: 575px) {\r\n  .horizontal-stepper {\r\n    & p,\r\n    & span {\r\n      opacity: 0;\r\n      visibility: hidden;\r\n      font-size: 12px;\r\n    }\r\n\r\n    &.active {\r\n      & p,\r\n      & span {\r\n        opacity: 1;\r\n        visibility: visible;\r\n      }\r\n    }\r\n\r\n    & > *,\r\n    & > button > * {\r\n      @include display-flex(flex, column, nowrap);\r\n    }\r\n\r\n    & .stepperlabel,\r\n    & .stepperbutton,\r\n    & .stepperlabel span:first-child,\r\n    & .stepperbutton span:first-child {\r\n      opacity: 1;\r\n      visibility: visible;\r\n    }\r\n  }\r\n\r\n  .horizontal-stepper-linear {\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n  }\r\n}",".form-checkbox {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.form-checkbox > input {\r\n  height: 18px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  padding: 10px;\r\n  top: 0;\r\n  width: 18px;\r\n  z-index: 2;\r\n  cursor: pointer;\r\n}\r\n\r\n.form-control-checkbox .form-checkbox > input {\r\n  height: 48px;\r\n  width: 48px;\r\n}\r\n\r\n.form-control-checkbox .form-checkbox {\r\n  height: 48px;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 48px;\r\n  justify-content: center;\r\n}\r\n\r\n.form-checkbox > input + .check {\r\n  border: 1px solid $sidebar-text-color;\r\n  border-radius: 2px;\r\n  color: $app-primary;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  height: 18px;\r\n  position: relative;\r\n  width: 18px;\r\n  z-index: -1;\r\n}\r\n\r\n.form-checkbox > input.sm + .check {\r\n  border: 1px solid $sidebar-text-color;\r\n  border-radius: 2px;\r\n  color: $app-primary;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  height: 14px;\r\n  position: relative;\r\n  top: 3px;\r\n  width: 14px;\r\n  z-index: -1;\r\n}\r\n\r\n.form-checkbox > input + .check i {\r\n  display: none;\r\n  left: 1px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 2px;\r\n}\r\n\r\n.form-checkbox > input.sm + .check i {\r\n  display: none;\r\n  left: 1px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 2px;\r\n}\r\n\r\n.form-checkbox > input:checked + span i {\r\n  display: block;\r\n  opacity: 1;\r\n}\r\n\r\n/*Radio and Checkbox styles*/\r\n\r\n.checkbox-replace {\r\n  padding-left: 20px;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"],\r\n.radio-replace input[type=\"radio\"] {\r\n  margin-left: -20px;\r\n  position: absolute;\r\n}\r\n\r\n.form-inline .checkbox-replace label {\r\n  padding-left: 5px;\r\n}\r\n\r\n.form-inline .checkbox-replace,\r\n.form-inline .radio-replace {\r\n  margin-right: 20px;\r\n}\r\n\r\n.form-inline .checkbox-replace:last-child {\r\n  margin-right: 0;\r\n}\r\n\r\n.checkbox-replace label {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  position: relative;\r\n  padding-left: 5px;\r\n}\r\n\r\n.checkbox-replace label::before {\r\n  content: \"\";\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 18px;\r\n  height: 18px;\r\n  left: 0;\r\n  top: 0;\r\n  margin-left: -20px;\r\n  margin-top: 2px;\r\n  border: 1px solid $sidebar-text-color;\r\n  border-radius: 3px;\r\n  background-color: $white;\r\n  @include transition (border 0.15s ease-in-out, color 0.15s ease-in-out);\r\n}\r\n\r\n.checkbox-replace label::after {\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 12px;\r\n  height: 12px;\r\n  left: 3px;\r\n  top: 5px;\r\n  margin-left: -20px;\r\n  font-size: 11px;\r\n  color: $gray-700;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"] {\r\n  opacity: 0;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:focus + label::before {\r\n  outline: 0 none;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:checked + label::after {\r\n  background-color: $gray-400;\r\n  content: \"\";\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:disabled + label {\r\n  opacity: 0.65;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:disabled + label::before {\r\n  background-color: $white;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.checkbox-replace.checkbox-inline {\r\n  margin-top: 0;\r\n}\r\n\r\n.checkbox-primary label::before {\r\n  border-color: $app-primary;\r\n}\r\n\r\n.checkbox-primary input[type=\"checkbox\"]:checked + label::after {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.checkbox-danger label::before {\r\n  border-color: $secondary;\r\n}\r\n\r\n.checkbox-danger input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $secondary;\r\n}\r\n\r\n.checkbox-info label::before {\r\n  border-color: $info;\r\n}\r\n\r\n.checkbox-info input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $info;\r\n}\r\n\r\n.checkbox-warning label::before {\r\n  border-color: $warning;\r\n}\r\n\r\n.checkbox-warning input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $warning;\r\n}\r\n\r\n.checkbox-success label::before {\r\n  border-color: $success;\r\n}\r\n\r\n.checkbox-success input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $success;\r\n}\r\n\r\n.radio-replace {\r\n  padding-left: 20px;\r\n}\r\n\r\n.radio-replace label {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  position: relative;\r\n  padding-left: 5px;\r\n}\r\n\r\n.radio-replace label::before {\r\n  content: \"\";\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 18px;\r\n  height: 18px;\r\n  left: 0;\r\n  top: 0;\r\n  margin-left: -20px;\r\n  margin-top: 2px;\r\n  border: 1px solid $gray-400;\r\n  border-radius: 50%;\r\n  background-color: $white;\r\n  @include transition(border 0.15s ease-in-out);\r\n}\r\n\r\n.radio-replace label::after {\r\n  display: inline-block;\r\n  position: absolute;\r\n  content: \" \";\r\n  width: 12px;\r\n  height: 12px;\r\n  left: 3px;\r\n  top: 5px;\r\n  margin-left: -20px;\r\n  border-radius: 50%;\r\n  background-color: $gray-400;\r\n  @include rotate (scale(0, 0));\r\n  @include transition (transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33))\r\n}\r\n\r\n.radio-replace input[type=\"radio\"] {\r\n  opacity: 0;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:focus + label::before {\r\n  outline: 0 none;\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:checked + label::after {\r\n  @include rotate (scale(1, 1));\r\n\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:disabled + label {\r\n  opacity: 0.65;\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:disabled + label::before {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.radio-replace.radio-inline {\r\n  margin-top: 0;\r\n}\r\n\r\n.radio-primary input[type=\"radio\"] + label::after {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.radio-primary input[type=\"radio\"]:checked + label::before {\r\n  border-color: $app-primary;\r\n}\r\n\r\n.radio-primary input[type=\"radio\"]:checked + label::after {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.radio-danger input[type=\"radio\"] + label::after {\r\n  background-color: $secondary;\r\n}\r\n\r\n.radio-danger input[type=\"radio\"]:checked + label::before {\r\n  border-color: $secondary;\r\n}\r\n\r\n.radio-danger input[type=\"radio\"]:checked + label::after {\r\n  background-color: $secondary;\r\n}\r\n\r\n.radio-info input[type=\"radio\"] + label::after {\r\n  background-color: $info;\r\n}\r\n\r\n.radio-info input[type=\"radio\"]:checked + label::before {\r\n  border-color: $info;\r\n}\r\n\r\n.radio-info input[type=\"radio\"]:checked + label::after {\r\n  background-color: $info;\r\n}\r\n\r\n.radio-warning input[type=\"radio\"] + label::after {\r\n  background-color: $warning;\r\n}\r\n\r\n.radio-warning input[type=\"radio\"]:checked + label::before {\r\n  border-color: $warning;\r\n}\r\n\r\n.radio-warning input[type=\"radio\"]:checked + label::after {\r\n  background-color: $warning;\r\n}\r\n\r\n.radio-success input[type=\"radio\"] + label::after {\r\n  background-color: $success;\r\n}\r\n\r\n.radio-success input[type=\"radio\"]:checked + label::before {\r\n  border-color: $success;\r\n}\r\n\r\n.radio-success input[type=\"radio\"]:checked + label::after {\r\n  background-color: $success;\r\n}\r\n\r\n.form-horizontal .checkbox, .form-horizontal .checkbox-inline, .form-horizontal .radio, .form-horizontal .radio-inline {\r\n  padding-top: 7px;\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.form-horizontal .form-inline .checkbox,\r\n.form-horizontal .form-inline .checkbox-inline,\r\n.form-horizontal .form-inline .radio,\r\n.form-horizontal .form-inline .radio-inline {\r\n  padding-top: 0;\r\n}\r\n\r\n.form-horizontal .checkbox, .form-horizontal .radio {\r\n  min-height: 27px;\r\n}\r\n\r\n.form-wizard .tab-content .pager.wizard .first a {\r\n  margin-right: 8px;\r\n}\r\n\r\n.form-wizard .tab-content .pager.wizard .last a {\r\n  margin-left: 8px;\r\n}\r\n\r\n.wizard-navbar {\r\n  margin: 60px auto 20px;\r\n}\r\n\r\n.wizard-navbar > ul {\r\n  display: table;\r\n  width: 100%;\r\n  text-align: center;\r\n  margin: 0;\r\n  font-weight: 600;\r\n  padding: 0;\r\n  list-style: none outside none;\r\n  table-layout: fixed;\r\n}\r\n\r\n.wizard-navbar > ul li {\r\n  display: table-cell;\r\n  width: 1%;\r\n  position: relative;\r\n}\r\n\r\n.wizard-navbar > ul li a {\r\n  color: $sidebar-text-color;\r\n  position: relative;\r\n  padding: 0 10px;\r\n  display: block;\r\n  text-decoration: none;\r\n}\r\n\r\n.wizard-navbar > ul li a span.wz-number {\r\n  background-color: $gray-200;\r\n  border-radius: 50%;\r\n\r\n  color: $gray-500;\r\n  display: block;\r\n  height: 40px;\r\n  left: 50%;\r\n  line-height: 40px;\r\n  margin-left: -20px;\r\n  margin-top: -50px;\r\n  position: absolute;\r\n  text-align: center;\r\n  @include transition(all 300ms ease-in-out 0s);\r\n  width: 40px;\r\n  z-index: 5;\r\n}\r\n\r\n.wizard-navbar > ul li.completed a span.wz-number {\r\n  background-color: $app-primary;\r\n  color: $white;\r\n}\r\n\r\n.wizard-navbar > ul li a.active span.wz-number {\r\n  background-color: $secondary;\r\n  color: $white;\r\n}\r\n\r\n.wizard-navbar > ul li a.active,\r\n.wizard-navbar > ul li.completed a {\r\n  color: $gray-600;\r\n}\r\n\r\n.wizard-navbar > ul li a:before,\r\n.wizard-navbar > ul li a:after {\r\n  content: '';\r\n  position: absolute;\r\n  height: 4px;\r\n  width: 50%;\r\n  background-color: $gray-200;\r\n  top: -32px;\r\n  left: 0;\r\n}\r\n\r\n.wizard-navbar > ul li a:after {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n\r\n.wizard-navbar > ul li a.active:before,\r\n.wizard-navbar > ul li a.active:after {\r\n  background-color: $secondary;\r\n}\r\n\r\n.wizard-navbar > ul li.completed a:before,\r\n.wizard-navbar > ul li.completed a:after {\r\n  background-color: $app-primary;\r\n}\r\n\r\nlabel.error {\r\n  display: block;\r\n  color: $danger;\r\n  font-weight: 400;\r\n  margin: 5px 0;\r\n}\r\n\r\n@media screen and (max-width: 479px) {\r\n  .wizard-navbar > ul li a span.wz-label {\r\n    visibility: hidden;\r\n  }\r\n\r\n  .wizard-navbar > ul li a.active span.wz-label {\r\n    visibility: visible;\r\n  }\r\n}\r\n\r\n.form-checkbox-custom {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.form-checkbox-custom .check {\r\n  margin-right: 10px;\r\n}\r\n\r\n.react-switch {\r\n  vertical-align: middle;\r\n  margin-left: 4px;\r\n}\r\n","/*Input Styles*/\r\n::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n::-moz-placeholder { /* Firefox 19+ */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n:-ms-input-placeholder { /* IE 10+ */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n:-moz-placeholder { /* Firefox 18- */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n.module-box-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n  font-size: 14px;\r\n}\r\n\r\n.module-box-header ::-moz-placeholder { /* Firefox 19+ */\r\n  font-size: 14px;\r\n}\r\n\r\n.module-box-header :-ms-input-placeholder { /* IE 10+ */\r\n  font-size: 14px;\r\n}\r\n\r\n.module-box-header :-moz-placeholder { /* Firefox 18- */\r\n  font-size: 14px;\r\n}\r\n\r\n// Search Bar Style\r\n.search-bar {\r\n  background-color: $white;\r\n  position: relative;\r\n  & .form-group {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin-bottom: 0;\r\n  }\r\n  & input[type=\"search\"] {\r\n    padding-right: 50px;\r\n  }\r\n\r\n  & .search-icon {\r\n    background-color: transparent;\r\n    border: 0 none;\r\n    color: lighten($gray-600, 10%);\r\n    height: 36px;\r\n    width: 30px;\r\n  }\r\n\r\n  & .form-control {\r\n    box-shadow: none;\r\n    &.form-control-lg + .search-icon {\r\n      position: absolute;\r\n      right: 14px;\r\n      top: 6px;\r\n    }\r\n  }\r\n\r\n  & .search-icon {\r\n    position: absolute;\r\n    right: 14px;\r\n    top: 3px;\r\n  }\r\n\r\n  &.right-side-icon {\r\n    & input[type=\"search\"] {\r\n      padding-right: 16px;\r\n      padding-left: 50px;\r\n    }\r\n\r\n    & .search-icon {\r\n      position: absolute;\r\n      left: 14px;\r\n      top: 2px;\r\n    }\r\n\r\n    & .form-control {\r\n      box-shadow: none;\r\n      &.form-control-lg + .search-icon {\r\n        position: absolute;\r\n        left: 14px;\r\n        top: 6px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.nav-searchbox .search-bar input {\r\n  & + .search-icon {\r\n    & i {\r\n      color: rgba($body-color, 0.8);\r\n    }\r\n  }\r\n}\r\n\r\n/* Removing arrows for input type number in Chrome, Safari, Edge, Opera */\r\n.inputClassComponent::-webkit-outer-spin-button,\r\n.inputClassComponent::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Removing arrows for input type number in Firefox */\r\n.inputClassComponent[type=number] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .jr-card .app-main-header {\r\n    & .search-bar {\r\n      width: 150px;\r\n    }\r\n  }\r\n}","/* Pages\r\n   ========================================================================== */\r\n@import \"login\";\r\n@import \"error\";\r\n@import \"editor\";\r\n@import \"contact\";\r\n@import \"portfolio\";\r\n@import \"faq\";\r\n@import \"dashboard\";\r\n@import \"dropzone\";","/*Login Styles*/\r\n/*Login Styles*/\r\n\r\n.indexPage {\r\n  background-color: #f4f6f8;\r\n  height: 100vh;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  padding: 0;\r\n  margin: 0;\r\n  @media screen and (max-width: 575px) {\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.landingPage {\r\n  background-color: #fff;\r\n  height: 680px;\r\n  background-position: bottom right;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  @media screen and (max-width: 575px) {\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.login-container {\r\n  position: relative;\r\n  height: 100%;\r\n}\r\n\r\n.login-content {\r\n  width: 420px;\r\n  margin: auto;\r\n  padding: 35px 35px 20px;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  border: solid 1px $gray-400;\r\n  font-size: 14px;\r\n  max-width: 94%;\r\n}\r\n\r\n.login-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.login-content .form-control {\r\n  background-color: map_get($gray, lighten-4);\r\n\r\n  &:focus {\r\n    box-shadow: none;\r\n    border-color: $app-primary;\r\n  }\r\n}\r\n\r\n.login-content .btn, .login-content .jr-btn {\r\n  padding: 10px 35px !important;\r\n}\r\n\r\n.app-login-container {\r\n  position: relative;\r\n  max-width: 680px;\r\n  width: 94%;\r\n  margin: 0 auto;\r\n\r\n  & .loader-view {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    text-align: center;\r\n    top: 0;\r\n    bottom: 0;\r\n    z-index: 2;\r\n  }\r\n}\r\n\r\n.app-login-main-content {\r\n  @include display-flex();\r\n  background-color: $white;\r\n  @include box-shadow($shadow);\r\n  @include border-radius(10px);\r\n  font-size: 14px;\r\n  overflow: hidden;\r\n}\r\n\r\n.app-login-content {\r\n  padding: 35px 35px 20px;\r\n  width: 60%;\r\n  order: 1;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    width: 100%;\r\n    order: 2;\r\n  }\r\n}\r\n\r\n.app-login-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.app-login-content .form-control {\r\n  background-color: map_get($gray, lighten-4);\r\n\r\n  &:focus {\r\n    box-shadow: none;\r\n    border-color: $app-primary;\r\n  }\r\n}\r\n\r\n.app-login-content .btn, .login-content .jr-btn {\r\n  padding: 10px 35px !important;\r\n}\r\n\r\n.app-logo-content {\r\n  background-color: $app-primary;\r\n  padding: 35px 35px 20px;\r\n  width: 40%;\r\n  order: 2;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    width: 100%;\r\n    order: 1;\r\n  }\r\n}\r\n\r\n.app-social-block {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-between);\r\n\r\n  & .social-link,\r\n  & .social-link li {\r\n    margin: 0;\r\n  }\r\n\r\n  & .social-link span {\r\n    border: solid 1px $app-primary;\r\n    @include border-radius(50%);\r\n    color: $app-primary;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $white;\r\n      background-color: $app-primary;\r\n    }\r\n  }\r\n\r\n  & p {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n","/*Error Styles*/\r\n\r\n.page-error-container {\r\n  padding: 30px 0;\r\n  position: relative;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 15px 0;\r\n  }\r\n}\r\n\r\n.page-error-content {\r\n  margin: 0 auto;\r\n  padding: 40px 0;\r\n  width: 380px;\r\n  max-width: 94%;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    padding: 15px 0;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.error-code {\r\n  color: $gray-900;\r\n  font-size: 160px;\r\n  text-align: center;\r\n  line-height: 1;\r\n  font-weight: 600;\r\n  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8);\r\n\r\n  @media screen and (max-width: 991px) {\r\n    font-size: 130px;\r\n  }\r\n\r\n  @media screen and (max-width: 767px) {\r\n    font-size: 100px;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    font-size: 80px;\r\n  }\r\n}\r\n\r\n.page-error-content h2 {\r\n  margin-bottom: $size-50;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n","/*Editor Styles*/\r\n.rdw-inline-wrapper {\r\n  @include display-flex();\r\n}\r\n\r\n.rdw-option-wrapper {\r\n  margin-bottom: 6px;\r\n}\r\n","/*Contact Page Styles*/\r\n\r\n.contact-form {\r\n  padding: 60px;\r\n}\r\n\r\n.contact-block {\r\n  & .contact-info {\r\n    list-style: none;\r\n    padding-left: 0;\r\n    margin-bottom: 0;\r\n    @include display-flex();\r\n    @include align-items(center);\r\n    -webkit-align-content: stretch;\r\n    -ms-flex-align: stretch;\r\n    align-content: stretch;\r\n\r\n    & li {\r\n      @include flex(1, 1, 0);\r\n      overflow: hidden;\r\n      padding: 10px 40px;\r\n      border-right: 2px solid $body-color;\r\n      word-wrap: break-word;\r\n\r\n      &:last-child {\r\n        border: 0 none;\r\n      }\r\n\r\n      & > i {\r\n        float: left;\r\n        font-size: 16px;\r\n        margin-right: 5px;\r\n      }\r\n\r\n      & .contact-body {\r\n        overflow: hidden;\r\n        & .icons-wrapper {\r\n          margin-top: 15px;\r\n          margin-left: 0;\r\n        }\r\n\r\n        & .icon {\r\n          background-color: map_get($indigo, 'lighten-1');\r\n          color: $white;\r\n          @include border-radius(50%);\r\n          margin-right: 6px;\r\n          margin-bottom: 6px;\r\n          &:last-child {\r\n            margin-right: 0;\r\n          }\r\n        }\r\n\r\n        & .twitter-icon {\r\n          background-color: map_get($light-blue, accent-2);\r\n        }\r\n\r\n        & .google-icon {\r\n          background-color: map_get($red, lighten-1);\r\n        }\r\n\r\n        & .linkedin-icon {\r\n          background-color: map_get($light-blue, darken-3);\r\n        }\r\n      }\r\n    }\r\n\r\n    &.vertical {\r\n      display: block;\r\n      margin-bottom: 0;\r\n      & li {\r\n        padding: 0 0 24px;\r\n        border-right: 0 none;\r\n        border-bottom: 2px solid $body-color;\r\n        margin-bottom: 24px;\r\n\r\n        &:last-child {\r\n          border: 0 none;\r\n          margin-bottom: 0;\r\n          padding-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .contact-form {\r\n    padding: 30px;\r\n  }\r\n\r\n  .contact-block {\r\n    & .contact-info {\r\n      display: block;\r\n      margin-bottom: 0;\r\n      & li {\r\n        padding: 0 0 24px;\r\n        border-right: 0 none;\r\n        border-bottom: 2px solid $body-color;\r\n        margin-bottom: 24px;\r\n\r\n        &:last-child {\r\n          border: 0 none;\r\n          margin-bottom: 0;\r\n          padding-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .content-section {\r\n    padding: 20px 10px 0;\r\n    text-align: center;\r\n    & h2 {\r\n      font-size: 28px;\r\n    }\r\n    & p {\r\n      font-size: 18px;\r\n    }\r\n  }\r\n}\r\n","/*Portfolio Styles*/\r\n\r\n.portfolio-section {\r\n  & .card-image {\r\n    margin-bottom: 20px;\r\n    & img {\r\n      width: 100%;\r\n      @include transition(all 1200ms ease);\r\n    }\r\n    &:hover {\r\n      & img {\r\n        -webkit-transform: scale(1.08);\r\n        -ms-transform: scale(1.08);\r\n        transform: scale(1.08);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.filter-with-bg-color {\r\n  & ul {\r\n    padding-left: 0;\r\n    margin: 0 -10px 45px;\r\n    & li {\r\n      display: inline-block;\r\n      margin-bottom: 10px;\r\n      padding: 0 10px;\r\n    }\r\n\r\n    & li a {\r\n      text-transform: uppercase;\r\n      font-size: 12px;\r\n      padding: 10px 24px;\r\n      border: 1px solid $app-primary;\r\n      display: block;\r\n      text-decoration: none;\r\n    }\r\n\r\n    & li a:hover,\r\n    & li a:focus,\r\n    & li a.active {\r\n      cursor: pointer;\r\n      background-color: $app-primary;\r\n      border-color: $app-primary;\r\n      color: $white;\r\n    }\r\n\r\n    @media screen and (max-width: 575px) {\r\n      margin-bottom: 15px;\r\n    }\r\n  }\r\n}","/*Faqs Styles*/\r\n\r\n.Collapsible {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n//The content within the collaspable ChatUserList\r\n.Collapsible__contentInner {\r\n  padding: 20px;\r\n  border: 1px solid $gray-200;\r\n  background-color: $white;\r\n  border-top: 0;\r\n\r\n  p {\r\n    margin-bottom: 10px;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n//The link which when clicked opens the collapsable ChatUserList\r\n.Collapsible__trigger {\r\n  display: block;\r\n  cursor: pointer;\r\n  font-weight: 400;\r\n  text-decoration: none;\r\n  position: relative;\r\n  padding: 18px 20px;\r\n  @include border-radius(8px);\r\n  background: theme-color(\"primary\");\r\n  color: $white;\r\n\r\n  &:after {\r\n    content: '\\f2f9';\r\n    font: {\r\n      family: 'Material-Design-Iconic-Font';\r\n      size: 20px;\r\n    }\r\n    position: absolute;\r\n    right: 24px;\r\n    top: 16px;\r\n    display: block;\r\n    transition: transform 300ms;\r\n  }\r\n\r\n  &.is-open {\r\n    @include border-radius(8px 8px 0 0);\r\n    &:after {\r\n      transform: rotateZ(180deg);\r\n    }\r\n  }\r\n}\r\n\r\n//SideNav\r\n.categories-list {\r\n  margin-bottom: 0;\r\n  & li {\r\n    margin-bottom: 10px;\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n  & li.active a {\r\n    color: $app-primary;\r\n  }\r\n  & .badge {\r\n    font-size: 9px;\r\n  }\r\n}\r\n\r\n.articles-section {\r\n  & .articles {\r\n    margin-bottom: 26px;\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.article-image {\r\n  display: block;\r\n  margin-bottom: 12px;\r\n  & > img {\r\n    @include border-radius(8px);\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.article-description {\r\n  & p {\r\n    font-weight: 500;\r\n    margin-bottom: 2px;\r\n  }\r\n}\r\n\r\n.meta-wrapper {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.meta-date,\r\n.meta-comment {\r\n  font-size: 14px;\r\n  color: $gray-500;\r\n  display: inline-block;\r\n  & i {\r\n    display: inline-block;\r\n    margin-right: 6px;\r\n  }\r\n}\r\n\r\n.meta-date {\r\n  & + .meta-comment {\r\n    margin-left: 10px;\r\n  }\r\n}\r\n\r\n\r\n","/*Dashboard Styles*/\r\n.box {\r\n  position: relative;\r\n\r\n  .box-top,\r\n  .box-bottom {\r\n    height: 100px;\r\n    padding: 32px 15px;\r\n    font-size: 40px;\r\n    line-height: 40px;\r\n    text-align: center;\r\n    font-weight: $display1-weight;\r\n    .size-h5 {\r\n      font-size: 24px;\r\n      margin-left: 2px;\r\n    }\r\n    .material-icons {\r\n      font-size: 40px;\r\n      line-height: 40px;\r\n    }\r\n  }\r\n\r\n  .box-bottom {\r\n    border-top: 1px solid rgba($black, .15);\r\n  }\r\n\r\n  .box-info {\r\n    position: absolute;\r\n    width: 100%;\r\n    top: 50%;\r\n    margin-top: -12px;\r\n    text-align: center;\r\n\r\n    span {\r\n      height: 24px;\r\n      display: inline-block;\r\n      padding: 4px 10px;\r\n      text-transform: uppercase;\r\n      line-height: 14px;\r\n      background-color: $white;\r\n      border: 1px solid rgba($black, .15);\r\n      font-size: 12px;\r\n      color: $text-muted;\r\n      border-radius: 1em;\r\n      .material-icons {\r\n        line-height: 14px;\r\n        font-size: 11px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.contact-list {\r\n  margin-bottom: 14px;\r\n\r\n  & i {\r\n    margin-right: 14px;\r\n    color: theme-color(\"primary\");\r\n  }\r\n\r\n  & .media {\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n.temp-section {\r\n\r\n  .temp-point,\r\n  .detail-icon {\r\n    font-size: 54px;\r\n  }\r\n}\r\n\r\n.assignment-table {\r\n  & tbody tr:nth-child(odd) {\r\n    background-color: $gray-300 !important;\r\n  }\r\n  & td {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n}\r\n\r\n.status-cell {\r\n  min-width: 100px;\r\n  max-width: 120px;\r\n  padding-right: 24px !important;\r\n  & .badge {\r\n    min-width: 70px;\r\n  }\r\n}\r\n\r\n.thumbnail-list {\r\n  margin-bottom: 0;\r\n  & .thumbnail-item {\r\n    padding: 0 2.5px;\r\n    display: inline-block;\r\n    width: 33.333%;\r\n    margin-bottom: 5px;\r\n\r\n    @media screen and (max-width: 767px) {\r\n      width: 50%;\r\n    }\r\n\r\n    @media screen and (max-width: 575px) {\r\n      width: 33.333%;\r\n    }\r\n  }\r\n}\r\n\r\n.post-list {\r\n  & .post-image .grid-thumb-equal {\r\n    padding-bottom: 100%;\r\n  }\r\n}\r\n\r\n/*Ecommerce Dashboard Styles*/\r\n.chart-f30 {\r\n  font-size: 30px;\r\n\r\n  @media screen and (max-width: 1099px) {\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n.chart-f20 {\r\n  font-size: 20px;\r\n\r\n  @media screen and (max-width: 1099px) {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n.chart-order {\r\n  & .col-5 {\r\n    order: 2;\r\n    text-align: center;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      order: 1;\r\n    }\r\n  }\r\n\r\n  & .col-7 {\r\n    order: 1;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      order: 2;\r\n    }\r\n  }\r\n}\r\n\r\n.tab-notifications {\r\n  margin-left: -$jr-card-margin + 4px;\r\n  margin-right: -$jr-card-margin + 4px;\r\n  border-bottom: 1px solid $gray-500;\r\n\r\n  @media screen and (max-width: 567px) {\r\n    button,\r\n    button * {\r\n      font-size: 12px !important;\r\n    }\r\n  }\r\n}\r\n\r\n.chart-title {\r\n  & h2 {\r\n    font-size: 22px;\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.img-fluid {\r\n  width: 100%;\r\n}\r\n\r\n.comment-footer {\r\n  & button {\r\n    margin-bottom: 6px;\r\n  }\r\n}\r\n\r\n/*Intranet Dashboard Styles*/\r\n.net-chart {\r\n  padding-left: 80px;\r\n  padding-right: 15px;\r\n  min-height: 100px;\r\n  position: relative;\r\n  overflow: hidden;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n\r\n  & .jr-card-thumb {\r\n    margin: 0;\r\n    width: $size-50;\r\n    height: $size-50;\r\n    color: $white;\r\n    font-size: 20px;\r\n    @include border-radius($border-radius-circle);\r\n    @include display-flex(flex, column, nowrap);\r\n    @include justify-content(center);\r\n    @include align-items(center);\r\n    @include transition(all 100ms ease);\r\n    position: absolute;\r\n    left: 15px;\r\n  }\r\n\r\n  &:hover .jr-card-thumb {\r\n    width: 70px;\r\n    height: 100%;\r\n    font-size: 30px;\r\n    @include border-radius(0);\r\n    position: absolute;\r\n    left: 0;\r\n  }\r\n}\r\n\r\n.net-chart-hr {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  min-height: $size-120;\r\n  padding-right: 8px;\r\n  overflow: hidden;\r\n\r\n  & .jr-card-thumb {\r\n    margin: -30px 12px -30px -30px;\r\n    min-width: $size-100 + 5px;\r\n  }\r\n\r\n  & .grid-thumb-equal {\r\n    padding-bottom: 130%;\r\n  }\r\n\r\n  & .jr-card-body {\r\n    width: calc(100% - #{$size-100});\r\n  }\r\n}\r\n\r\n.user-profile {\r\n  padding: 10px 0;\r\n}\r\n\r\n.mh-120 {\r\n  min-height: $size-120;\r\n}\r\n\r\n.jr-card-header-top {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin-right: -16px;\r\n}\r\n\r\n.jr-card-header-color {\r\n  padding: 10px 20px 20px;\r\n  margin: -24px -30px 25px;\r\n}\r\n\r\n.todo-cell-group {\r\n  & .todo-cell {\r\n    &:not(:last-child) {\r\n      margin-bottom: 8px;\r\n    }\r\n  }\r\n}\r\n\r\n.social-list-line {\r\n  position: relative;\r\n\r\n  &:not(:last-child):before {\r\n    border-left: solid 1px $gray-500;\r\n    content: \"\";\r\n    left: 20px;\r\n    position: absolute;\r\n    top: 5px;\r\n    bottom: 0;\r\n    width: 1px;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n\r\n.list-line-item {\r\n  position: relative;\r\n  padding-left: 40px;\r\n\r\n  &:not(:last-child):before {\r\n    border-left: solid 1px $gray-500;\r\n    content: \"\";\r\n    left: 20px;\r\n    position: absolute;\r\n    top: -25px;\r\n    bottom: -25px;\r\n    width: 1px;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n.list-line-badge {\r\n  position: absolute;\r\n  left: 16px;\r\n  top: 15px;\r\n  z-index: 2;\r\n  @include border-radius(50%);\r\n  height: 10px;\r\n  width: 10px;\r\n  background-color: $gray-500;\r\n}\r\n\r\n.circle-shape {\r\n  display: inline-block;\r\n  width: 8px;\r\n  height: 8px;\r\n  @include border-radius($border-radius-circle);\r\n}\r\n\r\n.project-list {\r\n  line-height: 1;\r\n\r\n  &:not(:last-child) {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  & .circle-shape {\r\n    margin-top: 4px;\r\n    margin-right: 16px;\r\n  }\r\n\r\n  & .project-name {\r\n    display: block;\r\n    margin-bottom: 4px;\r\n    color: $body-color;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $app-primary;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n.nav-pill-sales {\r\n  & li + li {\r\n    margin-right: -1px;\r\n  }\r\n  & .nav-link {\r\n    background-color: $gray-200;\r\n    border-radius: 0;\r\n    padding: 6px 15px;\r\n    color: $gray-600;\r\n    font-size: 13px;\r\n    border: $jr-border;\r\n\r\n    &.active {\r\n      background-color: $app-primary;\r\n      color: $white;\r\n      border-color: $app-primary;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n\r\n  & li:first-child .nav-link {\r\n    @include border-left-radius($border-radius);\r\n  }\r\n\r\n  & li:last-child .nav-link {\r\n    @include border-right-radius($border-radius);\r\n  }\r\n}\r\n\r\n.temp-week-list {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  color: lighten($gray-600, 8%);\r\n\r\n  & li:not(:last-child) {\r\n    margin-bottom: 10px;\r\n    @media screen and (max-width: 340px) {\r\n      margin-bottom: 20px;\r\n    }\r\n  }\r\n\r\n  & img {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n\r\n  & span {\r\n    display: inline-block;\r\n\r\n    &.temp-point {\r\n      margin: 0 20px;\r\n\r\n      @media screen and (max-width: 1199px) {\r\n        margin: 0 10px;\r\n      }\r\n\r\n      @media screen and (max-width: 1050px) {\r\n        margin: 0 5px;\r\n      }\r\n\r\n      @media screen and (max-width: 340px) {\r\n        margin: 0 20px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.temp-section {\r\n\r\n  .temp-point {\r\n    font-size: 36px;\r\n    font-weight: 700;\r\n    margin-bottom: 0;\r\n\r\n    & sub,\r\n    & sup {\r\n      font-size: 70%;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n","/*Dropzone Styles*/\r\n.dropzone-card {\r\n  position: relative;\r\n}\r\n\r\n.dropzone {\r\n  margin-bottom: 20px;\r\n\r\n  & > div {\r\n    margin: 0 auto;\r\n    padding: 15px;\r\n    @include display-flex(flex, column, nowrap);\r\n    @include justify-content(center);\r\n\r\n    & :last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n\r\n  & .btn {\r\n    margin-top: 20px;\r\n  }\r\n}\r\n\r\n.upload-file-list {\r\n  list-style: none;\r\n  padding-left: 0;\r\n\r\n  & li {\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.form-group-dropzone {\r\n  & label {\r\n    margin-bottom: 6px;\r\n  }\r\n\r\n  & .form-control {\r\n    max-width: 200px;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n","/* Slider\r\n   ========================================================================== */\r\n.brand-logo {\r\n  @extend %thumb-equal;\r\n  border: 1px solid $gray-300;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  margin-bottom: 20px;\r\n  padding-bottom: 75%;\r\n\r\n  & .brand-logo-inner {\r\n    @extend %thumb-cover;\r\n    text-align: center;\r\n\r\n    &:before {\r\n      content: \"\";\r\n      display: inline-block;\r\n      height: 100%;\r\n      vertical-align: middle;\r\n    }\r\n\r\n    & img {\r\n      height: auto;\r\n      max-height: 100%;\r\n      max-width: 100%;\r\n      display: inline-block;\r\n      vertical-align: middle;\r\n      width: auto !important;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    @include transition(all 0.4s ease-in-out 0.1s);\r\n    background-color: darken($white, 5%);\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n.owl-app-frame {\r\n  &.owl-carousel .owl-item img {\r\n    display: inline-block;\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.carousel-item {\r\n  & img {\r\n    max-width: 100%;\r\n  }\r\n}","/* Modules\r\n   ========================================================================== */\r\n@import \"app-module\";\r\n@import \"chat\";\r\n@import \"mail\";\r\n@import \"contact\";\r\n@import \"calendar\";","/* App Module Style */\r\n\r\n.app-wrapper-module {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include align-items(stretch);\r\n  height: 100%;\r\n}\r\n\r\n.app-module {\r\n  position: relative;\r\n  @include display-flex(flex, row, nowrap);\r\n  margin: -36px -40px 0 -40px;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin: -20px;\r\n  }\r\n}\r\n\r\n.module-side {\r\n  position: relative;\r\n  z-index: 2;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(0, 1, 230px);\r\n  max-width: 230px;\r\n  min-width: 230px;\r\n}\r\n\r\n.module-side-header {\r\n  border-bottom: solid 1px $gray-200;\r\n  @include display-flex(flex, column, nowrap);\r\n\r\n  & .user-detail {\r\n    padding: 15px 10px;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.module-logo {\r\n  padding: 10px;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(center);\r\n  min-height: 78px;\r\n  font-size: 20px;\r\n  background-color: lighten($gray-100, 0.5%);\r\n  color: darken($gray-800, 2%);\r\n  & .zmdi {\r\n    font-size: 28px;\r\n  }\r\n}\r\n\r\n.module-user-info {\r\n  @include display-flex(flex, column, nowrap);\r\n}\r\n\r\n.module-user-detail {\r\n  font-size: 12px;\r\n}\r\n\r\n.module-side-content {\r\n  @extend .module-user-info;\r\n}\r\n\r\n.module-add-task {\r\n  @include display-flex();\r\n  padding: 24px;\r\n}\r\n\r\n.module-nav {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n\r\n  & li {\r\n    @include display-flex(flex, column, nowrap);\r\n  }\r\n\r\n  & li a {\r\n    padding: 12px 29px;\r\n    color: lighten($body-color, 20%);\r\n    @include display-flex();\r\n    @include align-items(center);\r\n    text-decoration: none;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $body-color;\r\n    }\r\n\r\n    &.active {\r\n      color: $app-primary;\r\n    }\r\n  }\r\n\r\n  & li i {\r\n    margin-right: 16px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  & li span {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  & li.module-nav-label {\r\n    padding: 12px 29px;\r\n  }\r\n}\r\n\r\n.module-box {\r\n  position: relative;\r\n  z-index: 2;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(1, 1, auto);\r\n  max-width: calc(100% - 231px);\r\n}\r\n\r\n.module-box-header {\r\n  padding: 10px 26px;\r\n  min-height: 79px;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  background-color: $white;\r\n  border-bottom: solid 1px $gray-200;\r\n\r\n  & .search-bar.right-side-icon {\r\n    min-width: 350px;\r\n\r\n    & .form-control {\r\n      @include border-radius(0);\r\n      height: 46px;\r\n      padding: 10px 18px 10px 40px;\r\n\r\n      &:focus {\r\n        background-color: $gray-100;\r\n      }\r\n    }\r\n\r\n    & .search-icon {\r\n      width: 25px;\r\n      height: 46px;\r\n      font-size: 16px;\r\n      left: 10px;\r\n      top: 0;\r\n      padding: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.module-box-header-inner {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-between);\r\n}\r\n\r\n.module-box-content {\r\n  background-color: $white;\r\n  @include display-flex(flex, column, nowrap);\r\n}\r\n\r\n.module-box-topbar {\r\n  padding: 8px 12px;\r\n  @include display-flex();\r\n  border-bottom: solid 1px $gray-200;\r\n\r\n  & button + button {\r\n    @include border-radius(0);\r\n  }\r\n}\r\n\r\n.module-box-topbar-todo {\r\n  padding-left: 64px;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding-left: 27px;\r\n  }\r\n}\r\n\r\n.module-list-icon {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  padding-right: 10px;\r\n}\r\n\r\n.bar-icon {\r\n  margin-right: 15px;\r\n}\r\n\r\n.toolbar-separator {\r\n  border-left: solid 1px $gray-400;\r\n  height: 100%;\r\n  width: 1px;\r\n  margin: 0 12px;\r\n}\r\n\r\n.toolbar-left {\r\n  margin-left: auto;\r\n}\r\n\r\n.module-list {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n}\r\n\r\n.module-list-item {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  padding: 15px 28px;\r\n  border-bottom: solid 1px $gray-200;\r\n  z-index: 5;\r\n  position: relative;\r\n  cursor: pointer;\r\n\r\n  & > .check-label {\r\n    margin-left: 0;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  &.mail-cell {\r\n    padding-left: 12px;\r\n    @include align-items(start);\r\n  }\r\n}\r\n\r\n.module-detail-header {\r\n  margin-bottom: 10px;\r\n\r\n  & > .check-label {\r\n    margin-right: auto;\r\n  }\r\n}\r\n\r\n.module-list-info {\r\n  @include flex(1, 1, 0);\r\n  @include display-flex(flex, column, nowrap);\r\n  max-width: calc(100% - 169px);\r\n}\r\n\r\n.module-todo-content {\r\n  position: relative;\r\n\r\n  & .subject {\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.module-list-actions {\r\n  text-align: right;\r\n}\r\n\r\n.app-module-sidenav {\r\n  background-color: $white;\r\n  border-right: solid 1px $gray-200;\r\n  position: relative;\r\n  z-index: 9;\r\n\r\n  & .chat-sidenav-main {\r\n    max-width: 300px;\r\n    min-width: 300px;\r\n    width: 90%;\r\n  }\r\n}\r\n\r\n.module-date {\r\n  max-width: 160px;\r\n\r\n  & > div:before {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.module-detail-item {\r\n  padding: 10px 28px;\r\n}\r\n\r\n.task-title {\r\n  font-size: 18px;\r\n}\r\n\r\n.chat-todo-avatar {\r\n  margin-right: 15px;\r\n}\r\n\r\n.modal-title {\r\n  @include display-flex();\r\n  @include justify-content(space-between);\r\n  @include align-items(center);\r\n  width: 100%;\r\n  font-size: 18px;\r\n}\r\n\r\n.loader-view-block {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n\r\n}\r\n\r\n.loader-view {\r\n  @extend .loader-view-block;\r\n}\r\n\r\n.module-date > div {\r\n  @include align-items(center);\r\n}\r\n\r\n@media screen and (max-width: 1199px) {\r\n  .module-side {\r\n    @include display-flex(block, row, nowrap);\r\n    @include flex(1);\r\n    max-width: $side-nav-width;\r\n    min-width: $side-nav-width;\r\n    background-color: $white;\r\n  }\r\n\r\n  .module-box-header {\r\n    position: relative;\r\n    min-height: 58px;\r\n    padding: 5px 26px 5px 75px;\r\n\r\n    & .drawer-btn {\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      z-index: 1;\r\n      border-right: solid 1px $gray-200;\r\n      height: 58px;\r\n      width: 56px;\r\n      @include border-radius(0);\r\n      font-size: 22px;\r\n    }\r\n\r\n    & .search-bar.right-side-icon .form-control {\r\n      height: 38px;\r\n      padding: 5px 18px 5px 40px;\r\n    }\r\n\r\n    & .search-bar.right-side-icon .search-icon {\r\n      height: 38px;\r\n    }\r\n  }\r\n\r\n  .chat-loader-view {\r\n    height: calc(100vh - 120px);\r\n  }\r\n\r\n  .module-box {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 991px) {\r\n  .modal-dialog {\r\n    max-width: 750px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .app-module {\r\n    padding-top: 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 599px) {\r\n  .module-box-header .search-bar {\r\n    margin-left: 0;\r\n    max-width: none;\r\n\r\n    &.right-side-icon {\r\n      min-width: 250px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .module-list-item {\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .module-list-info {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .module-box-header {\r\n    & .nav-searchbox.quick-menu .dropdown-menu {\r\n      right: auto !important;\r\n      left: 0 !important;\r\n    }\r\n\r\n    & .search-bar.right-side-icon {\r\n      min-width: 200px;\r\n\r\n      & .form-control {\r\n        @include border-radius(0.25rem);\r\n      }\r\n    }\r\n\r\n    & .nav-searchbox.quick-menu .dropdown-menu {\r\n      &:after {\r\n        right: auto;\r\n        left: 9px;\r\n      }\r\n\r\n      &:before {\r\n        right: auto;\r\n        left: 9px;\r\n      }\r\n    }\r\n\r\n    & .search-bar {\r\n      padding-right: 2px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .module-box-header {\r\n    & .search-bar.right-side-icon {\r\n      min-width: 100px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 399px) {\r\n  .d-xs-flex {\r\n    display: flex !important;\r\n  }\r\n}\r\n","/*Chat Module Styles*/\r\n\r\n.chat-module {\r\n  @include flex();\r\n\r\n  &:before {\r\n    left: -29px;\r\n  }\r\n}\r\n\r\n.chat-module-box {\r\n  @include display-flex(flex, row, nowrap);\r\n  @include flex(1);\r\n  background-color: $gray-100;\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.chat-sidenav {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(0, 1, 315px);\r\n  min-width: 315px;\r\n  border-right: solid 1px $gray-200;\r\n}\r\n\r\n.chat-box {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(1);\r\n  max-width: 100%;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.chat-sidenav-header {\r\n  @include display-flex(flex, column, nowrap);\r\n  padding: 25px 20px 12px;\r\n  background-color: lighten($gray-100, 0.5%);\r\n}\r\n\r\n.chat-user-hd {\r\n  @include display-flex();\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.chat-sidenav-header .search-wrapper {\r\n  @include display-flex(flex, column, nowrap);\r\n  margin-bottom: 0;\r\n\r\n  & .search-bar.right-side-icon {\r\n    @include flex();\r\n\r\n    & .form-control {\r\n      @include box-shadow(none);\r\n      @include border-radius(0);\r\n      padding-left: 42px;\r\n      height: 42px;\r\n    }\r\n\r\n    & .search-icon {\r\n      left: 10px;\r\n      top: 0;\r\n      height: 42px;\r\n      padding: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.chat-avatar {\r\n  min-width: $size-50;\r\n\r\n  .chat-user-item & {\r\n    padding: 0 5px;\r\n    min-width: 10px;\r\n  }\r\n\r\n  .chat-user-hd & {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.chat-avatar-mode {\r\n  position: relative;\r\n  max-width: $size-50;\r\n\r\n  & .chat-mode {\r\n    display: block;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 2px;\r\n    z-index: 1;\r\n    width: 12px;\r\n    height: 12px;\r\n    border-radius: 50%;\r\n\r\n    &.small {\r\n      width: 8px;\r\n      height: 8px;\r\n    }\r\n\r\n    &.online {\r\n      background-color: map_get($green, base);\r\n      @extend %online-effect;\r\n    }\r\n\r\n    &.offline {\r\n      background-color: $white;\r\n      border: solid 1px map_get($green, base);\r\n      @extend %online-effect;\r\n    }\r\n\r\n    &.away {\r\n      background-color: map_get($yellow, darken-1);\r\n      @extend %away-effect;\r\n    }\r\n  }\r\n\r\n  .chat-main-header-info & {\r\n    max-width: $size-60;\r\n  }\r\n}\r\n\r\n.chat-sidenav-content {\r\n  background-color: $white;\r\n}\r\n\r\n.chat-sidenav-title {\r\n  padding: 10px 16px;\r\n  font-size: $font-size-base;\r\n  color: $info;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n}\r\n\r\n.chat-tabs-header {\r\n  background-color: lighten($gray-100, 0.5%) !important;\r\n}\r\n\r\n.chat-user {\r\n  @include display-flex(flex, column, nowrap);\r\n\r\n  &.chat-user-center {\r\n    @include justify-content(center);\r\n    @include align-items(center);\r\n\r\n    & .chat-avatar {\r\n      margin-left: auto;\r\n    }\r\n  }\r\n}\r\n\r\n.chat-user-item {\r\n  border-bottom: solid 1px $gray-200;\r\n  padding: 16px;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  cursor: pointer;\r\n  max-height: 96px;\r\n\r\n  &.active,\r\n  &:hover {\r\n    background-color: lighten($app-primary, 45%);\r\n  }\r\n}\r\n\r\n.chat-user-row {\r\n  margin: 0 -5px;\r\n  @include align-items(center);\r\n}\r\n\r\n.chat-info {\r\n  padding: 0 5px;\r\n\r\n  & p {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  & .h4 {\r\n    display: block;\r\n    margin-bottom: 3px;\r\n  }\r\n}\r\n\r\n.chat-info-des {\r\n  color: $gray-600;\r\n  font-size: 13px;\r\n}\r\n\r\n.chat-date {\r\n  padding: 0 5px;\r\n  text-align: right;\r\n}\r\n\r\n.chat-contact-col {\r\n  @extend .chat-info;\r\n}\r\n\r\n.chat-box-main {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  height: 100%;\r\n}\r\n\r\n.module-default {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n  height: 100%;\r\n  padding: 15px;\r\n}\r\n\r\n.s-128 {\r\n  font-size: 128px !important;\r\n  width: 128px !important;\r\n  height: 128px !important;\r\n  line-height: 128px !important;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.chat-main {\r\n  @include display-flex(flex, column, nowrap);\r\n}\r\n\r\n.chat-main-header {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  border-bottom: solid 1px $gray-200;\r\n  padding: 16px;\r\n  background-color: $white;\r\n  width: 100%;\r\n}\r\n\r\n.chat-main-header-info {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin-right: auto;\r\n}\r\n\r\n.chat-contact-name {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n}\r\n\r\n.chat-main-footer {\r\n  @include display-flex(flex, column, nowrap);\r\n  border-top: solid 1px $gray-200;\r\n  padding: 16px;\r\n  background-color: $white;\r\n  width: 100%;\r\n\r\n  & .form-group {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.todo-main-footer {\r\n  padding: 6px 16px;\r\n}\r\n\r\n.chat-item {\r\n  padding: 16px;\r\n\r\n  & .bubble {\r\n    padding: 8px 12px;\r\n    background-color: $white;\r\n    @include border-radius(20px 20px 20px 0px);\r\n    position: relative;\r\n    margin-left: 16px;\r\n    max-width: 600px;\r\n    border: solid 1px $gray-400;\r\n  }\r\n\r\n  &.flex-row-reverse {\r\n    & .bubble {\r\n      margin-right: 16px;\r\n      margin-left: 0;\r\n      background-color: lighten($app-primary, 45%);\r\n      @include border-radius(20px 20px 0 20px);\r\n    }\r\n  }\r\n}\r\n\r\n.chat-btn {\r\n  font-size: 38px !important;\r\n  margin: 0 10px 0 -8px;\r\n}\r\n\r\n.chat-textarea {\r\n  height: 40px;\r\n  @include box-shadow(none);\r\n  @include border-radius(0);\r\n}\r\n\r\n.last-message-time {\r\n  font-size: 11px;\r\n  color: $gray-500;\r\n}\r\n\r\n@media screen and (max-width: 1399px) {\r\n  .s-128 {\r\n    font-size: 100px !important;\r\n    width: 100px !important;\r\n    height: 100px !important;\r\n    line-height: 100px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1199px) {\r\n  .chat-module {\r\n    margin: -24px -29px -23px;\r\n    padding-top: 0;\r\n  }\r\n\r\n  .chat-main-header {\r\n    padding: 8px 24px;\r\n\r\n    & .size-60 {\r\n      height: 50px !important;\r\n      width: 50px !important;\r\n      line-height: 50px;\r\n    }\r\n\r\n    & button {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n\r\n  .chat-main-header-info {\r\n    & .chat-avatar-mode {\r\n      max-width: 50px;\r\n    }\r\n  }\r\n\r\n  .chat-contact-name,\r\n  .chat-sidenav-title {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .chat-main-footer {\r\n    padding: 8px 16px;\r\n  }\r\n\r\n  .s-128 {\r\n    font-size: 128px !important;\r\n    width: 128px !important;\r\n    height: 128px !important;\r\n    line-height: 128px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .s-128 {\r\n    font-size: 100px !important;\r\n    width: 100px !important;\r\n    height: 100px !important;\r\n    line-height: 100px !important;\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .chat-sidenav-title,\r\n  .chat-contact-name {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .s-128 {\r\n    font-size: 80px !important;\r\n    width: 80px !important;\r\n    height: 80px !important;\r\n    line-height: 80px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .module-default {\r\n    h1 {\r\n      font-size: 17px;\r\n    }\r\n  }\r\n  .s-128 {\r\n    font-size: 40px !important;\r\n    width: 40px !important;\r\n    height: 40px !important;\r\n    line-height: 40px !important;\r\n  }\r\n}\r\n\r\n","/*Mails Module Styles*/\r\n\r\n.module-box-row {\r\n  @include display-flex();\r\n  width: 100%;\r\n}\r\n\r\n.module-box-column {\r\n  @include display-flex(flex, column, nowrap);\r\n  width: 100%;\r\n}\r\n\r\n.mail-user-info {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n\r\n  & .avatar {\r\n    margin-right: 10px;\r\n  }\r\n\r\n  & .time,\r\n  & button {\r\n    margin-left: auto;\r\n  }\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.module-list-item.mail-cell {\r\n  @include display-flex();\r\n}\r\n\r\n.mail-detail {\r\n  padding: 24px !important;\r\n}\r\n\r\n.mail-header {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n}\r\n\r\n.mail-header-content {\r\n  @include display-flex(flex, column, nowrap);\r\n\r\n  & .subject {\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.show-detail {\r\n  cursor: pointer;\r\n}\r\n\r\n.text-truncate {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.module-list-content {\r\n  & .subject {\r\n    @extend .text-truncate;\r\n  }\r\n\r\n  & .message {\r\n    @include display-flex(flex, column, nowrap);\r\n    color: darken($gray-500, 10%);\r\n    font-size: 13px;\r\n\r\n    p {\r\n      @extend .text-truncate;\r\n      margin-bottom: 8px;\r\n    }\r\n  }\r\n}\r\n\r\n.size {\r\n  margin: 5px 0;\r\n}\r\n\r\n.sender-name {\r\n  margin-right: 0;\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n}\r\n\r\n.mail-header-actions {\r\n  text-align: right;\r\n  min-width: 100px;\r\n  @include display-flex();\r\n\r\n  & .icon-btn:not(:last-child) {\r\n    margin-right: 3px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .module-list-item.mail-cell {\r\n    padding-right: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 576px) {\r\n  .mail-list {\r\n    @include flex(1, 1, auto);\r\n    max-width: 100%;\r\n    border-right: 0 none;\r\n  }\r\n\r\n  .mail-detail {\r\n    @include flex(1, 1, auto);\r\n    max-width: 100%;\r\n\r\n    & .module-list-scroll {\r\n      padding: 24px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 499px) {\r\n  .mail-header {\r\n    display: block;\r\n    @include align-items(flex-start);\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-flex-wrap: nowrap;\r\n    -ms-flex-wrap: nowrap;\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .mail-header-actions {\r\n    text-align: left;\r\n    min-width: 10px;\r\n  }\r\n\r\n  .MuiDialog-paperWidthSm-99 {\r\n    max-width: 250px !important;\r\n  }\r\n}","/*Contact Module Styles*/\r\n\r\n.contact-item {\r\n  @include align-items(center);\r\n  @include display-flex();\r\n  border-bottom: solid 1px $gray-200;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.contact-name {\r\n  font-size: 15px;\r\n}\r\n\r\n.modal-box {\r\n  position: relative;\r\n}\r\n\r\n.modal-w {\r\n  max-width: 400px;\r\n  min-width: 350px;\r\n\r\n  .modal-box-mail & {\r\n    min-width: 600px;\r\n  }\r\n}\r\n\r\n.modal-box-header {\r\n  color: $white;\r\n  @include border-top-radius(4px);\r\n}\r\n\r\n.modal-box-header h2 {\r\n  color: $white;\r\n  position: relative;\r\n\r\n  & button {\r\n    position: absolute;\r\n    right: 0;\r\n    top: -10px;\r\n    z-index: 1;\r\n    color: $white;\r\n  }\r\n}\r\n\r\n.modal-box-content {\r\n  padding: 24px;\r\n\r\n  & .avatar {\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.modal-box-footer {\r\n  padding: 0 24px 24px;\r\n\r\n  & .attach-file {\r\n    @include display-flex();\r\n    @include align-items(center);\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n.btn-fixed {\r\n  position: fixed !important;\r\n  right: 40px;\r\n  bottom: 60px;\r\n  z-index: 100;\r\n}\r\n\r\n.draggable-icon {\r\n  cursor: all-scroll;\r\n  color: $gray-600;\r\n\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    cursor: all-scroll;\r\n    color: $gray-900;\r\n  }\r\n}\r\n\r\n.module-side-nav {\r\n  padding: 20px 0;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .modal-w {\r\n    .modal-box-mail & {\r\n      min-width: 500px;\r\n    }\r\n  }\r\n\r\n  .modal-box-header h2 {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .modal-w {\r\n    min-width: 300px;\r\n\r\n    .modal-box-mail & {\r\n      min-width: 400px;\r\n    }\r\n  }\r\n\r\n  .modal-box-header h2 {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 419px) {\r\n  .modal-w {\r\n    min-width: 250px;\r\n\r\n    .modal-box-mail & {\r\n      min-width: 250px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .con-inf-mw-100 {\r\n    min-width: 100% !important;\r\n  }\r\n}\r\n","/* Calendar Module Style */\r\n\r\n.rbc-calendar {\r\n  .app-calendar & {\r\n    @include display-flex(flex, column, nowrap);\r\n    @include flex(1);\r\n    min-height: calc(100vh - 160px);\r\n  }\r\n\r\n  .app-cul-calendar & {\r\n    min-height: calc(100vh - 200px);\r\n  }\r\n}\r\n\r\n.rbc-event {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.rbc-event.rbc-selected {\r\n  background-color: darken($app-primary, 10%);\r\n}\r\n\r\n.rbc-slot-selection {\r\n  background-color: rgba($app-primary, 0.7);\r\n}\r\n\r\n.rbc-toolbar button:active,\r\n.rbc-toolbar button.rbc-active {\r\n  color: $white;\r\n  background-image: none;\r\n  @include box-shadow(none);\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-toolbar button:active:hover,\r\n.rbc-toolbar button.rbc-active:hover,\r\n.rbc-toolbar button:active:focus,\r\n.rbc-toolbar button.rbc-active:focus {\r\n  color: $white;\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-toolbar button:focus {\r\n  color: $white;\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-toolbar button:hover {\r\n  color: $white;\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-month-row {\r\n  min-height: 100px;\r\n}\r\n\r\n.rbc-event {\r\n  min-height: 50px;\r\n}\r\n\r\n@media screen and (max-width: 867px) {\r\n  .rbc-toolbar {\r\n    @include display-flex(flex, column, nowrap);\r\n    @include align-items(flex-start);\r\n  }\r\n\r\n  .rbc-toolbar .rbc-toolbar-label {\r\n    margin: 8px 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-height: 600px) {\r\n  .rbc-calendar {\r\n    .app-calendar & {\r\n      min-height: 400px;\r\n    }\r\n\r\n    .app-cul-calendar & {\r\n      min-height: 400px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 467px) {\r\n  .rbc-toolbar {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .rbc-toolbar button {\r\n    padding: 5px 10px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
